/* eslint-disable */
// AUTO-GENERATED BY npm run generate-index
// Do not edit manually.

import * as aboveGroundStorageTanksUndergroundStorageTanks from './relational/above_ground_storage_tanks_underground_storage_tanks/index.js'
import * as abvtex from './relational/abvtex/index.js'
import * as accessories from './relational/accessories/index.js'
import * as additionnalPhotosNonRelatedToQuestions from './relational/additionnal_photos_non_related_to_questions/index.js'
import * as addressLine_1 from './global/address_line_1/index.js'
import * as addressLine_2 from './global/address_line_2/index.js'
import * as administrativeCosts from './relational/administrative_costs/index.js'
import * as age_1 from './relational/age_1/index.js'
import * as age_2 from './relational/age_2/index.js'
import * as age_3 from './relational/age_3/index.js'
import * as ageFactoredIntoHiringDecisionsNotLineLegal from './relational/age_factored_into_hiring_decisions_not_line_legal/index.js'
import * as agencyContractWorker from './relational/agency_contract_worker/index.js'
import * as agents from './transactional/agents/index.js'
import * as ageReferencedNotLineLegalRequirements from './relational/age_referenced_not_line_legal_requirements/index.js'
import * as allowSharingAddress from './transactional/allow_sharing_address/index.js'
import * as allowSharingProof from './transactional/allow_sharing_proof/index.js'
import * as allPublicHolidays_1 from './relational/all_public_holidays_1/index.js'
import * as allPublicHolidays_2 from './relational/all_public_holidays_2/index.js'
import * as amforiClientId from './global/amfori_client_id/index.js'
import * as amforiClientSecret from './global/amfori_client_secret/index.js'
import * as amforiCredentialsRevokedAt from './global/amfori_credentials_revoked_at/index.js'
import * as amforiCredentialsVerifiedAt from './global/amfori_credentials_verified_at/index.js'
import * as amforiLastSyncedAt from './global/amfori_last_synced_at/index.js'
import * as amforiMemberId from './global/amfori_member_id/index.js'
import * as amforiSiteIds from './global/amfori_site_ids/index.js'
import * as annualLeave_1 from './relational/annual_leave_1/index.js'
import * as annualLeave_2 from './relational/annual_leave_2/index.js'
import * as annualProductionCapacity from './relational/annual_production_capacity/index.js'
import * as annualPurchaseVolume from './transactional/annual_purchase_volume/index.js'
import * as annualRevenue from './relational/annual_revenue/index.js'
import * as antiDiscrimination from './relational/anti_discrimination/index.js'
import * as antiHarassmentAndAbuse from './relational/anti_harassment_and_abuse/index.js'
import * as apparel from './relational/apparel/index.js'
import * as approximateNumberOfSupervisors_1 from './relational/approximate_number_of_supervisors_1/index.js'
import * as approximateNumberOfSupervisors_2 from './relational/approximate_number_of_supervisors_2/index.js'
import * as approximateNumberOfSupervisors_3 from './relational/approximate_number_of_supervisors_3/index.js'
import * as approximateNumberOfSupervisors_4 from './relational/approximate_number_of_supervisors_4/index.js'
import * as approximateNumberOfWorkers_1 from './relational/approximate_number_of_workers_1/index.js'
import * as approximateNumberOfWorkers_2 from './relational/approximate_number_of_workers_2/index.js'
import * as approximateNumberOfWorkers_3 from './relational/approximate_number_of_workers_3/index.js'
import * as approximateNumberOfWorkers_4 from './relational/approximate_number_of_workers_4/index.js'
import * as areAffordableMenstrualProductsAvailableInTheWorkplace from './relational/are_affordable_menstrual_products_available_in_the_workplace/index.js'
import * as areAllEmergencyExitsAccessibleUnobstructedAndUnlockedDu from './relational/are_all_emergency_exits_accessible_unobstructed_and_unlocked_du/index.js'
import * as areAllEmergencyExitsClearlyMarked from './relational/are_all_emergency_exits_clearly_marked/index.js'
import * as areAllInkindBenefitsVoluntary from './relational/are_all_inkind_benefits_voluntary/index.js'
import * as areAllLoansAndorAdvancesInLineWLegalReqs from './relational/are_all_loans_andor_advances_in_line_w_legal_reqs/index.js'
import * as areAllNewWrkrsProvdWACopyOfTheFacsWorkplaceRulesAv from './relational/are_all_new_wrkrs_provd_w_a_copy_of_the_facs_workplace_rules_av/index.js'
import * as areAllOvertimeWorkingHoursInLineWLegalLimits from './relational/are_all_overtime_working_hours_in_line_w_legal_limits/index.js'
import * as areAllWrkrsOfferedAnyOfTheFollowingProgramsByTheFac from './relational/are_all_wrkrs_offered_any_of_the_following_programs_by_the_fac/index.js'
import * as areAllWrkrsOfferedAnyOfTheFollowingTypesOfDevelopment from './relational/are_all_wrkrs_offered_any_of_the_following_types_of_development/index.js'
import * as areAllWrkrsOfferedAnyOfTheFollowingTypesOfMarketAcce from './relational/are_all_wrkrs_offered_any_of_the_following_types_of_market_acce/index.js'
import * as areAnyMaterialsThatAreNotRelevantToTheMaintenanceOfT from './relational/are_any_materials_that_are_not_relevant_to_the_maintenance_of_t/index.js'
import * as areAnyMonetaryDepositsRequiredOfWrkrs from './relational/are_any_monetary_deposits_required_of_wrkrs/index.js'
import * as areArrangementsInCaseOfMedicalEmergencyIncludingOnsite from './relational/are_arrangements_in_case_of_medical_emergency_including_onsite/index.js'
import * as areBipartiteCommitteeMembersReleasedFromWorkDutiesToPr from './relational/are_bipartite_committee_members_released_from_work_duties_to_pr/index.js'
import * as areBipartiteCommitteesEstablishedAndFunctioningInLineW from './relational/are_bipartite_committees_established_and_functioning_in_line_w/index.js'
import * as areBipartiteCommitteeSEstablishedFunctioningLineLegal from './relational/are_bipartite_committee_s_established_functioning_line_legal/index.js'
import * as areBipartiteCommitteeSPlaceAlthoughThereAre from './relational/are_bipartite_committee_s_place_although_there_are/index.js'
import * as areBuildingconstructionStructuralSafetyAndFirePermitsAnd from './relational/are_buildingconstruction_structural_safety_and_fire_permits_and/index.js'
import * as areBuildingconstructionStructuralSafetyAndFirePermitsAnd_1 from './relational/are_buildingconstruction_structural_safety_and_fire_permits_and_1/index.js'
import * as areChemicalsAndHazardousSubstancesLabeledInLineWLegal from './relational/are_chemicals_and_hazardous_substances_labeled_in_line_w_legal/index.js'
import * as areChemicalsAndHazardousSubstancesStoredInLineWLegalR from './relational/are_chemicals_and_hazardous_substances_stored_in_line_w_legal_r/index.js'
import * as areChildrenBelowTheLegalMinimumAgeForEmploymentAllowed from './relational/are_children_below_the_legal_minimum_age_for_employment_allowed/index.js'
import * as areContractsForAllPersonsWhoPerformWorkForTheFacBoth from './relational/are_contracts_for_all_persons_who_perform_work_for_the_fac_both/index.js'
import * as areDisciplinaryMeasuresForWrkrsInLineWLegalReqs from './relational/are_disciplinary_measures_for_wrkrs_in_line_w_legal_reqs/index.js'
import * as areElectricalOutletsUsedForPluggingInCordedEquipmentIn from './relational/are_electrical_outlets_used_for_plugging_in_corded_equipment_in/index.js'
import * as areElectricalWiresCablesSwitchesPlugsPanelsDistribution from './relational/are_electrical_wires_cables_switches_plugs_panels_distribution/index.js'
import * as areElevatorsLiftsInLineWLegalReqs from './relational/are_elevators_lifts_in_line_w_legal_reqs/index.js'
import * as areElevatorsLiftsLineLegalRequirements from './relational/are_elevators_lifts_line_legal_requirements/index.js'
import * as areEmergencyEvacuationProceduresInLineWLegalReqs from './relational/are_emergency_evacuation_procedures_in_line_w_legal_reqs/index.js'
import * as areEmergencyExitsInLineWOtherLegalReqs from './relational/are_emergency_exits_in_line_w_other_legal_reqs/index.js'
import * as areErgonomicMeasuresInLineWLegalReqs from './relational/are_ergonomic_measures_in_line_w_legal_reqs/index.js'
import * as areErgonomicMeasuresLineLegalRequirements from './relational/are_ergonomic_measures_line_legal_requirements/index.js'
import * as areExemptionTermsAccurateCurrentValidAndFollowedByThe from './relational/are_exemption_terms_accurate_current_valid_and_followed_by_the/index.js'
import * as areFacDoorsExitsAndStairsInLineWLegalReqs from './relational/are_fac_doors_exits_and_stairs_in_line_w_legal_reqs/index.js'
import * as areFacilityDoorsExitsStairsLineLegalRequirements from './relational/are_facility_doors_exits_stairs_line_legal_requirements/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_1 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_1/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_10 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_10/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_11 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_11/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_12 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_12/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_2 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_2/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_3 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_3/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_4 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_4/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_5 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_5/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_6 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_6/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_7 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_7/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_8 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_8/index.js'
import * as areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_9 from './relational/are_fac_practices_failing_to_comply_w_any_legal_reqs_not_covere_9/index.js'
import * as areFacTemperatureAndVentilationInLineWApplicableLegal from './relational/are_fac_temperature_and_ventilation_in_line_w_applicable_legal/index.js'
import * as areFlammablecombustibleMaterialsSafelyStored from './relational/are_flammablecombustible_materials_safely_stored/index.js'
import * as areFuelStorageTanksDesignedAndHandledInLineWLegalReq from './relational/are_fuel_storage_tanks_designed_and_handled_in_line_w_legal_req/index.js'
import * as areFuelStorageTanksDesignedHandledLineLegal from './relational/are_fuel_storage_tanks_designed_handled_line_legal/index.js'
import * as areGrievanceHandlingAndDisputeResolutionProceduresAccess from './relational/are_grievance_handling_and_dispute_resolution_procedures_access/index.js'
import * as areGrievancesAndDisputesResolvedInLineWLegalReqs from './relational/are_grievances_and_disputes_resolved_in_line_w_legal_reqs/index.js'
import * as areGrievancesDisputesResolvedLineLegalRequirements from './relational/are_grievances_disputes_resolved_line_legal_requirements/index.js'
import * as areKindBenefitsVoluntary from './relational/are_kind_benefits_voluntary/index.js'
import * as areLaborRecruitersEmploymentAgenciesEverResponsibleForT from './relational/are_labor_recruiters_employment_agencies_ever_responsible_for_t/index.js'
import * as areLegallyRequiredGuardsProperlyInstalledAndMaintainedO from './relational/are_legally_required_guards_properly_installed_and_maintained_o/index.js'
import * as areLegallyRequiredGuardsProperlyInstalledMaintainedOn from './relational/are_legally_required_guards_properly_installed_maintained_on/index.js'
import * as areLegallyRequiredMechanismsForDialogueBetweenTheEmploy from './relational/are_legally_required_mechanisms_for_dialogue_between_the_employ/index.js'
import * as areLegallyRequiredSafetyWarningsPostedInTheWorkplace from './relational/are_legally_required_safety_warnings_posted_in_the_workplace/index.js'
import * as areLegallyRequiredWrkrsRepresentativesIfAnyElectedAndF from './relational/are_legally_required_wrkrs_representatives_if_any_elected_and_f/index.js'
import * as areLoansAdvancesLineLegalRequirements from './relational/are_loans_advances_line_legal_requirements/index.js'
import * as areMachineryAndLightingConnectedToTheAppropriateTypeOf from './relational/are_machinery_and_lighting_connected_to_the_appropriate_type_of/index.js'
import * as areManagersAndSupvsHeldAccountableForEnsuringThatThere from './relational/are_managers_and_supvs_held_accountable_for_ensuring_that_there/index.js'
import * as areMechanismsToCooperationBetweenWrkrsAndMgmtOnOccupat from './relational/are_mechanisms_to_cooperation_between_wrkrs_and_mgmt_on_occupat/index.js'
import * as areMonetaryDepositsOutLineLegalRequirements from './relational/are_monetary_deposits_out_line_legal_requirements/index.js'
import * as areMonetaryDepositsOutOfLineWLegalReqs from './relational/are_monetary_deposits_out_of_line_w_legal_reqs/index.js'
import * as areMonetaryDepositsRequiredWorkers from './relational/are_monetary_deposits_required_workers/index.js'
import * as areOffSiteCanteensEatingAreasManagedFacility from './relational/are_off_site_canteens_eating_areas_managed_facility/index.js'
import * as areOnsiteCanteensEatingAreasLineLegalRequirements from './relational/are_onsite_canteens_eating_areas_line_legal_requirements/index.js'
import * as areOnsiteChildcareFacilitiesInLineWLegalReqs from './relational/are_onsite_childcare_facilities_in_line_w_legal_reqs/index.js'
import * as areOnSiteChildcareFacilitiesLineLegalRequirements from './relational/are_on_site_childcare_facilities_line_legal_requirements/index.js'
import * as areOvertimeHoursPaidAtAPremiumRateOfAtLeast_125Times from './relational/are_overtime_hours_paid_at_a_premium_rate_of_at_least_125_times/index.js'
import * as arePaySlipsInALanguageAllWrkrsCanUndstand from './relational/are_pay_slips_in_a_language_all_wrkrs_can_undstand/index.js'
import * as arePaySlipsLanguageWorkersCanUnderstand from './relational/are_pay_slips_language_workers_can_understand/index.js'
import * as arePersonnelFilesMaintainedInLineWLegalReqs from './relational/are_personnel_files_maintained_in_line_w_legal_reqs/index.js'
import * as arePersonnelFilesMaintainedLineLegalRequirements from './relational/are_personnel_files_maintained_line_legal_requirements/index.js'
import * as arePoliciesProceduresEndorsedSeniorManagement from './relational/are_policies_procedures_endorsed_senior_management/index.js'
import * as arePossibleSourcesOfIgnitionSufficientlySafeguarded from './relational/are_possible_sources_of_ignition_sufficiently_safeguarded/index.js'
import * as arePregnantAndNursingWrkrsProtectedAgainstSafetyAndHea from './relational/are_pregnant_and_nursing_wrkrs_protected_against_safety_and_hea/index.js'
import * as areProbationaryTimePeriodsInLineWLegalReqs from './relational/are_probationary_time_periods_in_line_w_legal_reqs/index.js'
import * as areProbationaryTimePeriodsLineLegalRequirements from './relational/are_probationary_time_periods_line_legal_requirements/index.js'
import * as areProtRestrForWrkrsUndTheAgeOf_18InLineWLegalReqs from './relational/are_prot_restr_for_wrkrs_und_the_age_of_18_in_line_w_legal_reqs/index.js'
import * as areProvisionsWinTheCollectiveBargainingAgreementsCbaAt from './relational/are_provisions_win_the_collective_bargaining_agreements_cba_at/index.js'
import * as areRecruitmentFeesAndRelatedCostsPaidByWrkrsInLineW from './relational/are_recruitment_fees_and_related_costs_paid_by_wrkrs_in_line_w/index.js'
import * as areRecruitmentFeesRelatedCostsPaidWorkersLine from './relational/are_recruitment_fees_related_costs_paid_workers_line/index.js'
import * as areRestroomsRegularlyStockedWNecessarySupplies from './relational/are_restrooms_regularly_stocked_w_necessary_supplies/index.js'
import * as areSafetyDataSheetsSdsFormerlyMsdsAvailableForAllChem from './relational/are_safety_data_sheets_sds_formerly_msds_available_for_all_chem/index.js'
import * as areSeparateToiletsProvdForMalesAndFemales from './relational/are_separate_toilets_provd_for_males_and_females/index.js'
import * as areSpecializedHealthChecksConductedForWrkrsPerformingHi from './relational/are_specialized_health_checks_conducted_for_wrkrs_performing_hi/index.js'
import * as areTemperatureAndVentilationSystemsMaintainedInLineWLe from './relational/are_temperature_and_ventilation_systems_maintained_in_line_w_le/index.js'
import * as areTheBeltAreasOfCompressorsAndGeneratorsFullyEnclosed from './relational/are_the_belt_areas_of_compressors_and_generators_fully_enclosed/index.js'
import * as areTheFacility_1 from './relational/are_the_facility_1/index.js'
import * as areTheFacility_2 from './relational/are_the_facility_2/index.js'
import * as areTheFacility_3 from './relational/are_the_facility_3/index.js'
import * as areTheFacsEmploymentContractsForForeignMigrantsInLine from './relational/are_the_facs_employment_contracts_for_foreign_migrants_in_line/index.js'
import * as areTheFacsPracticesAroundMakingAccommodationsForPhysica from './relational/are_the_facs_practices_around_making_accommodations_for_physica/index.js'
import * as areTheFacsSanitationPracticesInLineWLegalReqs from './relational/are_the_facs_sanitation_practices_in_line_w_legal_reqs/index.js'
import * as areTheFacsWasteDisposalPracticesInLineWLegalReqs from './relational/are_the_facs_waste_disposal_practices_in_line_w_legal_reqs/index.js'
import * as areThereAnyBipartiteCommitteesInPlaceAtTheFac from './relational/are_there_any_bipartite_committees_in_place_at_the_fac/index.js'
import * as areThereAnyRestrToWrkrsApplyingForOrTakingLeave from './relational/are_there_any_restr_to_wrkrs_applying_for_or_taking_leave/index.js'
import * as areTheReasonsForOvertimeInLineWLegalReqs from './relational/are_the_reasons_for_overtime_in_line_w_legal_reqs/index.js'
import * as areThereCasesWhereTrashDebrisOrEmptyContainersHaveAcc from './relational/are_there_cases_where_trash_debris_or_empty_containers_have_acc/index.js'
import * as areThereOnsiteChildcareFacilities from './relational/are_there_onsite_childcare_facilities/index.js'
import * as areThereRestrictionsWorkersApplyingTakingLeave from './relational/are_there_restrictions_workers_applying_taking_leave/index.js'
import * as areThereSufficientEmergencyExitsFromAllWorkStationsAnd from './relational/are_there_sufficient_emergency_exits_from_all_work_stations_and/index.js'
import * as areThereWrittenRecsOfTheseCases from './relational/are_there_written_recs_of_these_cases/index.js'
import * as areThereWrittenRecsOfTheseCases_1 from './relational/are_there_written_recs_of_these_cases_1/index.js'
import * as areThereWrittenRecsOfTheseCases_10 from './relational/are_there_written_recs_of_these_cases_10/index.js'
import * as areThereWrittenRecsOfTheseCases_11 from './relational/are_there_written_recs_of_these_cases_11/index.js'
import * as areThereWrittenRecsOfTheseCases_12 from './relational/are_there_written_recs_of_these_cases_12/index.js'
import * as areThereWrittenRecsOfTheseCases_13 from './relational/are_there_written_recs_of_these_cases_13/index.js'
import * as areThereWrittenRecsOfTheseCases_14 from './relational/are_there_written_recs_of_these_cases_14/index.js'
import * as areThereWrittenRecsOfTheseCases_15 from './relational/are_there_written_recs_of_these_cases_15/index.js'
import * as areThereWrittenRecsOfTheseCases_2 from './relational/are_there_written_recs_of_these_cases_2/index.js'
import * as areThereWrittenRecsOfTheseCases_3 from './relational/are_there_written_recs_of_these_cases_3/index.js'
import * as areThereWrittenRecsOfTheseCases_4 from './relational/are_there_written_recs_of_these_cases_4/index.js'
import * as areThereWrittenRecsOfTheseCases_5 from './relational/are_there_written_recs_of_these_cases_5/index.js'
import * as areThereWrittenRecsOfTheseCases_6 from './relational/are_there_written_recs_of_these_cases_6/index.js'
import * as areThereWrittenRecsOfTheseCases_7 from './relational/are_there_written_recs_of_these_cases_7/index.js'
import * as areThereWrittenRecsOfTheseCases_8 from './relational/are_there_written_recs_of_these_cases_8/index.js'
import * as areThereWrittenRecsOfTheseCases_9 from './relational/are_there_written_recs_of_these_cases_9/index.js'
import * as areTheseStepsToHelpWrkrsWHivAidsInLineWLegalReqs from './relational/are_these_steps_to_help_wrkrs_w_hiv_aids_in_line_w_legal_reqs/index.js'
import * as areTheseStepsToHelpWrkrsWInfectionsOrIllnessesOtherT from './relational/are_these_steps_to_help_wrkrs_w_infections_or_illnesses_other_t/index.js'
import * as areTheWeeklyRestDaysProvdByTheFacInLineWLegalReqs from './relational/are_the_weekly_rest_days_provd_by_the_fac_in_line_w_legal_reqs/index.js'
import * as areToiletsCleanAndSanitizedOnARegularBasis from './relational/are_toilets_clean_and_sanitized_on_a_regular_basis/index.js'
import * as areToiletsInLineWLegalReqs from './relational/are_toilets_in_line_w_legal_reqs/index.js'
import * as areToiletsLineLegalRequirements from './relational/are_toilets_line_legal_requirements/index.js'
import * as areTradeUnionOfficersFromTheFederationexternalTradeUnio from './relational/are_trade_union_officers_from_the_federationexternal_trade_unio/index.js'
import * as areWagePaymentsMadeRegularlyAndOnTimeAndInLineWLega from './relational/are_wage_payments_made_regularly_and_on_time_and_in_line_w_lega/index.js'
import * as areWagePaymentsMadeRegularlyOnTimeLine from './relational/are_wage_payments_made_regularly_on_time_line/index.js'
import * as areWarehousesWinOrSeparateFromProductionBuildings from './relational/are_warehouses_win_or_separate_from_production_buildings/index.js'
import * as areWasteDisposaldischargePermitsAvailableAndUpToDate from './relational/are_waste_disposaldischarge_permits_available_and_up_to_date/index.js'
import * as areWeeklyRestDaysProvidedFacilityLineLegal from './relational/are_weekly_rest_days_provided_facility_line_legal/index.js'
import * as areWkrsInformedTermsCondSurroundingGrantingRepayment from './relational/are_wkrs_informed_terms_cond_surrounding_granting_repayment/index.js'
import * as areWkrsWhoHandleTetrachloroethylenePercProvidedRequired from './relational/are_wkrs_who_handle_tetrachloroethylene_perc_provided_required/index.js'
import * as areWorkerExposuresNoiseLineLegalRequirements from './relational/are_worker_exposures_noise_line_legal_requirements/index.js'
import * as areWorkerExposuresToAirborneParticulatesEgDustFibersFu from './relational/are_worker_exposures_to_airborne_particulates_eg_dust_fibers_fu/index.js'
import * as areWorkerExposuresToNoiseInLineWLegalReqs from './relational/are_worker_exposures_to_noise_in_line_w_legal_reqs/index.js'
import * as areWorkers from './relational/are_workers/index.js'
import * as areWorkersAllowedAccessDrinkingWaterTime from './relational/are_workers_allowed_access_drinking_water_time/index.js'
import * as areWorkersAllowedAccessToiletsRestroomsTime from './relational/are_workers_allowed_access_toilets_restrooms_time/index.js'
import * as areWorkersBasicWagesEverReviewedAndAdjustedForTheEnti from './relational/are_workers_basic_wages_ever_reviewed_and_adjusted_for_the_enti/index.js'
import * as areWorkersInformedAboutTheirIndividualWagesDeductions from './relational/are_workers_informed_about_their_individual_wages_deductions/index.js'
import * as areWorkersInformedExistenceKindBenefits from './relational/are_workers_informed_existence_kind_benefits/index.js'
import * as areWorkersPaidDirectlyFacilityThrough_3rdParty from './relational/are_workers_paid_directly_facility_through_3rd_party/index.js'
import * as areWorkersPaidDuringBreastfeedingBreaksLineLegal from './relational/are_workers_paid_during_breastfeeding_breaks_line_legal/index.js'
import * as areWorkersPaidTheirFullWagesLegallyRequired from './relational/are_workers_paid_their_full_wages_legally_required/index.js'
import * as areWorkersReimbursedRecruitmentFeesRelatedCostsPaid from './relational/are_workers_reimbursed_recruitment_fees_related_costs_paid/index.js'
import * as areWorkersWhoHandleNNDimethylformamideDmf from './relational/are_workers_who_handle_n_n_dimethylformamide_dmf/index.js'
import * as areWorkersWhoHandlePotassiumPermanganatePpProvided from './relational/are_workers_who_handle_potassium_permanganate_pp_provided/index.js'
import * as areWorkplaceRulesMadeVisibleInFacCommonAreasEgCanteen from './relational/are_workplace_rules_made_visible_in_fac_common_areas_eg_canteen/index.js'
import * as areWorkTargetsForProductionEgQuotaOrPieceWorkInLine from './relational/are_work_targets_for_production_eg_quota_or_piece_work_in_line/index.js'
import * as areWorkTargetsProductionEGQuotaPiece from './relational/are_work_targets_production_e_g_quota_piece/index.js'
import * as areWrittenJobDescOrJobApplicationFormsThatReferenceOt from './relational/are_written_job_desc_or_job_application_forms_that_reference_ot/index.js'
import * as areWrittenRecsOfComplaintsAndGrievancesAndTheMgmtsRes from './relational/are_written_recs_of_complaints_and_grievances_and_the_mgmts_res/index.js'
import * as areWrittenRecsOfDisciplinaryActionsMaintainedInWrkrsPe from './relational/are_written_recs_of_disciplinary_actions_maintained_in_wrkrs_pe/index.js'
import * as areWrittenRecsOfSuggestionsAndFeedbackMaintainedForAt from './relational/are_written_recs_of_suggestions_and_feedback_maintained_for_at/index.js'
import * as areWrkrsAbleToRefuseOvertimeForAnyReason from './relational/are_wrkrs_able_to_refuse_overtime_for_any_reason/index.js'
import * as areWrkrsAllowedAccessToDrinkingWaterAtAnyTime from './relational/are_wrkrs_allowed_access_to_drinking_water_at_any_time/index.js'
import * as areWrkrsAllowedAccessToToiletsrestroomsAtAnyTime from './relational/are_wrkrs_allowed_access_to_toiletsrestrooms_at_any_time/index.js'
import * as areWrkrsAndWrkrsRepresentativesFreeToMeetWoutThePrese from './relational/are_wrkrs_and_wrkrs_representatives_free_to_meet_wout_the_prese/index.js'
import * as areWrkrsAwareOfTheCommitteesRoleAndAdvantages from './relational/are_wrkrs_aware_of_the_committees_role_and_advantages/index.js'
import * as areWrkrsAwareOfTheProcessesInPlaceForGrievanceHandlin from './relational/are_wrkrs_aware_of_the_processes_in_place_for_grievance_handlin/index.js'
import * as areWrkrsEverResponsibleForTheCostOfAnyOfTheFollowing from './relational/are_wrkrs_ever_responsible_for_the_cost_of_any_of_the_following/index.js'
import * as areWrkrsExposedToHazardousSubstancesInTheProductionPro from './relational/are_wrkrs_exposed_to_hazardous_substances_in_the_production_pro/index.js'
import * as areWrkrsForcedToWorkOvertimeUndThreatOfPenalty from './relational/are_wrkrs_forced_to_work_overtime_und_threat_of_penalty/index.js'
import * as areWrkrsFreeToComeAndGoFromTheDormitoriesAndTheIndu from './relational/are_wrkrs_free_to_come_and_go_from_the_dormitories_and_the_indu/index.js'
import * as areWrkrsFreeToFormATradeUnionOfTheirChoosing from './relational/are_wrkrs_free_to_form_a_trade_union_of_their_choosing/index.js'
import * as areWrkrsFreeToJoinATradeUnionOfTheirChoosing from './relational/are_wrkrs_free_to_join_a_trade_union_of_their_choosing/index.js'
import * as areWrkrsFreeToTakeLeaveOnceGivenApproval from './relational/are_wrkrs_free_to_take_leave_once_given_approval/index.js'
import * as areWrkrsFreeToTerminateTheirEmploymentAfterTheirNotice from './relational/are_wrkrs_free_to_terminate_their_employment_after_their_notice/index.js'
import * as areWrkrsInformedAboutTheirIndividualWagesAndDeductions from './relational/are_wrkrs_informed_about_their_individual_wages_and_deductions/index.js'
import * as areWrkrsInformedOfTheExistenceOfInkindBenefits from './relational/are_wrkrs_informed_of_the_existence_of_inkind_benefits/index.js'
import * as areWrkrsPaidDirectlyByTheFacOrThrough_3rdPartyAgents from './relational/are_wrkrs_paid_directly_by_the_fac_or_through_3rd_party_agents/index.js'
import * as areWrkrsPaidDuringBreastfeedingBreaksInLineWLegalReqs from './relational/are_wrkrs_paid_during_breastfeeding_breaks_in_line_w_legal_reqs/index.js'
import * as areWrkrsPaidForAllWorkrelatedActivitiesOutsideOfRegula from './relational/are_wrkrs_paid_for_all_workrelated_activities_outside_of_regula/index.js'
import * as areWrkrsPaidTheirFullWagesInTheLegallyRequiredManner from './relational/are_wrkrs_paid_their_full_wages_in_the_legally_required_manner/index.js'
import * as areWrkrsProvdWAPrivateMeetingSpaceAtTheWorkplaceInL from './relational/are_wrkrs_provd_w_a_private_meeting_space_at_the_workplace_in_l/index.js'
import * as areWrkrsReimbursedForRecruitmentFeesAndRelatedCostsPai from './relational/are_wrkrs_reimbursed_for_recruitment_fees_and_related_costs_pai/index.js'
import * as areWrkrsRestrictedFromLeavingTheWorkplaceInOrderToFor from './relational/are_wrkrs_restricted_from_leaving_the_workplace_in_order_to_for/index.js'
import * as areWrkrsSubjectToNegativeConsequencesIfTheyRemoveThems from './relational/are_wrkrs_subject_to_negative_consequences_if_they_remove_thems/index.js'
import * as areWrkrsTrainedAndRequiredToUsePersonalProtEquipmentI from './relational/are_wrkrs_trained_and_required_to_use_personal_prot_equipment_i/index.js'
import * as areWrkrsTrainedOnChemicalHazardsAndSafeWorkPracticesP from './relational/are_wrkrs_trained_on_chemical_hazards_and_safe_work_practices_p/index.js'
import * as assembly from './relational/assembly/index.js'
import * as assemblyEGCorrugatedBoard from './relational/assembly_e_g_corrugated_board/index.js'
import * as audit_24412dqa111 from './global/audit_24412dqa111/index.js'
import * as audit_4pppwlgmbnl from './global/audit_4pppwlgmbnl/index.js'
import * as audit_6atu4r8e1aq from './global/audit_6atu4r8e1aq/index.js'
import * as auditAmforiBepi from './global/audit_amfori_bepi/index.js'
import * as auditAwsAllianceForWaterStewardship from './global/audit_aws_alliance_for_water_stewardship/index.js'
import * as auditBetterWork from './global/audit_better_work/index.js'
import * as auditBluesign from './global/audit_bluesign/index.js'
import * as auditBsci from './global/audit_bsci/index.js'
import * as auditC28ljiab8qc from './global/audit_c28ljiab8qc/index.js'
import * as auditControlUnionFairChoiceAudit from './global/audit_control_union_fair_choice_audit/index.js'
import * as auditEti from './global/audit_eti/index.js'
import * as auditEwsEuropeanWaterStewardship from './global/audit_ews_european_water_stewardship/index.js'
import * as auditFactoryVisit from './global/audit_factory_visit/index.js'
import * as auditFairWearFoundation from './global/audit_fair_wear_foundation/index.js'
import * as auditFla from './global/audit_fla/index.js'
import * as auditGots from './global/audit_gots/index.js'
import * as auditGreenButtonAudit from './global/audit_green_button_audit/index.js'
import * as auditGub825fyuyf from './global/audit_gub825fyuyf/index.js'
import * as auditHiggFemHiggFacilityEnvironmentalModule from './global/audit_higg_fem_higg_facility_environmental_module/index.js'
import * as auditHiggFslmHiggFacilitySocialLaborModule from './global/audit_higg_fslm_higg_facility_social_labor_module/index.js'
import * as auditIcs from './global/audit_ics/index.js'
import * as auditIctiEthicalToyProgram from './global/audit_icti_ethical_toy_program/index.js'
import * as auditImpactProgram from './global/audit_impact_program/index.js'
import * as auditIso_26000 from './global/audit_iso_26000/index.js'
import * as auditKeh8dtw175b from './global/audit_keh8dtw175b/index.js'
import * as auditOcsAudit from './global/audit_ocs_audit/index.js'
import * as auditOekoTex from './global/audit_oeko_tex/index.js'
import * as auditOhsas_18001 from './global/audit_ohsas_18001/index.js'
import * as auditQz1m274j4ym from './global/audit_qz1m274j4ym/index.js'
import * as auditSa8000 from './global/audit_sa8000/index.js'
import * as auditSedexSmeta from './global/audit_sedex_smeta/index.js'
import * as auditSfpSustainableFibreProgramme from './global/audit_sfp_sustainable_fibre_programme/index.js'
import * as auditSlcpConvergedAssessmentFramework from './global/audit_slcp_converged_assessment_framework/index.js'
import * as auditSustainableTextileSolutions from './global/audit_sustainable_textile_solutions/index.js'
import * as auditWfkr7fwt9tw from './global/audit_wfkr7fwt9tw/index.js'
import * as auditWrap from './global/audit_wrap/index.js'
import * as bangladeshAreTheWorkers from './relational/bangladesh_are_the_workers/index.js'
import * as bangladeshDoAllWrkrsOtherThanApprenticesSubstitutebadli from './relational/bangladesh_do_all_wrkrs_other_than_apprentices_substitutebadli/index.js'
import * as bangladeshDoesFacComplyLegalReqEnsureAgainst from './relational/bangladesh_does_fac_comply_legal_req_ensure_against/index.js'
import * as bangladeshDoesFacilityHaveLegallyRequiredLicenseStorage from './relational/bangladesh_does_facility_have_legally_required_license_storage/index.js'
import * as bangladeshDoesFacilityHaveLegallyRequiredQualifiedWelfare from './relational/bangladesh_does_facility_have_legally_required_qualified_welfare/index.js'
import * as bangladeshDoesTheFacHaveLegallyRequiredQualifiedWelfare from './relational/bangladesh_does_the_fac_have_legally_required_qualified_welfare/index.js'
import * as bangladeshDoesTheFacHaveTheLegallyRequiredLicenseForS from './relational/bangladesh_does_the_fac_have_the_legally_required_license_for_s/index.js'
import * as bangladeshHasFacilityEstablishedWorkers from './relational/bangladesh_has_facility_established_workers/index.js'
import * as batteryChargingAreasElectricForkliftTrucksAreClose from './relational/battery_charging_areas_electric_forklift_trucks_are_close/index.js'
import * as benefitsNotMaintained from './relational/benefits_not_maintained/index.js'
import * as betterCottonInitiativeBci from './relational/better_cotton_initiative_bci/index.js'
import * as bipartiteCommCommunicatesWkrsUpper from './relational/bipartite_comm_communicates_wkrs_upper/index.js'
import * as bipartiteCommitteeMeetingActionItemsAreTracked from './relational/bipartite_committee_meeting_action_items_are_tracked/index.js'
import * as bipartiteCommitteeMeetingMinutesAreSharedWorkforce from './relational/bipartite_committee_meeting_minutes_are_shared_workforce/index.js'
import * as bipartiteCommitteeMeetingsAreHeldLeastQuarterly from './relational/bipartite_committee_meetings_are_held_least_quarterly/index.js'
import * as bipartiteCommitteeMeetingsAreHeldOnMonthlyBasis from './relational/bipartite_committee_meetings_are_held_on_monthly_basis/index.js'
import * as blendingFormulating from './relational/blending_formulating/index.js'
import * as briberyAndAntiCorruption from './relational/bribery_and_anti_corruption/index.js'
import * as bsciBusinessSocialComplianceInitiative from './relational/bsci_business_social_compliance_initiative/index.js'
import * as buildingIsSharedWOtherFacilitiesenterprises from './relational/building_is_shared_w_other_facilitiesenterprises/index.js'
import * as cambodiaAttendanceBonusCasualWorkers from './relational/cambodia_attendance_bonus_casual_workers/index.js'
import * as cambodiaAttendanceBonusDuringLeave from './relational/cambodia_attendance_bonus_during_leave/index.js'
import * as cambodiaAttendanceBonusNewWorkers from './relational/cambodia_attendance_bonus_new_workers/index.js'
import * as cambodiaDoesFacIncludeEntirePeriodContinuousEmployment from './relational/cambodia_does_fac_include_entire_period_continuous_employment/index.js'
import * as cambodiaIsThePieceRateSetAtALevelThatPermitsWrkrsOf from './relational/cambodia_is_the_piece_rate_set_at_a_level_that_permits_wrkrs_of/index.js'
import * as cambodiaSeniorityIndemnityUdcWkrs from './relational/cambodia_seniority_indemnity_udc_wkrs/index.js'
import * as cambodiaTransportHomePlaceSleepWorkersWhoFinish from './relational/cambodia_transport_home_place_sleep_workers_who_finish/index.js'
import * as cambodiaWageSupplementsHousingAllowances from './relational/cambodia_wage_supplements_housing_allowances/index.js'
import * as cambodiaWhichOfTheFollowingOtherWagePaymentsWereNotIn from './relational/cambodia_which_of_the_following_other_wage_payments_were_not_in/index.js'
import * as canApprenticesTraineesInternsAPositionInTheFacThatIs from './relational/can_apprentices_trainees_interns_a_position_in_the_fac_that_is/index.js'
import * as canChangeCoreInformation from './transactional/can_change_core_information/index.js'
import * as canReadProductStory from './transactional/can_read_product_story/index.js'
import * as canteenEatingAreasAreNotProtectedFromElements from './relational/canteen_eating_areas_are_not_protected_from_elements/index.js'
import * as canteenEatingAreasAreNotSeparateFromProduction from './relational/canteen_eating_areas_are_not_separate_from_production/index.js'
import * as canteens from './relational/canteens/index.js'
import * as canTheTradeUnionsFreelyFormAndJoinFederationsAndConfe from './relational/can_the_trade_unions_freely_form_and_join_federations_and_confe/index.js'
import * as canWrkrsWhoOweDebtsToTheFacAndorAThirdPartyFreelyL from './relational/can_wrkrs_who_owe_debts_to_the_fac_andor_a_third_party_freely_l/index.js'
import * as capacityChildcareFacilityNotSufficientCoverNeedWorkers from './relational/capacity_childcare_facility_not_sufficient_cover_need_workers/index.js'
import * as carbonIntensityScope from './relational/carbon_intensity_scope/index.js'
import * as cardStoredValue from './relational/card_stored_value/index.js'
import * as cash from './relational/cash/index.js'
import * as casting_1 from './relational/casting_1/index.js'
import * as casting_2 from './relational/casting_2/index.js'
import * as chainCustodyStandardCcs from './relational/chain_custody_standard_ccs/index.js'
import * as check from './relational/check/index.js'
import * as chemical from './relational/chemical/index.js'
import * as chemicalsDisposedWasteBinContainersWhichAreGenerally from './relational/chemicals_disposed_waste_bin_containers_which_are_generally/index.js'
import * as chemicalsHazardousSubstances from './relational/chemicals_hazardous_substances/index.js'
import * as chemicalStorageAreasDoNotHaveChemicalSpill from './relational/chemical_storage_areas_do_not_have_chemical_spill/index.js'
import * as chemicalSynthesis from './relational/chemical_synthesis/index.js'
import * as childcare from './relational/childcare/index.js'
import * as childCare from './relational/child_care/index.js'
import * as childcareFacilitiesAreNotKeptCleanSafeHygienic from './relational/childcare_facilities_are_not_kept_clean_safe_hygienic/index.js'
import * as childcareFacilitiesAreNotOnGroundFloor from './relational/childcare_facilities_are_not_on_ground_floor/index.js'
import * as childcareFacNotProvidedAdequateSuppliesInfrastructure from './relational/childcare_fac_not_provided_adequate_supplies_infrastructure/index.js'
import * as childcareStaffDoNotGoThroughAppropriatePre from './relational/childcare_staff_do_not_go_through_appropriate_pre/index.js'
import * as childLaborYoungWorkers from './relational/child_labor_young_workers/index.js'
import * as city from './global/city/index.js'
import * as coating from './relational/coating/index.js'
import * as collaborationEndDate from './transactional/collaboration_end_date/index.js'
import * as collaborationStartDate from './transactional/collaboration_start_date/index.js'
import * as collaborationStatus from './transactional/collaboration_status/index.js'
import * as commercialRegistrationNumber from './global/commercial_registration_number/index.js'
import * as commuteServiceProvidedOrganizedFacility from './relational/commute_service_provided_organized_facility/index.js'
import * as companyLeverage from './transactional/company_leverage/index.js'
import * as companySize from './relational/company_size/index.js'
import * as complaintsGrievancesAreNotSettledDirectlyBetweenWorker from './relational/complaints_grievances_are_not_settled_directly_between_worker/index.js'
import * as complaintsGrievancesNotAdditionalStakeholders from './relational/complaints_grievances_not_additional_stakeholders/index.js'
import * as compressedGasCylindersAreNotStoredAwayFrom from './relational/compressed_gas_cylinders_are_not_stored_away_from/index.js'
import * as compressedGasCylindersAreNotStoredEnclosedCage from './relational/compressed_gas_cylinders_are_not_stored_enclosed_cage/index.js'
import * as connectionType from './transactional/connection_type/index.js'
import * as contactPersonEmail from './transactional/contact_person_email/index.js'
import * as contractsDoNotClearlyAccuratelyStateTermsConditions from './relational/contracts_do_not_clearly_accurately_state_terms_conditions/index.js'
import * as contractWorkersWorkersEmployedThirdPartyWhoAre from './relational/contract_workers_workers_employed_third_party_who_are/index.js'
import * as convertingRawMaterialIncomingPaperboardPlasticResin from './relational/converting_raw_material_incoming_paperboard_plastic_resin/index.js'
import * as copiesContractsAreNotProvidedWorkersLineApplicable from './relational/copies_contracts_are_not_provided_workers_line_applicable/index.js'
import * as copiesTermsConditionsDocumentsAreNotProvidedWorkers from './relational/copies_terms_conditions_documents_are_not_provided_workers/index.js'
import * as country from './global/country/index.js'
import * as countryName from './global/country_name/index.js'
import * as county from './global/county/index.js'
import * as cutting_1 from './relational/cutting_1/index.js'
import * as cutting_2 from './relational/cutting_2/index.js'
import * as deductionsAreNotVoluntarilyAcceptedWorkers from './relational/deductions_are_not_voluntarily_accepted_workers/index.js'
import * as deductionsWagesAreNotExplainedWorkers from './relational/deductions_wages_are_not_explained_workers/index.js'
import * as describeAccommodationsArrangementsMade from './relational/describe_accommodations_arrangements_made/index.js'
import * as describeAnyOtherTypesOfBuildings from './relational/describe_any_other_types_of_buildings/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_1 from './relational/describe_concerns_difficulties_questions_listed_this_section_1/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_2 from './relational/describe_concerns_difficulties_questions_listed_this_section_2/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_3 from './relational/describe_concerns_difficulties_questions_listed_this_section_3/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_4 from './relational/describe_concerns_difficulties_questions_listed_this_section_4/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_5 from './relational/describe_concerns_difficulties_questions_listed_this_section_5/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_6 from './relational/describe_concerns_difficulties_questions_listed_this_section_6/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_7 from './relational/describe_concerns_difficulties_questions_listed_this_section_7/index.js'
import * as describeConcernsDifficultiesQuestionsListedThisSection_8 from './relational/describe_concerns_difficulties_questions_listed_this_section_8/index.js'
import * as describeHoursWorkedViolationLegalLimitsTypeWork from './relational/describe_hours_worked_violation_legal_limits_type_work/index.js'
import * as describeHowMonthlyCapacityCalculatedEGDo from './relational/describe_how_monthly_capacity_calculated_e_g_do/index.js'
import * as describeOffSiteDormitoriesVisited from './relational/describe_off_site_dormitories_visited/index.js'
import * as describeOnsiteDormitoriesVisited from './relational/describe_onsite_dormitories_visited/index.js'
import * as describeOtherGroundSIdentifiedFactoredIntoHiring from './relational/describe_other_ground_s_identified_factored_into_hiring/index.js'
import * as describeOtherReferencesApplicationsForms from './relational/describe_other_references_applications_forms/index.js'
import * as describeTheMostRepresentativeDepartmentWinTheFac from './relational/describe_the_most_representative_department_win_the_fac/index.js'
import * as describeTheseInformalProcedures from './relational/describe_these_informal_procedures/index.js'
import * as describeTypesFirefightingEquipmentUsedWhichAreasFacility from './relational/describe_types_firefighting_equipment_used_which_areas_facility/index.js'
import * as describeTypeWorkHoursWorkedNightBothFemale from './relational/describe_type_work_hours_worked_night_both_female/index.js'
import * as describeWhichLanguagesAreNotAvailableGrievanceHandling from './relational/describe_which_languages_are_not_available_grievance_handling/index.js'
import * as description from './relational/description/index.js'
import * as didAnyOfTheFollowingOccurDuringOrAfterIndustrialActio from './relational/did_any_of_the_following_occur_during_or_after_industrial_actio/index.js'
import * as didAnyWrkrsWorkMoreThan_60HoursInTotalRegularOvertime from './relational/did_any_wrkrs_work_more_than_60_hours_in_total_regular_overtime/index.js'
import * as didAnyWrkrsWorkMoreThan_72HoursInTotalRegularOvertime from './relational/did_any_wrkrs_work_more_than_72_hours_in_total_regular_overtime/index.js'
import * as didAnyWrkrsWorkMoreThan_80HoursInTotalRegularOvertime from './relational/did_any_wrkrs_work_more_than_80_hours_in_total_regular_overtime/index.js'
import * as didAnyWrkrsWorkMoreThan_90HoursInTotalRegularOvertime from './relational/did_any_wrkrs_work_more_than_90_hours_in_total_regular_overtime/index.js'
import * as didAssessmentTakePlaceConsecutivelly from './relational/did_assessment_take_place_consecutivelly/index.js'
import * as didFacilityExperienceExceptionalCircumstancesIELarge from './relational/did_facility_experience_exceptional_circumstances_i_e_large/index.js'
import * as didFacilityHaveOtherWageDeductionsBesidesLegally from './relational/did_facility_have_other_wage_deductions_besides_legally/index.js'
import * as didTheFacActivelySeekToProvOrAttainAnyOfTheFollowin from './relational/did_the_fac_actively_seek_to_prov_or_attain_any_of_the_followin/index.js'
import * as didTheFacCommIncludeAnyOfTheFollowingSelectAllThatA from './relational/did_the_fac_comm_include_any_of_the_following_select_all_that_a/index.js'
import * as didTheFacComplyWLegalReqsToInformAndorGetPermission from './relational/did_the_fac_comply_w_legal_reqs_to_inform_andor_get_permission/index.js'
import * as didTheFacConsultWWorkerRepresentativesAndorTradeUnion from './relational/did_the_fac_consult_w_worker_representatives_andor_trade_union/index.js'
import * as didTheFacExperienceExceptionalCircumstancesIeLargeLate from './relational/did_the_fac_experience_exceptional_circumstances_ie_large_late/index.js'
import * as didTheFacHaveAnyOtherWageDeductionsBesidesLegallyRequ from './relational/did_the_fac_have_any_other_wage_deductions_besides_legally_requ/index.js'
import * as didTheFacMaintainWasteDisposalRecsIncludingDocumentatio from './relational/did_the_fac_maintain_waste_disposal_recs_including_documentatio/index.js'
import * as didTheFacParticipateInAnyOfTheFollowingActivitiesRela from './relational/did_the_fac_participate_in_any_of_the_following_activities_rela/index.js'
import * as didTheFacParticipateInAnyOfTheFollowingActivitiesRela_1 from './relational/did_the_fac_participate_in_any_of_the_following_activities_rela_1/index.js'
import * as didTheFacParticipateInAnyOfTheFollowingActivitiesRela_2 from './relational/did_the_fac_participate_in_any_of_the_following_activities_rela_2/index.js'
import * as didTheFacParticipateInAnyOfTheFollowingActivitiesRela_3 from './relational/did_the_fac_participate_in_any_of_the_following_activities_rela_3/index.js'
import * as didTheFacParticipateInAnyTypeOfEconomicEmpowermentPro from './relational/did_the_fac_participate_in_any_type_of_economic_empowerment_pro/index.js'
import * as didWorkersWorkMoreThan_60HoursTotal from './relational/did_workers_work_more_than_60_hours_total/index.js'
import * as didWorkersWorkMoreThan_72HoursTotal from './relational/did_workers_work_more_than_72_hours_total/index.js'
import * as didWorkersWorkMoreThan_80HoursTotal from './relational/did_workers_work_more_than_80_hours_total/index.js'
import * as didWorkersWorkMoreThan_90HoursTotal from './relational/did_workers_work_more_than_90_hours_total/index.js'
import * as dieCutting from './relational/die_cutting/index.js'
import * as dieCuttingEGCartons from './relational/die_cutting_e_g_cartons/index.js'
import * as directDepositIntoBankAccount from './relational/direct_deposit_into_bank_account/index.js'
import * as disability_1 from './relational/disability_1/index.js'
import * as disability_2 from './relational/disability_2/index.js'
import * as disability_3 from './relational/disability_3/index.js'
import * as disabilityReferencedNotLineLegalRequirements from './relational/disability_referenced_not_line_legal_requirements/index.js'
import * as discipline from './relational/discipline/index.js'
import * as discrimination_1 from './relational/discrimination_1/index.js'
import * as discrimination_2 from './relational/discrimination_2/index.js'
import * as displayName from './relational/display_name/index.js'
import * as doAllPersonsWhoPerformWorkForTheFacBothOnThePremise from './relational/do_all_persons_who_perform_work_for_the_fac_both_on_the_premise/index.js'
import * as doAnyOccupationalSafetyAndHealthMeasuresIncludingCollec from './relational/do_any_occupational_safety_and_health_measures_including_collec/index.js'
import * as doApprovedBuildingPlansReflectTheCurrentBuildingsStruct from './relational/do_approved_building_plans_reflect_the_current_buildings_struct/index.js'
import * as doesAnyWorkerOweDebtsToTheFacAndorAThirdParty from './relational/does_any_worker_owe_debts_to_the_fac_andor_a_third_party/index.js'
import * as doesFacComplyLegalRestrictionsRegardingPaymentInstead from './relational/does_fac_comply_legal_restrictions_regarding_payment_instead/index.js'
import * as doesFacContinuouslyMonitorMaintainSpecificRegulatedIndoor from './relational/does_fac_continuously_monitor_maintain_specific_regulated_indoor/index.js'
import * as doesFacilityChargeKindBenefitsBelowCost from './relational/does_facility_charge_kind_benefits_below_cost/index.js'
import * as doesFacilityComplyOccupationalSafetyHealthRelatedLegal from './relational/does_facility_comply_occupational_safety_health_related_legal/index.js'
import * as doesFacilityConsultWorkersNotifyThemAdvanceAbout from './relational/does_facility_consult_workers_notify_them_advance_about/index.js'
import * as doesFacilityConsultWorkersProvideMinimumNoticePeriod from './relational/does_facility_consult_workers_provide_minimum_notice_period/index.js'
import * as doesFacilityHaveConfinedSpacesThatLegallyRequire from './relational/does_facility_have_confined_spaces_that_legally_require/index.js'
import * as doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_1 from './relational/does_facility_have_emergency_alarm_system_types_emergencies_1/index.js'
import * as doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_2 from './relational/does_facility_have_emergency_alarm_system_types_emergencies_2/index.js'
import * as doesFacilityHaveFireDetectionAlarmSystemLine from './relational/does_facility_have_fire_detection_alarm_system_line/index.js'
import * as doesFacilityHaveFireDetectionAlarmSystemPlace from './relational/does_facility_have_fire_detection_alarm_system_place/index.js'
import * as doesFacilityHaveLegallyRequiredFirefightingEquipment from './relational/does_facility_have_legally_required_firefighting_equipment/index.js'
import * as doesFacilityHaveLegallyRequiredUpDatePermits from './relational/does_facility_have_legally_required_up_date_permits/index.js'
import * as doesFacilityHaveMechanismPlaceProtectWorkers from './relational/does_facility_have_mechanism_place_protect_workers/index.js'
import * as doesFacilityHaveOccupationalSafetyHealthOshCommittee from './relational/does_facility_have_occupational_safety_health_osh_committee/index.js'
import * as doesFacilityHaveWorkAreasRiskHeatCold from './relational/does_facility_have_work_areas_risk_heat_cold/index.js'
import * as doesFacilityHaveWrittenPlanHandlingOutbreaksContagious from './relational/does_facility_have_written_plan_handling_outbreaks_contagious/index.js'
import * as doesFacilityHireDisabledPersonsLineLegalRequirements from './relational/does_facility_hire_disabled_persons_line_legal_requirements/index.js'
import * as doesFacilityIncludePeriodsMaternityLeaveWorkers from './relational/does_facility_include_periods_maternity_leave_workers/index.js'
import * as doesFacilityIncludeSandblastingItsProcesses from './relational/does_facility_include_sandblasting_its_processes/index.js'
import * as doesFacilityLimitUseFixedTermContracts from './relational/does_facility_limit_use_fixed_term_contracts/index.js'
import * as doesFacilityLoanAdvanceMoneyWorkers from './relational/does_facility_loan_advance_money_workers/index.js'
import * as doesFacilityMonitorIndoorAirQualityLineLegal from './relational/does_facility_monitor_indoor_air_quality_line_legal/index.js'
import * as doesFacilityOnlyRequireWorkersTakePaidUnpaid from './relational/does_facility_only_require_workers_take_paid_unpaid/index.js'
import * as doesFacilityPayWorkersCorrectlyDuringWorkStoppages from './relational/does_facility_pay_workers_correctly_during_work_stoppages/index.js'
import * as doesFacilityPerformType from './relational/does_facility_perform_type/index.js'
import * as doesFacilityProvideBreaksDuringWorkdayLineLegal from './relational/does_facility_provide_breaks_during_workday_line_legal/index.js'
import * as doesFacilityProvideKindBenefitsLineLegalRequirements from './relational/does_facility_provide_kind_benefits_line_legal_requirements/index.js'
import * as doesFacilityProvideTimeOffBreastfeedingLineLegal from './relational/does_facility_provide_time_off_breastfeeding_line_legal/index.js'
import * as doesFacilityProvideWorkersCompensatoryTimeOffLine from './relational/does_facility_provide_workers_compensatory_time_off_line/index.js'
import * as doesFacilityProvideWorkersFreePotableDrinkingWater from './relational/does_facility_provide_workers_free_potable_drinking_water/index.js'
import * as doesFacilityProvideWorkersPotableDrinkingWaterLine from './relational/does_facility_provide_workers_potable_drinking_water_line/index.js'
import * as doesFacilityRecruitingAgencyProvideForeignMigrantsSigned from './relational/does_facility_recruiting_agency_provide_foreign_migrants_signed/index.js'
import * as doesFacilityRegularlyTestServiceFireExtinguishersOther from './relational/does_facility_regularly_test_service_fire_extinguishers_other/index.js'
import * as doesFacilityRequireHivAidsTestsDuringEmployment from './relational/does_facility_require_hiv_aids_tests_during_employment/index.js'
import * as doesFacilityRequireHivAidsTestsDuringHiring from './relational/does_facility_require_hiv_aids_tests_during_hiring/index.js'
import * as doesFacilityRequireOtherInfectionIllnessTestsE_1 from './relational/does_facility_require_other_infection_illness_tests_e_1/index.js'
import * as doesFacilityRequireOtherInfectionIllnessTestsE_2 from './relational/does_facility_require_other_infection_illness_tests_e_2/index.js'
import * as doesFacilityTakeDeductionsFromWagesThatAre from './relational/does_facility_take_deductions_from_wages_that_are/index.js'
import * as doesFacilityTestNoiseExposureLevelsLineLegal from './relational/does_facility_test_noise_exposure_levels_line_legal/index.js'
import * as doesFacilityUseFixedTermContracts from './relational/does_facility_use_fixed_term_contracts/index.js'
import * as doesFacMgmtRegularlyMeetWTradeUnionsToProactivelyAddr from './relational/does_fac_mgmt_regularly_meet_w_trade_unions_to_proactively_addr/index.js'
import * as doesFacRegisterTheirWkrsSocialSecurityInstitutions from './relational/does_fac_register_their_wkrs_social_security_institutions/index.js'
import * as doesTheEmployerAllowWrkrsToCarryOutTradeUnionActiviti from './relational/does_the_employer_allow_wrkrs_to_carry_out_trade_union_activiti/index.js'
import * as doesTheEmployerUseAnyOtherCoerciveTacticsToForceWrkrs from './relational/does_the_employer_use_any_other_coercive_tactics_to_force_wrkrs/index.js'
import * as doesTheFacArrangeHealthChecksForAllWrkrsUndTheAge from './relational/does_the_fac_arrange_health_checks_for_all_wrkrs_und_the_age/index.js'
import * as doesTheFacCalculateRegularHoursAsAnAverage from './relational/does_the_fac_calculate_regular_hours_as_an_average/index.js'
import * as doesTheFacChargeForInkindBenefitsAtOrBelowCost from './relational/does_the_fac_charge_for_inkind_benefits_at_or_below_cost/index.js'
import * as doesTheFacCommunicateImprovementPlansToInterestedStakeh from './relational/does_the_fac_communicate_improvement_plans_to_interested_stakeh/index.js'
import * as doesTheFacCommunicatePubliclyOnSocialAndLaborPerforman from './relational/does_the_fac_communicate_publicly_on_social_and_labor_performan/index.js'
import * as doesTheFacComplyWApplicableLegalReqsConcerningHomewrkr from './relational/does_the_fac_comply_w_applicable_legal_reqs_concerning_homewrkr/index.js'
import * as doesTheFacComplyWLegalReqsRegardingHealthChecksForWr from './relational/does_the_fac_comply_w_legal_reqs_regarding_health_checks_for_wr/index.js'
import * as doesTheFacComplyWLegalReqsRegardingMedicalChecksForW from './relational/does_the_fac_comply_w_legal_reqs_regarding_medical_checks_for_w/index.js'
import * as doesTheFacComplyWLegalReqsRegardingQualifiedOshStaff from './relational/does_the_fac_comply_w_legal_reqs_regarding_qualified_osh_staff/index.js'
import * as doesTheFacComplyWLegalRestrRegardingPaymentInsteadOf from './relational/does_the_fac_comply_w_legal_restr_regarding_payment_instead_of/index.js'
import * as doesTheFacComplyWOccupationalSafetyAndHealthrelatedLeg from './relational/does_the_fac_comply_w_occupational_safety_and_healthrelated_leg/index.js'
import * as doesTheFacConductMaintenanceOnElectricalEquipmentWElec from './relational/does_the_fac_conduct_maintenance_on_electrical_equipment_w_elec/index.js'
import * as doesTheFacConductRegularEmergencyDrillsForAllWrkrsAnd from './relational/does_the_fac_conduct_regular_emergency_drills_for_all_wrkrs_and/index.js'
import * as doesTheFacConductRegularReviewsAndorAssessmentsOfSocia from './relational/does_the_fac_conduct_regular_reviews_andor_assessments_of_socia/index.js'
import * as doesTheFacConductWorkerPerformanceEvaluationsBasedOnA from './relational/does_the_fac_conduct_worker_performance_evaluations_based_on_a/index.js'
import * as doesTheFacConsultWWrkrsAndorProvAMinimumNoticePeriod from './relational/does_the_fac_consult_w_wrkrs_andor_prov_a_minimum_notice_period/index.js'
import * as doesTheFacCreateImprovementPlansBasedOnSocialAndLabor from './relational/does_the_fac_create_improvement_plans_based_on_social_and_labor/index.js'
import * as doesTheFacDeductTradeUnionDuesFromWagesInLineWLegal from './relational/does_the_fac_deduct_trade_union_dues_from_wages_in_line_w_legal/index.js'
import * as doesTheFacEmployOrContractServicesForSecurityPersonnel from './relational/does_the_fac_employ_or_contract_services_for_security_personnel/index.js'
import * as doesTheFacEngageProactivelyWRelevantStakeholdersBefore from './relational/does_the_fac_engage_proactively_w_relevant_stakeholders_before/index.js'
import * as doesTheFacEvaluateExposureToConcentrationsOfAirbornePa from './relational/does_the_fac_evaluate_exposure_to_concentrations_of_airborne_pa/index.js'
import * as doesTheFacEvaluateWorkerExposureToChemicalsAndHazardou from './relational/does_the_fac_evaluate_worker_exposure_to_chemicals_and_hazardou/index.js'
import * as doesTheFacFailToCollectAndForwardWrkrsContributionsTo from './relational/does_the_fac_fail_to_collect_and_forward_wrkrs_contributions_to/index.js'
import * as doesTheFacFollowAllLegalReqsOnProvisionAndMaintenance from './relational/does_the_fac_follow_all_legal_reqs_on_provision_and_maintenance/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesConcerningP from './relational/does_the_fac_follow_any_of_the_following_practices_concerning_p/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRegardingWo from './relational/does_the_fac_follow_any_of_the_following_practices_regarding_wo/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRelatedToC from './relational/does_the_fac_follow_any_of_the_following_practices_related_to_c/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRelatedToM from './relational/does_the_fac_follow_any_of_the_following_practices_related_to_m/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRelatedToO from './relational/does_the_fac_follow_any_of_the_following_practices_related_to_o/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW from './relational/does_the_fac_follow_any_of_the_following_practices_related_to_w/index.js'
import * as doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW_1 from './relational/does_the_fac_follow_any_of_the_following_practices_related_to_w_1/index.js'
import * as doesTheFacGenerateAirborneParticulatesDustFibersMistsF from './relational/does_the_fac_generate_airborne_particulates_dust_fibers_mists_f/index.js'
import * as doesTheFacHaveAClimateAdaptationActionPlan from './relational/does_the_fac_have_a_climate_adaptation_action_plan/index.js'
import * as doesTheFacHaveACurrentContractWAnAuthorizedAgencyTo from './relational/does_the_fac_have_a_current_contract_w_an_authorized_agency_to/index.js'
import * as doesTheFacHaveAFireDetectionAndAlarmSystemInPlace from './relational/does_the_fac_have_a_fire_detection_and_alarm_system_in_place/index.js'
import * as doesTheFacHaveAFormalizedProcessOfReviewingDocumentati from './relational/does_the_fac_have_a_formalized_process_of_reviewing_documentati/index.js'
import * as doesTheFacHaveALegallyRequiredFireBrigadeemergencyResp from './relational/does_the_fac_have_a_legally_required_fire_brigadeemergency_resp/index.js'
import * as doesTheFacHaveAnEstablishedAccidentInvestigationProcedu from './relational/does_the_fac_have_an_established_accident_investigation_procedu/index.js'
import * as doesTheFacHaveAnOccupationalSafetyAndHealthOshCommitt from './relational/does_the_fac_have_an_occupational_safety_and_health_osh_committ/index.js'
import * as doesTheFacHaveAnyAdditionalSafetyMeasuresInPlaceRelat from './relational/does_the_fac_have_any_additional_safety_measures_in_place_relat/index.js'
import * as doesTheFacHaveAnyOfTheFollowingAdditionalSafetyMeasur from './relational/does_the_fac_have_any_of_the_following_additional_safety_measur/index.js'
import * as doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRegard from './relational/does_the_fac_have_any_of_the_following_measures_in_place_regard/index.js'
import * as doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate from './relational/does_the_fac_have_any_of_the_following_measures_in_place_relate/index.js'
import * as doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_1 from './relational/does_the_fac_have_any_of_the_following_measures_in_place_relate_1/index.js'
import * as doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_2 from './relational/does_the_fac_have_any_of_the_following_measures_in_place_relate_2/index.js'
import * as doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceToThe from './relational/does_the_fac_have_any_of_the_following_measures_in_place_to_the/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_1 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_1/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_10 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_10/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_11 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_11/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_12 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_12/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_13 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_13/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_14 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_14/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_15 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_15/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_16 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_16/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_17 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_17/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_18 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_18/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_2 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_2/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_3 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_3/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_4 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_4/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_5 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_5/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_6 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_6/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_7 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_7/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_8 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_8/index.js'
import * as doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_9 from './relational/does_the_fac_have_any_of_the_following_safety_measures_in_place_9/index.js'
import * as doesTheFacHaveAnyOfTheseAdditionalMeasuresInPlaceRel from './relational/does_the_fac_have_any_of_these_additional_measures_in_place_rel/index.js'
import * as doesTheFacHaveAnyWorkAreasWRiskOfHeatOrColdStress from './relational/does_the_fac_have_any_work_areas_w_risk_of_heat_or_cold_stress/index.js'
import * as doesTheFacHaveASufficientNumOfToiletsForTheNumOfWr from './relational/does_the_fac_have_a_sufficient_num_of_toilets_for_the_num_of_wr/index.js'
import * as doesTheFacHaveASystemForReviewingPoliciesAndProcedure from './relational/does_the_fac_have_a_system_for_reviewing_policies_and_procedure/index.js'
import * as doesTheFacHaveAWhistleblowerSystemInPlace from './relational/does_the_fac_have_a_whistleblower_system_in_place/index.js'
import * as doesTheFacHaveAWrittenChartShowingTheIndividualsRespo from './relational/does_the_fac_have_a_written_chart_showing_the_individuals_respo/index.js'
import * as doesTheFacHaveAWrittenEmergencyResponsePlan from './relational/does_the_fac_have_a_written_emergency_response_plan/index.js'
import * as doesTheFacHaveAWrittenStrategyGoalsDocumentsForSocial from './relational/does_the_fac_have_a_written_strategy_goals_documents_for_social/index.js'
import * as doesTheFacHaveConfinedSpaces from './relational/does_the_fac_have_confined_spaces/index.js'
import * as doesTheFacHaveElevatorsLifts from './relational/does_the_fac_have_elevators_lifts/index.js'
import * as doesTheFacHaveErgonomicMeasuresInPlaceThatConsiderThe from './relational/does_the_fac_have_ergonomic_measures_in_place_that_consider_the/index.js'
import * as doesTheFacHaveEstablishedGrievanceHandlingAndDisputeRe from './relational/does_the_fac_have_established_grievance_handling_and_dispute_re/index.js'
import * as doesTheFacHaveForkliftsOrOtherTypesOfLiftingEquipment from './relational/does_the_fac_have_forklifts_or_other_types_of_lifting_equipment/index.js'
import * as doesTheFacHaveIAnEstablishedUnionOnsiteAndorIiWrkrs from './relational/does_the_fac_have_i_an_established_union_onsite_andor_ii_wrkrs/index.js'
import * as doesTheFacHaveLegallyRequiredAndUpToDatePermitsCerti from './relational/does_the_fac_have_legally_required_and_up_to_date_permits_certi/index.js'
import * as doesTheFacHaveLegallyRequiredFirefightingEquipment from './relational/does_the_fac_have_legally_required_firefighting_equipment/index.js'
import * as doesTheFacHaveLegallyRequiredPostedEvacuationPlansMark from './relational/does_the_fac_have_legally_required_posted_evacuation_plans_mark/index.js'
import * as doesTheFacHaveSafetyMeasuresInPlaceRegardingAsbestosS from './relational/does_the_fac_have_safety_measures_in_place_regarding_asbestos_s/index.js'
import * as doesTheFacHaveSafetyMeasuresInPlaceRegardingOnsiteVeh from './relational/does_the_fac_have_safety_measures_in_place_regarding_onsite_veh/index.js'
import * as doesTheFacHaveWrittenPoliciesAndorFormalProceduresFor from './relational/does_the_fac_have_written_policies_andor_formal_procedures_for/index.js'
import * as doesTheFacHaveWrittenProceduresForClassificationCollect from './relational/does_the_fac_have_written_procedures_for_classification_collect/index.js'
import * as doesTheFacHireDisabledPersonsInLineWLegalReqs from './relational/does_the_fac_hire_disabled_persons_in_line_w_legal_reqs/index.js'
import * as doesTheFacIncludeAllPeriodsOfMaternityLeaveInTheWrkr from './relational/does_the_fac_include_all_periods_of_maternity_leave_in_the_wrkr/index.js'
import * as doesTheFacInformAllWrkrsAboutCbasAndProvCopiesInLin from './relational/does_the_fac_inform_all_wrkrs_about_cbas_and_prov_copies_in_lin/index.js'
import * as doesTheFacKeepAllWorkerHealthInfoConfidential from './relational/does_the_fac_keep_all_worker_health_info_confidential/index.js'
import * as doesTheFacLimitTheUseOfFixedtermContracts from './relational/does_the_fac_limit_the_use_of_fixedterm_contracts/index.js'
import * as doesTheFacLoanAndorAdvanceMoneyToWrkrs from './relational/does_the_fac_loan_andor_advance_money_to_wrkrs/index.js'
import * as doesTheFacMaintainAListregisterOfWrkrsUndAge_18InLin from './relational/does_the_fac_maintain_a_listregister_of_wrkrs_und_age_18_in_lin/index.js'
import * as doesTheFacMaintainAnInventoryOfAllChemicalsAndHazardo from './relational/does_the_fac_maintain_an_inventory_of_all_chemicals_and_hazardo/index.js'
import * as doesTheFacMaintainAValidLaborInspectionVisitBookRecor from './relational/does_the_fac_maintain_a_valid_labor_inspection_visit_book_recor/index.js'
import * as doesTheFacMaintainJobDescsForAllPositionsWinTheFac from './relational/does_the_fac_maintain_job_descs_for_all_positions_win_the_fac/index.js'
import * as doesTheFacMaintainOnlyOneAccuratePayrollRecord from './relational/does_the_fac_maintain_only_one_accurate_payroll_record/index.js'
import * as doesTheFacMaintainOnlyOneAccurateSetOfWorkingHourRec from './relational/does_the_fac_maintain_only_one_accurate_set_of_working_hour_rec/index.js'
import * as doesTheFacMaintainParentalPermissionOfWrkrsUndTheAge from './relational/does_the_fac_maintain_parental_permission_of_wrkrs_und_the_age/index.js'
import * as doesTheFacMaintainRecordedParentalPermissionForWrkrsUn from './relational/does_the_fac_maintain_recorded_parental_permission_for_wrkrs_un/index.js'
import * as doesTheFacMaintainRecsOfElectricalEquipmentMaintenance from './relational/does_the_fac_maintain_recs_of_electrical_equipment_maintenance/index.js'
import * as doesTheFacMonitorIndoorAirQualityInLineWLegalReqs from './relational/does_the_fac_monitor_indoor_air_quality_in_line_w_legal_reqs/index.js'
import * as doesTheFacMonitorTheWorkingHoursOfAllWrkrsUndTheAge from './relational/does_the_fac_monitor_the_working_hours_of_all_wrkrs_und_the_age/index.js'
import * as doesTheFacNeedToReleaseWrkrsToBeAvailableForGovernme from './relational/does_the_fac_need_to_release_wrkrs_to_be_available_for_governme/index.js'
import * as doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo from './relational/does_the_fac_observe_any_of_the_following_practices_related_to/index.js'
import * as doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo_1 from './relational/does_the_fac_observe_any_of_the_following_practices_related_to_1/index.js'
import * as doesTheFacOfferFemaleWrkrsInTheSupplyChainIeFemaleW from './relational/does_the_fac_offer_female_wrkrs_in_the_supply_chain_ie_female_w/index.js'
import * as doesTheFacOfferParticipateInAnyApprenticeshipTraineeIn from './relational/does_the_fac_offer_participate_in_any_apprenticeship_trainee_in/index.js'
import * as doesTheFacOrRecruitingAgencyProvForeignMigrantsWASig from './relational/does_the_fac_or_recruiting_agency_prov_foreign_migrants_w_a_sig/index.js'
import * as doesTheFacPayWrkrsCorrectlyDuringWorkStoppagesInLine from './relational/does_the_fac_pay_wrkrs_correctly_during_work_stoppages_in_line/index.js'
import * as doesTheFacPerformAnyTypeOfHotWorkIeWeldingSoldering from './relational/does_the_fac_perform_any_type_of_hot_work_ie_welding_soldering/index.js'
import * as doesTheFacProvAllLegallyRequiredFacilities from './relational/does_the_fac_prov_all_legally_required_facilities/index.js'
import * as doesTheFacProvBreaksDuringTheWorkdayInLineWLegalReq from './relational/does_the_fac_prov_breaks_during_the_workday_in_line_w_legal_req/index.js'
import * as doesTheFacProvCommAndTrainingOnSocialAndLaborPractic from './relational/does_the_fac_prov_comm_and_training_on_social_and_labor_practic/index.js'
import * as doesTheFacProvHandWashingFacilitiesEquippedWCleanWate from './relational/does_the_fac_prov_hand_washing_facilities_equipped_w_clean_wate/index.js'
import * as doesTheFacProvInkindBenefitsEvenIfNotLegallyRequired from './relational/does_the_fac_prov_inkind_benefits_even_if_not_legally_required/index.js'
import * as doesTheFacProvInkindBenefitsInLineWLegalReqs from './relational/does_the_fac_prov_inkind_benefits_in_line_w_legal_reqs/index.js'
import * as doesTheFacProvLegallyRequiredCompensationBenefitsRelate from './relational/does_the_fac_prov_legally_required_compensation_benefits_relate/index.js'
import * as doesTheFacProvOtherInsuranceToWrkrsWhoAreNotCovered from './relational/does_the_fac_prov_other_insurance_to_wrkrs_who_are_not_covered/index.js'
import * as doesTheFacProvSpecialHealthAndSafetyTrainingsSeparate from './relational/does_the_fac_prov_special_health_and_safety_trainings_separate/index.js'
import * as doesTheFacProvTheListregisterOfWrkrsUndAge_18ToGover from './relational/does_the_fac_prov_the_listregister_of_wrkrs_und_age_18_to_gover/index.js'
import * as doesTheFacProvTimeOffForBreastfeedingInLineWLegalRe from './relational/does_the_fac_prov_time_off_for_breastfeeding_in_line_w_legal_re/index.js'
import * as doesTheFacProvWrkrsWCompensatoryTimeOffInLineWLegal from './relational/does_the_fac_prov_wrkrs_w_compensatory_time_off_in_line_w_legal/index.js'
import * as doesTheFacProvWrkrsWFreePotableDrinkingWater from './relational/does_the_fac_prov_wrkrs_w_free_potable_drinking_water/index.js'
import * as doesTheFacProvWrkrsWPersonalProtEquipmentPpeInLineW from './relational/does_the_fac_prov_wrkrs_w_personal_prot_equipment_ppe_in_line_w/index.js'
import * as doesTheFacProvWrkrsWPotableDrinkingWaterInLineWLega from './relational/does_the_fac_prov_wrkrs_w_potable_drinking_water_in_line_w_lega/index.js'
import * as doesTheFacPublishAReportAtLeastEvery_2YearsRegarding from './relational/does_the_fac_publish_a_report_at_least_every_2_years_regarding/index.js'
import * as doesTheFacRecordWorkrelatedAccidentsAndDiseasesAndRepo from './relational/does_the_fac_record_workrelated_accidents_and_diseases_and_repo/index.js'
import * as doesTheFacRefuseToBargainCollectivelyOrRefuseToBargai from './relational/does_the_fac_refuse_to_bargain_collectively_or_refuse_to_bargai/index.js'
import * as doesTheFacRegisterTheirWrkrsWSocialSecurityInstitution from './relational/does_the_fac_register_their_wrkrs_w_social_security_institution/index.js'
import * as doesTheFacRegularlyTestAndServiceFireExtinguishersAnd from './relational/does_the_fac_regularly_test_and_service_fire_extinguishers_and/index.js'
import * as doesTheFacRentOrOwnThePremisesTheyOccupy from './relational/does_the_fac_rent_or_own_the_premises_they_occupy/index.js'
import * as doesTheFacRequireHivAidsTestingAtAnyTimeDuringEmploy from './relational/does_the_fac_require_hiv_aids_testing_at_any_time_during_employ/index.js'
import * as doesTheFacRequireHivAidsTestingDuringTheHiringProcess from './relational/does_the_fac_require_hiv_aids_testing_during_the_hiring_process/index.js'
import * as doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati from './relational/does_the_fac_require_other_infection_or_illness_tests_eg_hepati/index.js'
import * as doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati_1 from './relational/does_the_fac_require_other_infection_or_illness_tests_eg_hepati_1/index.js'
import * as doesTheFacRequireWrkrsToJoinATradeUnion from './relational/does_the_fac_require_wrkrs_to_join_a_trade_union/index.js'
import * as doesTheFacReviewupdatePoliciesAndProceduresWrittenOrIn from './relational/does_the_fac_reviewupdate_policies_and_procedures_written_or_in/index.js'
import * as doesTheFacTakeAnyDeductionsFromWagesThatAreNotInLin from './relational/does_the_fac_take_any_deductions_from_wages_that_are_not_in_lin/index.js'
import * as doesTheFacTestNoiseExposureLevelsInLineWLegalReqs from './relational/does_the_fac_test_noise_exposure_levels_in_line_w_legal_reqs/index.js'
import * as doesTheFacTreatAllTradeUnionsEquallyOrAsStipulatedBy from './relational/does_the_fac_treat_all_trade_unions_equally_or_as_stipulated_by/index.js'
import * as doesTheFacUseChemicalsAndorHazardousSubstances from './relational/does_the_fac_use_chemicals_andor_hazardous_substances/index.js'
import * as doesTheFacUseContractorPersonnelToPerformMaintenanceWo from './relational/does_the_fac_use_contractor_personnel_to_perform_maintenance_wo/index.js'
import * as doesTheFacUseFixedtermContracts from './relational/does_the_fac_use_fixedterm_contracts/index.js'
import * as doesTheFacUseLaserOrRadiationProducingEquipment from './relational/does_the_fac_use_laser_or_radiation_producing_equipment/index.js'
import * as doesTheFacUsePortableLadders from './relational/does_the_fac_use_portable_ladders/index.js'
import * as doesTheFacUsePrisonLabor from './relational/does_the_fac_use_prison_labor/index.js'
import * as doFoodServiceWrkrsHaveValidHealthsanitationCertificatesp from './relational/do_food_service_wrkrs_have_valid_healthsanitation_certificatesp/index.js'
import * as domesticMigrantWorkers from './relational/domestic_migrant_workers/index.js'
import * as doOperatorsTechniciansForMachineryEquipmentElectricalIns from './relational/do_operators_technicians_for_machinery_equipment_electrical_ins/index.js'
import * as doOperatorsTechniciansInstallBoiler from './relational/do_operators_technicians_install_boiler/index.js'
import * as doOtherTypesOfWrittenDocumentsExplainingTheTermsAndCo from './relational/do_other_types_of_written_documents_explaining_the_terms_and_co/index.js'
import * as doPaySlipsContainAccurateInfoOnWorkerWagesInADetaile from './relational/do_pay_slips_contain_accurate_info_on_worker_wages_in_a_detaile/index.js'
import * as doPaySlipsContainAccurateInformationOnWorker from './relational/do_pay_slips_contain_accurate_information_on_worker/index.js'
import * as doRegularWorkingHoursExceedLegalReqs from './relational/do_regular_working_hours_exceed_legal_reqs/index.js'
import * as dormitories from './relational/dormitories/index.js'
import * as doSecurityPersonnelCarryWeapons from './relational/do_security_personnel_carry_weapons/index.js'
import * as doSecurityPersonnelCarryWeaponsOnTheProductionFloor from './relational/do_security_personnel_carry_weapons_on_the_production_floor/index.js'
import * as doThesePoliciesAndorProceduresHaveAReferenceToNational from './relational/do_these_policies_andor_procedures_have_a_reference_to_national/index.js'
import * as doTradeUnionRepresentativesHaveAccessToWrkrsInTheWork from './relational/do_trade_union_representatives_have_access_to_wrkrs_in_the_work/index.js'
import * as doTradeUnionRepresentativesHaveTimeOffToAttendRelevant from './relational/do_trade_union_representatives_have_time_off_to_attend_relevant/index.js'
import * as doTradeUnionRepresentativesHaveTimeOffToCarryOutTheir from './relational/do_trade_union_representatives_have_time_off_to_carry_out_their/index.js'
import * as doWorkersHaveAccessExternalContactsOutsideTheir from './relational/do_workers_have_access_external_contacts_outside_their/index.js'
import * as doWorkersUnderstandInformationIncludedWithinTheirWritten from './relational/do_workers_understand_information_included_within_their_written/index.js'
import * as doWorkersUnderstandTermsConditionsWithinTheirWritten from './relational/do_workers_understand_terms_conditions_within_their_written/index.js'
import * as doWorkplaceRulesComplyWLegalReqs from './relational/do_workplace_rules_comply_w_legal_reqs/index.js'
import * as doWrkrsHaveAccessToExternalContactsOutsideOfMgmtThat from './relational/do_wrkrs_have_access_to_external_contacts_outside_of_mgmt_that/index.js'
import * as doWrkrsHaveTheAbilityToDisputeAndCorrectWagePayments from './relational/do_wrkrs_have_the_ability_to_dispute_and_correct_wage_payments/index.js'
import * as doWrkrsHaveTheRightToConsultWAndBeRepresentedEither from './relational/do_wrkrs_have_the_right_to_consult_w_and_be_represented_either/index.js'
import * as doWrkrsHaveTheRightToRespondToAndorAppealAnyDiscipli from './relational/do_wrkrs_have_the_right_to_respond_to_andor_appeal_any_discipli/index.js'
import * as doWrkrsKeepAllOfTheirOriginalPersonalDocumentsSuchAs from './relational/do_wrkrs_keep_all_of_their_original_personal_documents_such_as/index.js'
import * as doWrkrsSignAllWrittenRecsOfDisciplinaryActionsTakenAg from './relational/do_wrkrs_sign_all_written_recs_of_disciplinary_actions_taken_ag/index.js'
import * as doWrkrsUndstandTheInfoIncludedWinTheirWrittenTermsAnd from './relational/do_wrkrs_undstand_the_info_included_win_their_written_terms_and/index.js'
import * as doWrkrsUndstandTheTermsAndConditionsWinTheirWrittenEm from './relational/do_wrkrs_undstand_the_terms_and_conditions_win_their_written_em/index.js'
import * as dunsNumber from './global/duns_number/index.js'
import * as durationOfTheCbaThatCoversThe_2ndGreatestNumOfWrkrsI from './relational/duration_of_the_cba_that_covers_the_2nd_greatest_num_of_wrkrs_i/index.js'
import * as durationOfTheCbaThatCoversThe_3rdGreatestNumOfWrkrsI from './relational/duration_of_the_cba_that_covers_the_3rd_greatest_num_of_wrkrs_i/index.js'
import * as durationOfTheCbaThatCoversTheGreatestNumOfWrkrsInTh from './relational/duration_of_the_cba_that_covers_the_greatest_num_of_wrkrs_in_th/index.js'
import * as duringRecruitmentProcessDoMaterialsSuchAsJob from './relational/during_recruitment_process_do_materials_such_as_job/index.js'
import * as duringTheRecruitmentProcessDoMaterialsSuchAsJobDescOr from './relational/during_the_recruitment_process_do_materials_such_as_job_desc_or/index.js'
import * as dyeing_1 from './relational/dyeing_1/index.js'
import * as dyeing_2 from './relational/dyeing_2/index.js'
import * as electronics from './relational/electronics/index.js'
import * as elevatorsNotWiredBeInoperableWhenElevatorDoors from './relational/elevators_not_wired_be_inoperable_when_elevator_doors/index.js'
import * as embossing from './relational/embossing/index.js'
import * as embroidery from './relational/embroidery/index.js'
import * as emergencyAlarmNotDistinctFromOtherAlarmsSignals from './relational/emergency_alarm_not_distinct_from_other_alarms_signals/index.js'
import * as emergencyAlarmSystemButtonsSwitchesPullStationsAre from './relational/emergency_alarm_system_buttons_switches_pull_stations_are/index.js'
import * as emergencyAlarmSystemCannotBeHeardSeenAcross from './relational/emergency_alarm_system_cannot_be_heard_seen_across/index.js'
import * as emergencyAlarmSystemNotFittedBackUpPower from './relational/emergency_alarm_system_not_fitted_back_up_power/index.js'
import * as emergencyExitDoorsDoNotOpenOutwardsAre from './relational/emergency_exit_doors_do_not_open_outwards_are/index.js'
import * as employmentStatusNotMaintained from './relational/employment_status_not_maintained/index.js'
import * as enabledCustomInfo from './transactional/enabled_custom_info/index.js'
import * as energyIEFuelCoalElectricityGasEtc from './relational/energy_i_e_fuel_coal_electricity_gas_etc/index.js'
import * as energyManagementSystem from './relational/energy_management_system/index.js'
import * as energySourcesPefcr from './relational/energy_sources_pefcr/index.js'
import * as equipmentCosts from './relational/equipment_costs/index.js'
import * as ethiopiaPayWorkersCorrectlyDuringPrenatalVisits from './relational/ethiopia_pay_workers_correctly_during_prenatal_visits/index.js'
import * as ethiopiaPayWorkersCorrectlyWhenTheyTakeTime from './relational/ethiopia_pay_workers_correctly_when_they_take_time/index.js'
import * as ethiopiaProvideLegallyRequiredTimeOffPrenatalVisits from './relational/ethiopia_provide_legally_required_time_off_prenatal_visits/index.js'
import * as ethiopiaProvideTimeOffWorkersAppearLaborDispute from './relational/ethiopia_provide_time_off_workers_appear_labor_dispute/index.js'
import * as etiEthicalTradingInitiative from './relational/eti_ethical_trading_initiative/index.js'
import * as europeanFlaxCertifiedCompany from './relational/european_flax_certified_company/index.js'
import * as existingProductionWorkers_1 from './relational/existing_production_workers_1/index.js'
import * as existingProductionWorkers_10 from './relational/existing_production_workers_10/index.js'
import * as existingProductionWorkers_11 from './relational/existing_production_workers_11/index.js'
import * as existingProductionWorkers_12 from './relational/existing_production_workers_12/index.js'
import * as existingProductionWorkers_13 from './relational/existing_production_workers_13/index.js'
import * as existingProductionWorkers_14 from './relational/existing_production_workers_14/index.js'
import * as existingProductionWorkers_15 from './relational/existing_production_workers_15/index.js'
import * as existingProductionWorkers_16 from './relational/existing_production_workers_16/index.js'
import * as existingProductionWorkers_17 from './relational/existing_production_workers_17/index.js'
import * as existingProductionWorkers_18 from './relational/existing_production_workers_18/index.js'
import * as existingProductionWorkers_19 from './relational/existing_production_workers_19/index.js'
import * as existingProductionWorkers_2 from './relational/existing_production_workers_2/index.js'
import * as existingProductionWorkers_20 from './relational/existing_production_workers_20/index.js'
import * as existingProductionWorkers_21 from './relational/existing_production_workers_21/index.js'
import * as existingProductionWorkers_22 from './relational/existing_production_workers_22/index.js'
import * as existingProductionWorkers_23 from './relational/existing_production_workers_23/index.js'
import * as existingProductionWorkers_24 from './relational/existing_production_workers_24/index.js'
import * as existingProductionWorkers_3 from './relational/existing_production_workers_3/index.js'
import * as existingProductionWorkers_4 from './relational/existing_production_workers_4/index.js'
import * as existingProductionWorkers_5 from './relational/existing_production_workers_5/index.js'
import * as existingProductionWorkers_6 from './relational/existing_production_workers_6/index.js'
import * as existingProductionWorkers_7 from './relational/existing_production_workers_7/index.js'
import * as existingProductionWorkers_8 from './relational/existing_production_workers_8/index.js'
import * as existingProductionWorkers_9 from './relational/existing_production_workers_9/index.js'
import * as eyewashStationsShowersAreNotClearClutterDebris from './relational/eyewash_stations_showers_are_not_clear_clutter_debris/index.js'
import * as eyewashStationsShowersAreNotClearlyIdentifiable from './relational/eyewash_stations_showers_are_not_clearly_identifiable/index.js'
import * as eyewashStationsShowersAreNotEasyAccess from './relational/eyewash_stations_showers_are_not_easy_access/index.js'
import * as eyewashStationsShowersAreNotRegularlyInspected from './relational/eyewash_stations_showers_are_not_regularly_inspected/index.js'
import * as eyewashStationsShowersDoNotUsePotableWater from './relational/eyewash_stations_showers_do_not_use_potable_water/index.js'
import * as eyewashStationsShowersInspectionLogsAreNotKept from './relational/eyewash_stations_showers_inspection_logs_are_not_kept/index.js'
import * as facDoesNotReviewupdatePoliciesAndProceduresWrittenOrIn from './relational/fac_does_not_reviewupdate_policies_and_procedures_written_or_in/index.js'
import * as facDoesNotUseAnyMethodsAndIsNotAwareOfChangesupdates from './relational/fac_does_not_use_any_methods_and_is_not_aware_of_changesupdates/index.js'
import * as facEmail from './relational/fac_email/index.js'
import * as facFailingComplyLegalReqContractsHiringPractices from './relational/fac_failing_comply_legal_req_contracts_hiring_practices/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_1 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_1/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_2 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_2/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_3 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_3/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_4 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_4/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_5 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_5/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_6 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_6/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_7 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_7/index.js'
import * as facFailingComplyLegalReqNotCoveredElsewhere_8 from './relational/fac_failing_comply_legal_req_not_covered_elsewhere_8/index.js'
import * as facFailingComplyLegalReqWagesBenefitsPertaining from './relational/fac_failing_comply_legal_req_wages_benefits_pertaining/index.js'
import * as facFailingComplyLegalReqWorkingHoursPertaining from './relational/fac_failing_comply_legal_req_working_hours_pertaining/index.js'
import * as facilityAcceptsWorkersFromGovernmentPrograms from './relational/facility_accepts_workers_from_government_programs/index.js'
import * as facilityAccessibleFireResponseEmergencyVehiclesAlthough from './relational/facility_accessible_fire_response_emergency_vehicles_although/index.js'
import * as facilityAccessibleFireResponseEmergencyVehiclesLine from './relational/facility_accessible_fire_response_emergency_vehicles_line/index.js'
import * as facilityAddressLocalLanguageAsPerBusinessLicense from './relational/facility_address_local_language_as_per_business_license/index.js'
import * as facilityAdministeringHivAidsTestsDuringHiringProcess from './relational/facility_administering_hiv_aids_tests_during_hiring_process/index.js'
import * as facilityAdministeringOtherInfectionIllnessTestsEG from './relational/facility_administering_other_infection_illness_tests_e_g/index.js'
import * as facilityFailingCorrectlyPayWorkersTheseTypesLeave from './relational/facility_failing_correctly_pay_workers_these_types_leave/index.js'
import * as facilityFailingCorrectlyProvideWorkersTimeOffThese from './relational/facility_failing_correctly_provide_workers_time_off_these/index.js'
import * as facilityHasNotPerformedAsbestosExposureAssessment from './relational/facility_has_not_performed_asbestos_exposure_assessment/index.js'
import * as facilityHasNotTakenProperStepsEnsureThat from './relational/facility_has_not_taken_proper_steps_ensure_that/index.js'
import * as facilityHasOverdueSocialInsuranceSocialSecurityDebts from './relational/facility_has_overdue_social_insurance_social_security_debts/index.js'
import * as facilityLightingLineLegalRequirements from './relational/facility_lighting_line_legal_requirements/index.js'
import * as facilityLineLegalRequirementsWhenAdministeringHivAids from './relational/facility_line_legal_requirements_when_administering_hiv_aids/index.js'
import * as facilityNameLocalLanguageAsPerBusinessLicense from './relational/facility_name_local_language_as_per_business_license/index.js'
import * as facilityPaidHousingAllowance from './relational/facility_paid_housing_allowance/index.js'
import * as facilityPaidMealAllowance from './relational/facility_paid_meal_allowance/index.js'
import * as facilityPaidSeniorityGratuityBonus from './relational/facility_paid_seniority_gratuity_bonus/index.js'
import * as facilityPaidTransportationAllowance from './relational/facility_paid_transportation_allowance/index.js'
import * as facilityProcesses from './relational/facility_processes/index.js'
import * as facilityRequiresPregnancyTestsThatAreNotRequired_1 from './relational/facility_requires_pregnancy_tests_that_are_not_required_1/index.js'
import * as facilityRequiresPregnancyTestsThatAreNotRequired_2 from './relational/facility_requires_pregnancy_tests_that_are_not_required_2/index.js'
import * as facilityRequiresUseContraceptivesOtherFormsBirthControl_1 from './relational/facility_requires_use_contraceptives_other_forms_birth_control_1/index.js'
import * as facilityRequiresUseContraceptivesOtherFormsBirthControl_2 from './relational/facility_requires_use_contraceptives_other_forms_birth_control_2/index.js'
import * as facilityRequiresVirginityTestBeforeHiring from './relational/facility_requires_virginity_test_before_hiring/index.js'
import * as facilityStairwayStepsAreNotEven from './relational/facility_stairway_steps_are_not_even/index.js'
import * as facilityStepSurfacesAreNotMadeFromSlip from './relational/facility_step_surfaces_are_not_made_from_slip/index.js'
import * as facilityWorkplaceRules from './relational/facility_workplace_rules/index.js'
import * as facIsInAMultifloorBuilding from './relational/fac_is_in_a_multifloor_building/index.js'
import * as facLineLegalReqWhenAdministeringOtherInfection from './relational/fac_line_legal_req_when_administering_other_infection/index.js'
import * as facRequiresPregnancyTestsThatAreNotRequiredByApplicabl from './relational/fac_requires_pregnancy_tests_that_are_not_required_by_applicabl/index.js'
import * as facRequiresWkrProvideCommitmentsVerballyWritingThat from './relational/fac_requires_wkr_provide_commitments_verbally_writing_that/index.js'
import * as facsAverageMonthlyVolumeNumericalAmount from './relational/facs_average_monthly_volume_numerical_amount/index.js'
import * as facsMonthlyCapacityNumericalAmount from './relational/facs_monthly_capacity_numerical_amount/index.js'
import * as facsMonthlyCapacityUnitOfMeasurement from './relational/facs_monthly_capacity_unit_of_measurement/index.js'
import * as facsMonthlyVolumeUnitOfMeasurement from './relational/facs_monthly_volume_unit_of_measurement/index.js'
import * as fallProtectionEquipmentMaintenanceLogsAreNotKept from './relational/fall_protection_equipment_maintenance_logs_are_not_kept/index.js'
import * as fallProtectionEquipmentNotGoodCondition from './relational/fall_protection_equipment_not_good_condition/index.js'
import * as familyResponsibilities_1 from './relational/family_responsibilities_1/index.js'
import * as familyResponsibilities_2 from './relational/family_responsibilities_2/index.js'
import * as familyResponsibilities_3 from './relational/family_responsibilities_3/index.js'
import * as familyResponsibilitiesFactoredIntoHiringDecisionsNotLine from './relational/family_responsibilities_factored_into_hiring_decisions_not_line/index.js'
import * as familyResponsibilitiesReferencedNotLineLegalRequirements from './relational/family_responsibilities_referenced_not_line_legal_requirements/index.js'
import * as fifthWageLevelDefinedByFacCompleteDefinitionOfThisLev from './relational/fifth_wage_level_defined_by_fac_complete_definition_of_this_lev/index.js'
import * as finalProductWarehousingStorage from './relational/final_product_warehousing_storage/index.js'
import * as finishing_1 from './relational/finishing_1/index.js'
import * as finishing_2 from './relational/finishing_2/index.js'
import * as finishingOfTextiles from './relational/finishing_of_textiles/index.js'
import * as firefightingEquipmentNotAccessible from './relational/firefighting_equipment_not_accessible/index.js'
import * as firefightingEquipmentNotClearlyMarkedEquippedInstructions from './relational/firefighting_equipment_not_clearly_marked_equipped_instructions/index.js'
import * as firstWageLevelDefinedByFacThisIsTheLowestWageLevelC from './relational/first_wage_level_defined_by_fac_this_is_the_lowest_wage_level_c/index.js'
import * as flaFairLaborAssociation from './relational/fla_fair_labor_association/index.js'
import * as floorsHaveBeenAddedSinceOriginalConstruction from './relational/floors_have_been_added_since_original_construction/index.js'
import * as food from './relational/food/index.js'
import * as foodAndBeverage from './relational/food_and_beverage/index.js'
import * as foodPreparationStorageEatingAreasAreNotKept from './relational/food_preparation_storage_eating_areas_are_not_kept/index.js'
import * as footwear from './relational/footwear/index.js'
import * as footwearClothing from './relational/footwear_clothing/index.js'
import * as forEachAdditionalActiveTradeUnionThatIsSmallerThanThe from './relational/for_each_additional_active_trade_union_that_is_smaller_than_the/index.js'
import * as forEachAdditionalCollectiveBargainingAgreementCbaNotCov from './relational/for_each_additional_collective_bargaining_agreement_cba_not_cov/index.js'
import * as foreignMigrantWorkers from './relational/foreign_migrant_workers/index.js'
import * as forHowManyMonthsAreRecsOfDisciplinaryActionsMaintained from './relational/for_how_many_months_are_recs_of_disciplinary_actions_maintained/index.js'
import * as forkliftRoutesAreNotClearlyMarked from './relational/forklift_routes_are_not_clearly_marked/index.js'
import * as forWrkrsSeekingToEndTheirEmploymentHowManyDaysOfNoti from './relational/for_wrkrs_seeking_to_end_their_employment_how_many_days_of_noti/index.js'
import * as fourthWageLevelDefinedByFacCompleteDefinitionOfThisLe from './relational/fourth_wage_level_defined_by_fac_complete_definition_of_this_le/index.js'
import * as freedomAssociationCollectiveBargaining from './relational/freedom_association_collective_bargaining/index.js'
import * as ftusaFairTradeUsa from './relational/ftusa_fair_trade_usa/index.js'
import * as fullAddressLocalize from './global/full_address_localize/index.js'
import * as furniture from './relational/furniture/index.js'
import * as geojson from './global/geojson/index.js'
import * as ghgEmissionsOffsetScope from './relational/ghg_emissions_offset_scope/index.js'
import * as glassProcessing from './relational/glass_processing/index.js'
import * as globalLocationNumber from './global/global_location_number/index.js'
import * as gluing_1 from './relational/gluing_1/index.js'
import * as gluing_2 from './relational/gluing_2/index.js'
import * as gluing_3 from './relational/gluing_3/index.js'
import * as gotsGlobalOrganicTextileStandard from './relational/gots_global_organic_textile_standard/index.js'
import * as governmentProgramsFacilityParticipatesIn from './relational/government_programs_facility_participates_in/index.js'
import * as grievanceHandlingDisputeResolutionProcAccessLanguages from './relational/grievance_handling_dispute_resolution_proc_access_languages/index.js'
import * as grievanceHandlingDisputeResolutionProceduresAccessibleSome from './relational/grievance_handling_dispute_resolution_procedures_accessible_some/index.js'
import * as grievanceMechanismChannels from './relational/grievance_mechanism_channels/index.js'
import * as grievanceMechanismLocallyAvailableForPotentialExternalStakeholders from './relational/grievance_mechanism_locally_available_for_potential_external_stakeholders/index.js'
import * as grievanceSystems from './relational/grievance_systems/index.js'
import * as grsGlobalRecyclingStandard from './relational/grs_global_recycling_standard/index.js'
import * as handbags from './relational/handbags/index.js'
import * as harassment_1 from './relational/harassment_1/index.js'
import * as harassment_2 from './relational/harassment_2/index.js'
import * as hasAllLegallyRequiredActionBeenTakenToAssessMonitorAn from './relational/has_all_legally_required_action_been_taken_to_assess_monitor_an/index.js'
import * as hasAnyNewPast_3YearsConstructionBeenAddedToTheBuildin from './relational/has_any_new_past_3_years_construction_been_added_to_the_buildin/index.js'
import * as hasFacConductedAssessmentIdentifyEquipContainsPcb from './relational/has_fac_conducted_assessment_identify_equip_contains_pcb/index.js'
import * as hasFacilityActedAgainstLegalRequirementsHiringTemporary from './relational/has_facility_acted_against_legal_requirements_hiring_temporary/index.js'
import * as hasFacilityConductedHealthSafetyRiskAssessmentLine from './relational/has_facility_conducted_health_safety_risk_assessment_line/index.js'
import * as hasFacilityHadRushOrdersWithinAssessmentPeriod from './relational/has_facility_had_rush_orders_within_assessment_period/index.js'
import * as hasFacilityTakenLegallyRequiredMeasuresProtectWorkers from './relational/has_facility_taken_legally_required_measures_protect_workers/index.js'
import * as hasFacilityTakenLegallyRequiredStepsEnableWorkers_1 from './relational/has_facility_taken_legally_required_steps_enable_workers_1/index.js'
import * as hasFacilityTakenLegallyRequiredStepsEnableWorkers_2 from './relational/has_facility_taken_legally_required_steps_enable_workers_2/index.js'
import * as hasFacilityTakenLegallyRequiredStepsEnableWorkers_3 from './relational/has_facility_taken_legally_required_steps_enable_workers_3/index.js'
import * as hasFacilityTrainedWorkersUseFireFightingEquipment from './relational/has_facility_trained_workers_use_fire_fighting_equipment/index.js'
import * as hasFacMadeDisabledPersons from './relational/has_fac_made_disabled_persons/index.js'
import * as hasFacThreatenedIntimidatedHarassedPunishedTerminatedNot from './relational/has_fac_threatened_intimidated_harassed_punished_terminated_not/index.js'
import * as hasLegallyRequiredActionBeenTakenAssessMonitor_1 from './relational/has_legally_required_action_been_taken_assess_monitor_1/index.js'
import * as hasLegallyRequiredActionBeenTakenAssessMonitor_2 from './relational/has_legally_required_action_been_taken_assess_monitor_2/index.js'
import * as hasTerminationForcedResignationRetrenchmentOrRetirementE from './relational/has_termination_forced_resignation_retrenchment_or_retirement_e/index.js'
import * as hasTheFacActedAgainstLegalReqsByHiringTemporaryprobati from './relational/has_the_fac_acted_against_legal_reqs_by_hiring_temporaryprobati/index.js'
import * as hasTheFacBeenSubjectToAnyFinesOrSanctionsRelatedToS from './relational/has_the_fac_been_subject_to_any_fines_or_sanctions_related_to_s/index.js'
import * as hasTheFacConductedAHealthAndSafetyRiskAssessment from './relational/has_the_fac_conducted_a_health_and_safety_risk_assessment/index.js'
import * as hasTheFacConductedAHealthAndSafetyRiskAssessmentInLi from './relational/has_the_fac_conducted_a_health_and_safety_risk_assessment_in_li/index.js'
import * as hasTheFacConductedAnAssessmentToIdentifyIfEquipmentCo from './relational/has_the_fac_conducted_an_assessment_to_identify_if_equipment_co/index.js'
import * as hasTheFacConductedARiskAssessmentOrTestingToDetermine from './relational/has_the_fac_conducted_a_risk_assessment_or_testing_to_determine/index.js'
import * as hasTheFacDefinedThePersonsResponsibleForTheImplementat from './relational/has_the_fac_defined_the_persons_responsible_for_the_implementat/index.js'
import * as hasTheFacEncouragedSourcingPracticesThatResultedInThe from './relational/has_the_fac_encouraged_sourcing_practices_that_resulted_in_the/index.js'
import * as hasTheFacEngagedInAnyOfTheseActionsDueToAWorkersTr from './relational/has_the_fac_engaged_in_any_of_these_actions_due_to_a_workers_tr/index.js'
import * as hasTheFacEverTriedToPreventAnyWrkrsFromParticipating from './relational/has_the_fac_ever_tried_to_prevent_any_wrkrs_from_participating/index.js'
import * as hasTheFacEverWheldOrThreatenedToWholdOrDelayedWageP from './relational/has_the_fac_ever_wheld_or_threatened_to_whold_or_delayed_wage_p/index.js'
import * as hasTheFacFailedToImplementAnyApplicableCourtOrdersArb from './relational/has_the_fac_failed_to_implement_any_applicable_court_orders_arb/index.js'
import * as hasTheFacFailedToImplementAnyOfTheProvisionsInTheCb from './relational/has_the_fac_failed_to_implement_any_of_the_provisions_in_the_cb/index.js'
import * as hasTheFacFailedToMaintainAnyOfTheFollowingForWrkrsD from './relational/has_the_fac_failed_to_maintain_any_of_the_following_for_wrkrs_d/index.js'
import * as hasTheFacImplementedAnyOtherCommunityImpactProjectsTha from './relational/has_the_fac_implemented_any_other_community_impact_projects_tha/index.js'
import * as hasTheFacImplementedAnyOtherProjectsThatHaveSoughtTo from './relational/has_the_fac_implemented_any_other_projects_that_have_sought_to/index.js'
import * as hasTheFacMadeAccommodationsarrangementsForPhysicallyDisa from './relational/has_the_fac_made_accommodationsarrangements_for_physically_disa/index.js'
import * as hasTheFacMgmtTriedToControlManipulateOrInterfereWAny from './relational/has_the_fac_mgmt_tried_to_control_manipulate_or_interfere_w_any/index.js'
import * as hasTheFacReceivedRecognitionAwardFromAPubliclyKnownIn from './relational/has_the_fac_received_recognition_award_from_a_publicly_known_in/index.js'
import * as hasTheFacSetSpecificGoalstargetsForImprovementOnSocial from './relational/has_the_fac_set_specific_goalstargets_for_improvement_on_social/index.js'
import * as hasTheFacSetTargetsForSocialAndLaborPerformanceAddres from './relational/has_the_fac_set_targets_for_social_and_labor_performance_addres/index.js'
import * as hasTheFacTakenLegallyRequiredMeasuresToProtectWrkrsFr from './relational/has_the_fac_taken_legally_required_measures_to_protect_wrkrs_fr/index.js'
import * as hasTheFacTakenStepsToEnableWrkrsWHivaidsToRetainThe from './relational/has_the_fac_taken_steps_to_enable_wrkrs_w_hivaids_to_retain_the/index.js'
import * as hasTheFacTakenStepsToEnableWrkrsWhoBecomeDisabledFor from './relational/has_the_fac_taken_steps_to_enable_wrkrs_who_become_disabled_for/index.js'
import * as hasTheFacTakenStepsToEnableWrkrsWInfectionsOrIllness from './relational/has_the_fac_taken_steps_to_enable_wrkrs_w_infections_or_illness/index.js'
import * as hasTheFacThreatenedIntimidatedHarassedPunishedTerminated from './relational/has_the_fac_threatened_intimidated_harassed_punished_terminated/index.js'
import * as hasTheFacTrainedWrkrsToUseFirefightingEquipmentInLine from './relational/has_the_fac_trained_wrkrs_to_use_firefighting_equipment_in_line/index.js'
import * as haveAnyCasesOfThreatsSuchAsReportingToAuthoritiesDepo from './relational/have_any_cases_of_threats_such_as_reporting_to_authorities_depo/index.js'
import * as haveAnyCasesOfViolenceOrThreatsOfViolenceToIntimidate from './relational/have_any_cases_of_violence_or_threats_of_violence_to_intimidate/index.js'
import * as haveDecisionsOfTerminationForcedResignationRetrenchmentO from './relational/have_decisions_of_termination_forced_resignation_retrenchment_o/index.js'
import * as haveRaceEthnicGroupSkinColorSexGender_1 from './relational/have_race_ethnic_group_skin_color_sex_gender_1/index.js'
import * as haveRaceEthnicGroupSkinColorSexGender_2 from './relational/have_race_ethnic_group_skin_color_sex_gender_2/index.js'
import * as haveRaceEthnicGroupSkinColorSexGender_3 from './relational/have_race_ethnic_group_skin_color_sex_gender_3/index.js'
import * as haveRaceEthnicGroupSkinColorSexGenderReligionPolitical from './relational/have_race_ethnic_group_skin_color_sex_gender_religion_political/index.js'
import * as haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_1 from './relational/have_race_ethnic_group_skin_color_sex_gender_religion_political_1/index.js'
import * as haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_2 from './relational/have_race_ethnic_group_skin_color_sex_gender_religion_political_2/index.js'
import * as haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_3 from './relational/have_race_ethnic_group_skin_color_sex_gender_religion_political_3/index.js'
import * as haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_4 from './relational/have_race_ethnic_group_skin_color_sex_gender_religion_political_4/index.js'
import * as haveThereBeenAndorAreThereCurrentlyCasesOfConcernAbou from './relational/have_there_been_andor_are_there_currently_cases_of_concern_abou/index.js'
import * as haveThereBeenAnyCasesOfPhysicalVerbalPsychologicalHara from './relational/have_there_been_any_cases_of_physical_verbal_psychological_hara/index.js'
import * as haveThereBeenAnyIncidencesOfForcedLaborIncludingSaleA from './relational/have_there_been_any_incidences_of_forced_labor_including_sale_a/index.js'
import * as haveThereBeenCasesOfSexualHarassment from './relational/have_there_been_cases_of_sexual_harassment/index.js'
import * as haveWorkersBeenDeniedAccessTheirOriginalPersonal from './relational/have_workers_been_denied_access_their_original_personal/index.js'
import * as haveWrkrsBeenDeniedAccessToAnyOfTheirOriginalPersonal from './relational/have_wrkrs_been_denied_access_to_any_of_their_original_personal/index.js'
import * as healthAndSafety from './relational/health_and_safety/index.js'
import * as healthClinics from './relational/health_clinics/index.js'
import * as healthSafety from './relational/health_safety/index.js'
import * as heatPressHeatingCooling_1 from './relational/heat_press_heating_cooling_1/index.js'
import * as heatPressHeatingCooling_2 from './relational/heat_press_heating_cooling_2/index.js'
import * as higgId from './global/higg_id/index.js'
import * as hivAidsStatusRealPerceived_1 from './relational/hiv_aids_status_real_perceived_1/index.js'
import * as hivAidsStatusRealPerceived_2 from './relational/hiv_aids_status_real_perceived_2/index.js'
import * as hivAidsStatusRealPerceived_3 from './relational/hiv_aids_status_real_perceived_3/index.js'
import * as hivAidsStatusRealPerceivedFactoredIntoHiring from './relational/hiv_aids_status_real_perceived_factored_into_hiring/index.js'
import * as hivAidsStatusRealPerceivedReferencedNotLine from './relational/hiv_aids_status_real_perceived_referenced_not_line/index.js'
import * as homeAccessories from './relational/home_accessories/index.js'
import * as homeTextiles from './relational/home_textiles/index.js'
import * as homeworkers from './relational/homeworkers/index.js'
import * as hotWorkPerformedLineLegalRequirements from './relational/hot_work_performed_line_legal_requirements/index.js'
import * as householdProducts from './relational/household_products/index.js'
import * as housing from './relational/housing/index.js'
import * as howAreComplaintsAndGrievancesSettledSelectAllThatApply from './relational/how_are_complaints_and_grievances_settled_select_all_that_apply/index.js'
import * as howAreHoursOfWorkRecordedForWrkrsSelectAllThatApply from './relational/how_are_hours_of_work_recorded_for_wrkrs_select_all_that_apply/index.js'
import * as howAreWrkrsPaidSelectAllThatApply from './relational/how_are_wrkrs_paid_select_all_that_apply/index.js'
import * as howDoesTheFacDefineWageGradesLevels from './relational/how_does_the_fac_define_wage_grades_levels/index.js'
import * as howDoesTheFacEngageWWrkrsToProactivelySeekSuggestions from './relational/how_does_the_fac_engage_w_wrkrs_to_proactively_seek_suggestions/index.js'
import * as howDoesTheFacProvCommAndTrainingToIndividualsResponsi from './relational/how_does_the_fac_prov_comm_and_training_to_individuals_responsi/index.js'
import * as howDoesTheFacProvCommAndTrainingToNewProductionWrkrs from './relational/how_does_the_fac_prov_comm_and_training_to_new_production_wrkrs/index.js'
import * as howDoesTheFacProvCommAndTrainingToSecurityGuardsSele from './relational/how_does_the_fac_prov_comm_and_training_to_security_guards_sele/index.js'
import * as howDoesTheFacProvCommAndTrainingToSeniorMgmtSelectA from './relational/how_does_the_fac_prov_comm_and_training_to_senior_mgmt_select_a/index.js'
import * as howDoesTheFacProvCommAndTrainingToSupplierssubcontract from './relational/how_does_the_fac_prov_comm_and_training_to_supplierssubcontract/index.js'
import * as howDoesTheFacProvOngoingCommAndTrainingToExistingPro from './relational/how_does_the_fac_prov_ongoing_comm_and_training_to_existing_pro/index.js'
import * as howManyCasesOfHarassmentBasedUponAgeOccurred from './relational/how_many_cases_of_harassment_based_upon_age_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponDisabilityOccurred from './relational/how_many_cases_of_harassment_based_upon_disability_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponGenderIdentityOccurre from './relational/how_many_cases_of_harassment_based_upon_gender_identity_occurre/index.js'
import * as howManyCasesOfHarassmentBasedUponHivaidsStatusOccurred from './relational/how_many_cases_of_harassment_based_upon_hivaids_status_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponMaritalStatusOccurred from './relational/how_many_cases_of_harassment_based_upon_marital_status_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponNationalExtractionOcc from './relational/how_many_cases_of_harassment_based_upon_national_extraction_occ/index.js'
import * as howManyCasesOfHarassmentBasedUponNationalityforeignMigr from './relational/how_many_cases_of_harassment_based_upon_nationalityforeign_migr/index.js'
import * as howManyCasesOfHarassmentBasedUponOtherOccurred from './relational/how_many_cases_of_harassment_based_upon_other_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponPoliticalOpinionOccur from './relational/how_many_cases_of_harassment_based_upon_political_opinion_occur/index.js'
import * as howManyCasesOfHarassmentBasedUponPregnancymaternityStat from './relational/how_many_cases_of_harassment_based_upon_pregnancymaternity_stat/index.js'
import * as howManyCasesOfHarassmentBasedUponRaceEthnicGroupSkin from './relational/how_many_cases_of_harassment_based_upon_race_ethnic_group_skin/index.js'
import * as howManyCasesOfHarassmentBasedUponReligionOccurred from './relational/how_many_cases_of_harassment_based_upon_religion_occurred/index.js'
import * as howManyCasesOfHarassmentBasedUponSexualOrientationOccu from './relational/how_many_cases_of_harassment_based_upon_sexual_orientation_occu/index.js'
import * as howManyCasesOfHarassmentBasedUponSocialOriginOccurred from './relational/how_many_cases_of_harassment_based_upon_social_origin_occurred/index.js'
import * as howManyCasesOfSexualHarassmentOccurred from './relational/how_many_cases_of_sexual_harassment_occurred/index.js'
import * as howManyCasesOfWorkerHarassmentBySecurityPersonnelHave from './relational/how_many_cases_of_worker_harassment_by_security_personnel_have/index.js'
import * as howManyCollectiveBargainingAgreementsCbasHaveThere from './relational/how_many_collective_bargaining_agreements_cbas_have_there/index.js'
import * as howManyCollectiveBargainingAgreementsCbasHaveThereBeen from './relational/how_many_collective_bargaining_agreements_cbas_have_there_been/index.js'
import * as howManyEmployerMembersAreInTheBipartiteCommittee from './relational/how_many_employer_members_are_in_the_bipartite_committee/index.js'
import * as howManyEmployerMembersAreInTheOshCommittee from './relational/how_many_employer_members_are_in_the_osh_committee/index.js'
import * as howManyFemaleMembersAreInTheBipartiteCommittee from './relational/how_many_female_members_are_in_the_bipartite_committee/index.js'
import * as howManyFemaleMembersAreInTheOshCommittee from './relational/how_many_female_members_are_in_the_osh_committee/index.js'
import * as howManyFemalesAreUndTheApplicableLegalMinimumWorkingA from './relational/how_many_females_are_und_the_applicable_legal_minimum_working_a/index.js'
import * as howManyForeignMigrantWorkerMembersAreInTheOshCommitte from './relational/how_many_foreign_migrant_worker_members_are_in_the_osh_committe/index.js'
import * as howManyForeignMigrantWrkrsAreInTheBipartiteCommittee from './relational/how_many_foreign_migrant_wrkrs_are_in_the_bipartite_committee/index.js'
import * as howManyIndustrialActionsstrikesHaveOccurred from './relational/how_many_industrial_actionsstrikes_have_occurred/index.js'
import * as howManyLangsMustBeSpokenBySupvsAndMgmtInOrderToEff from './relational/how_many_langs_must_be_spoken_by_supvs_and_mgmt_in_order_to_eff/index.js'
import * as howManyLanguagesMustBeSpokenSupervisorsManagement from './relational/how_many_languages_must_be_spoken_supervisors_management/index.js'
import * as howManyMalesAreUndTheApplicableLegalMinimumWorkingAge from './relational/how_many_males_are_und_the_applicable_legal_minimum_working_age/index.js'
import * as howManyMembersAreInTheBipartiteCommittee from './relational/how_many_members_are_in_the_bipartite_committee/index.js'
import * as howManyMembersAreInTheOshCommittee from './relational/how_many_members_are_in_the_osh_committee/index.js'
import * as howManyNationalitiesAreRepresentedAmongWorkersSupervisors from './relational/how_many_nationalities_are_represented_among_workers_supervisors/index.js'
import * as howManyNationalitiesAreRepresentedAmongWrkrsAndSupvsAt from './relational/how_many_nationalities_are_represented_among_wrkrs_and_supvs_at/index.js'
import * as howManyOffSiteDormitoriesWereVisitedProvide from './relational/how_many_off_site_dormitories_were_visited_provide/index.js'
import * as howManyOnsiteDormitoriesWereVisitedProvideTotal from './relational/how_many_onsite_dormitories_were_visited_provide_total/index.js'
import * as howManySocialLaborAuditsHaveTakenPlace from './relational/how_many_social_labor_audits_have_taken_place/index.js'
import * as howManyStillValidIndependentCertificationStandardAudits from './relational/how_many_still_valid_independent_certification_standard_audits/index.js'
import * as howManyTotalDaysWereWrkrsOnStrikeForAllStrikesDuring from './relational/how_many_total_days_were_wrkrs_on_strike_for_all_strikes_during/index.js'
import * as howManyTotalPersonDaysWereWrkrsOnStrikeForAllStrikes from './relational/how_many_total_person_days_were_wrkrs_on_strike_for_all_strikes/index.js'
import * as howManyUnionRepresentativesAreInTheBipartiteCommittee from './relational/how_many_union_representatives_are_in_the_bipartite_committee/index.js'
import * as howManyUnionRepresentativesAreInTheOshCommittee from './relational/how_many_union_representatives_are_in_the_osh_committee/index.js'
import * as howManyWageGradesLevelsDoesTheFacHave from './relational/how_many_wage_grades_levels_does_the_fac_have/index.js'
import * as howManyWorkerMembersAreInTheBipartiteCommittee from './relational/how_many_worker_members_are_in_the_bipartite_committee/index.js'
import * as howManyWorkerMembersAreInTheOshCommittee from './relational/how_many_worker_members_are_in_the_osh_committee/index.js'
import * as howManyWorkersBecameDisabledWhateverReason from './relational/how_many_workers_became_disabled_whatever_reason/index.js'
import * as howManyWorkersUnderAge_18HaveWorked from './relational/how_many_workers_under_age_18_have_worked/index.js'
import * as howManyWrkrsBecameDisabledForAWorkrelatedReason from './relational/how_many_wrkrs_became_disabled_for_a_workrelated_reason/index.js'
import * as howManyWrkrsBecameDisabledForWhateverReason from './relational/how_many_wrkrs_became_disabled_for_whatever_reason/index.js'
import * as howOftenHasTheGrievanceMechanismBeenUsedInTheAssessme from './relational/how_often_has_the_grievance_mechanism_been_used_in_the_assessme/index.js'
import * as icsInitiativeComplianceSustainability from './relational/ics_initiative_compliance_sustainability/index.js'
import * as identificationDetailsFirstLastNameOrgPartiesPresent from './relational/identification_details_first_last_name_org_parties_present/index.js'
import * as idsBadgesSwipeCards from './relational/ids_badges_swipe_cards/index.js'
import * as ietpIctiEthicalToyProgram from './relational/ietp_icti_ethical_toy_program/index.js'
import * as ifEquipmentContainsPcbDoesTheFacHaveAllOfTheFollowin from './relational/if_equipment_contains_pcb_does_the_fac_have_all_of_the_followin/index.js'
import * as ifMoreThan_10DaysPleaseDescribe from './relational/if_more_than_10_days_please_describe/index.js'
import * as ifNoDescWhenAssessorOnSiteAndWhyVerifNotTakePlace from './relational/if_no_desc_when_assessor_on_site_and_why_verif_not_take_place/index.js'
import * as ifOtherPleaseDescribe_1 from './relational/if_other_please_describe_1/index.js'
import * as ifOtherPleaseDescribe_10 from './relational/if_other_please_describe_10/index.js'
import * as ifOtherPleaseDescribe_11 from './relational/if_other_please_describe_11/index.js'
import * as ifOtherPleaseDescribe_12 from './relational/if_other_please_describe_12/index.js'
import * as ifOtherPleaseDescribe_13 from './relational/if_other_please_describe_13/index.js'
import * as ifOtherPleaseDescribe_14 from './relational/if_other_please_describe_14/index.js'
import * as ifOtherPleaseDescribe_15 from './relational/if_other_please_describe_15/index.js'
import * as ifOtherPleaseDescribe_16 from './relational/if_other_please_describe_16/index.js'
import * as ifOtherPleaseDescribe_17 from './relational/if_other_please_describe_17/index.js'
import * as ifOtherPleaseDescribe_18 from './relational/if_other_please_describe_18/index.js'
import * as ifOtherPleaseDescribe_19 from './relational/if_other_please_describe_19/index.js'
import * as ifOtherPleaseDescribe_2 from './relational/if_other_please_describe_2/index.js'
import * as ifOtherPleaseDescribe_20 from './relational/if_other_please_describe_20/index.js'
import * as ifOtherPleaseDescribe_3 from './relational/if_other_please_describe_3/index.js'
import * as ifOtherPleaseDescribe_4 from './relational/if_other_please_describe_4/index.js'
import * as ifOtherPleaseDescribe_5 from './relational/if_other_please_describe_5/index.js'
import * as ifOtherPleaseDescribe_6 from './relational/if_other_please_describe_6/index.js'
import * as ifOtherPleaseDescribe_7 from './relational/if_other_please_describe_7/index.js'
import * as ifOtherPleaseDescribe_8 from './relational/if_other_please_describe_8/index.js'
import * as ifOtherPleaseDescribe_9 from './relational/if_other_please_describe_9/index.js'
import * as ifTheFacEngagedEitherDirectlyOrViaIndustrialTradeAsso from './relational/if_the_fac_engaged_either_directly_or_via_industrial_trade_asso/index.js'
import * as ifTheFacHasNoTradeUnionAreWrkrsFreeToTheirNonunion from './relational/if_the_fac_has_no_trade_union_are_wrkrs_free_to_their_nonunion/index.js'
import * as ifTheFacHasOverdueSocialInsuranceSocialSecurityDebtsD from './relational/if_the_fac_has_overdue_social_insurance_social_security_debts_d/index.js'
import * as ifWrkrsArePaidByDirectDepositIntoABankAccountDoThey from './relational/if_wrkrs_are_paid_by_direct_deposit_into_a_bank_account_do_they/index.js'
import * as ifWrkrsArePaidThrough_3rdPartyAgentsHaveWrkrsAuthorize from './relational/if_wrkrs_are_paid_through_3rd_party_agents_have_wrkrs_authorize/index.js'
import * as ifYesAreHealthChecksArrangedPriorToEmployment from './relational/if_yes_are_health_checks_arranged_prior_to_employment/index.js'
import * as ifYesAreTheseHivAidsTestsAdministeredInLineWLegalRe_1 from './relational/if_yes_are_these_hiv_aids_tests_administered_in_line_w_legal_re_1/index.js'
import * as ifYesAreTheseInfectionOrIllnessTestsAdministeredInLin_1 from './relational/if_yes_are_these_infection_or_illness_tests_administered_in_lin_1/index.js'
import * as ifYesAreWorkerPerformanceEvaluationsSharedAndorDiscusse from './relational/if_yes_are_worker_performance_evaluations_shared_andor_discusse/index.js'
import * as ifYesDoesTheFacFollowAnyOfTheFollowingPracticesRegar from './relational/if_yes_does_the_fac_follow_any_of_the_following_practices_regar/index.js'
import * as ifYesDoRegularHoursExceed_48HoursPerWeek from './relational/if_yes_do_regular_hours_exceed_48_hours_per_week/index.js'
import * as ifYesDoWrkrsConfirmTheAccuracyOfPayoutsAndRepayments from './relational/if_yes_do_wrkrs_confirm_the_accuracy_of_payouts_and_repayments/index.js'
import * as ifYesPleaseDescribe_1 from './relational/if_yes_please_describe_1/index.js'
import * as ifYesPleaseDescribe_2 from './relational/if_yes_please_describe_2/index.js'
import * as ifYesPleaseProvide from './relational/if_yes_please_provide/index.js'
import * as iloBetterWorkInternationalLabourOrganization from './relational/ilo_better_work_international_labour_organization/index.js'
import * as imageList from './relational/image_list/index.js'
import * as inappropriateContainersAreUsedDispensingChemicals from './relational/inappropriate_containers_are_used_dispensing_chemicals/index.js'
import * as incoterms from './transactional/incoterms/index.js'
import * as individualsResponsibleForImplementation_1 from './relational/individuals_responsible_for_implementation_1/index.js'
import * as individualsResponsibleForImplementation_10 from './relational/individuals_responsible_for_implementation_10/index.js'
import * as individualsResponsibleForImplementation_11 from './relational/individuals_responsible_for_implementation_11/index.js'
import * as individualsResponsibleForImplementation_12 from './relational/individuals_responsible_for_implementation_12/index.js'
import * as individualsResponsibleForImplementation_13 from './relational/individuals_responsible_for_implementation_13/index.js'
import * as individualsResponsibleForImplementation_14 from './relational/individuals_responsible_for_implementation_14/index.js'
import * as individualsResponsibleForImplementation_15 from './relational/individuals_responsible_for_implementation_15/index.js'
import * as individualsResponsibleForImplementation_16 from './relational/individuals_responsible_for_implementation_16/index.js'
import * as individualsResponsibleForImplementation_17 from './relational/individuals_responsible_for_implementation_17/index.js'
import * as individualsResponsibleForImplementation_18 from './relational/individuals_responsible_for_implementation_18/index.js'
import * as individualsResponsibleForImplementation_19 from './relational/individuals_responsible_for_implementation_19/index.js'
import * as individualsResponsibleForImplementation_2 from './relational/individuals_responsible_for_implementation_2/index.js'
import * as individualsResponsibleForImplementation_20 from './relational/individuals_responsible_for_implementation_20/index.js'
import * as individualsResponsibleForImplementation_21 from './relational/individuals_responsible_for_implementation_21/index.js'
import * as individualsResponsibleForImplementation_22 from './relational/individuals_responsible_for_implementation_22/index.js'
import * as individualsResponsibleForImplementation_23 from './relational/individuals_responsible_for_implementation_23/index.js'
import * as individualsResponsibleForImplementation_24 from './relational/individuals_responsible_for_implementation_24/index.js'
import * as individualsResponsibleForImplementation_3 from './relational/individuals_responsible_for_implementation_3/index.js'
import * as individualsResponsibleForImplementation_4 from './relational/individuals_responsible_for_implementation_4/index.js'
import * as individualsResponsibleForImplementation_5 from './relational/individuals_responsible_for_implementation_5/index.js'
import * as individualsResponsibleForImplementation_6 from './relational/individuals_responsible_for_implementation_6/index.js'
import * as individualsResponsibleForImplementation_7 from './relational/individuals_responsible_for_implementation_7/index.js'
import * as individualsResponsibleForImplementation_8 from './relational/individuals_responsible_for_implementation_8/index.js'
import * as individualsResponsibleForImplementation_9 from './relational/individuals_responsible_for_implementation_9/index.js'
import * as indonesiaDoesFacComplyLegalReqConcerningOutsourced from './relational/indonesia_does_fac_comply_legal_req_concerning_outsourced/index.js'
import * as indonesiaDoesFacComplyLegalReqConcerningPremium from './relational/indonesia_does_fac_comply_legal_req_concerning_premium/index.js'
import * as initialRefresherTrainOnResponsibilitiesMembersFireBrigade from './relational/initial_refresher_train_on_responsibilities_members_fire_brigade/index.js'
import * as inLineWLegalReqsAreAnyOfTheConfinedSpacesPermitRequ from './relational/in_line_w_legal_reqs_are_any_of_the_confined_spaces_permit_requ/index.js'
import * as insuranceCosts from './relational/insurance_costs/index.js'
import * as internalCompanyCode from './relational/internal_company_code/index.js'
import * as ioshBusinessAssuranceCertification from './relational/iosh_business_assurance_certification/index.js'
import * as isAccessToHighVoltageAreasAndGeneratorAreasRestricted from './relational/is_access_to_high_voltage_areas_and_generator_areas_restricted/index.js'
import * as isAJobApplicantsCurrentOrPreviousTradeUnionMembership from './relational/is_a_job_applicants_current_or_previous_trade_union_membership/index.js'
import * as isALightningProtectorarrestorSystemInstalledOnTheBuildi from './relational/is_a_lightning_protectorarrestor_system_installed_on_the_buildi/index.js'
import * as isAnAnnualReviewOfTheEmergencyResponsePlanConductedTo from './relational/is_an_annual_review_of_the_emergency_response_plan_conducted_to/index.js'
import * as isBurningOfWasteDoneOnsite from './relational/is_burning_of_waste_done_onsite/index.js'
import * as isDocumentationOfHealthChecksMaintainedAndUpToDate from './relational/is_documentation_of_health_checks_maintained_and_up_to_date/index.js'
import * as isElectricalEquipmentInspectionAndMaintenanceCarriedOut from './relational/is_electrical_equipment_inspection_and_maintenance_carried_out/index.js'
import * as isFacLightingInLineWLegalReqs from './relational/is_fac_lighting_in_line_w_legal_reqs/index.js'
import * as isHotWorkPerformedInLineWLegalReqs from './relational/is_hot_work_performed_in_line_w_legal_reqs/index.js'
import * as isLaserAndRadiationProducingEquipmentInLineWLegalReqs from './relational/is_laser_and_radiation_producing_equipment_in_line_w_legal_reqs/index.js'
import * as iso_14001 from './relational/iso_14001/index.js'
import * as iso_26000 from './relational/iso_26000/index.js'
import * as iso_31000 from './relational/iso_31000/index.js'
import * as iso_45001 from './relational/iso_45001/index.js'
import * as iso_50001UneEnIso_5000s from './relational/iso_50001_une_en_iso_5000s/index.js'
import * as iso_9000 from './relational/iso_9000/index.js'
import * as isOvertimeVoluntaryInLineWLegalReqs from './relational/is_overtime_voluntary_in_line_w_legal_reqs/index.js'
import * as isRequiredHealthAndSafetyTrainingForWrkrsOfferedFreeO from './relational/is_required_health_and_safety_training_for_wrkrs_offered_free_o/index.js'
import * as isTheBackupEmergencyPowerSystemWorkingAndInGoodCondit from './relational/is_the_backup_emergency_power_system_working_and_in_good_condit/index.js'
import * as isTheCommuteServiceProvdByOrganizedByTheFac from './relational/is_the_commute_service_provd_by_organized_by_the_fac/index.js'
import * as isTheEmergencyAlarmSystemForAllTypesOfEmergenciesOthe from './relational/is_the_emergency_alarm_system_for_all_types_of_emergencies_othe/index.js'
import * as isTheFacAccessibleToFireResponseAndEmergencyResponseV from './relational/is_the_fac_accessible_to_fire_response_and_emergency_response_v/index.js'
import * as isTheFacConsultingWTradeUnionsInLineWLegalReqs from './relational/is_the_fac_consulting_w_trade_unions_in_line_w_legal_reqs/index.js'
import * as isTheFacFailingToComplyWAnyLegalReqsForContractsAnd from './relational/is_the_fac_failing_to_comply_w_any_legal_reqs_for_contracts_and/index.js'
import * as isTheFacFailingToComplyWAnyLegalReqsForDisciplineHa from './relational/is_the_fac_failing_to_comply_w_any_legal_reqs_for_discipline_ha/index.js'
import * as isTheFacFailingToComplyWAnyLegalReqsForHealthSafety from './relational/is_the_fac_failing_to_comply_w_any_legal_reqs_for_health_safety/index.js'
import * as isTheFacFailingToComplyWAnyLegalReqsForTerminationP from './relational/is_the_fac_failing_to_comply_w_any_legal_reqs_for_termination_p/index.js'
import * as isTheFacFailingToComplyWAnyLegalReqsForWorkingHours from './relational/is_the_fac_failing_to_comply_w_any_legal_reqs_for_working_hours/index.js'
import * as isTheFacFailingToComplyWLegalReqsForAnyOfTheFollow from './relational/is_the_fac_failing_to_comply_w_legal_reqs_for_any_of_the_follow/index.js'
import * as isTheFacFailingToComplyWLegalReqsRegardingWorkerResi from './relational/is_the_fac_failing_to_comply_w_legal_reqs_regarding_worker_resi/index.js'
import * as isTheFacFailingToContributeTheLegallyRequiredAmountFo from './relational/is_the_fac_failing_to_contribute_the_legally_required_amount_fo/index.js'
import * as isTheFacFailingToCorrectlyPayWrkrsForAnyOfTheseType from './relational/is_the_fac_failing_to_correctly_pay_wrkrs_for_any_of_these_type/index.js'
import * as isTheFacFailingToCorrectlyProvWrkrsTimeOffForAnyOf from './relational/is_the_fac_failing_to_correctly_prov_wrkrs_time_off_for_any_of/index.js'
import * as isTheFacFailingToImplementMeasuresRegardingHousingdormi from './relational/is_the_fac_failing_to_implement_measures_regarding_housingdormi/index.js'
import * as isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe from './relational/is_the_fac_failing_to_pay_any_worker_at_least_the_basic_wage_re/index.js'
import * as isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe_1 from './relational/is_the_fac_failing_to_pay_any_worker_at_least_the_basic_wage_re_1/index.js'
import * as isTheFacFailingToPayAnyWorkerAtLeastTheLegalMinimum from './relational/is_the_fac_failing_to_pay_any_worker_at_least_the_legal_minimum/index.js'
import * as isTheFacFailingToPayWrkrsCorrectlyForAnyOfTheseType from './relational/is_the_fac_failing_to_pay_wrkrs_correctly_for_any_of_these_type/index.js'
import * as isTheFacFailingToPayWrkrsOvertimeInLineWLegalReqsI from './relational/is_the_fac_failing_to_pay_wrkrs_overtime_in_line_w_legal_reqs_i/index.js'
import * as isTheFacFailingToPayWrkrsPremiumPayAsLegallyRequired from './relational/is_the_fac_failing_to_pay_wrkrs_premium_pay_as_legally_required/index.js'
import * as isTheFacility_1 from './relational/is_the_facility_1/index.js'
import * as isTheFacility_2 from './relational/is_the_facility_2/index.js'
import * as isTheFacility_3 from './relational/is_the_facility_3/index.js'
import * as isTheFacsApprenticeshipTrainingInternshipProgramInLine from './relational/is_the_facs_apprenticeship_training_internship_program_in_line/index.js'
import * as isTheFacsPracticeAroundFinancialOrOtherSupportOfTheU from './relational/is_the_facs_practice_around_financial_or_other_support_of_the_u/index.js'
import * as isTheFacsPracticeAroundLimitsOnTheUseOfFixedtermCont from './relational/is_the_facs_practice_around_limits_on_the_use_of_fixedterm_cont/index.js'
import * as isTheFacsPracticeOfConsultingWWrkrsAndorNotifyingThem from './relational/is_the_facs_practice_of_consulting_w_wrkrs_andor_notifying_them/index.js'
import * as isTheFacsPracticeOfProvidingSpecialHealthAndSafetyTra from './relational/is_the_facs_practice_of_providing_special_health_and_safety_tra/index.js'
import * as isTheFacsPracticeOfRequiringWrkrsToTakePaidOrUnpaid from './relational/is_the_facs_practice_of_requiring_wrkrs_to_take_paid_or_unpaid/index.js'
import * as isTheFacsRecruitmentProcessForForeignMigrantWrkrsInLi from './relational/is_the_facs_recruitment_process_for_foreign_migrant_wrkrs_in_li/index.js'
import * as isTheFireDetectionAndAlarmSystemInLineWLegalReqs from './relational/is_the_fire_detection_and_alarm_system_in_line_w_legal_reqs/index.js'
import * as isTheLightningProtectorarrestorSystemInLineWLegalReqs from './relational/is_the_lightning_protectorarrestor_system_in_line_w_legal_reqs/index.js'
import * as isTheOshCommitteeFormedAndFunctioningInLineWLegalReq from './relational/is_the_osh_committee_formed_and_functioning_in_line_w_legal_req/index.js'
import * as isTheOtherGroundsIdentifiedFactoredIntoHiringDecisions from './relational/is_the_other_grounds_identified_factored_into_hiring_decisions/index.js'
import * as isThereAManualOrAutomaticEmergencyAlarmSystemForAllT from './relational/is_there_a_manual_or_automatic_emergency_alarm_system_for_all_t/index.js'
import * as isThereAnElectricalPowerSubstationOnsiteAtTheFac from './relational/is_there_an_electrical_power_substation_onsite_at_the_fac/index.js'
import * as isThereAnOffsiteCanteenManagedByTheFac from './relational/is_there_an_offsite_canteen_managed_by_the_fac/index.js'
import * as isThereAnOnsiteCanteeneatingArea from './relational/is_there_an_onsite_canteeneating_area/index.js'
import * as isThereAWrittenOccupationalHealthAndSafetyPolicyInLin from './relational/is_there_a_written_occupational_health_and_safety_policy_in_lin/index.js'
import * as isTheReceiptOfWagePaymentConfirmedInWritingByWrkrs from './relational/is_the_receipt_of_wage_payment_confirmed_in_writing_by_wrkrs/index.js'
import * as isThereOnsiteVehicleTrafficAtTheFac from './relational/is_there_onsite_vehicle_traffic_at_the_fac/index.js'
import * as isThereWrittenDocumentationSurroundingTheTermsAndCondit from './relational/is_there_written_documentation_surrounding_the_terms_and_condit/index.js'
import * as isTheRiskAssessmentUpdatedIfNewMachineryProcessesChemi from './relational/is_the_risk_assessment_updated_if_new_machinery_processes_chemi/index.js'
import * as isTheSubstationInLineWLegalReqsOrFireratedConstructio from './relational/is_the_substation_in_line_w_legal_reqs_or_firerated_constructio/index.js'
import * as isTheWorkplaceCleanAndTidy from './relational/is_the_workplace_clean_and_tidy/index.js'
import * as isThisFacOwnedAndorManagedByAWoman from './relational/is_this_fac_owned_andor_managed_by_a_woman/index.js'
import * as labeling from './relational/labeling/index.js'
import * as labsLifeBuildingSafety from './relational/labs_life_building_safety/index.js'
import * as laminating from './relational/laminating/index.js'
import * as laminationCoating from './relational/lamination_coating/index.js'
import * as laserRadiationProducingEquipmentLineLegalRequirements from './relational/laser_radiation_producing_equipment_line_legal_requirements/index.js'
import * as lasting_1 from './relational/lasting_1/index.js'
import * as lasting_2 from './relational/lasting_2/index.js'
import * as leatherTanningFinishing from './relational/leather_tanning_finishing/index.js'
import * as leatherTanningWetOperations from './relational/leather_tanning_wet_operations/index.js'
import * as leatherWorkingGroupBronze from './relational/leather_working_group_bronze/index.js'
import * as leatherWorkingGroupGold from './relational/leather_working_group_gold/index.js'
import * as leatherWorkingGroupSilver from './relational/leather_working_group_silver/index.js'
import * as legalServices from './relational/legal_services/index.js'
import * as lighting from './relational/lighting/index.js'
import * as listAdditionalNationalitiesApproximateWkrsSupervisorsHere from './relational/list_additional_nationalities_approximate_wkrs_supervisors_here/index.js'
import * as listAnyAdditionalNationalitiesAndTheApproximateOfWrkrs from './relational/list_any_additional_nationalities_and_the_approximate_of_wrkrs/index.js'
import * as listTheBusinessNmsOfTheOtherOccupantsOfTheBuilding from './relational/list_the_business_nms_of_the_other_occupants_of_the_building/index.js'
import * as livingWageCalculation from './relational/living_wage_calculation/index.js'
import * as livingWageLocalCurrency from './relational/living_wage_local_currency/index.js'
import * as localBrandRepresentatives from './relational/local_brand_representatives/index.js'
import * as localLawEnforcementGovernmentAgency from './relational/local_law_enforcement_government_agency/index.js'
import * as lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon from './relational/lowest_wage_grade_level_average_monthly_allowance_incentive_bon/index.js'
import * as lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon_1 from './relational/lowest_wage_grade_level_average_monthly_allowance_incentive_bon_1/index.js'
import * as lowestWageGradeLevelAverageMonthlyBasicWageFemale from './relational/lowest_wage_grade_level_average_monthly_basic_wage_female/index.js'
import * as lowestWageGradeLevelAverageMonthlyBasicWageMale from './relational/lowest_wage_grade_level_average_monthly_basic_wage_male/index.js'
import * as lowestWageGradeLevelAverageMonthlyOvertimeEarningsFemal from './relational/lowest_wage_grade_level_average_monthly_overtime_earnings_femal/index.js'
import * as lowestWageGradeLevelAverageMonthlyOvertimeEarningsMale from './relational/lowest_wage_grade_level_average_monthly_overtime_earnings_male/index.js'
import * as lowestWageGradeLevelAverageMonthlyTakehomePayFemale from './relational/lowest_wage_grade_level_average_monthly_takehome_pay_female/index.js'
import * as lowestWageGradeLevelAverageMonthlyTakehomePayMale from './relational/lowest_wage_grade_level_average_monthly_takehome_pay_male/index.js'
import * as lowestWagePaidRegularWork from './relational/lowest_wage_paid_regular_work/index.js'
import * as luggageBags from './relational/luggage_bags/index.js'
import * as manufactureKnittedCrochetedFabrics from './relational/manufacture_knitted_crocheted_fabrics/index.js'
import * as manufactureOfWearingApparel from './relational/manufacture_of_wearing_apparel/index.js'
import * as manufacturerIdentificationCode from './global/manufacturer_identification_code/index.js'
import * as maritalStatus_1 from './relational/marital_status_1/index.js'
import * as maritalStatus_2 from './relational/marital_status_2/index.js'
import * as maritalStatus_3 from './relational/marital_status_3/index.js'
import * as maritalStatusFactoredIntoHiringDecisionsNotLine from './relational/marital_status_factored_into_hiring_decisions_not_line/index.js'
import * as maritalStatusReferencedNotLineLegalRequirements from './relational/marital_status_referenced_not_line_legal_requirements/index.js'
import * as materialCutoff from './relational/material_cutoff/index.js'
import * as maternityLeave_1 from './relational/maternity_leave_1/index.js'
import * as maternityLeave_2 from './relational/maternity_leave_2/index.js'
import * as maternityNotCollectedForwarded from './relational/maternity_not_collected_forwarded/index.js'
import * as medicalCosts from './relational/medical_costs/index.js'
import * as medicalFacilitiesClinicsAreNotKeptCleanSanitary from './relational/medical_facilities_clinics_are_not_kept_clean_sanitary/index.js'
import * as medicalFacilitiesClinicsAreNotOperationDuringWorking from './relational/medical_facilities_clinics_are_not_operation_during_working/index.js'
import * as medicalNotCollectedForwarded from './relational/medical_not_collected_forwarded/index.js'
import * as medicalServices from './relational/medical_services/index.js'
import * as medicinesStoredMedicalFacilitiesClinicsAreNotKept from './relational/medicines_stored_medical_facilities_clinics_are_not_kept/index.js'
import * as metalProcessing from './relational/metal_processing/index.js'
import * as metalWork from './relational/metal_work/index.js'
import * as minimumAmountPaidHolidays from './relational/minimum_amount_paid_holidays/index.js'
import * as minimumOrderQuantity from './relational/minimum_order_quantity/index.js'
import * as minimumOrderQuantityPerStyle from './relational/minimum_order_quantity_per_style/index.js'
import * as minimumWageAgreedOnCbaLocalCurrency from './relational/minimum_wage_agreed_on_cba_local_currency/index.js'
import * as mininumWageLocalCurrency from './relational/mininum_wage_local_currency/index.js'
import * as mobileMoney from './relational/mobile_money/index.js'
import * as molding_1 from './relational/molding_1/index.js'
import * as molding_2 from './relational/molding_2/index.js'
import * as molding_3 from './relational/molding_3/index.js'
import * as moldingPlastic from './relational/molding_plastic/index.js'
import * as namesOfOrganizationsProvidingContractWorkers from './relational/names_of_organizations_providing_contract_workers/index.js'
import * as namesOfOrganizationsProvidingContractWorkersNotPartOfTheProductionProcess from './relational/names_of_organizations_providing_contract_workers_not_part_of_the_production_process/index.js'
import * as nanomaterials from './relational/nanomaterials/index.js'
import * as nationalExtraction_1 from './relational/national_extraction_1/index.js'
import * as nationalExtraction_2 from './relational/national_extraction_2/index.js'
import * as nationalExtraction_3 from './relational/national_extraction_3/index.js'
import * as nationalExtractionFactoredIntoHiringDecisionsNotLine from './relational/national_extraction_factored_into_hiring_decisions_not_line/index.js'
import * as nationalExtractionReferencedNotLineLegalRequirements from './relational/national_extraction_referenced_not_line_legal_requirements/index.js'
import * as nationalities from './relational/nationalities/index.js'
import * as nationality_2 from './relational/nationality_2/index.js'
import * as nationality_3 from './relational/nationality_3/index.js'
import * as nationality_4 from './relational/nationality_4/index.js'
import * as nationalityForeignMigrantWorkerStatus_1 from './relational/nationality_foreign_migrant_worker_status_1/index.js'
import * as nationalityForeignMigrantWorkerStatus_2 from './relational/nationality_foreign_migrant_worker_status_2/index.js'
import * as nationalityForeignMigrantWorkerStatus_3 from './relational/nationality_foreign_migrant_worker_status_3/index.js'
import * as nationalityForeignMigrantWorkerStatusFactoredIntoHiring from './relational/nationality_foreign_migrant_worker_status_factored_into_hiring/index.js'
import * as nationalityForeignMigrantWorkerStatusReferencedNotLine from './relational/nationality_foreign_migrant_worker_status_referenced_not_line/index.js'
import * as newProductionWorkers_1 from './relational/new_production_workers_1/index.js'
import * as newProductionWorkers_10 from './relational/new_production_workers_10/index.js'
import * as newProductionWorkers_11 from './relational/new_production_workers_11/index.js'
import * as newProductionWorkers_12 from './relational/new_production_workers_12/index.js'
import * as newProductionWorkers_13 from './relational/new_production_workers_13/index.js'
import * as newProductionWorkers_14 from './relational/new_production_workers_14/index.js'
import * as newProductionWorkers_15 from './relational/new_production_workers_15/index.js'
import * as newProductionWorkers_16 from './relational/new_production_workers_16/index.js'
import * as newProductionWorkers_17 from './relational/new_production_workers_17/index.js'
import * as newProductionWorkers_18 from './relational/new_production_workers_18/index.js'
import * as newProductionWorkers_19 from './relational/new_production_workers_19/index.js'
import * as newProductionWorkers_2 from './relational/new_production_workers_2/index.js'
import * as newProductionWorkers_20 from './relational/new_production_workers_20/index.js'
import * as newProductionWorkers_21 from './relational/new_production_workers_21/index.js'
import * as newProductionWorkers_22 from './relational/new_production_workers_22/index.js'
import * as newProductionWorkers_23 from './relational/new_production_workers_23/index.js'
import * as newProductionWorkers_24 from './relational/new_production_workers_24/index.js'
import * as newProductionWorkers_3 from './relational/new_production_workers_3/index.js'
import * as newProductionWorkers_4 from './relational/new_production_workers_4/index.js'
import * as newProductionWorkers_5 from './relational/new_production_workers_5/index.js'
import * as newProductionWorkers_6 from './relational/new_production_workers_6/index.js'
import * as newProductionWorkers_7 from './relational/new_production_workers_7/index.js'
import * as newProductionWorkers_8 from './relational/new_production_workers_8/index.js'
import * as newProductionWorkers_9 from './relational/new_production_workers_9/index.js'
import * as newProductionWorkersExistingProductionWorkersDoNot from './relational/new_production_workers_existing_production_workers_do_not/index.js'
import * as newProductionWorkersExistingSecurityGuards_1 from './relational/new_production_workers_existing_security_guards_1/index.js'
import * as newProductionWorkersExistingSecurityGuards_2 from './relational/new_production_workers_existing_security_guards_2/index.js'
import * as nmOfTheFederationOrConfederationOrBothWWhichThe_2ndL from './relational/nm_of_the_federation_or_confederation_or_both_w_which_the_2nd_l/index.js'
import * as nmOfTheFederationOrConfederationOrBothWWhichThe_3rdL from './relational/nm_of_the_federation_or_confederation_or_both_w_which_the_3rd_l/index.js'
import * as nmOfTheFederationOrConfederationOrBothWWhichThe_4thL from './relational/nm_of_the_federation_or_confederation_or_both_w_which_the_4th_l/index.js'
import * as nmOfTheFederationOrConfederationOrBothWWhichThe_5thL from './relational/nm_of_the_federation_or_confederation_or_both_w_which_the_5th_l/index.js'
import * as nmOfTheFederationOrConfederationOrBothWWhichTheLarge from './relational/nm_of_the_federation_or_confederation_or_both_w_which_the_large/index.js'
import * as nmOfUnionWThe_2ndLargestMembership from './relational/nm_of_union_w_the_2nd_largest_membership/index.js'
import * as nmOfUnionWThe_3rdLargestMembership from './relational/nm_of_union_w_the_3rd_largest_membership/index.js'
import * as nmOfUnionWThe_4thLargestMembership from './relational/nm_of_union_w_the_4th_largest_membership/index.js'
import * as nmOfUnionWThe_5thLargestMembership from './relational/nm_of_union_w_the_5th_largest_membership/index.js'
import * as nmOfUnionWTheLargestMembership from './relational/nm_of_union_w_the_largest_membership/index.js'
import * as nNDimethylformamideDmf from './relational/n_n_dimethylformamide_dmf/index.js'
import * as noAdequateGuardrailsFencingExposedOverheadWorkingSurfaces from './relational/no_adequate_guardrails_fencing_exposed_overhead_working_surfaces/index.js'
import * as noAdequateStrengthStorageRacksSupportExistingLoads from './relational/no_adequate_strength_storage_racks_support_existing_loads/index.js'
import * as noAdjustableEquipmentAccommodateIndWorkerNeedsProvided from './relational/no_adjustable_equipment_accommodate_ind_worker_needs_provided/index.js'
import * as noAdjustableWorkstationsAccommodateIndWorkerNeedsProvided from './relational/no_adjustable_workstations_accommodate_ind_worker_needs_provided/index.js'
import * as noAnnualMedicalExaminationsDoneOnFoodService from './relational/no_annual_medical_examinations_done_on_food_service/index.js'
import * as noAppointedDoctorNurseMedicalFacilitiesClinicS from './relational/no_appointed_doctor_nurse_medical_facilities_clinic_s/index.js'
import * as noAppropriateDesignStorageAreas from './relational/no_appropriate_design_storage_areas/index.js'
import * as noAppropriateDistanceOtherControlsEGFire from './relational/no_appropriate_distance_other_controls_e_g_fire/index.js'
import * as noAppropriateEquipmentFightFiresIncludingCorrectPpe from './relational/no_appropriate_equipment_fight_fires_including_correct_ppe/index.js'
import * as noAppropriateProtectionLaserRadiationEquipment from './relational/no_appropriate_protection_laser_radiation_equipment/index.js'
import * as noAppropriateProtectionsEnsureNoAccidentalEntryEach from './relational/no_appropriate_protections_ensure_no_accidental_entry_each/index.js'
import * as noAppropriateSafeStoragePpeEquipmentClothingOn from './relational/no_appropriate_safe_storage_ppe_equipment_clothing_on/index.js'
import * as noAppropriateSignsLaserRadiationEquipment from './relational/no_appropriate_signs_laser_radiation_equipment/index.js'
import * as noAppropriateVentilationAreasWhereHotWorkConducted from './relational/no_appropriate_ventilation_areas_where_hot_work_conducted/index.js'
import * as noApprovedDesignatedAreaHotWork from './relational/no_approved_designated_area_hot_work/index.js'
import * as noAssessmentAfterDrillLearnHowImproveEvacuation from './relational/no_assessment_after_drill_learn_how_improve_evacuation/index.js'
import * as noAssuranceThatChemicalContainersAreProperlyCapped from './relational/no_assurance_that_chemical_containers_are_properly_capped/index.js'
import * as noAssuranceThatChemicalsAreBroughtIntoFacility from './relational/no_assurance_that_chemicals_are_brought_into_facility/index.js'
import * as noAssuranceThatChildrenAreOnlyReleasedParents from './relational/no_assurance_that_children_are_only_released_parents/index.js'
import * as noAssuranceThatCompressedGasCylindersAreOnly from './relational/no_assurance_that_compressed_gas_cylinders_are_only/index.js'
import * as noAssuranceThatCompressedGasCylindersHaveClosed from './relational/no_assurance_that_compressed_gas_cylinders_have_closed/index.js'
import * as noAssuranceThatDoorsWindowsAreClosed from './relational/no_assurance_that_doors_windows_are_closed/index.js'
import * as noAssuranceThatEveryWorkerEvacuates from './relational/no_assurance_that_every_worker_evacuates/index.js'
import * as noAssuranceThatOnlyAuthorizedPeopleVehiclesAre from './relational/no_assurance_that_only_authorized_people_vehicles_are/index.js'
import * as noAssuranceThatOnlyAuthorizedTrainedQualifiedPeople from './relational/no_assurance_that_only_authorized_trained_qualified_people/index.js'
import * as noAssuranceThatVehiclesAreDrivenAppropriateSpeed from './relational/no_assurance_that_vehicles_are_driven_appropriate_speed/index.js'
import * as noAssuranceThatVehiclesAreOnlyUsedPurposes from './relational/no_assurance_that_vehicles_are_only_used_purposes/index.js'
import * as noAssuranceThatWorkersContractorsWhoEnterConfined_1 from './relational/no_assurance_that_workers_contractors_who_enter_confined_1/index.js'
import * as noAssuranceThatWorkersContractorsWhoEnterConfined_2 from './relational/no_assurance_that_workers_contractors_who_enter_confined_2/index.js'
import * as noAssuranceThatWorkersDisabilitiesSpecialNeedsAre from './relational/no_assurance_that_workers_disabilities_special_needs_are/index.js'
import * as noAssuranceThatWorkersMeetAssemblyMeetingPoints from './relational/no_assurance_that_workers_meet_assembly_meeting_points/index.js'
import * as noAssuranceThatWorkersWorkingRadiationSourcesAre from './relational/no_assurance_that_workers_working_radiation_sources_are/index.js'
import * as noAuthorizedEntryOnlyAccessForEachConfinedSpace from './relational/no_authorized_entry_only_access_for_each_confined_space/index.js'
import * as noAutomaticCentralizedEmergencyAlarmSystem from './relational/no_automatic_centralized_emergency_alarm_system/index.js'
import * as noAutomaticFireExtinguishingSystemChemicalStorageAreas from './relational/no_automatic_fire_extinguishing_system_chemical_storage_areas/index.js'
import * as noBackUpBatteryProvidingContinuousLightingWithin from './relational/no_back_up_battery_providing_continuous_lighting_within/index.js'
import * as noBreakdownPossibleAcrossTypesSocialInsuranceTotal_1 from './relational/no_breakdown_possible_across_types_social_insurance_total_1/index.js'
import * as noBreakdownPossibleAcrossTypesSocialInsuranceTotal_2 from './relational/no_breakdown_possible_across_types_social_insurance_total_2/index.js'
import * as noCertifiedFireResistantDoorsNoFireResistant from './relational/no_certified_fire_resistant_doors_no_fire_resistant/index.js'
import * as noClearDisplayLoadCapacityIENumber from './relational/no_clear_display_load_capacity_i_e_number/index.js'
import * as noCompleteSpillKitAppropriateTypesUseChemicals from './relational/no_complete_spill_kit_appropriate_types_use_chemicals/index.js'
import * as noConsistentUsePpeEquipmentClothingProvidedWorkers from './relational/no_consistent_use_ppe_equipment_clothing_provided_workers/index.js'
import * as noDesignatedEmergencyAssemblyAreasMeetingPointsWhich from './relational/no_designated_emergency_assembly_areas_meeting_points_which/index.js'
import * as noDisplayPostingMachineryEquipSafetyInstructionsWkrs from './relational/no_display_posting_machinery_equip_safety_instructions_wkrs/index.js'
import * as noEasyEntryIesExitSChemicalStorage from './relational/no_easy_entry_ies_exit_s_chemical_storage/index.js'
import * as noEquipMaterialsMaternalHealthcareMedicalFacClinic from './relational/no_equip_materials_maternal_healthcare_medical_fac_clinic/index.js'
import * as noFireExtinguisherProvidedFacilityWhenHotWorks from './relational/no_fire_extinguisher_provided_facility_when_hot_works/index.js'
import * as noFunctioningLockoutTagoutProgramMachineryEquipApplicable from './relational/no_functioning_lockout_tagout_program_machinery_equip_applicable/index.js'
import * as noHandrailHandrailingsAreNotGoodCondition from './relational/no_handrail_handrailings_are_not_good_condition/index.js'
import * as noHandwashingSanitizingStations from './relational/no_handwashing_sanitizing_stations/index.js'
import * as noHazardousSubstancesWetProcessesBeingUsed from './relational/no_hazardous_substances_wet_processes_being_used/index.js'
import * as noHowDoesFacilityEnsureTemperatureMaintainedProvide from './relational/no_how_does_facility_ensure_temperature_maintained_provide/index.js'
import * as noIlluminationNoVisibilityEmergencyExitsWhenIt from './relational/no_illumination_no_visibility_emergency_exits_when_it/index.js'
import * as noImpactWorkersWorkersReceiveTheirRegularPay from './relational/no_impact_workers_workers_receive_their_regular_pay/index.js'
import * as noImplBasicMedicalSurveillanceTechniquesMonitorWkrs from './relational/no_impl_basic_medical_surveillance_techniques_monitor_wkrs/index.js'
import * as noInspectionHotWorkEquipmentPriorUse from './relational/no_inspection_hot_work_equipment_prior_use/index.js'
import * as noLabelingMaterialsContainingAsbestosExposureAreas from './relational/no_labeling_materials_containing_asbestos_exposure_areas/index.js'
import * as noLabelingSegregationCompressedGasCylinders from './relational/no_labeling_segregation_compressed_gas_cylinders/index.js'
import * as noLockingDevicesOnLaddersLaddersNotSecure from './relational/no_locking_devices_on_ladders_ladders_not_secure/index.js'
import * as noMaintenanceRegularInspectionLaserRadiationEquipment from './relational/no_maintenance_regular_inspection_laser_radiation_equipment/index.js'
import * as noMaintenanceWorkerMachineryEquipmentTrainingRecordsLeast from './relational/no_maintenance_worker_machinery_equipment_training_records_least/index.js'
import * as noMarkingOf from './relational/no_marking_of/index.js'
import * as noMeasuresArePlacePreventFloorOpeningsHoles from './relational/no_measures_are_place_prevent_floor_openings_holes/index.js'
import * as noMeasuresArePlacePreventStandingWaterDue from './relational/no_measures_are_place_prevent_standing_water_due/index.js'
import * as noMeasuresPlacePreventUnauthorizedEntryChemicalStorage from './relational/no_measures_place_prevent_unauthorized_entry_chemical_storage/index.js'
import * as noMeasuresPreventAccidentalTippingFallingCompressedGas from './relational/no_measures_prevent_accidental_tipping_falling_compressed_gas/index.js'
import * as noMeasuresPreventWorkersFromSlippingOnFloors from './relational/no_measures_prevent_workers_from_slipping_on_floors/index.js'
import * as noMonitoringContractedPersonnelFacilityEnsureTheyPerform from './relational/no_monitoring_contracted_personnel_facility_ensure_they_perform/index.js'
import * as noneAboveFacCollectsForwardsLegallyRequiredContributions from './relational/none_above_fac_collects_forwards_legally_required_contributions/index.js'
import * as noneAboveFacilityContributionsTotalBrokenDownAre from './relational/none_above_facility_contributions_total_broken_down_are/index.js'
import * as noneAboveFacilityFollowsPracticesListedAboveRegarding from './relational/none_above_facility_follows_practices_listed_above_regarding/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAbovePrevent from './relational/none_above_facility_meeting_measures_listed_above_prevent/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_1 from './relational/none_above_facility_meeting_measures_listed_above_regarding_1/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_10 from './relational/none_above_facility_meeting_measures_listed_above_regarding_10/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_11 from './relational/none_above_facility_meeting_measures_listed_above_regarding_11/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_12 from './relational/none_above_facility_meeting_measures_listed_above_regarding_12/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_13 from './relational/none_above_facility_meeting_measures_listed_above_regarding_13/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_14 from './relational/none_above_facility_meeting_measures_listed_above_regarding_14/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_15 from './relational/none_above_facility_meeting_measures_listed_above_regarding_15/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_16 from './relational/none_above_facility_meeting_measures_listed_above_regarding_16/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_17 from './relational/none_above_facility_meeting_measures_listed_above_regarding_17/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_18 from './relational/none_above_facility_meeting_measures_listed_above_regarding_18/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_19 from './relational/none_above_facility_meeting_measures_listed_above_regarding_19/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_2 from './relational/none_above_facility_meeting_measures_listed_above_regarding_2/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_20 from './relational/none_above_facility_meeting_measures_listed_above_regarding_20/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_21 from './relational/none_above_facility_meeting_measures_listed_above_regarding_21/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_22 from './relational/none_above_facility_meeting_measures_listed_above_regarding_22/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_23 from './relational/none_above_facility_meeting_measures_listed_above_regarding_23/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_24 from './relational/none_above_facility_meeting_measures_listed_above_regarding_24/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_25 from './relational/none_above_facility_meeting_measures_listed_above_regarding_25/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_26 from './relational/none_above_facility_meeting_measures_listed_above_regarding_26/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_27 from './relational/none_above_facility_meeting_measures_listed_above_regarding_27/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_28 from './relational/none_above_facility_meeting_measures_listed_above_regarding_28/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_29 from './relational/none_above_facility_meeting_measures_listed_above_regarding_29/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_3 from './relational/none_above_facility_meeting_measures_listed_above_regarding_3/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_4 from './relational/none_above_facility_meeting_measures_listed_above_regarding_4/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_5 from './relational/none_above_facility_meeting_measures_listed_above_regarding_5/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_6 from './relational/none_above_facility_meeting_measures_listed_above_regarding_6/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_7 from './relational/none_above_facility_meeting_measures_listed_above_regarding_7/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_8 from './relational/none_above_facility_meeting_measures_listed_above_regarding_8/index.js'
import * as noneAboveFacilityMeetingMeasuresListedAboveRegarding_9 from './relational/none_above_facility_meeting_measures_listed_above_regarding_9/index.js'
import * as noneAboveListedGroupsReceiveCommunicationTrainingOn from './relational/none_above_listed_groups_receive_communication_training_on/index.js'
import * as noneAboveListedReceiveCommunicationTrainingOnAnti_1 from './relational/none_above_listed_receive_communication_training_on_anti_1/index.js'
import * as noneAboveListedReceiveCommunicationTrainingOnAnti_2 from './relational/none_above_listed_receive_communication_training_on_anti_2/index.js'
import * as noneAboveListedReceiveCommunicationTrainingOnBribery from './relational/none_above_listed_receive_communication_training_on_bribery/index.js'
import * as noneAboveListedReceiveCommunicationTrainingOnProhibition from './relational/none_above_listed_receive_communication_training_on_prohibition/index.js'
import * as noneAboveListedReceiveVerbalCommunicationFromFacility from './relational/none_above_listed_receive_verbal_communication_from_facility/index.js'
import * as noneAboveListedReceiveWrittenCommunicationFromFacility from './relational/none_above_listed_receive_written_communication_from_facility/index.js'
import * as noneOfTheAbove_1 from './relational/none_of_the_above_1/index.js'
import * as noneOfTheAbove_10 from './relational/none_of_the_above_10/index.js'
import * as noneOfTheAbove_11 from './relational/none_of_the_above_11/index.js'
import * as noneOfTheAbove_2 from './relational/none_of_the_above_2/index.js'
import * as noneOfTheAbove_3 from './relational/none_of_the_above_3/index.js'
import * as noneOfTheAbove_4 from './relational/none_of_the_above_4/index.js'
import * as noneOfTheAbove_5 from './relational/none_of_the_above_5/index.js'
import * as noneOfTheAbove_6 from './relational/none_of_the_above_6/index.js'
import * as noneOfTheAbove_7 from './relational/none_of_the_above_7/index.js'
import * as noneOfTheAbove_8 from './relational/none_of_the_above_8/index.js'
import * as noneOfTheAbove_9 from './relational/none_of_the_above_9/index.js'
import * as nonGovernmentOrganizationsNgosWomenSGroups from './relational/non_government_organizations_ngos_women_s_groups/index.js'
import * as nonWoven from './relational/non_woven/index.js'
import * as noParkingForkliftsDesignatedLocationSWhenNot from './relational/no_parking_forklifts_designated_location_s_when_not/index.js'
import * as noPermitHotWorkOutsideApprovedDesignatedArea from './relational/no_permit_hot_work_outside_approved_designated_area/index.js'
import * as noPreventionOverloadingMaterialsOnForkliftTrucks from './relational/no_prevention_overloading_materials_on_forklift_trucks/index.js'
import * as noPreventionPlacingLaddersFrontDoorsThatAre from './relational/no_prevention_placing_ladders_front_doors_that_are/index.js'
import * as noPreventionTyingAchieveAdditional from './relational/no_prevention_tying_achieve_additional/index.js'
import * as noPreventionUsingForkliftsLiftWorkersSoThat from './relational/no_prevention_using_forklifts_lift_workers_so_that/index.js'
import * as noPreventionUsingLaddersHorizontalPositionAsPlatform from './relational/no_prevention_using_ladders_horizontal_position_as_platform/index.js'
import * as noProtectedExplosionProofLightingStorageAreas from './relational/no_protected_explosion_proof_lighting_storage_areas/index.js'
import * as noProtectionFromFallingObjectsUnderneathGradedSurfaces from './relational/no_protection_from_falling_objects_underneath_graded_surfaces/index.js'
import * as noProvisionAdditionalPpeEGMasksGloves from './relational/no_provision_additional_ppe_e_g_masks_gloves/index.js'
import * as noProvisionMedicalFacilitiesClinicSSuppliesEquipment from './relational/no_provision_medical_facilities_clinic_s_supplies_equipment/index.js'
import * as noProvisionPpeEquipmentSuchAsHearingProtection from './relational/no_provision_ppe_equipment_such_as_hearing_protection/index.js'
import * as noReferencesAbove from './relational/no_references_above/index.js'
import * as noRegularInspectionDamageMaintenancePortableLadders from './relational/no_regular_inspection_damage_maintenance_portable_ladders/index.js'
import * as noRegularInspectionElevatorsLifts from './relational/no_regular_inspection_elevators_lifts/index.js'
import * as noRegularInspectionMaintenanceForkLifts from './relational/no_regular_inspection_maintenance_fork_lifts/index.js'
import * as noRegularMaintenanceInspectionTestingEmergencyAlarmSystem from './relational/no_regular_maintenance_inspection_testing_emergency_alarm_system/index.js'
import * as noRescueEquipmentReadyUseWhenConfinedSpace from './relational/no_rescue_equipment_ready_use_when_confined_space/index.js'
import * as noRestBreaksRotationsWorkersWhoAreExposed from './relational/no_rest_breaks_rotations_workers_who_are_exposed/index.js'
import * as noRiskAssessmentWhereSignificantHeatColdExposure from './relational/no_risk_assessment_where_significant_heat_cold_exposure/index.js'
import * as normalHoursOfOperationPerDay from './relational/normal_hours_of_operation_per_day/index.js'
import * as noSafePerformanceExcavationTrenchingWorkIE from './relational/no_safe_performance_excavation_trenching_work_i_e/index.js'
import * as noSafetyDevicesOnElevatorDoorsPreventThem from './relational/no_safety_devices_on_elevator_doors_prevent_them/index.js'
import * as noSafetyOrientationProvidedContractorPersonnelFacility from './relational/no_safety_orientation_provided_contractor_personnel_facility/index.js'
import * as noSafeUseScaffoldingIESecuredPermanent from './relational/no_safe_use_scaffolding_i_e_secured_permanent/index.js'
import * as noSecuringLaddersWhenNotUse from './relational/no_securing_ladders_when_not_use/index.js'
import * as noSew from './relational/no_sew/index.js'
import * as noShieldsProtectWorkersFromRadiantHeatSources from './relational/no_shields_protect_workers_from_radiant_heat_sources/index.js'
import * as noSignsEachConfinedSpaceIndicatingTheyAre from './relational/no_signs_each_confined_space_indicating_they_are/index.js'
import * as noStaffMonitorsLeadsArePresentListenWatch from './relational/no_staff_monitors_leads_are_present_listen_watch/index.js'
import * as noStorageFallProtectionEquipmentDesignatedLocation from './relational/no_storage_fall_protection_equipment_designated_location/index.js'
import * as noSufficientNumbersChildcareStaffEnsureSafetyWell from './relational/no_sufficient_numbers_childcare_staff_ensure_safety_well/index.js'
import * as noSystemAccountWorkersDuringEmergencyEvacuation from './relational/no_system_account_workers_during_emergency_evacuation/index.js'
import * as noSystemIdentifyingFromPhysically from './relational/no_system_identifying_from_physically/index.js'
import * as notApplicable_1 from './relational/not_applicable_1/index.js'
import * as notApplicable_2 from './relational/not_applicable_2/index.js'
import * as notApplicableFacilityDoesNotHaveStairsRaised from './relational/not_applicable_facility_does_not_have_stairs_raised/index.js'
import * as notApplicableNoFallProtectionNeeded from './relational/not_applicable_no_fall_protection_needed/index.js'
import * as notApplicableSeeCountrySpecificQuestionSBelow_1 from './relational/not_applicable_see_country_specific_question_s_below_1/index.js'
import * as notApplicableSeeCountrySpecificQuestionSBelow_2 from './relational/not_applicable_see_country_specific_question_s_below_2/index.js'
import * as notes from './relational/notes/index.js'
import * as notFullyFunctioningEmergencyAlarmSystem from './relational/not_fully_functioning_emergency_alarm_system/index.js'
import * as noTrainingCommunicationOnDueDiligenceRequirementsSupplier from './relational/no_training_communication_on_due_diligence_requirements_supplier/index.js'
import * as noTrainingCommunicationOnRawMaterialsDueDiligence from './relational/no_training_communication_on_raw_materials_due_diligence/index.js'
import * as noTrainingOnErgonomicFactorsGoodPracticesPrevent from './relational/no_training_on_ergonomic_factors_good_practices_prevent/index.js'
import * as noTrainingOnFoodSafetyProperHygieneRules from './relational/no_training_on_food_safety_proper_hygiene_rules/index.js'
import * as noTrainingWorkersOnPreventingSpreadContagiousDiseases from './relational/no_training_workers_on_preventing_spread_contagious_diseases/index.js'
import * as notSubstantiatedRejected from './relational/not_substantiated_rejected/index.js'
import * as notWorkersContractorsWhoEnterConfinedSpacesKnow from './relational/not_workers_contractors_who_enter_confined_spaces_know/index.js'
import * as noUnannouncedEmergencyDrills from './relational/no_unannounced_emergency_drills/index.js'
import * as noVerificationFacThatContractorPersonnelHaveAppropriate from './relational/no_verification_fac_that_contractor_personnel_have_appropriate/index.js'
import * as noVisualSafetyManagementFeaturesSuchAsIndicators from './relational/no_visual_safety_management_features_such_as_indicators/index.js'
import * as noWallsFencesOtherBarriersAlongHighWorking from './relational/no_walls_fences_other_barriers_along_high_working/index.js'
import * as noWarningLightsAudibleSignalsReverseTravelOn from './relational/no_warning_lights_audible_signals_reverse_travel_on/index.js'
import * as noWarningsEitherThroughVerbalWrittenCommunicationAre from './relational/no_warnings_either_through_verbal_written_communication_are/index.js'
import * as noWarningSignElevatorsEG from './relational/no_warning_sign_elevators_e_g/index.js'
import * as noWrittenDocumentationEmergencyDrills from './relational/no_written_documentation_emergency_drills/index.js'
import * as noWrittenPoliciesProceduresPlaceButInformalProcedures from './relational/no_written_policies_procedures_place_but_informal_procedures/index.js'
import * as noWrittenProceduresPlaceReportingRespondingChemicalSpills from './relational/no_written_procedures_place_reporting_responding_chemical_spills/index.js'
import * as numberAgencyContractWorkers from './relational/number_agency_contract_workers/index.js'
import * as numberCommutingInjuriesInclFatalitiesLast_12Months from './relational/number_commuting_injuries_incl_fatalities_last_12_months/index.js'
import * as numberContractWorkersWorkersEmployedThirdPartyWho from './relational/number_contract_workers_workers_employed_third_party_who/index.js'
import * as numberForeignMigrantSupervisors from './relational/number_foreign_migrant_supervisors/index.js'
import * as numberForeignMigrantWorkers from './relational/number_foreign_migrant_workers/index.js'
import * as numberMaleAgencyContractWorkers from './relational/number_male_agency_contract_workers/index.js'
import * as numberMaleForeignMigrantSupervisors from './relational/number_male_foreign_migrant_supervisors/index.js'
import * as numberMaleForeignMigrantWorkers from './relational/number_male_foreign_migrant_workers/index.js'
import * as numberMaleWorkersWhoAreTraineesApprenticesInterns from './relational/number_male_workers_who_are_trainees_apprentices_interns/index.js'
import * as numberOfCasualWorkers from './relational/number_of_casual_workers/index.js'
import * as numberOfContractWorkers from './relational/number_of_contract_workers/index.js'
import * as numberOfContractWorkersNotPartOfTheProductionProcess from './relational/number_of_contract_workers_not_part_of_the_production_process/index.js'
import * as numberOfDiverseCasualWorkers from './relational/number_of_diverse_casual_workers/index.js'
import * as numberOfDiverseContractWorkers from './relational/number_of_diverse_contract_workers/index.js'
import * as numberOfDiverseDomesticMigrantWorkers from './relational/number_of_diverse_domestic_migrant_workers/index.js'
import * as numberOfDiverseForeignMigrantSupervisors from './relational/number_of_diverse_foreign_migrant_supervisors/index.js'
import * as numberOfDiverseForeignMigrantWorkers from './relational/number_of_diverse_foreign_migrant_workers/index.js'
import * as numberOfDiverseFullTimeWorkers from './relational/number_of_diverse_full_time_workers/index.js'
import * as numberOfDiverseNightShiftWorkers from './relational/number_of_diverse_night_shift_workers/index.js'
import * as numberOfDiversePartTimeWorkers from './relational/number_of_diverse_part_time_workers/index.js'
import * as numberOfDiversePermanentWorkers from './relational/number_of_diverse_permanent_workers/index.js'
import * as numberOfDiverseSeasonalWorkers from './relational/number_of_diverse_seasonal_workers/index.js'
import * as numberOfDiverseSupervisors from './relational/number_of_diverse_supervisors/index.js'
import * as numberOfDiverseTemporaryWorkers from './relational/number_of_diverse_temporary_workers/index.js'
import * as numberOfDiverseTraineesApprenticesInternWorkers from './relational/number_of_diverse_trainees_apprentices_intern_workers/index.js'
import * as numberOfDiverseUnionisedWorkers from './relational/number_of_diverse_unionised_workers/index.js'
import * as numberOfDiverseWorkers from './relational/number_of_diverse_workers/index.js'
import * as numberOfDiverseWorkersHiredDirectly from './relational/number_of_diverse_workers_hired_directly/index.js'
import * as numberOfDiverseWorkersHiredIndirectly from './relational/number_of_diverse_workers_hired_indirectly/index.js'
import * as numberOfDiverseWorkersOnParentalLeave from './relational/number_of_diverse_workers_on_parental_leave/index.js'
import * as numberOfDiverseWorkersPaidByUnit from './relational/number_of_diverse_workers_paid_by_unit/index.js'
import * as numberOfDiverseWorkersUnder_18 from './relational/number_of_diverse_workers_under_18/index.js'
import * as numberOfDiverseWorkersUnderCba from './relational/number_of_diverse_workers_under_cba/index.js'
import * as numberOfDiverseWorkersUnderProbation from './relational/number_of_diverse_workers_under_probation/index.js'
import * as numberOfDiverseWorkersWithDisability from './relational/number_of_diverse_workers_with_disability/index.js'
import * as numberOfDiverseWorkersWithRefugeeStatus from './relational/number_of_diverse_workers_with_refugee_status/index.js'
import * as numberOfDiverseWorkersWorkingRemotelyOrBringWorkHome from './relational/number_of_diverse_workers_working_remotely_or_bring_work_home/index.js'
import * as numberOfDomesticMigrantWorkers from './relational/number_of_domestic_migrant_workers/index.js'
import * as numberOfEmployees from './relational/number_of_employees/index.js'
import * as numberOfFemaleCasualWorkers from './relational/number_of_female_casual_workers/index.js'
import * as numberOfFemaleContractWorkers from './relational/number_of_female_contract_workers/index.js'
import * as numberOfFemaleDomesticMigrantWorkers from './relational/number_of_female_domestic_migrant_workers/index.js'
import * as numberOfFemaleEmployees from './relational/number_of_female_employees/index.js'
import * as numberOfFemaleForeignMigrantSupervisors from './relational/number_of_female_foreign_migrant_supervisors/index.js'
import * as numberOfFemaleForeignMigrantWorkers from './relational/number_of_female_foreign_migrant_workers/index.js'
import * as numberOfFemaleFullTimeWorkers from './relational/number_of_female_full_time_workers/index.js'
import * as numberOfFemaleNightShiftWorkers from './relational/number_of_female_night_shift_workers/index.js'
import * as numberOfFemalePartTimeWorkers from './relational/number_of_female_part_time_workers/index.js'
import * as numberOfFemalePermanentWorkers from './relational/number_of_female_permanent_workers/index.js'
import * as numberOfFemaleSeasonalWorkers from './relational/number_of_female_seasonal_workers/index.js'
import * as numberOfFemaleSupervisors from './relational/number_of_female_supervisors/index.js'
import * as numberOfFemaleTemporaryWorkers from './relational/number_of_female_temporary_workers/index.js'
import * as numberOfFemaleTraineesApprenticesInternWorkers from './relational/number_of_female_trainees_apprentices_intern_workers/index.js'
import * as numberOfFemaleUnionisedWorkers from './relational/number_of_female_unionised_workers/index.js'
import * as numberOfFemaleWorkers from './relational/number_of_female_workers/index.js'
import * as numberOfFemaleWorkersHiredDirectly from './relational/number_of_female_workers_hired_directly/index.js'
import * as numberOfFemaleWorkersHiredIndirectly from './relational/number_of_female_workers_hired_indirectly/index.js'
import * as numberOfFemaleWorkersOnParentalLeave from './relational/number_of_female_workers_on_parental_leave/index.js'
import * as numberOfFemaleWorkersPaidByUnit from './relational/number_of_female_workers_paid_by_unit/index.js'
import * as numberOfFemaleWorkersUnder_18 from './relational/number_of_female_workers_under_18/index.js'
import * as numberOfFemaleWorkersUnderCba from './relational/number_of_female_workers_under_cba/index.js'
import * as numberOfFemaleWorkersUnderProbation from './relational/number_of_female_workers_under_probation/index.js'
import * as numberOfFemaleWorkersWithDisability from './relational/number_of_female_workers_with_disability/index.js'
import * as numberOfFemaleWorkersWithRefugeeStatus from './relational/number_of_female_workers_with_refugee_status/index.js'
import * as numberOfFemaleWorkersWorkingRemotelyOrBringWorkHome from './relational/number_of_female_workers_working_remotely_or_bring_work_home/index.js'
import * as numberOfForeignMigrantSupervisors from './relational/number_of_foreign_migrant_supervisors/index.js'
import * as numberOfForeignMigrantWorkers from './relational/number_of_foreign_migrant_workers/index.js'
import * as numberOffSiteHousingSitesOccupiedWorkersManaged_1 from './relational/number_off_site_housing_sites_occupied_workers_managed_1/index.js'
import * as numberOffSiteHousingSitesOccupiedWorkersManaged_2 from './relational/number_off_site_housing_sites_occupied_workers_managed_2/index.js'
import * as numberOfFullTimeWorkers from './relational/number_of_full_time_workers/index.js'
import * as numberOfMaleCasualWorkers from './relational/number_of_male_casual_workers/index.js'
import * as numberOfMaleContractWorkers from './relational/number_of_male_contract_workers/index.js'
import * as numberOfMaleDomesticMigrantWorkers from './relational/number_of_male_domestic_migrant_workers/index.js'
import * as numberOfMaleEmployees from './relational/number_of_male_employees/index.js'
import * as numberOfMaleForeignMigrantSupervisors from './relational/number_of_male_foreign_migrant_supervisors/index.js'
import * as numberOfMaleForeignMigrantWorkers from './relational/number_of_male_foreign_migrant_workers/index.js'
import * as numberOfMaleFullTimeWorkers from './relational/number_of_male_full_time_workers/index.js'
import * as numberOfMaleNightShiftWorkers from './relational/number_of_male_night_shift_workers/index.js'
import * as numberOfMalePartTimeWorkers from './relational/number_of_male_part_time_workers/index.js'
import * as numberOfMalePermanentWorkers from './relational/number_of_male_permanent_workers/index.js'
import * as numberOfMaleSeasonalWorkers from './relational/number_of_male_seasonal_workers/index.js'
import * as numberOfMaleSupervisors from './relational/number_of_male_supervisors/index.js'
import * as numberOfMaleTemporaryWorkers from './relational/number_of_male_temporary_workers/index.js'
import * as numberOfMaleTraineesApprenticesInternWorkers from './relational/number_of_male_trainees_apprentices_intern_workers/index.js'
import * as numberOfMaleUnionisedWorkers from './relational/number_of_male_unionised_workers/index.js'
import * as numberOfMaleWorkers from './relational/number_of_male_workers/index.js'
import * as numberOfMaleWorkersHiredDirectly from './relational/number_of_male_workers_hired_directly/index.js'
import * as numberOfMaleWorkersHiredIndirectly from './relational/number_of_male_workers_hired_indirectly/index.js'
import * as numberOfMaleWorkersOnParentalLeave from './relational/number_of_male_workers_on_parental_leave/index.js'
import * as numberOfMaleWorkersPaidByUnit from './relational/number_of_male_workers_paid_by_unit/index.js'
import * as numberOfMaleWorkersUnder_18 from './relational/number_of_male_workers_under_18/index.js'
import * as numberOfMaleWorkersUnderCba from './relational/number_of_male_workers_under_cba/index.js'
import * as numberOfMaleWorkersUnderProbation from './relational/number_of_male_workers_under_probation/index.js'
import * as numberOfMaleWorkersWithDisability from './relational/number_of_male_workers_with_disability/index.js'
import * as numberOfMaleWorkersWithRefugeeStatus from './relational/number_of_male_workers_with_refugee_status/index.js'
import * as numberOfMaleWorkersWorkingRemotelyOrBringWorkHome from './relational/number_of_male_workers_working_remotely_or_bring_work_home/index.js'
import * as numberOfPartTimeWorkers from './relational/number_of_part_time_workers/index.js'
import * as numberOfPermanentEmployees from './relational/number_of_permanent_employees/index.js'
import * as numberOfPermanentWorkers from './relational/number_of_permanent_workers/index.js'
import * as numberOfPregnantOrBreastfeedingWorkers from './relational/number_of_pregnant_or_breastfeeding_workers/index.js'
import * as numberOfProductionSites from './relational/number_of_production_sites/index.js'
import * as numberOfSupervisors from './relational/number_of_supervisors/index.js'
import * as numberOfTemporaryWorkers from './relational/number_of_temporary_workers/index.js'
import * as numberOfTraineesApprenticesInternWorkers from './relational/number_of_trainees_apprentices_intern_workers/index.js'
import * as numberOfWorkers from './relational/number_of_workers/index.js'
import * as numberOfWorkersOnMaternityLeave from './relational/number_of_workers_on_maternity_leave/index.js'
import * as numberOfWorkersPaidByUnit from './relational/number_of_workers_paid_by_unit/index.js'
import * as numberOfWorkersReturnedFromMaternityLeave from './relational/number_of_workers_returned_from_maternity_leave/index.js'
import * as numberOfWorkersUnder_18 from './relational/number_of_workers_under_18/index.js'
import * as numberOfWorkersUnderProbation from './relational/number_of_workers_under_probation/index.js'
import * as numberOfWorkersWithDisability from './relational/number_of_workers_with_disability/index.js'
import * as numberOfWorkersWithRefugeeStatus from './relational/number_of_workers_with_refugee_status/index.js'
import * as numberOfWorkersWorkingRemotelyOrBringWorkHome from './relational/number_of_workers_working_remotely_or_bring_work_home/index.js'
import * as numberOnSiteDormitories from './relational/number_on_site_dormitories/index.js'
import * as numberWeeklyRestDaysLeast_24ConsecutiveHours from './relational/number_weekly_rest_days_least_24_consecutive_hours/index.js'
import * as numberWorkersWhoAreTraineesApprenticesInterns from './relational/number_workers_who_are_trainees_apprentices_interns/index.js'
import * as numberWorkRelatedDangerousOccurrencesLast_12Months from './relational/number_work_related_dangerous_occurrences_last_12_months/index.js'
import * as numberWorkRelatedDiseasesLast_12Months from './relational/number_work_related_diseases_last_12_months/index.js'
import * as numberWorkRelatedFatalitiesLast_12Months from './relational/number_work_related_fatalities_last_12_months/index.js'
import * as numberWorkRelatedInjuriesThatResultedLeastThree from './relational/number_work_related_injuries_that_resulted_least_three/index.js'
import * as numberWorkRelatedInjuriesThatResultedLessThan from './relational/number_work_related_injuries_that_resulted_less_than/index.js'
import * as numOfAllFloors from './relational/num_of_all_floors/index.js'
import * as numOfCommutingInjuriesInclFatalitiesInTheLast_12Months from './relational/num_of_commuting_injuries_incl_fatalities_in_the_last_12_months/index.js'
import * as numOfContractWorkersEmployedByThirdPartyNotPartOfTheProductionProcess from './relational/num_of_contract_workers_employed_by_third_party_not_part_of_the_production_process/index.js'
import * as numOfDiverseManagers from './relational/num_of_diverse_managers/index.js'
import * as numOfEstablishedTradeUnionsInTheFac from './relational/num_of_established_trade_unions_in_the_fac/index.js'
import * as numOfFemaleManagers from './relational/num_of_female_managers/index.js'
import * as numOfFemaleUnionMembersInTheUnionWThe_2ndLargestMemb from './relational/num_of_female_union_members_in_the_union_w_the_2nd_largest_memb/index.js'
import * as numOfFemaleUnionMembersInTheUnionWThe_3rdLargestMemb from './relational/num_of_female_union_members_in_the_union_w_the_3rd_largest_memb/index.js'
import * as numOfFemaleUnionMembersInTheUnionWThe_4thLargestMemb from './relational/num_of_female_union_members_in_the_union_w_the_4th_largest_memb/index.js'
import * as numOfFemaleUnionMembersInTheUnionWThe_5thLargestMemb from './relational/num_of_female_union_members_in_the_union_w_the_5th_largest_memb/index.js'
import * as numOfFemaleUnionMembersInTheUnionWTheLargestMembersh from './relational/num_of_female_union_members_in_the_union_w_the_largest_membersh/index.js'
import * as numOfFemaleUnionOfficialsInTheUnionWThe_2ndLargestMe from './relational/num_of_female_union_officials_in_the_union_w_the_2nd_largest_me/index.js'
import * as numOfFemaleUnionOfficialsInTheUnionWThe_3rdLargestMe from './relational/num_of_female_union_officials_in_the_union_w_the_3rd_largest_me/index.js'
import * as numOfFemaleUnionOfficialsInTheUnionWThe_4thLargestMe from './relational/num_of_female_union_officials_in_the_union_w_the_4th_largest_me/index.js'
import * as numOfFemaleUnionOfficialsInTheUnionWThe_5thLargestMe from './relational/num_of_female_union_officials_in_the_union_w_the_5th_largest_me/index.js'
import * as numOfFemaleUnionOfficialsInTheUnionWTheLargestMember from './relational/num_of_female_union_officials_in_the_union_w_the_largest_member/index.js'
import * as numOfFemaleWrkrsInFifthWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_fifth_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInFourthWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_fourth_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInLowestWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_lowest_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInSecondWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_second_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInSeventhWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_seventh_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInSixthWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_sixth_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInThirdWageLevelDefinedByFac from './relational/num_of_female_wrkrs_in_third_wage_level_defined_by_fac/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade from './relational/num_of_female_wrkrs_in_wage_level_grade/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_1 from './relational/num_of_female_wrkrs_in_wage_level_grade_1/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_1LowestWageGradeLev from './relational/num_of_female_wrkrs_in_wage_level_grade_1_lowest_wage_grade_lev/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_2 from './relational/num_of_female_wrkrs_in_wage_level_grade_2/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_3 from './relational/num_of_female_wrkrs_in_wage_level_grade_3/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_4 from './relational/num_of_female_wrkrs_in_wage_level_grade_4/index.js'
import * as numOfFemaleWrkrsInWageLevelGrade_5 from './relational/num_of_female_wrkrs_in_wage_level_grade_5/index.js'
import * as numOfFemaleWrkrsInWageLevelSemiskilled from './relational/num_of_female_wrkrs_in_wage_level_semiskilled/index.js'
import * as numOfFemaleWrkrsInWageLevelSkilled from './relational/num_of_female_wrkrs_in_wage_level_skilled/index.js'
import * as numOfFemaleWrkrsInWageLevelUnskilled from './relational/num_of_female_wrkrs_in_wage_level_unskilled/index.js'
import * as numOfFemaleWrkrsWhoWerePromotedWAnIncreaseInTheirBa from './relational/num_of_female_wrkrs_who_were_promoted_w_an_increase_in_their_ba/index.js'
import * as numOfMaleManagers from './relational/num_of_male_managers/index.js'
import * as numOfMaleWrkrsWhoWerePromotedWAnIncreaseInTheirBasi from './relational/num_of_male_wrkrs_who_were_promoted_w_an_increase_in_their_basi/index.js'
import * as numOfManagers from './relational/num_of_managers/index.js'
import * as numOfOffsiteHousingSitesOccupiedByWrkrsManagedAndCont from './relational/num_of_offsite_housing_sites_occupied_by_wrkrs_managed_and_cont/index.js'
import * as numOfOffsiteHousingSitesOccupiedByWrkrsManagedOrContr from './relational/num_of_offsite_housing_sites_occupied_by_wrkrs_managed_or_contr/index.js'
import * as numOfOnsiteDormitories from './relational/num_of_onsite_dormitories/index.js'
import * as numOfProductionBuildingsOnsite from './relational/num_of_production_buildings_onsite/index.js'
import * as numOfRegularDailyHoursWorkedAtTheFac from './relational/num_of_regular_daily_hours_worked_at_the_fac/index.js'
import * as numOfRegularWeeklyHoursWorkedAtTheFac from './relational/num_of_regular_weekly_hours_worked_at_the_fac/index.js'
import * as numOfShiftsAndHoursOfOperationForEachNormalOperations from './relational/num_of_shifts_and_hours_of_operation_for_each_normal_operations/index.js'
import * as numOfShiftsAndHoursOfOperationForEachPeakOperations from './relational/num_of_shifts_and_hours_of_operation_for_each_peak_operations/index.js'
import * as numOfWarehousesOnsite from './relational/num_of_warehouses_onsite/index.js'
import * as numOfWeeklyRestDaysAtLeast_24ConsecutiveHoursLongProv from './relational/num_of_weekly_rest_days_at_least_24_consecutive_hours_long_prov/index.js'
import * as numOfWorkrelatedDangerousOccurrencesInTheLast_12Months from './relational/num_of_workrelated_dangerous_occurrences_in_the_last_12_months/index.js'
import * as numOfWorkrelatedDiseasesInTheLast_12Months from './relational/num_of_workrelated_diseases_in_the_last_12_months/index.js'
import * as numOfWorkrelatedFatalitiesAndInjuriesThatResultedInAt from './relational/num_of_workrelated_fatalities_and_injuries_that_resulted_in_at/index.js'
import * as numOfWorkrelatedInjuriesThatResultedInLessThanThreeDa from './relational/num_of_workrelated_injuries_that_resulted_in_less_than_three_da/index.js'
import * as oekoTex from './relational/oeko_tex/index.js'
import * as officialName from './global/official_name/index.js'
import * as officialNameLocalized from './global/official_name_localized/index.js'
import * as operatingLicenseregistration from './relational/operating_licenseregistration/index.js'
import * as operatingLicenseregistrationIsAvailableAndUpToDate from './relational/operating_licenseregistration_is_available_and_up_to_date/index.js'
import * as organicContentStandardOcs from './relational/organic_content_standard_ocs/index.js'
import * as osHubId from './global/os_hub_id/index.js'
import * as other_1 from './relational/other_1/index.js'
import * as other_10 from './relational/other_10/index.js'
import * as other_11 from './relational/other_11/index.js'
import * as other_12 from './relational/other_12/index.js'
import * as other_13 from './relational/other_13/index.js'
import * as other_14 from './relational/other_14/index.js'
import * as other_15 from './relational/other_15/index.js'
import * as other_16 from './relational/other_16/index.js'
import * as other_2 from './relational/other_2/index.js'
import * as other_3 from './relational/other_3/index.js'
import * as other_4 from './relational/other_4/index.js'
import * as other_5 from './relational/other_5/index.js'
import * as other_6 from './relational/other_6/index.js'
import * as other_7 from './relational/other_7/index.js'
import * as other_8 from './relational/other_8/index.js'
import * as other_9 from './relational/other_9/index.js'
import * as otherActionImpactingWorkers from './relational/other_action_impacting_workers/index.js'
import * as otherDescribeTypeRequiredLeaveThatNotPaid from './relational/other_describe_type_required_leave_that_not_paid/index.js'
import * as otherDescribeTypeRequiredLeaveThatNotProvided from './relational/other_describe_type_required_leave_that_not_provided/index.js'
import * as otherGroundSIdentifiedFactoredIntoHiringDecisions from './relational/other_ground_s_identified_factored_into_hiring_decisions/index.js'
import * as otherHazardousSubstancesWetProcesses from './relational/other_hazardous_substances_wet_processes/index.js'
import * as otherMonetaryBonusesAllowances from './relational/other_monetary_bonuses_allowances/index.js'
import * as otherMonetaryBonusesAndorAllowances from './relational/other_monetary_bonuses_andor_allowances/index.js'
import * as otherNotCollectedForwarded from './relational/other_not_collected_forwarded/index.js'
import * as otherTypesRequiredLeave_1 from './relational/other_types_required_leave_1/index.js'
import * as otherTypesRequiredLeave_2 from './relational/other_types_required_leave_2/index.js'
import * as overtimeVoluntaryLineLegalRequirements from './relational/overtime_voluntary_line_legal_requirements/index.js'
import * as overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat from './relational/overview_of_the_issues_covered_in_the_cba_that_covers_the_great/index.js'
import * as overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_1 from './relational/overview_of_the_issues_covered_in_the_cba_that_covers_the_great_1/index.js'
import * as overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_2 from './relational/overview_of_the_issues_covered_in_the_cba_that_covers_the_great_2/index.js'
import * as packaging_1 from './relational/packaging_1/index.js'
import * as packaging_2 from './relational/packaging_2/index.js'
import * as packaging_3 from './relational/packaging_3/index.js'
import * as packaging_4 from './relational/packaging_4/index.js'
import * as packagingProducts from './relational/packaging_products/index.js'
import * as packing from './relational/packing/index.js'
import * as pakistanDoesEmployerMaintainFairPriceShop from './relational/pakistan_does_employer_maintain_fair_price_shop/index.js'
import * as pakistanDoesFacilityPayWorkersLegallyRequiredYearly from './relational/pakistan_does_facility_pay_workers_legally_required_yearly/index.js'
import * as pakistanDoWorkers_1 from './relational/pakistan_do_workers_1/index.js'
import * as pakistanDoWorkers_2 from './relational/pakistan_do_workers_2/index.js'
import * as pakistanDoWorkersReceiveCorrectPaymentWorkRelated from './relational/pakistan_do_workers_receive_correct_payment_work_related/index.js'
import * as pakistanDoWorkersSurvivorsReceiveRequiredMedicalCare from './relational/pakistan_do_workers_survivors_receive_required_medical_care/index.js'
import * as pakistanHasEmployerAdoptedCodeConductProtectAgainst from './relational/pakistan_has_employer_adopted_code_conduct_protect_against/index.js'
import * as pakistanHasEmployerSetUpFunctioningInquiryCommittee from './relational/pakistan_has_employer_set_up_functioning_inquiry_committee/index.js'
import * as pakistanPayWorkersCorrectlyDuringIddatLeave from './relational/pakistan_pay_workers_correctly_during_iddat_leave/index.js'
import * as pakistanProvideRequiredTimeOffIddat from './relational/pakistan_provide_required_time_off_iddat/index.js'
import * as paperProcessing from './relational/paper_processing/index.js'
import * as partiesToTheCbaThatCoversThe_2ndGreatestNumOfWrkrsIn from './relational/parties_to_the_cba_that_covers_the_2nd_greatest_num_of_wrkrs_in/index.js'
import * as partiesToTheCbaThatCoversThe_3rdGreatestNumOfWrkrsIn from './relational/parties_to_the_cba_that_covers_the_3rd_greatest_num_of_wrkrs_in/index.js'
import * as partiesToTheCbaThatCoversTheGreatestNumOfWrkrsInThe from './relational/parties_to_the_cba_that_covers_the_greatest_num_of_wrkrs_in_the/index.js'
import * as paternityLeave_1 from './relational/paternity_leave_1/index.js'
import * as paternityLeave_2 from './relational/paternity_leave_2/index.js'
import * as payAndBenefits from './relational/pay_and_benefits/index.js'
import * as payrollDiverseWorkersSampled from './relational/payroll_diverse_workers_sampled/index.js'
import * as payrollFemaleWorkersSampled from './relational/payroll_female_workers_sampled/index.js'
import * as payrollHowManyWorkersWereSampled from './relational/payroll_how_many_workers_were_sampled/index.js'
import * as payrollMaleWorkersSampled from './relational/payroll_male_workers_sampled/index.js'
import * as payrollRecordsAreNotConsistentAttendanceRecordsOther from './relational/payroll_records_are_not_consistent_attendance_records_other/index.js'
import * as payrollRecordsDoNotShowTypesSocialInsurance from './relational/payroll_records_do_not_show_types_social_insurance/index.js'
import * as payrollRecordsEachWorkerAreNotMaintainedLeast from './relational/payroll_records_each_worker_are_not_maintained_least/index.js'
import * as payrollRecsDoNotShowAllTheTypesOfSocialInsuranceThe from './relational/payroll_recs_do_not_show_all_the_types_of_social_insurance_the/index.js'
import * as payrollWhatPercentageSampledWorkforceWasImpacted from './relational/payroll_what_percentage_sampled_workforce_was_impacted/index.js'
import * as payrollWorkersSampledHowManyWorkersReceivedLess from './relational/payroll_workers_sampled_how_many_workers_received_less/index.js'
import * as pctOfWorkforceCoveredByTheCbaThatCoversThe_2ndGreates from './relational/pct_of_workforce_covered_by_the_cba_that_covers_the_2nd_greates/index.js'
import * as pctOfWorkforceCoveredByTheCbaThatCoversThe_3rdGreates from './relational/pct_of_workforce_covered_by_the_cba_that_covers_the_3rd_greates/index.js'
import * as pctOfWorkforceCoveredByTheCbaThatCoversTheGreatestNu from './relational/pct_of_workforce_covered_by_the_cba_that_covers_the_greatest_nu/index.js'
import * as pctOfWrkrsThatAreTradeUnionMembers from './relational/pct_of_wrkrs_that_are_trade_union_members/index.js'
import * as peakOperationMonths from './relational/peak_operation_months/index.js'
import * as penaltiesMonetaryOtherwiseAreUsedEnsureThatWorkers from './relational/penalties_monetary_otherwise_are_used_ensure_that_workers/index.js'
import * as pensionProvidentFundNotCollectedForwarded from './relational/pension_provident_fund_not_collected_forwarded/index.js'
import * as percentageNumberOfNormalWorkforce from './relational/percentage_number_of_normal_workforce/index.js'
import * as personalCareBeautyProducts from './relational/personal_care_beauty_products/index.js'
import * as personalLeave_1 from './relational/personal_leave_1/index.js'
import * as personalLeave_2 from './relational/personal_leave_2/index.js'
import * as phone from './relational/phone/index.js'
import * as plasticRubberProcessing from './relational/plastic_rubber_processing/index.js'
import * as pleaseDescribe_1 from './relational/please_describe_1/index.js'
import * as pleaseDescribe_2 from './relational/please_describe_2/index.js'
import * as pleaseDescribe_3 from './relational/please_describe_3/index.js'
import * as pleaseDescribe_4 from './relational/please_describe_4/index.js'
import * as pleaseDescribe_5 from './relational/please_describe_5/index.js'
import * as pleaseDescribe_6 from './relational/please_describe_6/index.js'
import * as pleaseDescribe_7 from './relational/please_describe_7/index.js'
import * as pleaseDescribeWhat_1 from './relational/please_describe_what_1/index.js'
import * as pleaseDescribeWhat_2 from './relational/please_describe_what_2/index.js'
import * as pleaseDescribeWhat_3 from './relational/please_describe_what_3/index.js'
import * as pleaseSelectTheFacility from './relational/please_select_the_facility/index.js'
import * as politicalOpinion_1 from './relational/political_opinion_1/index.js'
import * as politicalOpinion_2 from './relational/political_opinion_2/index.js'
import * as politicalOpinion_3 from './relational/political_opinion_3/index.js'
import * as politicalOpinionFactoredIntoHiringDecisionsNotLine from './relational/political_opinion_factored_into_hiring_decisions_not_line/index.js'
import * as politicalOpinionReferencedNotLineLegalRequirements from './relational/political_opinion_referenced_not_line_legal_requirements/index.js'
import * as positionNotMaintained from './relational/position_not_maintained/index.js'
import * as potassiumPermanganatePp from './relational/potassium_permanganate_pp/index.js'
import * as poweredMotorVehiclesPmvProcedures from './relational/powered_motor_vehicles_pmv_procedures/index.js'
import * as powerNotTurnedOff from './relational/power_not_turned_off/index.js'
import * as ppeEquipmentClothingProvidedNotGoodConditionNot from './relational/ppe_equipment_clothing_provided_not_good_condition_not/index.js'
import * as ppeNotCorrectSizeWorkers from './relational/ppe_not_correct_size_workers/index.js'
import * as ppeRelatedNNDimethylformamideDmfGoodCondition from './relational/ppe_related_n_n_dimethylformamide_dmf_good_condition/index.js'
import * as ppeRelatedPotassiumPermanganatePpGoodConditionRegularly from './relational/ppe_related_potassium_permanganate_pp_good_condition_regularly/index.js'
import * as ppeRelatedTetrachloroethyleneRegularlyReplaced from './relational/ppe_related_tetrachloroethylene_regularly_replaced/index.js'
import * as pregnancyMaternityStatus_1 from './relational/pregnancy_maternity_status_1/index.js'
import * as pregnancyMaternityStatus_2 from './relational/pregnancy_maternity_status_2/index.js'
import * as pregnancyMaternityStatus_3 from './relational/pregnancy_maternity_status_3/index.js'
import * as pregnancyMaternityStatusFactoredIntoHiringDecisionsNot from './relational/pregnancy_maternity_status_factored_into_hiring_decisions_not/index.js'
import * as pregnancyMaternityStatusReferencedNotLineLegalReq from './relational/pregnancy_maternity_status_referenced_not_line_legal_req/index.js'
import * as preparationSpinningTextileFibers from './relational/preparation_spinning_textile_fibers/index.js'
import * as pressureVesselsSafety from './relational/pressure_vessels_safety/index.js'
import * as primaryLanguageSpokenAtTheFac from './relational/primary_language_spoken_at_the_fac/index.js'
import * as primaryLanguageSpokenByFacMgmt from './relational/primary_language_spoken_by_fac_mgmt/index.js'
import * as priming from './relational/priming/index.js'
import * as printing_1 from './relational/printing_1/index.js'
import * as printing_2 from './relational/printing_2/index.js'
import * as printing_3 from './relational/printing_3/index.js'
import * as productCapabilities from './transactional/product_capabilities/index.js'
import * as productLevels from './relational/product_levels/index.js'
import * as productTypes from './relational/product_types/index.js'
import * as prohibitionOfForcedLabor from './relational/prohibition_of_forced_labor/index.js'
import * as provApproximateOfSupvsWhoCanCommunicateInThePrimaryLa from './relational/prov_approximate_of_supvs_who_can_communicate_in_the_primary_la/index.js'
import * as provApproximateOfSupvsWhoCanCommunicateInThisLanguage from './relational/prov_approximate_of_supvs_who_can_communicate_in_this_language/index.js'
import * as provApproximateOfSupvsWhoCanCommunicateInThisLanguage_1 from './relational/prov_approximate_of_supvs_who_can_communicate_in_this_language_1/index.js'
import * as provApproximateOfWrkrsWhoCanCommunicateInThePrimaryLa from './relational/prov_approximate_of_wrkrs_who_can_communicate_in_the_primary_la/index.js'
import * as provApproximateOfWrkrsWhoCanCommunicateInThisLanguage from './relational/prov_approximate_of_wrkrs_who_can_communicate_in_this_language/index.js'
import * as provApproximateOfWrkrsWhoCanCommunicateInThisLanguage_1 from './relational/prov_approximate_of_wrkrs_who_can_communicate_in_this_language_1/index.js'
import * as provideApproximateSupervisorsLanguage_1 from './relational/provide_approximate_supervisors_language_1/index.js'
import * as provideApproximateSupervisorsLanguage_2 from './relational/provide_approximate_supervisors_language_2/index.js'
import * as provideApproximateSupervisorsPrimaryLanguage from './relational/provide_approximate_supervisors_primary_language/index.js'
import * as provideApproximateWorkersWhoCanCommunicatePrimaryLanguage from './relational/provide_approximate_workers_who_can_communicate_primary_language/index.js'
import * as provideApproximateWorkersWhoCanCommunicateThisLanguage_1 from './relational/provide_approximate_workers_who_can_communicate_this_language_1/index.js'
import * as provideApproximateWorkersWhoCanCommunicateThisLanguage_2 from './relational/provide_approximate_workers_who_can_communicate_this_language_2/index.js'
import * as provideDetailsHousingArrangementsIncludingMinimumHowMany from './relational/provide_details_housing_arrangements_including_minimum_how_many/index.js'
import * as provideListHealthSafetyTrainingsOfferedExistingProduction from './relational/provide_list_health_safety_trainings_offered_existing_production/index.js'
import * as provideListHealthSafetyTrainingsOfferedNewProduction from './relational/provide_list_health_safety_trainings_offered_new_production/index.js'
import * as provideListTrainOfferedIndividualsRespImplHealth from './relational/provide_list_train_offered_individuals_resp_impl_health/index.js'
import * as raceEthnicGroupSkinColor_1 from './relational/race_ethnic_group_skin_color_1/index.js'
import * as raceEthnicGroupSkinColor_2 from './relational/race_ethnic_group_skin_color_2/index.js'
import * as raceEthnicGroupSkinColor_3 from './relational/race_ethnic_group_skin_color_3/index.js'
import * as raceEthnicGroupSkinColorFactoredIntoHiring from './relational/race_ethnic_group_skin_color_factored_into_hiring/index.js'
import * as raceEthnicGroupSkinColorReferencedNotLine from './relational/race_ethnic_group_skin_color_referenced_not_line/index.js'
import * as rawMaterialsSourcing from './relational/raw_materials_sourcing/index.js'
import * as rawMaterialStorageWarehousing from './relational/raw_material_storage_warehousing/index.js'
import * as rbaResponsibleBusinessAlliance from './relational/rba_responsible_business_alliance/index.js'
import * as rbaVap from './relational/rba_vap/index.js'
import * as receiptWagePaymentConfirmedWritingWorkers from './relational/receipt_wage_payment_confirmed_writing_workers/index.js'
import * as recruitmentAndHiring from './relational/recruitment_and_hiring/index.js'
import * as recycledClaimStandardRcs from './relational/recycled_claim_standard_rcs/index.js'
import * as referenceInternationalLawIloConventions from './relational/reference_international_law_ilo_conventions/index.js'
import * as referenceOtherNationalIntlReqDeclarationsGoalsGuiding from './relational/reference_other_national_intl_req_declarations_goals_guiding/index.js'
import * as referenceToNationalLaw from './relational/reference_to_national_law/index.js'
import * as regularHoursWorkedAtNight from './relational/regular_hours_worked_at_night/index.js'
import * as regularHoursWorkedOnPublicHolidays from './relational/regular_hours_worked_on_public_holidays/index.js'
import * as regularHoursWorkedOnWeeklyRestDays from './relational/regular_hours_worked_on_weekly_rest_days/index.js'
import * as relationshipType from './transactional/relationship_type/index.js'
import * as religion_1 from './relational/religion_1/index.js'
import * as religion_2 from './relational/religion_2/index.js'
import * as religion_3 from './relational/religion_3/index.js'
import * as religionFactoredIntoHiringDecisionsNotLineLegal from './relational/religion_factored_into_hiring_decisions_not_line_legal/index.js'
import * as religionReferencedNotLineLegalRequirements from './relational/religion_referenced_not_line_legal_requirements/index.js'
import * as residencesAreLocatedWinAnyFacBuildings from './relational/residences_are_located_win_any_fac_buildings/index.js'
import * as residentialBuildingHasBeenConvertedIntoAFac from './relational/residential_building_has_been_converted_into_a_fac/index.js'
import * as respectedCommunityMemberS from './relational/respected_community_member_s/index.js'
import * as responsiblePerson from './transactional/responsible_person/index.js'
import * as retracedId from './global/retraced_id/index.js'
import * as retracedRiskScore from './relational/retraced_risk_score/index.js'
import * as rjcResponsibleJewelryCouncil from './relational/rjc_responsible_jewelry_council/index.js'
import * as rospaGold from './relational/rospa_gold/index.js'
import * as rospaSilver from './relational/rospa_silver/index.js'
import * as rotaryPrinting from './relational/rotary_printing/index.js'
import * as sa8000SocialAccountabilityInternational from './relational/sa8000_social_accountability_international/index.js'
import * as safetyCommitteeDoesNotCommunicateComplaintsProblemsShared from './relational/safety_committee_does_not_communicate_complaints_problems_shared/index.js'
import * as safetyCommitteeDoesNotConductSafetyInspectionsDoes from './relational/safety_committee_does_not_conduct_safety_inspections_does/index.js'
import * as safetyCommitteeMeetingActionItemsAreNotTracked from './relational/safety_committee_meeting_action_items_are_not_tracked/index.js'
import * as safetyCommitteeMeetingMinutesAreNotSharedWorkforce from './relational/safety_committee_meeting_minutes_are_not_shared_workforce/index.js'
import * as safetyCommitteeMeetingsAreNotHeldLeastOnce from './relational/safety_committee_meetings_are_not_held_least_once/index.js'
import * as safetyCommitteeMeetingsAreNotHeldLeastQuarterly from './relational/safety_committee_meetings_are_not_held_least_quarterly/index.js'
import * as screenPrinting from './relational/screen_printing/index.js'
import * as seamTaping from './relational/seam_taping/index.js'
import * as secondMostCommonlySpokenLanguageAtTheFac from './relational/second_most_commonly_spoken_language_at_the_fac/index.js'
import * as secondWageLevelDefinedByFacCompleteDefinitionOfThisLe from './relational/second_wage_level_defined_by_fac_complete_definition_of_this_le/index.js'
import * as securityGuards_1 from './relational/security_guards_1/index.js'
import * as securityGuards_10 from './relational/security_guards_10/index.js'
import * as securityGuards_2 from './relational/security_guards_2/index.js'
import * as securityGuards_3 from './relational/security_guards_3/index.js'
import * as securityGuards_4 from './relational/security_guards_4/index.js'
import * as securityGuards_5 from './relational/security_guards_5/index.js'
import * as securityGuards_6 from './relational/security_guards_6/index.js'
import * as securityGuards_7 from './relational/security_guards_7/index.js'
import * as securityGuards_8 from './relational/security_guards_8/index.js'
import * as securityGuards_9 from './relational/security_guards_9/index.js'
import * as selectTheFacsApplicableThreeLetterCurrencyCode from './relational/select_the_facs_applicable_three_letter_currency_code/index.js'
import * as seniorManagement_1 from './relational/senior_management_1/index.js'
import * as seniorManagement_10 from './relational/senior_management_10/index.js'
import * as seniorManagement_11 from './relational/senior_management_11/index.js'
import * as seniorManagement_12 from './relational/senior_management_12/index.js'
import * as seniorManagement_13 from './relational/senior_management_13/index.js'
import * as seniorManagement_14 from './relational/senior_management_14/index.js'
import * as seniorManagement_15 from './relational/senior_management_15/index.js'
import * as seniorManagement_16 from './relational/senior_management_16/index.js'
import * as seniorManagement_17 from './relational/senior_management_17/index.js'
import * as seniorManagement_18 from './relational/senior_management_18/index.js'
import * as seniorManagement_19 from './relational/senior_management_19/index.js'
import * as seniorManagement_2 from './relational/senior_management_2/index.js'
import * as seniorManagement_20 from './relational/senior_management_20/index.js'
import * as seniorManagement_21 from './relational/senior_management_21/index.js'
import * as seniorManagement_22 from './relational/senior_management_22/index.js'
import * as seniorManagement_23 from './relational/senior_management_23/index.js'
import * as seniorManagement_24 from './relational/senior_management_24/index.js'
import * as seniorManagement_3 from './relational/senior_management_3/index.js'
import * as seniorManagement_4 from './relational/senior_management_4/index.js'
import * as seniorManagement_5 from './relational/senior_management_5/index.js'
import * as seniorManagement_6 from './relational/senior_management_6/index.js'
import * as seniorManagement_7 from './relational/senior_management_7/index.js'
import * as seniorManagement_8 from './relational/senior_management_8/index.js'
import * as seniorManagement_9 from './relational/senior_management_9/index.js'
import * as seventhWageLevelDefinedByFacCompleteDefinitionOfThisL from './relational/seventh_wage_level_defined_by_fac_complete_definition_of_this_l/index.js'
import * as sewing from './relational/sewing/index.js'
import * as sexGender_1 from './relational/sex_gender_1/index.js'
import * as sexGender_2 from './relational/sex_gender_2/index.js'
import * as sexGender_3 from './relational/sex_gender_3/index.js'
import * as sexGenderFactoredIntoHiringDecisionsNotLine from './relational/sex_gender_factored_into_hiring_decisions_not_line/index.js'
import * as sexGenderReferencedNotLineLegalRequirements from './relational/sex_gender_referenced_not_line_legal_requirements/index.js'
import * as sexualOrientation_1 from './relational/sexual_orientation_1/index.js'
import * as sexualOrientation_2 from './relational/sexual_orientation_2/index.js'
import * as sexualOrientation_3 from './relational/sexual_orientation_3/index.js'
import * as sexualOrientationFactoredIntoHiringDecisionsNotLine from './relational/sexual_orientation_factored_into_hiring_decisions_not_line/index.js'
import * as sexualOrientationReferencedNotLineLegalRequirements from './relational/sexual_orientation_referenced_not_line_legal_requirements/index.js'
import * as shipping_1 from './relational/shipping_1/index.js'
import * as shipping_2 from './relational/shipping_2/index.js'
import * as sickLeave_1 from './relational/sick_leave_1/index.js'
import * as sickLeave_2 from './relational/sick_leave_2/index.js'
import * as signedCopiesContractsBetweenFacilityEachWorkerAre from './relational/signed_copies_contracts_between_facility_each_worker_are/index.js'
import * as signedCopiesTermsConditionsDocumentsBetweenFacilityEach from './relational/signed_copies_terms_conditions_documents_between_facility_each/index.js'
import * as sinceEquipmentContainsPcbDoesFacilityHaveFollowing from './relational/since_equipment_contains_pcb_does_facility_have_following/index.js'
import * as sixthWageLevelDefinedByFacCompleteDefinitionOfThisLev from './relational/sixth_wage_level_defined_by_fac_complete_definition_of_this_lev/index.js'
import * as skillsAndQualificationTests from './relational/skills_and_qualification_tests/index.js'
import * as slcpFacilityId from './global/slcp_facility_id/index.js'
import * as smetaSedexMembersEthicalTradeAudit from './relational/smeta_sedex_members_ethical_trade_audit/index.js'
import * as socialOrigin_1 from './relational/social_origin_1/index.js'
import * as socialOrigin_2 from './relational/social_origin_2/index.js'
import * as socialOrigin_3 from './relational/social_origin_3/index.js'
import * as socialOriginFactoredIntoHiringDecisionsNotLine from './relational/social_origin_factored_into_hiring_decisions_not_line/index.js'
import * as socialOriginReferencedNotLineLegalRequirements from './relational/social_origin_referenced_not_line_legal_requirements/index.js'
import * as sportsOutdoorHardGoods from './relational/sports_outdoor_hard_goods/index.js'
import * as sportsOutdoorSoftGoods from './relational/sports_outdoor_soft_goods/index.js'
import * as srMgntIndividualsResponsibleImplementationDoNotReceive_2 from './relational/sr_mgnt_individuals_responsible_implementation_do_not_receive_2/index.js'
import * as srMngtIndividualsResponsibleImplementationDoNotReceive_1 from './relational/sr_mngt_individuals_responsible_implementation_do_not_receive_1/index.js'
import * as srMngtIndividualsResponsibleImplementationExistingProd from './relational/sr_mngt_individuals_responsible_implementation_existing_prod/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_1 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_1/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_10 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_10/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_11 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_11/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_12 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_12/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_13 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_13/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_14 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_14/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_2 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_2/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_3 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_3/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_4 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_4/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_5 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_5/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_6 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_6/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_7 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_7/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_8 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_8/index.js'
import * as srMngtIndividualsResponsibleImplNewProdWorkers_9 from './relational/sr_mngt_individuals_responsible_impl_new_prod_workers_9/index.js'
import * as standardizationChemicalFinishing from './relational/standardization_chemical_finishing/index.js'
import * as standardLeadTime from './relational/standard_lead_time/index.js'
import * as startFinishTimesAreNotRecordedPeriodsWork from './relational/start_finish_times_are_not_recorded_periods_work/index.js'
import * as startFinishTimesPayrollSystemDoNotMatch from './relational/start_finish_times_payroll_system_do_not_match/index.js'
import * as stationaryCompressedGasCylindersAreNotConnectedFixed from './relational/stationary_compressed_gas_cylinders_are_not_connected_fixed/index.js'
import * as stockFitting from './relational/stock_fitting/index.js'
import * as storageRacksShelvingNotSecuredPermanentStructures from './relational/storage_racks_shelving_not_secured_permanent_structures/index.js'
import * as sublimation from './relational/sublimation/index.js'
import * as substantiatedStillWorkingOnRemedialAction from './relational/substantiated_still_working_on_remedial_action/index.js'
import * as substantiatedWithoutRemedy from './relational/substantiated_without_remedy/index.js'
import * as substantiatedWithRemedy from './relational/substantiated_with_remedy/index.js'
import * as sundriesApplication from './relational/sundries_application/index.js'
import * as suppliersSubcontractors_1 from './relational/suppliers_subcontractors_1/index.js'
import * as suppliersSubcontractors_10 from './relational/suppliers_subcontractors_10/index.js'
import * as suppliersSubcontractors_11 from './relational/suppliers_subcontractors_11/index.js'
import * as suppliersSubcontractors_12 from './relational/suppliers_subcontractors_12/index.js'
import * as suppliersSubcontractors_13 from './relational/suppliers_subcontractors_13/index.js'
import * as suppliersSubcontractors_14 from './relational/suppliers_subcontractors_14/index.js'
import * as suppliersSubcontractors_15 from './relational/suppliers_subcontractors_15/index.js'
import * as suppliersSubcontractors_16 from './relational/suppliers_subcontractors_16/index.js'
import * as suppliersSubcontractors_17 from './relational/suppliers_subcontractors_17/index.js'
import * as suppliersSubcontractors_18 from './relational/suppliers_subcontractors_18/index.js'
import * as suppliersSubcontractors_19 from './relational/suppliers_subcontractors_19/index.js'
import * as suppliersSubcontractors_2 from './relational/suppliers_subcontractors_2/index.js'
import * as suppliersSubcontractors_20 from './relational/suppliers_subcontractors_20/index.js'
import * as suppliersSubcontractors_3 from './relational/suppliers_subcontractors_3/index.js'
import * as suppliersSubcontractors_4 from './relational/suppliers_subcontractors_4/index.js'
import * as suppliersSubcontractors_5 from './relational/suppliers_subcontractors_5/index.js'
import * as suppliersSubcontractors_6 from './relational/suppliers_subcontractors_6/index.js'
import * as suppliersSubcontractors_7 from './relational/suppliers_subcontractors_7/index.js'
import * as suppliersSubcontractors_8 from './relational/suppliers_subcontractors_8/index.js'
import * as suppliersSubcontractors_9 from './relational/suppliers_subcontractors_9/index.js'
import * as supplierSubcontractorReceivesTrainCommOnDueDiligence from './relational/supplier_subcontractor_receives_train_comm_on_due_diligence/index.js'
import * as supplierSubcontractorReceivesTrainCommOnRawMaterials from './relational/supplier_subcontractor_receives_train_comm_on_raw_materials/index.js'
import * as supplyChainTier from './transactional/supply_chain_tier/index.js'
import * as tanningDressingLeatherDressingDyeingFur from './relational/tanning_dressing_leather_dressing_dyeing_fur/index.js'
import * as terminationAndRetrenchment from './relational/termination_and_retrenchment/index.js'
import * as termsConditionsDocumentsAreNotUpDate from './relational/terms_conditions_documents_are_not_up_date/index.js'
import * as termsConditionsDocumentsUnclearlyInaccuratelyState from './relational/terms_conditions_documents_unclearly_inaccurately_state/index.js'
import * as tetrachloroethylenePerc from './relational/tetrachloroethylene_perc/index.js'
import * as textileExchangeId from './global/textile_exchange_id/index.js'
import * as theBasisOfTheHarassmentSelectAllThatApply from './relational/the_basis_of_the_harassment_select_all_that_apply/index.js'
import * as theFacDoesNotCreateImprovementPlans from './relational/the_fac_does_not_create_improvement_plans/index.js'
import * as theFacDoesNotSetTargetsKeyPerformanceIndicators from './relational/the_fac_does_not_set_targets_key_performance_indicators/index.js'
import * as theFacPaidAnAnnualBonus from './relational/the_fac_paid_an_annual_bonus/index.js'
import * as theFacPaidAnAttendanceBonus from './relational/the_fac_paid_an_attendance_bonus/index.js'
import * as theFacPaidAProductivityBonus from './relational/the_fac_paid_a_productivity_bonus/index.js'
import * as theFacPaidHousingTransportationAndorMealAllowances from './relational/the_fac_paid_housing_transportation_andor_meal_allowances/index.js'
import * as theFacPaidSeniorityAndorGratuityBonus from './relational/the_fac_paid_seniority_andor_gratuity_bonus/index.js'
import * as thereAreNoOptionsSeniorManagementReviewDirect from './relational/there_are_no_options_senior_management_review_direct/index.js'
import * as thereLightningProtectorArrestorSystemLineLegalReq from './relational/there_lightning_protector_arrestor_system_line_legal_req/index.js'
import * as thereWrittenDocsSurroundingTermsCondGrantingRepayment from './relational/there_written_docs_surrounding_terms_cond_granting_repayment/index.js'
import * as thirdMostCommonlySpokenLanguageAtTheFac from './relational/third_most_commonly_spoken_language_at_the_fac/index.js'
import * as thirdWageLevelDefinedByFacCompleteDefinitionOfThisLev from './relational/third_wage_level_defined_by_fac_complete_definition_of_this_lev/index.js'
import * as totalFacAreaM2OnlyBuiltPremises from './relational/total_fac_area_m2_only_built_premises/index.js'
import * as totalNumberOfWorkers from './relational/total_number_of_workers/index.js'
import * as totalNumOfBuildingsOnsite from './relational/total_num_of_buildings_onsite/index.js'
import * as totalNumOfUnionMembersInTheUnionWThe_2ndLargestMembe from './relational/total_num_of_union_members_in_the_union_w_the_2nd_largest_membe/index.js'
import * as totalNumOfUnionMembersInTheUnionWThe_3rdLargestMembe from './relational/total_num_of_union_members_in_the_union_w_the_3rd_largest_membe/index.js'
import * as totalNumOfUnionMembersInTheUnionWThe_4thLargestMembe from './relational/total_num_of_union_members_in_the_union_w_the_4th_largest_membe/index.js'
import * as totalNumOfUnionMembersInTheUnionWThe_5thLargestMembe from './relational/total_num_of_union_members_in_the_union_w_the_5th_largest_membe/index.js'
import * as totalNumOfUnionMembersInTheUnionWTheLargestMembershi from './relational/total_num_of_union_members_in_the_union_w_the_largest_membershi/index.js'
import * as totalNumOfUnionOfficialsInTheUnionWThe_2ndLargestMem from './relational/total_num_of_union_officials_in_the_union_w_the_2nd_largest_mem/index.js'
import * as totalNumOfUnionOfficialsInTheUnionWThe_3rdLargestMem from './relational/total_num_of_union_officials_in_the_union_w_the_3rd_largest_mem/index.js'
import * as totalNumOfUnionOfficialsInTheUnionWThe_4thLargestMem from './relational/total_num_of_union_officials_in_the_union_w_the_4th_largest_mem/index.js'
import * as totalNumOfUnionOfficialsInTheUnionWThe_5thLargestMem from './relational/total_num_of_union_officials_in_the_union_w_the_5th_largest_mem/index.js'
import * as totalNumOfUnionOfficialsInTheUnionWTheLargestMembers from './relational/total_num_of_union_officials_in_the_union_w_the_largest_members/index.js'
import * as totalNumOfWrkrsInFifthWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_fifth_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInFourthWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_fourth_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInLowestWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_lowest_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInSecondWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_second_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInSeventhWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_seventh_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInSixthWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_sixth_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInThirdWageLevelDefinedByFac from './relational/total_num_of_wrkrs_in_third_wage_level_defined_by_fac/index.js'
import * as totalNumOfWrkrsInWageLevelGrade from './relational/total_num_of_wrkrs_in_wage_level_grade/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_1 from './relational/total_num_of_wrkrs_in_wage_level_grade_1/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_1LowestWageGradeLeve from './relational/total_num_of_wrkrs_in_wage_level_grade_1_lowest_wage_grade_leve/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_2 from './relational/total_num_of_wrkrs_in_wage_level_grade_2/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_3 from './relational/total_num_of_wrkrs_in_wage_level_grade_3/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_4 from './relational/total_num_of_wrkrs_in_wage_level_grade_4/index.js'
import * as totalNumOfWrkrsInWageLevelGrade_5 from './relational/total_num_of_wrkrs_in_wage_level_grade_5/index.js'
import * as totalNumOfWrkrsInWageLevelSemiskilled from './relational/total_num_of_wrkrs_in_wage_level_semiskilled/index.js'
import * as totalNumOfWrkrsInWageLevelSkilled from './relational/total_num_of_wrkrs_in_wage_level_skilled/index.js'
import * as totalNumOfWrkrsInWageLevelUnskilled from './relational/total_num_of_wrkrs_in_wage_level_unskilled/index.js'
import * as totalWorkerInterviews from './relational/total_worker_interviews/index.js'
import * as toys from './relational/toys/index.js'
import * as trafficLanesWalkPathsAreNotClearlyMarked from './relational/traffic_lanes_walk_paths_are_not_clearly_marked/index.js'
import * as trainingAndOrientation from './relational/training_and_orientation/index.js'
import * as trainingRecordsOnChemicalUseHandlingDisposalSpill from './relational/training_records_on_chemical_use_handling_disposal_spill/index.js'
import * as transliteratedDisplayName from './relational/transliterated_display_name/index.js'
import * as transliteratedOfficialName from './global/transliterated_official_name/index.js'
import * as transportation from './relational/transportation/index.js'
import * as travelAndLodging from './relational/travel_and_lodging/index.js'
import * as trims from './relational/trims/index.js'
import * as typeOfProcessesCarriedOutAtHome from './relational/type_of_processes_carried_out_at_home/index.js'
import * as under_12Over_18EnterAgeYoungestWorker from './relational/under_12_over_18_enter_age_youngest_worker/index.js'
import * as unemploymentNotCollectedForwarded from './relational/unemployment_not_collected_forwarded/index.js'
import * as uniforms from './relational/uniforms/index.js'
import * as unionRepresentatives from './relational/union_representatives/index.js'
import * as unsafeTransportationCompressedGasCylinders from './relational/unsafe_transportation_compressed_gas_cylinders/index.js'
import * as upperManagementDoesNotRecognizeAcceptSafetyCommittee from './relational/upper_management_does_not_recognize_accept_safety_committee/index.js'
import * as upperProductionIncludingStitching from './relational/upper_production_including_stitching/index.js'
import * as uscc from './global/uscc/index.js'
import * as vatId from './global/vat_id/index.js'
import * as vehiclesMaintenanceLogsNotKept from './relational/vehicles_maintenance_logs_not_kept/index.js'
import * as vehiclesNotGoodWorkingCondition from './relational/vehicles_not_good_working_condition/index.js'
import * as vendors from './transactional/vendors/index.js'
import * as verificationAssessmentWindow from './relational/verification_assessment_window/index.js'
import * as verifierBodyNameCountryProgramme from './relational/verifier_body_name_country_programme/index.js'
import * as verifierBodyType from './relational/verifier_body_type/index.js'
import * as verifierNamesAssessorIds from './relational/verifier_names_assessor_ids/index.js'
import * as verifierSApscaIdS from './relational/verifier_s_apsca_id_s/index.js'
import * as videoFile from './relational/video_file/index.js'
import * as vietnamDoesFacAllowancesAdditional from './relational/vietnam_does_fac_allowances_additional/index.js'
import * as vietnamDoesFacComplyLegalReqConcerningBreaks from './relational/vietnam_does_fac_comply_legal_req_concerning_breaks/index.js'
import * as vietnamDoesFacComplyLegalReqConcerningDispatched from './relational/vietnam_does_fac_comply_legal_req_concerning_dispatched/index.js'
import * as vietnamDoesFacInspectMeasureEnvironmentalCondWorkplace from './relational/vietnam_does_fac_inspect_measure_environmental_cond_workplace/index.js'
import * as vietnamDoesFacRegularlyInspectMaintainMachinesEquip from './relational/vietnam_does_fac_regularly_inspect_maintain_machines_equip/index.js'
import * as vietnamDoesTheFacCollectAndForwardWrkrsContributionsAs from './relational/vietnam_does_the_fac_collect_and_forward_wrkrs_contributions_as/index.js'
import * as vietnamFacContributionForSocialHealthAndUnemploymentIns from './relational/vietnam_fac_contribution_for_social_health_and_unemployment_ins/index.js'
import * as vietnamHasTheCollectiveAgreementInForceBeenApprovedBy from './relational/vietnam_has_the_collective_agreement_in_force_been_approved_by/index.js'
import * as vietnamPay_30MinutesTimeOffPerDay from './relational/vietnam_pay_30_minutes_time_off_per_day/index.js'
import * as vietnamProvide_30MinutesTimeOffPerDay from './relational/vietnam_provide_30_minutes_time_off_per_day/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_al/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl_1 from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_al_1/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_ba/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa_1 from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_ba_1/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_ov/index.js'
import * as wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv_1 from './relational/wage_grade_level_most_represented_in_the_fac_average_monthly_ov_1/index.js'
import * as wagesAndBenefits from './relational/wages_and_benefits/index.js'
import * as wagesNotMaintained from './relational/wages_not_maintained/index.js'
import * as warehousingDistribution from './relational/warehousing_distribution/index.js'
import * as washing from './relational/washing/index.js'
import * as wasteSources from './relational/waste_sources/index.js'
import * as wasteTreatmentManagement from './relational/waste_treatment_management/index.js'
import * as wasteWaterTreatmentProficiency from './relational/waste_water_treatment_proficiency/index.js'
import * as wasTheGrievanceMechanismDevelopedThroughSocialDialogueB from './relational/was_the_grievance_mechanism_developed_through_social_dialogue_b/index.js'
import * as waterManagementSystem from './relational/water_management_system/index.js'
import * as waterSources from './relational/water_sources/index.js'
import * as weavingOfTextiles from './relational/weaving_of_textiles/index.js'
import * as webshopCompanyDescription from './relational/webshop_company_description/index.js'
import * as webshopCompanyDisplayName from './relational/webshop_company_display_name/index.js'
import * as webshopCompanyImageList from './relational/webshop_company_image_list/index.js'
import * as webshopCompanyVideoFile from './relational/webshop_company_video_file/index.js'
import * as website from './global/website/index.js'
import * as welding from './relational/welding/index.js'
import * as wereAllOtherWagePaymentsInLineWLegalReqs from './relational/were_all_other_wage_payments_in_line_w_legal_reqs/index.js'
import * as wereAnyWrkrsUndTheLegalMinimumWorkingAgeWhenHired from './relational/were_any_wrkrs_und_the_legal_minimum_working_age_when_hired/index.js'
import * as wereAtLeastTwothirdsOfTheMeetingsAttendedBy_100OfMemb from './relational/were_at_least_twothirds_of_the_meetings_attended_by_100_of_memb/index.js'
import * as wereExceptionRequestsGrantedVerificationOversightOrgThis from './relational/were_exception_requests_granted_verification_oversight_org_this/index.js'
import * as wereInterpretersPresentDuringVerificationAssessment from './relational/were_interpreters_present_during_verification_assessment/index.js'
import * as wereOtherWagePaymentsLineLegalRequirements from './relational/were_other_wage_payments_line_legal_requirements/index.js'
import * as wereRecsOfAllWorkrelatedInjuriesFatalitiesAccidentsAnd from './relational/were_recs_of_all_workrelated_injuries_fatalities_accidents_and/index.js'
import * as wereTerminationsOfTradeUnionOfficialsIfAnyInLineWApp from './relational/were_terminations_of_trade_union_officials_if_any_in_line_w_app/index.js'
import * as wereWholdingsFromWagesOtherThanSocialSecurityCalculated from './relational/were_wholdings_from_wages_other_than_social_security_calculated/index.js'
import * as wereWithholdingsFromWagesOtherThanSocialSecurity from './relational/were_withholdings_from_wages_other_than_social_security/index.js'
import * as wereWorkers from './relational/were_workers/index.js'
import * as wetPrinting from './relational/wet_printing/index.js'
import * as whatAgeYoungestWorkerFacility from './relational/what_age_youngest_worker_facility/index.js'
import * as whatAnnualWorkerTurnoverPercent from './relational/what_annual_worker_turnover_percent/index.js'
import * as whatApproximatePctOfWrkrsArePaidByTheseOtherMeans from './relational/what_approximate_pct_of_wrkrs_are_paid_by_these_other_means/index.js'
import * as whatAreIndividualWorkersBasicWagesBasedUponSelectAllT from './relational/what_are_individual_workers_basic_wages_based_upon_select_all_t/index.js'
import * as whatAverageTimeDaysItTakesReachOutcome from './relational/what_average_time_days_it_takes_reach_outcome/index.js'
import * as whatHealthAndSafetyMeasuresDoesTheFacHaveToPreventTh from './relational/what_health_and_safety_measures_does_the_fac_have_to_prevent_th/index.js'
import * as whatIsTheAgeOfTheYoungestWorkerInTheFac from './relational/what_is_the_age_of_the_youngest_worker_in_the_fac/index.js'
import * as whatIsTheConstructionDateOfTheOldestBuildingTheFacOc from './relational/what_is_the_construction_date_of_the_oldest_building_the_fac_oc/index.js'
import * as whatIsTheFacsDefinitionOfLeadTime from './relational/what_is_the_facs_definition_of_lead_time/index.js'
import * as whatIsTheFacsFormOfProductionOperationsPlanning from './relational/what_is_the_facs_form_of_production_operations_planning/index.js'
import * as whatIsTheFacsMaximumLeadTimeWeeksAsUnitOfMeasurement from './relational/what_is_the_facs_maximum_lead_time_weeks_as_unit_of_measurement/index.js'
import * as whatIsTheMaximumLengthOfTimeInDaysThatTheFacConside from './relational/what_is_the_maximum_length_of_time_in_days_that_the_fac_conside/index.js'
import * as whatIsTheReasonForTheNewConstruction from './relational/what_is_the_reason_for_the_new_construction/index.js'
import * as whatPercentageNormalWorkforceDoesTotalNumberWorkers from './relational/what_percentage_normal_workforce_does_total_number_workers/index.js'
import * as whatPercentageWorkersArePaidCardStoredValue from './relational/what_percentage_workers_are_paid_card_stored_value/index.js'
import * as whatPercentageWorkersArePaidCash from './relational/what_percentage_workers_are_paid_cash/index.js'
import * as whatPercentageWorkersArePaidCheck from './relational/what_percentage_workers_are_paid_check/index.js'
import * as whatPercentageWorkersArePaidDirectDepositInto from './relational/what_percentage_workers_are_paid_direct_deposit_into/index.js'
import * as whatPercentageWorkersArePaidMobileMoney from './relational/what_percentage_workers_are_paid_mobile_money/index.js'
import * as whatTotalNumberInterviewsConductedContractWorkersWorkers from './relational/what_total_number_interviews_conducted_contract_workers_workers/index.js'
import * as whenADisciplinaryActionIsInitiatedAgainstAWorkerIsTha from './relational/when_a_disciplinary_action_is_initiated_against_a_worker_is_tha/index.js'
import * as whenMakingChangesContractsDoesFacilitySeekWritten from './relational/when_making_changes_contracts_does_facility_seek_written/index.js'
import * as whenPreparingFoodNoMeasuresPreventDecreasePotential from './relational/when_preparing_food_no_measures_prevent_decrease_potential/index.js'
import * as whenProductionvolumeIsLowerThanExpectedHowAreWrkrsImpa from './relational/when_productionvolume_is_lower_than_expected_how_are_wrkrs_impa/index.js'
import * as whenWasTheLastRiskAssessmentConducted from './relational/when_was_the_last_risk_assessment_conducted/index.js'
import * as whichFloorsDoesFacOccupyInAMultifloorSharedBuilding from './relational/which_floors_does_fac_occupy_in_a_multifloor_shared_building/index.js'
import * as whichHazardousSubstancesAreWrkrsExposed from './relational/which_hazardous_substances_are_wrkrs_exposed/index.js'
import * as whichLegalOvertimeLimitsAreNotBeingCompliedWSelectAll from './relational/which_legal_overtime_limits_are_not_being_complied_w_select_all/index.js'
import * as whichOfTheFollowingApprenticeshipTraineeInternshipProgra from './relational/which_of_the_following_apprenticeship_trainee_internship_progra/index.js'
import * as whichOfTheFollowingElementsAreReferencedInWrittenJobD from './relational/which_of_the_following_elements_are_referenced_in_written_job_d/index.js'
import * as whichOfTheFollowingFacSocialInsuranceContributionsBoth from './relational/which_of_the_following_fac_social_insurance_contributions_both/index.js'
import * as whichOfTheFollowingHasTheFacFailedToImplementSelectA from './relational/which_of_the_following_has_the_fac_failed_to_implement_select_a/index.js'
import * as whichOfTheFollowingIsAFactorInDecisionsOnCompensation from './relational/which_of_the_following_is_a_factor_in_decisions_on_compensation/index.js'
import * as whichOfTheFollowingIsAFactorInDecisionsOnConditionsO from './relational/which_of_the_following_is_a_factor_in_decisions_on_conditions_o/index.js'
import * as whichOfTheFollowingIsAFactorInDecisionsOnHiringSelec from './relational/which_of_the_following_is_a_factor_in_decisions_on_hiring_selec/index.js'
import * as whichOfTheFollowingIsAFactorInDecisionsOnPromotionOr from './relational/which_of_the_following_is_a_factor_in_decisions_on_promotion_or/index.js'
import * as whichOfTheFollowingIsAFactorInDecisionsOnTermination from './relational/which_of_the_following_is_a_factor_in_decisions_on_termination/index.js'
import * as whichOfTheFollowingLegallyRequiredCompensationBenefitsI from './relational/which_of_the_following_legally_required_compensation_benefits_i/index.js'
import * as whichOfTheFollowingRecruitmentFeesOrRelatedCostsDoesT from './relational/which_of_the_following_recruitment_fees_or_related_costs_does_t/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten from './relational/which_of_the_following_topics_are_included_win_the_facs_written/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_1 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_1/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_10 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_10/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_11 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_11/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_12 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_12/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_13 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_13/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_14 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_14/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_2 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_2/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_3 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_3/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_4 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_4/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_5 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_5/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_6 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_6/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_7 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_7/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_8 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_8/index.js'
import * as whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_9 from './relational/which_of_the_following_topics_are_included_win_the_facs_written_9/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheCommAndTraining from './relational/which_of_the_following_topics_are_part_of_the_comm_and_training/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheCommAndTraining_1 from './relational/which_of_the_following_topics_are_part_of_the_comm_and_training_1/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheCommAndTraining_2 from './relational/which_of_the_following_topics_are_part_of_the_comm_and_training_2/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheCommAndTraining_3 from './relational/which_of_the_following_topics_are_part_of_the_comm_and_training_3/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheCommAndTraining_4 from './relational/which_of_the_following_topics_are_part_of_the_comm_and_training_4/index.js'
import * as whichOfTheFollowingTopicsArePartOfTheOngoingCommAnd from './relational/which_of_the_following_topics_are_part_of_the_ongoing_comm_and/index.js'
import * as whichOfTheFollowingTopicsHaveBeenAssignedToAResponsib from './relational/which_of_the_following_topics_have_been_assigned_to_a_responsib/index.js'
import * as whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPay from './relational/which_of_the_following_types_of_leave_is_the_fac_failing_to_pay/index.js'
import * as whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPro from './relational/which_of_the_following_types_of_leave_is_the_fac_failing_to_pro/index.js'
import * as whichOfTheFollowingTypesOfOvertimeHoursIsTheFacFaili from './relational/which_of_the_following_types_of_overtime_hours_is_the_fac_faili/index.js'
import * as whichOfTheFollowingTypesOfRegularHoursWorkedAtAPremi from './relational/which_of_the_following_types_of_regular_hours_worked_at_a_premi/index.js'
import * as whichOfTheFollowingWorkIsPerformedByWrkrsUndAge_18Se from './relational/which_of_the_following_work_is_performed_by_wrkrs_und_age_18_se/index.js'
import * as whichOfTheItemsBelowApplySelectAllThatApply from './relational/which_of_the_items_below_apply_select_all_that_apply/index.js'
import * as whichTypesOfInkindBenefitsDoesTheFacProvSelectAllTha from './relational/which_types_of_inkind_benefits_does_the_fac_prov_select_all_tha/index.js'
import * as whoIsResponsibleForPayingRecruitmentFeesAndRelatedCost from './relational/who_is_responsible_for_paying_recruitment_fees_and_related_cost/index.js'
import * as whoPerformsTheClockinclockoutFunctionForWrkrsSelectAll from './relational/who_performs_the_clockinclockout_function_for_wrkrs_select_all/index.js'
import * as whoReceivesCommAndTrainingSelectAllThatApply from './relational/who_receives_comm_and_training_select_all_that_apply/index.js'
import * as whoResponsiblePayingRecruitmentFeesRelatedCostsWorker from './relational/who_responsible_paying_recruitment_fees_related_costs_worker/index.js'
import * as withdrawalOfComplaint from './relational/withdrawal_of_complaint/index.js'
import * as women from './relational/women/index.js'
import * as woodProcessing from './relational/wood_processing/index.js'
import * as worker_1 from './relational/worker_1/index.js'
import * as worker_2 from './relational/worker_2/index.js'
import * as workerFeedback from './relational/worker_feedback/index.js'
import * as workerRepresentatives from './relational/worker_representatives/index.js'
import * as workersAreNotRotatedBetweenTasksReduceExposure from './relational/workers_are_not_rotated_between_tasks_reduce_exposure/index.js'
import * as workersAreNotUsingFallProtectionWhenNeeded from './relational/workers_are_not_using_fall_protection_when_needed/index.js'
import * as workersArePaidDirectDepositIntoBankAccount from './relational/workers_are_paid_direct_deposit_into_bank_account/index.js'
import * as workersArePaidThrough_3rdPartyAgentsHave from './relational/workers_are_paid_through_3rd_party_agents_have/index.js'
import * as workersCannotRespondAppealSettlement from './relational/workers_cannot_respond_appeal_settlement/index.js'
import * as workersCannotTakeShortErgonomicBreaksDuringWork from './relational/workers_cannot_take_short_ergonomic_breaks_during_work/index.js'
import * as workersDoNotGiveWrittenConsentMoniesBe from './relational/workers_do_not_give_written_consent_monies_be/index.js'
import * as workersDoNotHaveAccessAccountStatusWage from './relational/workers_do_not_have_access_account_status_wage/index.js'
import * as workersDoNotHaveUnrestrictedAccessVerifyAccuracy from './relational/workers_do_not_have_unrestricted_access_verify_accuracy/index.js'
import * as workersDoNotKnowTheirPrimaryEvacuationRoute from './relational/workers_do_not_know_their_primary_evacuation_route/index.js'
import * as workersDoNotWearFallProtectionTimesWhen from './relational/workers_do_not_wear_fall_protection_times_when/index.js'
import * as workersMustStayHomeAreNotPaid from './relational/workers_must_stay_home_are_not_paid/index.js'
import * as workersMustStayHomeArePaidLegalMinimum from './relational/workers_must_stay_home_are_paid_legal_minimum/index.js'
import * as workersMustStayHomeArePaidLessThan from './relational/workers_must_stay_home_are_paid_less_than/index.js'
import * as workersMustStayHomeAreRequiredUseVacation from './relational/workers_must_stay_home_are_required_use_vacation/index.js'
import * as workersNotTrainedOnProperUseFallProtection from './relational/workers_not_trained_on_proper_use_fall_protection/index.js'
import * as workersThatWorkLaserRadiationProducingEquipmentDo from './relational/workers_that_work_laser_radiation_producing_equipment_do/index.js'
import * as workersTrainingLogsOnProperUseFallProtection from './relational/workers_training_logs_on_proper_use_fall_protection/index.js'
import * as workersWhoUseLaddersAreNotTrainedPlace from './relational/workers_who_use_ladders_are_not_trained_place/index.js'
import * as workingHourRecordsAreNotConsistentPayrollOther from './relational/working_hour_records_are_not_consistent_payroll_other/index.js'
import * as workingHourRecordsEachWorker from './relational/working_hour_records_each_worker/index.js'
import * as workingHourRecordsEachWorkerAreNotMaintained from './relational/working_hour_records_each_worker_are_not_maintained/index.js'
import * as workingHours from './relational/working_hours/index.js'
import * as workingHoursRecordsEachWeekWhen_60Hours from './relational/working_hours_records_each_week_when_60_hours/index.js'
import * as workingHoursRecordsHowManyWeeksWereSampled from './relational/working_hours_records_how_many_weeks_were_sampled/index.js'
import * as workingHoursRecordsWeeksSampledHowManyWeeks from './relational/working_hours_records_weeks_sampled_how_many_weeks/index.js'
import * as workload from './relational/workload/index.js'
import * as workosOrganizationId from './global/workos_organization_id/index.js'
import * as workRelatedInjuryIllnessDeathNotCollectedForwarded from './relational/work_related_injury_illness_death_not_collected_forwarded/index.js'
import * as wrapWorldwideResponsibleAccreditedProduction from './relational/wrap_worldwide_responsible_accredited_production/index.js'
import * as writtenJobDescriptionJobApplicationFormsReferenceOther from './relational/written_job_description_job_application_forms_reference_other/index.js'
import * as writtenPoliciesProcedures from './relational/written_policies_procedures/index.js'
import * as yesAreTermsConditionsSame from './relational/yes_are_terms_conditions_same/index.js'
import * as yesDescribeCircumstances from './relational/yes_describe_circumstances/index.js'
import * as yesDescribeHowBurningWasteControlled from './relational/yes_describe_how_burning_waste_controlled/index.js'
import * as yesDescribeHowWorkers from './relational/yes_describe_how_workers/index.js'
import * as yesDescribeTermsLoansAdvancesIEInterest from './relational/yes_describe_terms_loans_advances_i_e_interest/index.js'
import * as yesDescribeTypeDeductionsWagesMadeBesidesLegally from './relational/yes_describe_type_deductions_wages_made_besides_legally/index.js'
import * as yesDescribeWhatTypeConcernsWereMadeRegarding from './relational/yes_describe_what_type_concerns_were_made_regarding/index.js'
import * as yesDescribeWhatTypeHotWorkPerformedFacility from './relational/yes_describe_what_type_hot_work_performed_facility/index.js'
import * as yesDescribeWhatTypeLaserRadiationEquipmentUsed from './relational/yes_describe_what_type_laser_radiation_equipment_used/index.js'
import * as yesDoesFacilityRecruitingAgencyEverRequestThat from './relational/yes_does_facility_recruiting_agency_ever_request_that/index.js'
import * as yesDoWorkersConfirmAccuracyPayoutsRePayments from './relational/yes_do_workers_confirm_accuracy_payouts_re_payments/index.js'
import * as yesHowManyCasesWasVictimFemaleWorker_1 from './relational/yes_how_many_cases_was_victim_female_worker_1/index.js'
import * as yesHowManyCasesWasVictimFemaleWorker_2 from './relational/yes_how_many_cases_was_victim_female_worker_2/index.js'
import * as yesHowManyCasesWasVictimFemaleWorker_3 from './relational/yes_how_many_cases_was_victim_female_worker_3/index.js'
import * as yesHowManyCasesWasVictimMaleWorker_1 from './relational/yes_how_many_cases_was_victim_male_worker_1/index.js'
import * as yesHowManyCasesWasVictimMaleWorker_2 from './relational/yes_how_many_cases_was_victim_male_worker_2/index.js'
import * as yesHowManyCasesWasVictimMaleWorker_3 from './relational/yes_how_many_cases_was_victim_male_worker_3/index.js'
import * as yesHowManyComplaintsGrievancesWereReceivedFemale from './relational/yes_how_many_complaints_grievances_were_received_female/index.js'
import * as yesHowManyComplaintsGrievancesWereReceivedMale from './relational/yes_how_many_complaints_grievances_were_received_male/index.js'
import * as yesHowManySubcontractors from './relational/yes_how_many_subcontractors/index.js'
import * as yesHowManySuggestionsFeedbackReceivedFacilityAddressed_1 from './relational/yes_how_many_suggestions_feedback_received_facility_addressed_1/index.js'
import * as yesHowManySuggestionsFeedbackReceivedFacilityAddressed_2 from './relational/yes_how_many_suggestions_feedback_received_facility_addressed_2/index.js'
import * as yesHowManyWorkersAreCoveredThisOther from './relational/yes_how_many_workers_are_covered_this_other/index.js'
import * as yesWhatIndoorTemperatureCelsiusFacContinuouslyMaintains from './relational/yes_what_indoor_temperature_celsius_fac_continuously_maintains/index.js'
import * as zdhcId from './global/zdhc_id/index.js'
import * as zipCode from './global/zip_code/index.js'

export {
  aboveGroundStorageTanksUndergroundStorageTanks,
  abvtex,
  accessories,
  additionnalPhotosNonRelatedToQuestions,
  addressLine_1,
  addressLine_2,
  administrativeCosts,
  age_1,
  age_2,
  age_3,
  ageFactoredIntoHiringDecisionsNotLineLegal,
  agencyContractWorker,
  agents,
  ageReferencedNotLineLegalRequirements,
  allowSharingAddress,
  allowSharingProof,
  allPublicHolidays_1,
  allPublicHolidays_2,
  amforiClientId,
  amforiClientSecret,
  amforiCredentialsRevokedAt,
  amforiCredentialsVerifiedAt,
  amforiLastSyncedAt,
  amforiMemberId,
  amforiSiteIds,
  annualLeave_1,
  annualLeave_2,
  annualProductionCapacity,
  annualPurchaseVolume,
  annualRevenue,
  antiDiscrimination,
  antiHarassmentAndAbuse,
  apparel,
  approximateNumberOfSupervisors_1,
  approximateNumberOfSupervisors_2,
  approximateNumberOfSupervisors_3,
  approximateNumberOfSupervisors_4,
  approximateNumberOfWorkers_1,
  approximateNumberOfWorkers_2,
  approximateNumberOfWorkers_3,
  approximateNumberOfWorkers_4,
  areAffordableMenstrualProductsAvailableInTheWorkplace,
  areAllEmergencyExitsAccessibleUnobstructedAndUnlockedDu,
  areAllEmergencyExitsClearlyMarked,
  areAllInkindBenefitsVoluntary,
  areAllLoansAndorAdvancesInLineWLegalReqs,
  areAllNewWrkrsProvdWACopyOfTheFacsWorkplaceRulesAv,
  areAllOvertimeWorkingHoursInLineWLegalLimits,
  areAllWrkrsOfferedAnyOfTheFollowingProgramsByTheFac,
  areAllWrkrsOfferedAnyOfTheFollowingTypesOfDevelopment,
  areAllWrkrsOfferedAnyOfTheFollowingTypesOfMarketAcce,
  areAnyMaterialsThatAreNotRelevantToTheMaintenanceOfT,
  areAnyMonetaryDepositsRequiredOfWrkrs,
  areArrangementsInCaseOfMedicalEmergencyIncludingOnsite,
  areBipartiteCommitteeMembersReleasedFromWorkDutiesToPr,
  areBipartiteCommitteesEstablishedAndFunctioningInLineW,
  areBipartiteCommitteeSEstablishedFunctioningLineLegal,
  areBipartiteCommitteeSPlaceAlthoughThereAre,
  areBuildingconstructionStructuralSafetyAndFirePermitsAnd,
  areBuildingconstructionStructuralSafetyAndFirePermitsAnd_1,
  areChemicalsAndHazardousSubstancesLabeledInLineWLegal,
  areChemicalsAndHazardousSubstancesStoredInLineWLegalR,
  areChildrenBelowTheLegalMinimumAgeForEmploymentAllowed,
  areContractsForAllPersonsWhoPerformWorkForTheFacBoth,
  areDisciplinaryMeasuresForWrkrsInLineWLegalReqs,
  areElectricalOutletsUsedForPluggingInCordedEquipmentIn,
  areElectricalWiresCablesSwitchesPlugsPanelsDistribution,
  areElevatorsLiftsInLineWLegalReqs,
  areElevatorsLiftsLineLegalRequirements,
  areEmergencyEvacuationProceduresInLineWLegalReqs,
  areEmergencyExitsInLineWOtherLegalReqs,
  areErgonomicMeasuresInLineWLegalReqs,
  areErgonomicMeasuresLineLegalRequirements,
  areExemptionTermsAccurateCurrentValidAndFollowedByThe,
  areFacDoorsExitsAndStairsInLineWLegalReqs,
  areFacilityDoorsExitsStairsLineLegalRequirements,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_1,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_10,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_11,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_12,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_2,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_3,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_4,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_5,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_6,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_7,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_8,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_9,
  areFacTemperatureAndVentilationInLineWApplicableLegal,
  areFlammablecombustibleMaterialsSafelyStored,
  areFuelStorageTanksDesignedAndHandledInLineWLegalReq,
  areFuelStorageTanksDesignedHandledLineLegal,
  areGrievanceHandlingAndDisputeResolutionProceduresAccess,
  areGrievancesAndDisputesResolvedInLineWLegalReqs,
  areGrievancesDisputesResolvedLineLegalRequirements,
  areKindBenefitsVoluntary,
  areLaborRecruitersEmploymentAgenciesEverResponsibleForT,
  areLegallyRequiredGuardsProperlyInstalledAndMaintainedO,
  areLegallyRequiredGuardsProperlyInstalledMaintainedOn,
  areLegallyRequiredMechanismsForDialogueBetweenTheEmploy,
  areLegallyRequiredSafetyWarningsPostedInTheWorkplace,
  areLegallyRequiredWrkrsRepresentativesIfAnyElectedAndF,
  areLoansAdvancesLineLegalRequirements,
  areMachineryAndLightingConnectedToTheAppropriateTypeOf,
  areManagersAndSupvsHeldAccountableForEnsuringThatThere,
  areMechanismsToCooperationBetweenWrkrsAndMgmtOnOccupat,
  areMonetaryDepositsOutLineLegalRequirements,
  areMonetaryDepositsOutOfLineWLegalReqs,
  areMonetaryDepositsRequiredWorkers,
  areOffSiteCanteensEatingAreasManagedFacility,
  areOnsiteCanteensEatingAreasLineLegalRequirements,
  areOnsiteChildcareFacilitiesInLineWLegalReqs,
  areOnSiteChildcareFacilitiesLineLegalRequirements,
  areOvertimeHoursPaidAtAPremiumRateOfAtLeast_125Times,
  arePaySlipsInALanguageAllWrkrsCanUndstand,
  arePaySlipsLanguageWorkersCanUnderstand,
  arePersonnelFilesMaintainedInLineWLegalReqs,
  arePersonnelFilesMaintainedLineLegalRequirements,
  arePoliciesProceduresEndorsedSeniorManagement,
  arePossibleSourcesOfIgnitionSufficientlySafeguarded,
  arePregnantAndNursingWrkrsProtectedAgainstSafetyAndHea,
  areProbationaryTimePeriodsInLineWLegalReqs,
  areProbationaryTimePeriodsLineLegalRequirements,
  areProtRestrForWrkrsUndTheAgeOf_18InLineWLegalReqs,
  areProvisionsWinTheCollectiveBargainingAgreementsCbaAt,
  areRecruitmentFeesAndRelatedCostsPaidByWrkrsInLineW,
  areRecruitmentFeesRelatedCostsPaidWorkersLine,
  areRestroomsRegularlyStockedWNecessarySupplies,
  areSafetyDataSheetsSdsFormerlyMsdsAvailableForAllChem,
  areSeparateToiletsProvdForMalesAndFemales,
  areSpecializedHealthChecksConductedForWrkrsPerformingHi,
  areTemperatureAndVentilationSystemsMaintainedInLineWLe,
  areTheBeltAreasOfCompressorsAndGeneratorsFullyEnclosed,
  areTheFacility_1,
  areTheFacility_2,
  areTheFacility_3,
  areTheFacsEmploymentContractsForForeignMigrantsInLine,
  areTheFacsPracticesAroundMakingAccommodationsForPhysica,
  areTheFacsSanitationPracticesInLineWLegalReqs,
  areTheFacsWasteDisposalPracticesInLineWLegalReqs,
  areThereAnyBipartiteCommitteesInPlaceAtTheFac,
  areThereAnyRestrToWrkrsApplyingForOrTakingLeave,
  areTheReasonsForOvertimeInLineWLegalReqs,
  areThereCasesWhereTrashDebrisOrEmptyContainersHaveAcc,
  areThereOnsiteChildcareFacilities,
  areThereRestrictionsWorkersApplyingTakingLeave,
  areThereSufficientEmergencyExitsFromAllWorkStationsAnd,
  areThereWrittenRecsOfTheseCases,
  areThereWrittenRecsOfTheseCases_1,
  areThereWrittenRecsOfTheseCases_10,
  areThereWrittenRecsOfTheseCases_11,
  areThereWrittenRecsOfTheseCases_12,
  areThereWrittenRecsOfTheseCases_13,
  areThereWrittenRecsOfTheseCases_14,
  areThereWrittenRecsOfTheseCases_15,
  areThereWrittenRecsOfTheseCases_2,
  areThereWrittenRecsOfTheseCases_3,
  areThereWrittenRecsOfTheseCases_4,
  areThereWrittenRecsOfTheseCases_5,
  areThereWrittenRecsOfTheseCases_6,
  areThereWrittenRecsOfTheseCases_7,
  areThereWrittenRecsOfTheseCases_8,
  areThereWrittenRecsOfTheseCases_9,
  areTheseStepsToHelpWrkrsWHivAidsInLineWLegalReqs,
  areTheseStepsToHelpWrkrsWInfectionsOrIllnessesOtherT,
  areTheWeeklyRestDaysProvdByTheFacInLineWLegalReqs,
  areToiletsCleanAndSanitizedOnARegularBasis,
  areToiletsInLineWLegalReqs,
  areToiletsLineLegalRequirements,
  areTradeUnionOfficersFromTheFederationexternalTradeUnio,
  areWagePaymentsMadeRegularlyAndOnTimeAndInLineWLega,
  areWagePaymentsMadeRegularlyOnTimeLine,
  areWarehousesWinOrSeparateFromProductionBuildings,
  areWasteDisposaldischargePermitsAvailableAndUpToDate,
  areWeeklyRestDaysProvidedFacilityLineLegal,
  areWkrsInformedTermsCondSurroundingGrantingRepayment,
  areWkrsWhoHandleTetrachloroethylenePercProvidedRequired,
  areWorkerExposuresNoiseLineLegalRequirements,
  areWorkerExposuresToAirborneParticulatesEgDustFibersFu,
  areWorkerExposuresToNoiseInLineWLegalReqs,
  areWorkers,
  areWorkersAllowedAccessDrinkingWaterTime,
  areWorkersAllowedAccessToiletsRestroomsTime,
  areWorkersBasicWagesEverReviewedAndAdjustedForTheEnti,
  areWorkersInformedAboutTheirIndividualWagesDeductions,
  areWorkersInformedExistenceKindBenefits,
  areWorkersPaidDirectlyFacilityThrough_3rdParty,
  areWorkersPaidDuringBreastfeedingBreaksLineLegal,
  areWorkersPaidTheirFullWagesLegallyRequired,
  areWorkersReimbursedRecruitmentFeesRelatedCostsPaid,
  areWorkersWhoHandleNNDimethylformamideDmf,
  areWorkersWhoHandlePotassiumPermanganatePpProvided,
  areWorkplaceRulesMadeVisibleInFacCommonAreasEgCanteen,
  areWorkTargetsForProductionEgQuotaOrPieceWorkInLine,
  areWorkTargetsProductionEGQuotaPiece,
  areWrittenJobDescOrJobApplicationFormsThatReferenceOt,
  areWrittenRecsOfComplaintsAndGrievancesAndTheMgmtsRes,
  areWrittenRecsOfDisciplinaryActionsMaintainedInWrkrsPe,
  areWrittenRecsOfSuggestionsAndFeedbackMaintainedForAt,
  areWrkrsAbleToRefuseOvertimeForAnyReason,
  areWrkrsAllowedAccessToDrinkingWaterAtAnyTime,
  areWrkrsAllowedAccessToToiletsrestroomsAtAnyTime,
  areWrkrsAndWrkrsRepresentativesFreeToMeetWoutThePrese,
  areWrkrsAwareOfTheCommitteesRoleAndAdvantages,
  areWrkrsAwareOfTheProcessesInPlaceForGrievanceHandlin,
  areWrkrsEverResponsibleForTheCostOfAnyOfTheFollowing,
  areWrkrsExposedToHazardousSubstancesInTheProductionPro,
  areWrkrsForcedToWorkOvertimeUndThreatOfPenalty,
  areWrkrsFreeToComeAndGoFromTheDormitoriesAndTheIndu,
  areWrkrsFreeToFormATradeUnionOfTheirChoosing,
  areWrkrsFreeToJoinATradeUnionOfTheirChoosing,
  areWrkrsFreeToTakeLeaveOnceGivenApproval,
  areWrkrsFreeToTerminateTheirEmploymentAfterTheirNotice,
  areWrkrsInformedAboutTheirIndividualWagesAndDeductions,
  areWrkrsInformedOfTheExistenceOfInkindBenefits,
  areWrkrsPaidDirectlyByTheFacOrThrough_3rdPartyAgents,
  areWrkrsPaidDuringBreastfeedingBreaksInLineWLegalReqs,
  areWrkrsPaidForAllWorkrelatedActivitiesOutsideOfRegula,
  areWrkrsPaidTheirFullWagesInTheLegallyRequiredManner,
  areWrkrsProvdWAPrivateMeetingSpaceAtTheWorkplaceInL,
  areWrkrsReimbursedForRecruitmentFeesAndRelatedCostsPai,
  areWrkrsRestrictedFromLeavingTheWorkplaceInOrderToFor,
  areWrkrsSubjectToNegativeConsequencesIfTheyRemoveThems,
  areWrkrsTrainedAndRequiredToUsePersonalProtEquipmentI,
  areWrkrsTrainedOnChemicalHazardsAndSafeWorkPracticesP,
  assembly,
  assemblyEGCorrugatedBoard,
  audit_24412dqa111,
  audit_4pppwlgmbnl,
  audit_6atu4r8e1aq,
  auditAmforiBepi,
  auditAwsAllianceForWaterStewardship,
  auditBetterWork,
  auditBluesign,
  auditBsci,
  auditC28ljiab8qc,
  auditControlUnionFairChoiceAudit,
  auditEti,
  auditEwsEuropeanWaterStewardship,
  auditFactoryVisit,
  auditFairWearFoundation,
  auditFla,
  auditGots,
  auditGreenButtonAudit,
  auditGub825fyuyf,
  auditHiggFemHiggFacilityEnvironmentalModule,
  auditHiggFslmHiggFacilitySocialLaborModule,
  auditIcs,
  auditIctiEthicalToyProgram,
  auditImpactProgram,
  auditIso_26000,
  auditKeh8dtw175b,
  auditOcsAudit,
  auditOekoTex,
  auditOhsas_18001,
  auditQz1m274j4ym,
  auditSa8000,
  auditSedexSmeta,
  auditSfpSustainableFibreProgramme,
  auditSlcpConvergedAssessmentFramework,
  auditSustainableTextileSolutions,
  auditWfkr7fwt9tw,
  auditWrap,
  bangladeshAreTheWorkers,
  bangladeshDoAllWrkrsOtherThanApprenticesSubstitutebadli,
  bangladeshDoesFacComplyLegalReqEnsureAgainst,
  bangladeshDoesFacilityHaveLegallyRequiredLicenseStorage,
  bangladeshDoesFacilityHaveLegallyRequiredQualifiedWelfare,
  bangladeshDoesTheFacHaveLegallyRequiredQualifiedWelfare,
  bangladeshDoesTheFacHaveTheLegallyRequiredLicenseForS,
  bangladeshHasFacilityEstablishedWorkers,
  batteryChargingAreasElectricForkliftTrucksAreClose,
  benefitsNotMaintained,
  betterCottonInitiativeBci,
  bipartiteCommCommunicatesWkrsUpper,
  bipartiteCommitteeMeetingActionItemsAreTracked,
  bipartiteCommitteeMeetingMinutesAreSharedWorkforce,
  bipartiteCommitteeMeetingsAreHeldLeastQuarterly,
  bipartiteCommitteeMeetingsAreHeldOnMonthlyBasis,
  blendingFormulating,
  briberyAndAntiCorruption,
  bsciBusinessSocialComplianceInitiative,
  buildingIsSharedWOtherFacilitiesenterprises,
  cambodiaAttendanceBonusCasualWorkers,
  cambodiaAttendanceBonusDuringLeave,
  cambodiaAttendanceBonusNewWorkers,
  cambodiaDoesFacIncludeEntirePeriodContinuousEmployment,
  cambodiaIsThePieceRateSetAtALevelThatPermitsWrkrsOf,
  cambodiaSeniorityIndemnityUdcWkrs,
  cambodiaTransportHomePlaceSleepWorkersWhoFinish,
  cambodiaWageSupplementsHousingAllowances,
  cambodiaWhichOfTheFollowingOtherWagePaymentsWereNotIn,
  canApprenticesTraineesInternsAPositionInTheFacThatIs,
  canChangeCoreInformation,
  canReadProductStory,
  canteenEatingAreasAreNotProtectedFromElements,
  canteenEatingAreasAreNotSeparateFromProduction,
  canteens,
  canTheTradeUnionsFreelyFormAndJoinFederationsAndConfe,
  canWrkrsWhoOweDebtsToTheFacAndorAThirdPartyFreelyL,
  capacityChildcareFacilityNotSufficientCoverNeedWorkers,
  carbonIntensityScope,
  cardStoredValue,
  cash,
  casting_1,
  casting_2,
  chainCustodyStandardCcs,
  check,
  chemical,
  chemicalsDisposedWasteBinContainersWhichAreGenerally,
  chemicalsHazardousSubstances,
  chemicalStorageAreasDoNotHaveChemicalSpill,
  chemicalSynthesis,
  childcare,
  childCare,
  childcareFacilitiesAreNotKeptCleanSafeHygienic,
  childcareFacilitiesAreNotOnGroundFloor,
  childcareFacNotProvidedAdequateSuppliesInfrastructure,
  childcareStaffDoNotGoThroughAppropriatePre,
  childLaborYoungWorkers,
  city,
  coating,
  collaborationEndDate,
  collaborationStartDate,
  collaborationStatus,
  commercialRegistrationNumber,
  commuteServiceProvidedOrganizedFacility,
  companyLeverage,
  companySize,
  complaintsGrievancesAreNotSettledDirectlyBetweenWorker,
  complaintsGrievancesNotAdditionalStakeholders,
  compressedGasCylindersAreNotStoredAwayFrom,
  compressedGasCylindersAreNotStoredEnclosedCage,
  connectionType,
  contactPersonEmail,
  contractsDoNotClearlyAccuratelyStateTermsConditions,
  contractWorkersWorkersEmployedThirdPartyWhoAre,
  convertingRawMaterialIncomingPaperboardPlasticResin,
  copiesContractsAreNotProvidedWorkersLineApplicable,
  copiesTermsConditionsDocumentsAreNotProvidedWorkers,
  country,
  countryName,
  county,
  cutting_1,
  cutting_2,
  deductionsAreNotVoluntarilyAcceptedWorkers,
  deductionsWagesAreNotExplainedWorkers,
  describeAccommodationsArrangementsMade,
  describeAnyOtherTypesOfBuildings,
  describeConcernsDifficultiesQuestionsListedThisSection_1,
  describeConcernsDifficultiesQuestionsListedThisSection_2,
  describeConcernsDifficultiesQuestionsListedThisSection_3,
  describeConcernsDifficultiesQuestionsListedThisSection_4,
  describeConcernsDifficultiesQuestionsListedThisSection_5,
  describeConcernsDifficultiesQuestionsListedThisSection_6,
  describeConcernsDifficultiesQuestionsListedThisSection_7,
  describeConcernsDifficultiesQuestionsListedThisSection_8,
  describeHoursWorkedViolationLegalLimitsTypeWork,
  describeHowMonthlyCapacityCalculatedEGDo,
  describeOffSiteDormitoriesVisited,
  describeOnsiteDormitoriesVisited,
  describeOtherGroundSIdentifiedFactoredIntoHiring,
  describeOtherReferencesApplicationsForms,
  describeTheMostRepresentativeDepartmentWinTheFac,
  describeTheseInformalProcedures,
  describeTypesFirefightingEquipmentUsedWhichAreasFacility,
  describeTypeWorkHoursWorkedNightBothFemale,
  describeWhichLanguagesAreNotAvailableGrievanceHandling,
  description,
  didAnyOfTheFollowingOccurDuringOrAfterIndustrialActio,
  didAnyWrkrsWorkMoreThan_60HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_72HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_80HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_90HoursInTotalRegularOvertime,
  didAssessmentTakePlaceConsecutivelly,
  didFacilityExperienceExceptionalCircumstancesIELarge,
  didFacilityHaveOtherWageDeductionsBesidesLegally,
  didTheFacActivelySeekToProvOrAttainAnyOfTheFollowin,
  didTheFacCommIncludeAnyOfTheFollowingSelectAllThatA,
  didTheFacComplyWLegalReqsToInformAndorGetPermission,
  didTheFacConsultWWorkerRepresentativesAndorTradeUnion,
  didTheFacExperienceExceptionalCircumstancesIeLargeLate,
  didTheFacHaveAnyOtherWageDeductionsBesidesLegallyRequ,
  didTheFacMaintainWasteDisposalRecsIncludingDocumentatio,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_1,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_2,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_3,
  didTheFacParticipateInAnyTypeOfEconomicEmpowermentPro,
  didWorkersWorkMoreThan_60HoursTotal,
  didWorkersWorkMoreThan_72HoursTotal,
  didWorkersWorkMoreThan_80HoursTotal,
  didWorkersWorkMoreThan_90HoursTotal,
  dieCutting,
  dieCuttingEGCartons,
  directDepositIntoBankAccount,
  disability_1,
  disability_2,
  disability_3,
  disabilityReferencedNotLineLegalRequirements,
  discipline,
  discrimination_1,
  discrimination_2,
  displayName,
  doAllPersonsWhoPerformWorkForTheFacBothOnThePremise,
  doAnyOccupationalSafetyAndHealthMeasuresIncludingCollec,
  doApprovedBuildingPlansReflectTheCurrentBuildingsStruct,
  doesAnyWorkerOweDebtsToTheFacAndorAThirdParty,
  doesFacComplyLegalRestrictionsRegardingPaymentInstead,
  doesFacContinuouslyMonitorMaintainSpecificRegulatedIndoor,
  doesFacilityChargeKindBenefitsBelowCost,
  doesFacilityComplyOccupationalSafetyHealthRelatedLegal,
  doesFacilityConsultWorkersNotifyThemAdvanceAbout,
  doesFacilityConsultWorkersProvideMinimumNoticePeriod,
  doesFacilityHaveConfinedSpacesThatLegallyRequire,
  doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_1,
  doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_2,
  doesFacilityHaveFireDetectionAlarmSystemLine,
  doesFacilityHaveFireDetectionAlarmSystemPlace,
  doesFacilityHaveLegallyRequiredFirefightingEquipment,
  doesFacilityHaveLegallyRequiredUpDatePermits,
  doesFacilityHaveMechanismPlaceProtectWorkers,
  doesFacilityHaveOccupationalSafetyHealthOshCommittee,
  doesFacilityHaveWorkAreasRiskHeatCold,
  doesFacilityHaveWrittenPlanHandlingOutbreaksContagious,
  doesFacilityHireDisabledPersonsLineLegalRequirements,
  doesFacilityIncludePeriodsMaternityLeaveWorkers,
  doesFacilityIncludeSandblastingItsProcesses,
  doesFacilityLimitUseFixedTermContracts,
  doesFacilityLoanAdvanceMoneyWorkers,
  doesFacilityMonitorIndoorAirQualityLineLegal,
  doesFacilityOnlyRequireWorkersTakePaidUnpaid,
  doesFacilityPayWorkersCorrectlyDuringWorkStoppages,
  doesFacilityPerformType,
  doesFacilityProvideBreaksDuringWorkdayLineLegal,
  doesFacilityProvideKindBenefitsLineLegalRequirements,
  doesFacilityProvideTimeOffBreastfeedingLineLegal,
  doesFacilityProvideWorkersCompensatoryTimeOffLine,
  doesFacilityProvideWorkersFreePotableDrinkingWater,
  doesFacilityProvideWorkersPotableDrinkingWaterLine,
  doesFacilityRecruitingAgencyProvideForeignMigrantsSigned,
  doesFacilityRegularlyTestServiceFireExtinguishersOther,
  doesFacilityRequireHivAidsTestsDuringEmployment,
  doesFacilityRequireHivAidsTestsDuringHiring,
  doesFacilityRequireOtherInfectionIllnessTestsE_1,
  doesFacilityRequireOtherInfectionIllnessTestsE_2,
  doesFacilityTakeDeductionsFromWagesThatAre,
  doesFacilityTestNoiseExposureLevelsLineLegal,
  doesFacilityUseFixedTermContracts,
  doesFacMgmtRegularlyMeetWTradeUnionsToProactivelyAddr,
  doesFacRegisterTheirWkrsSocialSecurityInstitutions,
  doesTheEmployerAllowWrkrsToCarryOutTradeUnionActiviti,
  doesTheEmployerUseAnyOtherCoerciveTacticsToForceWrkrs,
  doesTheFacArrangeHealthChecksForAllWrkrsUndTheAge,
  doesTheFacCalculateRegularHoursAsAnAverage,
  doesTheFacChargeForInkindBenefitsAtOrBelowCost,
  doesTheFacCommunicateImprovementPlansToInterestedStakeh,
  doesTheFacCommunicatePubliclyOnSocialAndLaborPerforman,
  doesTheFacComplyWApplicableLegalReqsConcerningHomewrkr,
  doesTheFacComplyWLegalReqsRegardingHealthChecksForWr,
  doesTheFacComplyWLegalReqsRegardingMedicalChecksForW,
  doesTheFacComplyWLegalReqsRegardingQualifiedOshStaff,
  doesTheFacComplyWLegalRestrRegardingPaymentInsteadOf,
  doesTheFacComplyWOccupationalSafetyAndHealthrelatedLeg,
  doesTheFacConductMaintenanceOnElectricalEquipmentWElec,
  doesTheFacConductRegularEmergencyDrillsForAllWrkrsAnd,
  doesTheFacConductRegularReviewsAndorAssessmentsOfSocia,
  doesTheFacConductWorkerPerformanceEvaluationsBasedOnA,
  doesTheFacConsultWWrkrsAndorProvAMinimumNoticePeriod,
  doesTheFacCreateImprovementPlansBasedOnSocialAndLabor,
  doesTheFacDeductTradeUnionDuesFromWagesInLineWLegal,
  doesTheFacEmployOrContractServicesForSecurityPersonnel,
  doesTheFacEngageProactivelyWRelevantStakeholdersBefore,
  doesTheFacEvaluateExposureToConcentrationsOfAirbornePa,
  doesTheFacEvaluateWorkerExposureToChemicalsAndHazardou,
  doesTheFacFailToCollectAndForwardWrkrsContributionsTo,
  doesTheFacFollowAllLegalReqsOnProvisionAndMaintenance,
  doesTheFacFollowAnyOfTheFollowingPracticesConcerningP,
  doesTheFacFollowAnyOfTheFollowingPracticesRegardingWo,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToC,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToM,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToO,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW_1,
  doesTheFacGenerateAirborneParticulatesDustFibersMistsF,
  doesTheFacHaveAClimateAdaptationActionPlan,
  doesTheFacHaveACurrentContractWAnAuthorizedAgencyTo,
  doesTheFacHaveAFireDetectionAndAlarmSystemInPlace,
  doesTheFacHaveAFormalizedProcessOfReviewingDocumentati,
  doesTheFacHaveALegallyRequiredFireBrigadeemergencyResp,
  doesTheFacHaveAnEstablishedAccidentInvestigationProcedu,
  doesTheFacHaveAnOccupationalSafetyAndHealthOshCommitt,
  doesTheFacHaveAnyAdditionalSafetyMeasuresInPlaceRelat,
  doesTheFacHaveAnyOfTheFollowingAdditionalSafetyMeasur,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRegard,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_1,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_2,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceToThe,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_1,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_10,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_11,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_12,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_13,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_14,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_15,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_16,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_17,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_18,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_2,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_3,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_4,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_5,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_6,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_7,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_8,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_9,
  doesTheFacHaveAnyOfTheseAdditionalMeasuresInPlaceRel,
  doesTheFacHaveAnyWorkAreasWRiskOfHeatOrColdStress,
  doesTheFacHaveASufficientNumOfToiletsForTheNumOfWr,
  doesTheFacHaveASystemForReviewingPoliciesAndProcedure,
  doesTheFacHaveAWhistleblowerSystemInPlace,
  doesTheFacHaveAWrittenChartShowingTheIndividualsRespo,
  doesTheFacHaveAWrittenEmergencyResponsePlan,
  doesTheFacHaveAWrittenStrategyGoalsDocumentsForSocial,
  doesTheFacHaveConfinedSpaces,
  doesTheFacHaveElevatorsLifts,
  doesTheFacHaveErgonomicMeasuresInPlaceThatConsiderThe,
  doesTheFacHaveEstablishedGrievanceHandlingAndDisputeRe,
  doesTheFacHaveForkliftsOrOtherTypesOfLiftingEquipment,
  doesTheFacHaveIAnEstablishedUnionOnsiteAndorIiWrkrs,
  doesTheFacHaveLegallyRequiredAndUpToDatePermitsCerti,
  doesTheFacHaveLegallyRequiredFirefightingEquipment,
  doesTheFacHaveLegallyRequiredPostedEvacuationPlansMark,
  doesTheFacHaveSafetyMeasuresInPlaceRegardingAsbestosS,
  doesTheFacHaveSafetyMeasuresInPlaceRegardingOnsiteVeh,
  doesTheFacHaveWrittenPoliciesAndorFormalProceduresFor,
  doesTheFacHaveWrittenProceduresForClassificationCollect,
  doesTheFacHireDisabledPersonsInLineWLegalReqs,
  doesTheFacIncludeAllPeriodsOfMaternityLeaveInTheWrkr,
  doesTheFacInformAllWrkrsAboutCbasAndProvCopiesInLin,
  doesTheFacKeepAllWorkerHealthInfoConfidential,
  doesTheFacLimitTheUseOfFixedtermContracts,
  doesTheFacLoanAndorAdvanceMoneyToWrkrs,
  doesTheFacMaintainAListregisterOfWrkrsUndAge_18InLin,
  doesTheFacMaintainAnInventoryOfAllChemicalsAndHazardo,
  doesTheFacMaintainAValidLaborInspectionVisitBookRecor,
  doesTheFacMaintainJobDescsForAllPositionsWinTheFac,
  doesTheFacMaintainOnlyOneAccuratePayrollRecord,
  doesTheFacMaintainOnlyOneAccurateSetOfWorkingHourRec,
  doesTheFacMaintainParentalPermissionOfWrkrsUndTheAge,
  doesTheFacMaintainRecordedParentalPermissionForWrkrsUn,
  doesTheFacMaintainRecsOfElectricalEquipmentMaintenance,
  doesTheFacMonitorIndoorAirQualityInLineWLegalReqs,
  doesTheFacMonitorTheWorkingHoursOfAllWrkrsUndTheAge,
  doesTheFacNeedToReleaseWrkrsToBeAvailableForGovernme,
  doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo,
  doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo_1,
  doesTheFacOfferFemaleWrkrsInTheSupplyChainIeFemaleW,
  doesTheFacOfferParticipateInAnyApprenticeshipTraineeIn,
  doesTheFacOrRecruitingAgencyProvForeignMigrantsWASig,
  doesTheFacPayWrkrsCorrectlyDuringWorkStoppagesInLine,
  doesTheFacPerformAnyTypeOfHotWorkIeWeldingSoldering,
  doesTheFacProvAllLegallyRequiredFacilities,
  doesTheFacProvBreaksDuringTheWorkdayInLineWLegalReq,
  doesTheFacProvCommAndTrainingOnSocialAndLaborPractic,
  doesTheFacProvHandWashingFacilitiesEquippedWCleanWate,
  doesTheFacProvInkindBenefitsEvenIfNotLegallyRequired,
  doesTheFacProvInkindBenefitsInLineWLegalReqs,
  doesTheFacProvLegallyRequiredCompensationBenefitsRelate,
  doesTheFacProvOtherInsuranceToWrkrsWhoAreNotCovered,
  doesTheFacProvSpecialHealthAndSafetyTrainingsSeparate,
  doesTheFacProvTheListregisterOfWrkrsUndAge_18ToGover,
  doesTheFacProvTimeOffForBreastfeedingInLineWLegalRe,
  doesTheFacProvWrkrsWCompensatoryTimeOffInLineWLegal,
  doesTheFacProvWrkrsWFreePotableDrinkingWater,
  doesTheFacProvWrkrsWPersonalProtEquipmentPpeInLineW,
  doesTheFacProvWrkrsWPotableDrinkingWaterInLineWLega,
  doesTheFacPublishAReportAtLeastEvery_2YearsRegarding,
  doesTheFacRecordWorkrelatedAccidentsAndDiseasesAndRepo,
  doesTheFacRefuseToBargainCollectivelyOrRefuseToBargai,
  doesTheFacRegisterTheirWrkrsWSocialSecurityInstitution,
  doesTheFacRegularlyTestAndServiceFireExtinguishersAnd,
  doesTheFacRentOrOwnThePremisesTheyOccupy,
  doesTheFacRequireHivAidsTestingAtAnyTimeDuringEmploy,
  doesTheFacRequireHivAidsTestingDuringTheHiringProcess,
  doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati,
  doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati_1,
  doesTheFacRequireWrkrsToJoinATradeUnion,
  doesTheFacReviewupdatePoliciesAndProceduresWrittenOrIn,
  doesTheFacTakeAnyDeductionsFromWagesThatAreNotInLin,
  doesTheFacTestNoiseExposureLevelsInLineWLegalReqs,
  doesTheFacTreatAllTradeUnionsEquallyOrAsStipulatedBy,
  doesTheFacUseChemicalsAndorHazardousSubstances,
  doesTheFacUseContractorPersonnelToPerformMaintenanceWo,
  doesTheFacUseFixedtermContracts,
  doesTheFacUseLaserOrRadiationProducingEquipment,
  doesTheFacUsePortableLadders,
  doesTheFacUsePrisonLabor,
  doFoodServiceWrkrsHaveValidHealthsanitationCertificatesp,
  domesticMigrantWorkers,
  doOperatorsTechniciansForMachineryEquipmentElectricalIns,
  doOperatorsTechniciansInstallBoiler,
  doOtherTypesOfWrittenDocumentsExplainingTheTermsAndCo,
  doPaySlipsContainAccurateInfoOnWorkerWagesInADetaile,
  doPaySlipsContainAccurateInformationOnWorker,
  doRegularWorkingHoursExceedLegalReqs,
  dormitories,
  doSecurityPersonnelCarryWeapons,
  doSecurityPersonnelCarryWeaponsOnTheProductionFloor,
  doThesePoliciesAndorProceduresHaveAReferenceToNational,
  doTradeUnionRepresentativesHaveAccessToWrkrsInTheWork,
  doTradeUnionRepresentativesHaveTimeOffToAttendRelevant,
  doTradeUnionRepresentativesHaveTimeOffToCarryOutTheir,
  doWorkersHaveAccessExternalContactsOutsideTheir,
  doWorkersUnderstandInformationIncludedWithinTheirWritten,
  doWorkersUnderstandTermsConditionsWithinTheirWritten,
  doWorkplaceRulesComplyWLegalReqs,
  doWrkrsHaveAccessToExternalContactsOutsideOfMgmtThat,
  doWrkrsHaveTheAbilityToDisputeAndCorrectWagePayments,
  doWrkrsHaveTheRightToConsultWAndBeRepresentedEither,
  doWrkrsHaveTheRightToRespondToAndorAppealAnyDiscipli,
  doWrkrsKeepAllOfTheirOriginalPersonalDocumentsSuchAs,
  doWrkrsSignAllWrittenRecsOfDisciplinaryActionsTakenAg,
  doWrkrsUndstandTheInfoIncludedWinTheirWrittenTermsAnd,
  doWrkrsUndstandTheTermsAndConditionsWinTheirWrittenEm,
  dunsNumber,
  durationOfTheCbaThatCoversThe_2ndGreatestNumOfWrkrsI,
  durationOfTheCbaThatCoversThe_3rdGreatestNumOfWrkrsI,
  durationOfTheCbaThatCoversTheGreatestNumOfWrkrsInTh,
  duringRecruitmentProcessDoMaterialsSuchAsJob,
  duringTheRecruitmentProcessDoMaterialsSuchAsJobDescOr,
  dyeing_1,
  dyeing_2,
  electronics,
  elevatorsNotWiredBeInoperableWhenElevatorDoors,
  embossing,
  embroidery,
  emergencyAlarmNotDistinctFromOtherAlarmsSignals,
  emergencyAlarmSystemButtonsSwitchesPullStationsAre,
  emergencyAlarmSystemCannotBeHeardSeenAcross,
  emergencyAlarmSystemNotFittedBackUpPower,
  emergencyExitDoorsDoNotOpenOutwardsAre,
  employmentStatusNotMaintained,
  enabledCustomInfo,
  energyIEFuelCoalElectricityGasEtc,
  energyManagementSystem,
  energySourcesPefcr,
  equipmentCosts,
  ethiopiaPayWorkersCorrectlyDuringPrenatalVisits,
  ethiopiaPayWorkersCorrectlyWhenTheyTakeTime,
  ethiopiaProvideLegallyRequiredTimeOffPrenatalVisits,
  ethiopiaProvideTimeOffWorkersAppearLaborDispute,
  etiEthicalTradingInitiative,
  europeanFlaxCertifiedCompany,
  existingProductionWorkers_1,
  existingProductionWorkers_10,
  existingProductionWorkers_11,
  existingProductionWorkers_12,
  existingProductionWorkers_13,
  existingProductionWorkers_14,
  existingProductionWorkers_15,
  existingProductionWorkers_16,
  existingProductionWorkers_17,
  existingProductionWorkers_18,
  existingProductionWorkers_19,
  existingProductionWorkers_2,
  existingProductionWorkers_20,
  existingProductionWorkers_21,
  existingProductionWorkers_22,
  existingProductionWorkers_23,
  existingProductionWorkers_24,
  existingProductionWorkers_3,
  existingProductionWorkers_4,
  existingProductionWorkers_5,
  existingProductionWorkers_6,
  existingProductionWorkers_7,
  existingProductionWorkers_8,
  existingProductionWorkers_9,
  eyewashStationsShowersAreNotClearClutterDebris,
  eyewashStationsShowersAreNotClearlyIdentifiable,
  eyewashStationsShowersAreNotEasyAccess,
  eyewashStationsShowersAreNotRegularlyInspected,
  eyewashStationsShowersDoNotUsePotableWater,
  eyewashStationsShowersInspectionLogsAreNotKept,
  facDoesNotReviewupdatePoliciesAndProceduresWrittenOrIn,
  facDoesNotUseAnyMethodsAndIsNotAwareOfChangesupdates,
  facEmail,
  facFailingComplyLegalReqContractsHiringPractices,
  facFailingComplyLegalReqNotCoveredElsewhere_1,
  facFailingComplyLegalReqNotCoveredElsewhere_2,
  facFailingComplyLegalReqNotCoveredElsewhere_3,
  facFailingComplyLegalReqNotCoveredElsewhere_4,
  facFailingComplyLegalReqNotCoveredElsewhere_5,
  facFailingComplyLegalReqNotCoveredElsewhere_6,
  facFailingComplyLegalReqNotCoveredElsewhere_7,
  facFailingComplyLegalReqNotCoveredElsewhere_8,
  facFailingComplyLegalReqWagesBenefitsPertaining,
  facFailingComplyLegalReqWorkingHoursPertaining,
  facilityAcceptsWorkersFromGovernmentPrograms,
  facilityAccessibleFireResponseEmergencyVehiclesAlthough,
  facilityAccessibleFireResponseEmergencyVehiclesLine,
  facilityAddressLocalLanguageAsPerBusinessLicense,
  facilityAdministeringHivAidsTestsDuringHiringProcess,
  facilityAdministeringOtherInfectionIllnessTestsEG,
  facilityFailingCorrectlyPayWorkersTheseTypesLeave,
  facilityFailingCorrectlyProvideWorkersTimeOffThese,
  facilityHasNotPerformedAsbestosExposureAssessment,
  facilityHasNotTakenProperStepsEnsureThat,
  facilityHasOverdueSocialInsuranceSocialSecurityDebts,
  facilityLightingLineLegalRequirements,
  facilityLineLegalRequirementsWhenAdministeringHivAids,
  facilityNameLocalLanguageAsPerBusinessLicense,
  facilityPaidHousingAllowance,
  facilityPaidMealAllowance,
  facilityPaidSeniorityGratuityBonus,
  facilityPaidTransportationAllowance,
  facilityProcesses,
  facilityRequiresPregnancyTestsThatAreNotRequired_1,
  facilityRequiresPregnancyTestsThatAreNotRequired_2,
  facilityRequiresUseContraceptivesOtherFormsBirthControl_1,
  facilityRequiresUseContraceptivesOtherFormsBirthControl_2,
  facilityRequiresVirginityTestBeforeHiring,
  facilityStairwayStepsAreNotEven,
  facilityStepSurfacesAreNotMadeFromSlip,
  facilityWorkplaceRules,
  facIsInAMultifloorBuilding,
  facLineLegalReqWhenAdministeringOtherInfection,
  facRequiresPregnancyTestsThatAreNotRequiredByApplicabl,
  facRequiresWkrProvideCommitmentsVerballyWritingThat,
  facsAverageMonthlyVolumeNumericalAmount,
  facsMonthlyCapacityNumericalAmount,
  facsMonthlyCapacityUnitOfMeasurement,
  facsMonthlyVolumeUnitOfMeasurement,
  fallProtectionEquipmentMaintenanceLogsAreNotKept,
  fallProtectionEquipmentNotGoodCondition,
  familyResponsibilities_1,
  familyResponsibilities_2,
  familyResponsibilities_3,
  familyResponsibilitiesFactoredIntoHiringDecisionsNotLine,
  familyResponsibilitiesReferencedNotLineLegalRequirements,
  fifthWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  finalProductWarehousingStorage,
  finishing_1,
  finishing_2,
  finishingOfTextiles,
  firefightingEquipmentNotAccessible,
  firefightingEquipmentNotClearlyMarkedEquippedInstructions,
  firstWageLevelDefinedByFacThisIsTheLowestWageLevelC,
  flaFairLaborAssociation,
  floorsHaveBeenAddedSinceOriginalConstruction,
  food,
  foodAndBeverage,
  foodPreparationStorageEatingAreasAreNotKept,
  footwear,
  footwearClothing,
  forEachAdditionalActiveTradeUnionThatIsSmallerThanThe,
  forEachAdditionalCollectiveBargainingAgreementCbaNotCov,
  foreignMigrantWorkers,
  forHowManyMonthsAreRecsOfDisciplinaryActionsMaintained,
  forkliftRoutesAreNotClearlyMarked,
  forWrkrsSeekingToEndTheirEmploymentHowManyDaysOfNoti,
  fourthWageLevelDefinedByFacCompleteDefinitionOfThisLe,
  freedomAssociationCollectiveBargaining,
  ftusaFairTradeUsa,
  fullAddressLocalize,
  furniture,
  geojson,
  ghgEmissionsOffsetScope,
  glassProcessing,
  globalLocationNumber,
  gluing_1,
  gluing_2,
  gluing_3,
  gotsGlobalOrganicTextileStandard,
  governmentProgramsFacilityParticipatesIn,
  grievanceHandlingDisputeResolutionProcAccessLanguages,
  grievanceHandlingDisputeResolutionProceduresAccessibleSome,
  grievanceMechanismChannels,
  grievanceMechanismLocallyAvailableForPotentialExternalStakeholders,
  grievanceSystems,
  grsGlobalRecyclingStandard,
  handbags,
  harassment_1,
  harassment_2,
  hasAllLegallyRequiredActionBeenTakenToAssessMonitorAn,
  hasAnyNewPast_3YearsConstructionBeenAddedToTheBuildin,
  hasFacConductedAssessmentIdentifyEquipContainsPcb,
  hasFacilityActedAgainstLegalRequirementsHiringTemporary,
  hasFacilityConductedHealthSafetyRiskAssessmentLine,
  hasFacilityHadRushOrdersWithinAssessmentPeriod,
  hasFacilityTakenLegallyRequiredMeasuresProtectWorkers,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_1,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_2,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_3,
  hasFacilityTrainedWorkersUseFireFightingEquipment,
  hasFacMadeDisabledPersons,
  hasFacThreatenedIntimidatedHarassedPunishedTerminatedNot,
  hasLegallyRequiredActionBeenTakenAssessMonitor_1,
  hasLegallyRequiredActionBeenTakenAssessMonitor_2,
  hasTerminationForcedResignationRetrenchmentOrRetirementE,
  hasTheFacActedAgainstLegalReqsByHiringTemporaryprobati,
  hasTheFacBeenSubjectToAnyFinesOrSanctionsRelatedToS,
  hasTheFacConductedAHealthAndSafetyRiskAssessment,
  hasTheFacConductedAHealthAndSafetyRiskAssessmentInLi,
  hasTheFacConductedAnAssessmentToIdentifyIfEquipmentCo,
  hasTheFacConductedARiskAssessmentOrTestingToDetermine,
  hasTheFacDefinedThePersonsResponsibleForTheImplementat,
  hasTheFacEncouragedSourcingPracticesThatResultedInThe,
  hasTheFacEngagedInAnyOfTheseActionsDueToAWorkersTr,
  hasTheFacEverTriedToPreventAnyWrkrsFromParticipating,
  hasTheFacEverWheldOrThreatenedToWholdOrDelayedWageP,
  hasTheFacFailedToImplementAnyApplicableCourtOrdersArb,
  hasTheFacFailedToImplementAnyOfTheProvisionsInTheCb,
  hasTheFacFailedToMaintainAnyOfTheFollowingForWrkrsD,
  hasTheFacImplementedAnyOtherCommunityImpactProjectsTha,
  hasTheFacImplementedAnyOtherProjectsThatHaveSoughtTo,
  hasTheFacMadeAccommodationsarrangementsForPhysicallyDisa,
  hasTheFacMgmtTriedToControlManipulateOrInterfereWAny,
  hasTheFacReceivedRecognitionAwardFromAPubliclyKnownIn,
  hasTheFacSetSpecificGoalstargetsForImprovementOnSocial,
  hasTheFacSetTargetsForSocialAndLaborPerformanceAddres,
  hasTheFacTakenLegallyRequiredMeasuresToProtectWrkrsFr,
  hasTheFacTakenStepsToEnableWrkrsWHivaidsToRetainThe,
  hasTheFacTakenStepsToEnableWrkrsWhoBecomeDisabledFor,
  hasTheFacTakenStepsToEnableWrkrsWInfectionsOrIllness,
  hasTheFacThreatenedIntimidatedHarassedPunishedTerminated,
  hasTheFacTrainedWrkrsToUseFirefightingEquipmentInLine,
  haveAnyCasesOfThreatsSuchAsReportingToAuthoritiesDepo,
  haveAnyCasesOfViolenceOrThreatsOfViolenceToIntimidate,
  haveDecisionsOfTerminationForcedResignationRetrenchmentO,
  haveRaceEthnicGroupSkinColorSexGender_1,
  haveRaceEthnicGroupSkinColorSexGender_2,
  haveRaceEthnicGroupSkinColorSexGender_3,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_1,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_2,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_3,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_4,
  haveThereBeenAndorAreThereCurrentlyCasesOfConcernAbou,
  haveThereBeenAnyCasesOfPhysicalVerbalPsychologicalHara,
  haveThereBeenAnyIncidencesOfForcedLaborIncludingSaleA,
  haveThereBeenCasesOfSexualHarassment,
  haveWorkersBeenDeniedAccessTheirOriginalPersonal,
  haveWrkrsBeenDeniedAccessToAnyOfTheirOriginalPersonal,
  healthAndSafety,
  healthClinics,
  healthSafety,
  heatPressHeatingCooling_1,
  heatPressHeatingCooling_2,
  higgId,
  hivAidsStatusRealPerceived_1,
  hivAidsStatusRealPerceived_2,
  hivAidsStatusRealPerceived_3,
  hivAidsStatusRealPerceivedFactoredIntoHiring,
  hivAidsStatusRealPerceivedReferencedNotLine,
  homeAccessories,
  homeTextiles,
  homeworkers,
  hotWorkPerformedLineLegalRequirements,
  householdProducts,
  housing,
  howAreComplaintsAndGrievancesSettledSelectAllThatApply,
  howAreHoursOfWorkRecordedForWrkrsSelectAllThatApply,
  howAreWrkrsPaidSelectAllThatApply,
  howDoesTheFacDefineWageGradesLevels,
  howDoesTheFacEngageWWrkrsToProactivelySeekSuggestions,
  howDoesTheFacProvCommAndTrainingToIndividualsResponsi,
  howDoesTheFacProvCommAndTrainingToNewProductionWrkrs,
  howDoesTheFacProvCommAndTrainingToSecurityGuardsSele,
  howDoesTheFacProvCommAndTrainingToSeniorMgmtSelectA,
  howDoesTheFacProvCommAndTrainingToSupplierssubcontract,
  howDoesTheFacProvOngoingCommAndTrainingToExistingPro,
  howManyCasesOfHarassmentBasedUponAgeOccurred,
  howManyCasesOfHarassmentBasedUponDisabilityOccurred,
  howManyCasesOfHarassmentBasedUponGenderIdentityOccurre,
  howManyCasesOfHarassmentBasedUponHivaidsStatusOccurred,
  howManyCasesOfHarassmentBasedUponMaritalStatusOccurred,
  howManyCasesOfHarassmentBasedUponNationalExtractionOcc,
  howManyCasesOfHarassmentBasedUponNationalityforeignMigr,
  howManyCasesOfHarassmentBasedUponOtherOccurred,
  howManyCasesOfHarassmentBasedUponPoliticalOpinionOccur,
  howManyCasesOfHarassmentBasedUponPregnancymaternityStat,
  howManyCasesOfHarassmentBasedUponRaceEthnicGroupSkin,
  howManyCasesOfHarassmentBasedUponReligionOccurred,
  howManyCasesOfHarassmentBasedUponSexualOrientationOccu,
  howManyCasesOfHarassmentBasedUponSocialOriginOccurred,
  howManyCasesOfSexualHarassmentOccurred,
  howManyCasesOfWorkerHarassmentBySecurityPersonnelHave,
  howManyCollectiveBargainingAgreementsCbasHaveThere,
  howManyCollectiveBargainingAgreementsCbasHaveThereBeen,
  howManyEmployerMembersAreInTheBipartiteCommittee,
  howManyEmployerMembersAreInTheOshCommittee,
  howManyFemaleMembersAreInTheBipartiteCommittee,
  howManyFemaleMembersAreInTheOshCommittee,
  howManyFemalesAreUndTheApplicableLegalMinimumWorkingA,
  howManyForeignMigrantWorkerMembersAreInTheOshCommitte,
  howManyForeignMigrantWrkrsAreInTheBipartiteCommittee,
  howManyIndustrialActionsstrikesHaveOccurred,
  howManyLangsMustBeSpokenBySupvsAndMgmtInOrderToEff,
  howManyLanguagesMustBeSpokenSupervisorsManagement,
  howManyMalesAreUndTheApplicableLegalMinimumWorkingAge,
  howManyMembersAreInTheBipartiteCommittee,
  howManyMembersAreInTheOshCommittee,
  howManyNationalitiesAreRepresentedAmongWorkersSupervisors,
  howManyNationalitiesAreRepresentedAmongWrkrsAndSupvsAt,
  howManyOffSiteDormitoriesWereVisitedProvide,
  howManyOnsiteDormitoriesWereVisitedProvideTotal,
  howManySocialLaborAuditsHaveTakenPlace,
  howManyStillValidIndependentCertificationStandardAudits,
  howManyTotalDaysWereWrkrsOnStrikeForAllStrikesDuring,
  howManyTotalPersonDaysWereWrkrsOnStrikeForAllStrikes,
  howManyUnionRepresentativesAreInTheBipartiteCommittee,
  howManyUnionRepresentativesAreInTheOshCommittee,
  howManyWageGradesLevelsDoesTheFacHave,
  howManyWorkerMembersAreInTheBipartiteCommittee,
  howManyWorkerMembersAreInTheOshCommittee,
  howManyWorkersBecameDisabledWhateverReason,
  howManyWorkersUnderAge_18HaveWorked,
  howManyWrkrsBecameDisabledForAWorkrelatedReason,
  howManyWrkrsBecameDisabledForWhateverReason,
  howOftenHasTheGrievanceMechanismBeenUsedInTheAssessme,
  icsInitiativeComplianceSustainability,
  identificationDetailsFirstLastNameOrgPartiesPresent,
  idsBadgesSwipeCards,
  ietpIctiEthicalToyProgram,
  ifEquipmentContainsPcbDoesTheFacHaveAllOfTheFollowin,
  ifMoreThan_10DaysPleaseDescribe,
  ifNoDescWhenAssessorOnSiteAndWhyVerifNotTakePlace,
  ifOtherPleaseDescribe_1,
  ifOtherPleaseDescribe_10,
  ifOtherPleaseDescribe_11,
  ifOtherPleaseDescribe_12,
  ifOtherPleaseDescribe_13,
  ifOtherPleaseDescribe_14,
  ifOtherPleaseDescribe_15,
  ifOtherPleaseDescribe_16,
  ifOtherPleaseDescribe_17,
  ifOtherPleaseDescribe_18,
  ifOtherPleaseDescribe_19,
  ifOtherPleaseDescribe_2,
  ifOtherPleaseDescribe_20,
  ifOtherPleaseDescribe_3,
  ifOtherPleaseDescribe_4,
  ifOtherPleaseDescribe_5,
  ifOtherPleaseDescribe_6,
  ifOtherPleaseDescribe_7,
  ifOtherPleaseDescribe_8,
  ifOtherPleaseDescribe_9,
  ifTheFacEngagedEitherDirectlyOrViaIndustrialTradeAsso,
  ifTheFacHasNoTradeUnionAreWrkrsFreeToTheirNonunion,
  ifTheFacHasOverdueSocialInsuranceSocialSecurityDebtsD,
  ifWrkrsArePaidByDirectDepositIntoABankAccountDoThey,
  ifWrkrsArePaidThrough_3rdPartyAgentsHaveWrkrsAuthorize,
  ifYesAreHealthChecksArrangedPriorToEmployment,
  ifYesAreTheseHivAidsTestsAdministeredInLineWLegalRe_1,
  ifYesAreTheseInfectionOrIllnessTestsAdministeredInLin_1,
  ifYesAreWorkerPerformanceEvaluationsSharedAndorDiscusse,
  ifYesDoesTheFacFollowAnyOfTheFollowingPracticesRegar,
  ifYesDoRegularHoursExceed_48HoursPerWeek,
  ifYesDoWrkrsConfirmTheAccuracyOfPayoutsAndRepayments,
  ifYesPleaseDescribe_1,
  ifYesPleaseDescribe_2,
  ifYesPleaseProvide,
  iloBetterWorkInternationalLabourOrganization,
  imageList,
  inappropriateContainersAreUsedDispensingChemicals,
  incoterms,
  individualsResponsibleForImplementation_1,
  individualsResponsibleForImplementation_10,
  individualsResponsibleForImplementation_11,
  individualsResponsibleForImplementation_12,
  individualsResponsibleForImplementation_13,
  individualsResponsibleForImplementation_14,
  individualsResponsibleForImplementation_15,
  individualsResponsibleForImplementation_16,
  individualsResponsibleForImplementation_17,
  individualsResponsibleForImplementation_18,
  individualsResponsibleForImplementation_19,
  individualsResponsibleForImplementation_2,
  individualsResponsibleForImplementation_20,
  individualsResponsibleForImplementation_21,
  individualsResponsibleForImplementation_22,
  individualsResponsibleForImplementation_23,
  individualsResponsibleForImplementation_24,
  individualsResponsibleForImplementation_3,
  individualsResponsibleForImplementation_4,
  individualsResponsibleForImplementation_5,
  individualsResponsibleForImplementation_6,
  individualsResponsibleForImplementation_7,
  individualsResponsibleForImplementation_8,
  individualsResponsibleForImplementation_9,
  indonesiaDoesFacComplyLegalReqConcerningOutsourced,
  indonesiaDoesFacComplyLegalReqConcerningPremium,
  initialRefresherTrainOnResponsibilitiesMembersFireBrigade,
  inLineWLegalReqsAreAnyOfTheConfinedSpacesPermitRequ,
  insuranceCosts,
  internalCompanyCode,
  ioshBusinessAssuranceCertification,
  isAccessToHighVoltageAreasAndGeneratorAreasRestricted,
  isAJobApplicantsCurrentOrPreviousTradeUnionMembership,
  isALightningProtectorarrestorSystemInstalledOnTheBuildi,
  isAnAnnualReviewOfTheEmergencyResponsePlanConductedTo,
  isBurningOfWasteDoneOnsite,
  isDocumentationOfHealthChecksMaintainedAndUpToDate,
  isElectricalEquipmentInspectionAndMaintenanceCarriedOut,
  isFacLightingInLineWLegalReqs,
  isHotWorkPerformedInLineWLegalReqs,
  isLaserAndRadiationProducingEquipmentInLineWLegalReqs,
  iso_14001,
  iso_26000,
  iso_31000,
  iso_45001,
  iso_50001UneEnIso_5000s,
  iso_9000,
  isOvertimeVoluntaryInLineWLegalReqs,
  isRequiredHealthAndSafetyTrainingForWrkrsOfferedFreeO,
  isTheBackupEmergencyPowerSystemWorkingAndInGoodCondit,
  isTheCommuteServiceProvdByOrganizedByTheFac,
  isTheEmergencyAlarmSystemForAllTypesOfEmergenciesOthe,
  isTheFacAccessibleToFireResponseAndEmergencyResponseV,
  isTheFacConsultingWTradeUnionsInLineWLegalReqs,
  isTheFacFailingToComplyWAnyLegalReqsForContractsAnd,
  isTheFacFailingToComplyWAnyLegalReqsForDisciplineHa,
  isTheFacFailingToComplyWAnyLegalReqsForHealthSafety,
  isTheFacFailingToComplyWAnyLegalReqsForTerminationP,
  isTheFacFailingToComplyWAnyLegalReqsForWorkingHours,
  isTheFacFailingToComplyWLegalReqsForAnyOfTheFollow,
  isTheFacFailingToComplyWLegalReqsRegardingWorkerResi,
  isTheFacFailingToContributeTheLegallyRequiredAmountFo,
  isTheFacFailingToCorrectlyPayWrkrsForAnyOfTheseType,
  isTheFacFailingToCorrectlyProvWrkrsTimeOffForAnyOf,
  isTheFacFailingToImplementMeasuresRegardingHousingdormi,
  isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe,
  isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe_1,
  isTheFacFailingToPayAnyWorkerAtLeastTheLegalMinimum,
  isTheFacFailingToPayWrkrsCorrectlyForAnyOfTheseType,
  isTheFacFailingToPayWrkrsOvertimeInLineWLegalReqsI,
  isTheFacFailingToPayWrkrsPremiumPayAsLegallyRequired,
  isTheFacility_1,
  isTheFacility_2,
  isTheFacility_3,
  isTheFacsApprenticeshipTrainingInternshipProgramInLine,
  isTheFacsPracticeAroundFinancialOrOtherSupportOfTheU,
  isTheFacsPracticeAroundLimitsOnTheUseOfFixedtermCont,
  isTheFacsPracticeOfConsultingWWrkrsAndorNotifyingThem,
  isTheFacsPracticeOfProvidingSpecialHealthAndSafetyTra,
  isTheFacsPracticeOfRequiringWrkrsToTakePaidOrUnpaid,
  isTheFacsRecruitmentProcessForForeignMigrantWrkrsInLi,
  isTheFireDetectionAndAlarmSystemInLineWLegalReqs,
  isTheLightningProtectorarrestorSystemInLineWLegalReqs,
  isTheOshCommitteeFormedAndFunctioningInLineWLegalReq,
  isTheOtherGroundsIdentifiedFactoredIntoHiringDecisions,
  isThereAManualOrAutomaticEmergencyAlarmSystemForAllT,
  isThereAnElectricalPowerSubstationOnsiteAtTheFac,
  isThereAnOffsiteCanteenManagedByTheFac,
  isThereAnOnsiteCanteeneatingArea,
  isThereAWrittenOccupationalHealthAndSafetyPolicyInLin,
  isTheReceiptOfWagePaymentConfirmedInWritingByWrkrs,
  isThereOnsiteVehicleTrafficAtTheFac,
  isThereWrittenDocumentationSurroundingTheTermsAndCondit,
  isTheRiskAssessmentUpdatedIfNewMachineryProcessesChemi,
  isTheSubstationInLineWLegalReqsOrFireratedConstructio,
  isTheWorkplaceCleanAndTidy,
  isThisFacOwnedAndorManagedByAWoman,
  labeling,
  labsLifeBuildingSafety,
  laminating,
  laminationCoating,
  laserRadiationProducingEquipmentLineLegalRequirements,
  lasting_1,
  lasting_2,
  leatherTanningFinishing,
  leatherTanningWetOperations,
  leatherWorkingGroupBronze,
  leatherWorkingGroupGold,
  leatherWorkingGroupSilver,
  legalServices,
  lighting,
  listAdditionalNationalitiesApproximateWkrsSupervisorsHere,
  listAnyAdditionalNationalitiesAndTheApproximateOfWrkrs,
  listTheBusinessNmsOfTheOtherOccupantsOfTheBuilding,
  livingWageCalculation,
  livingWageLocalCurrency,
  localBrandRepresentatives,
  localLawEnforcementGovernmentAgency,
  lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon,
  lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon_1,
  lowestWageGradeLevelAverageMonthlyBasicWageFemale,
  lowestWageGradeLevelAverageMonthlyBasicWageMale,
  lowestWageGradeLevelAverageMonthlyOvertimeEarningsFemal,
  lowestWageGradeLevelAverageMonthlyOvertimeEarningsMale,
  lowestWageGradeLevelAverageMonthlyTakehomePayFemale,
  lowestWageGradeLevelAverageMonthlyTakehomePayMale,
  lowestWagePaidRegularWork,
  luggageBags,
  manufactureKnittedCrochetedFabrics,
  manufactureOfWearingApparel,
  manufacturerIdentificationCode,
  maritalStatus_1,
  maritalStatus_2,
  maritalStatus_3,
  maritalStatusFactoredIntoHiringDecisionsNotLine,
  maritalStatusReferencedNotLineLegalRequirements,
  materialCutoff,
  maternityLeave_1,
  maternityLeave_2,
  maternityNotCollectedForwarded,
  medicalCosts,
  medicalFacilitiesClinicsAreNotKeptCleanSanitary,
  medicalFacilitiesClinicsAreNotOperationDuringWorking,
  medicalNotCollectedForwarded,
  medicalServices,
  medicinesStoredMedicalFacilitiesClinicsAreNotKept,
  metalProcessing,
  metalWork,
  minimumAmountPaidHolidays,
  minimumOrderQuantity,
  minimumOrderQuantityPerStyle,
  minimumWageAgreedOnCbaLocalCurrency,
  mininumWageLocalCurrency,
  mobileMoney,
  molding_1,
  molding_2,
  molding_3,
  moldingPlastic,
  namesOfOrganizationsProvidingContractWorkers,
  namesOfOrganizationsProvidingContractWorkersNotPartOfTheProductionProcess,
  nanomaterials,
  nationalExtraction_1,
  nationalExtraction_2,
  nationalExtraction_3,
  nationalExtractionFactoredIntoHiringDecisionsNotLine,
  nationalExtractionReferencedNotLineLegalRequirements,
  nationalities,
  nationality_2,
  nationality_3,
  nationality_4,
  nationalityForeignMigrantWorkerStatus_1,
  nationalityForeignMigrantWorkerStatus_2,
  nationalityForeignMigrantWorkerStatus_3,
  nationalityForeignMigrantWorkerStatusFactoredIntoHiring,
  nationalityForeignMigrantWorkerStatusReferencedNotLine,
  newProductionWorkers_1,
  newProductionWorkers_10,
  newProductionWorkers_11,
  newProductionWorkers_12,
  newProductionWorkers_13,
  newProductionWorkers_14,
  newProductionWorkers_15,
  newProductionWorkers_16,
  newProductionWorkers_17,
  newProductionWorkers_18,
  newProductionWorkers_19,
  newProductionWorkers_2,
  newProductionWorkers_20,
  newProductionWorkers_21,
  newProductionWorkers_22,
  newProductionWorkers_23,
  newProductionWorkers_24,
  newProductionWorkers_3,
  newProductionWorkers_4,
  newProductionWorkers_5,
  newProductionWorkers_6,
  newProductionWorkers_7,
  newProductionWorkers_8,
  newProductionWorkers_9,
  newProductionWorkersExistingProductionWorkersDoNot,
  newProductionWorkersExistingSecurityGuards_1,
  newProductionWorkersExistingSecurityGuards_2,
  nmOfTheFederationOrConfederationOrBothWWhichThe_2ndL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_3rdL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_4thL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_5thL,
  nmOfTheFederationOrConfederationOrBothWWhichTheLarge,
  nmOfUnionWThe_2ndLargestMembership,
  nmOfUnionWThe_3rdLargestMembership,
  nmOfUnionWThe_4thLargestMembership,
  nmOfUnionWThe_5thLargestMembership,
  nmOfUnionWTheLargestMembership,
  nNDimethylformamideDmf,
  noAdequateGuardrailsFencingExposedOverheadWorkingSurfaces,
  noAdequateStrengthStorageRacksSupportExistingLoads,
  noAdjustableEquipmentAccommodateIndWorkerNeedsProvided,
  noAdjustableWorkstationsAccommodateIndWorkerNeedsProvided,
  noAnnualMedicalExaminationsDoneOnFoodService,
  noAppointedDoctorNurseMedicalFacilitiesClinicS,
  noAppropriateDesignStorageAreas,
  noAppropriateDistanceOtherControlsEGFire,
  noAppropriateEquipmentFightFiresIncludingCorrectPpe,
  noAppropriateProtectionLaserRadiationEquipment,
  noAppropriateProtectionsEnsureNoAccidentalEntryEach,
  noAppropriateSafeStoragePpeEquipmentClothingOn,
  noAppropriateSignsLaserRadiationEquipment,
  noAppropriateVentilationAreasWhereHotWorkConducted,
  noApprovedDesignatedAreaHotWork,
  noAssessmentAfterDrillLearnHowImproveEvacuation,
  noAssuranceThatChemicalContainersAreProperlyCapped,
  noAssuranceThatChemicalsAreBroughtIntoFacility,
  noAssuranceThatChildrenAreOnlyReleasedParents,
  noAssuranceThatCompressedGasCylindersAreOnly,
  noAssuranceThatCompressedGasCylindersHaveClosed,
  noAssuranceThatDoorsWindowsAreClosed,
  noAssuranceThatEveryWorkerEvacuates,
  noAssuranceThatOnlyAuthorizedPeopleVehiclesAre,
  noAssuranceThatOnlyAuthorizedTrainedQualifiedPeople,
  noAssuranceThatVehiclesAreDrivenAppropriateSpeed,
  noAssuranceThatVehiclesAreOnlyUsedPurposes,
  noAssuranceThatWorkersContractorsWhoEnterConfined_1,
  noAssuranceThatWorkersContractorsWhoEnterConfined_2,
  noAssuranceThatWorkersDisabilitiesSpecialNeedsAre,
  noAssuranceThatWorkersMeetAssemblyMeetingPoints,
  noAssuranceThatWorkersWorkingRadiationSourcesAre,
  noAuthorizedEntryOnlyAccessForEachConfinedSpace,
  noAutomaticCentralizedEmergencyAlarmSystem,
  noAutomaticFireExtinguishingSystemChemicalStorageAreas,
  noBackUpBatteryProvidingContinuousLightingWithin,
  noBreakdownPossibleAcrossTypesSocialInsuranceTotal_1,
  noBreakdownPossibleAcrossTypesSocialInsuranceTotal_2,
  noCertifiedFireResistantDoorsNoFireResistant,
  noClearDisplayLoadCapacityIENumber,
  noCompleteSpillKitAppropriateTypesUseChemicals,
  noConsistentUsePpeEquipmentClothingProvidedWorkers,
  noDesignatedEmergencyAssemblyAreasMeetingPointsWhich,
  noDisplayPostingMachineryEquipSafetyInstructionsWkrs,
  noEasyEntryIesExitSChemicalStorage,
  noEquipMaterialsMaternalHealthcareMedicalFacClinic,
  noFireExtinguisherProvidedFacilityWhenHotWorks,
  noFunctioningLockoutTagoutProgramMachineryEquipApplicable,
  noHandrailHandrailingsAreNotGoodCondition,
  noHandwashingSanitizingStations,
  noHazardousSubstancesWetProcessesBeingUsed,
  noHowDoesFacilityEnsureTemperatureMaintainedProvide,
  noIlluminationNoVisibilityEmergencyExitsWhenIt,
  noImpactWorkersWorkersReceiveTheirRegularPay,
  noImplBasicMedicalSurveillanceTechniquesMonitorWkrs,
  noInspectionHotWorkEquipmentPriorUse,
  noLabelingMaterialsContainingAsbestosExposureAreas,
  noLabelingSegregationCompressedGasCylinders,
  noLockingDevicesOnLaddersLaddersNotSecure,
  noMaintenanceRegularInspectionLaserRadiationEquipment,
  noMaintenanceWorkerMachineryEquipmentTrainingRecordsLeast,
  noMarkingOf,
  noMeasuresArePlacePreventFloorOpeningsHoles,
  noMeasuresArePlacePreventStandingWaterDue,
  noMeasuresPlacePreventUnauthorizedEntryChemicalStorage,
  noMeasuresPreventAccidentalTippingFallingCompressedGas,
  noMeasuresPreventWorkersFromSlippingOnFloors,
  noMonitoringContractedPersonnelFacilityEnsureTheyPerform,
  noneAboveFacCollectsForwardsLegallyRequiredContributions,
  noneAboveFacilityContributionsTotalBrokenDownAre,
  noneAboveFacilityFollowsPracticesListedAboveRegarding,
  noneAboveFacilityMeetingMeasuresListedAbovePrevent,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_1,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_10,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_11,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_12,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_13,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_14,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_15,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_16,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_17,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_18,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_19,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_2,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_20,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_21,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_22,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_23,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_24,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_25,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_26,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_27,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_28,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_29,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_3,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_4,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_5,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_6,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_7,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_8,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_9,
  noneAboveListedGroupsReceiveCommunicationTrainingOn,
  noneAboveListedReceiveCommunicationTrainingOnAnti_1,
  noneAboveListedReceiveCommunicationTrainingOnAnti_2,
  noneAboveListedReceiveCommunicationTrainingOnBribery,
  noneAboveListedReceiveCommunicationTrainingOnProhibition,
  noneAboveListedReceiveVerbalCommunicationFromFacility,
  noneAboveListedReceiveWrittenCommunicationFromFacility,
  noneOfTheAbove_1,
  noneOfTheAbove_10,
  noneOfTheAbove_11,
  noneOfTheAbove_2,
  noneOfTheAbove_3,
  noneOfTheAbove_4,
  noneOfTheAbove_5,
  noneOfTheAbove_6,
  noneOfTheAbove_7,
  noneOfTheAbove_8,
  noneOfTheAbove_9,
  nonGovernmentOrganizationsNgosWomenSGroups,
  nonWoven,
  noParkingForkliftsDesignatedLocationSWhenNot,
  noPermitHotWorkOutsideApprovedDesignatedArea,
  noPreventionOverloadingMaterialsOnForkliftTrucks,
  noPreventionPlacingLaddersFrontDoorsThatAre,
  noPreventionTyingAchieveAdditional,
  noPreventionUsingForkliftsLiftWorkersSoThat,
  noPreventionUsingLaddersHorizontalPositionAsPlatform,
  noProtectedExplosionProofLightingStorageAreas,
  noProtectionFromFallingObjectsUnderneathGradedSurfaces,
  noProvisionAdditionalPpeEGMasksGloves,
  noProvisionMedicalFacilitiesClinicSSuppliesEquipment,
  noProvisionPpeEquipmentSuchAsHearingProtection,
  noReferencesAbove,
  noRegularInspectionDamageMaintenancePortableLadders,
  noRegularInspectionElevatorsLifts,
  noRegularInspectionMaintenanceForkLifts,
  noRegularMaintenanceInspectionTestingEmergencyAlarmSystem,
  noRescueEquipmentReadyUseWhenConfinedSpace,
  noRestBreaksRotationsWorkersWhoAreExposed,
  noRiskAssessmentWhereSignificantHeatColdExposure,
  normalHoursOfOperationPerDay,
  noSafePerformanceExcavationTrenchingWorkIE,
  noSafetyDevicesOnElevatorDoorsPreventThem,
  noSafetyOrientationProvidedContractorPersonnelFacility,
  noSafeUseScaffoldingIESecuredPermanent,
  noSecuringLaddersWhenNotUse,
  noSew,
  noShieldsProtectWorkersFromRadiantHeatSources,
  noSignsEachConfinedSpaceIndicatingTheyAre,
  noStaffMonitorsLeadsArePresentListenWatch,
  noStorageFallProtectionEquipmentDesignatedLocation,
  noSufficientNumbersChildcareStaffEnsureSafetyWell,
  noSystemAccountWorkersDuringEmergencyEvacuation,
  noSystemIdentifyingFromPhysically,
  notApplicable_1,
  notApplicable_2,
  notApplicableFacilityDoesNotHaveStairsRaised,
  notApplicableNoFallProtectionNeeded,
  notApplicableSeeCountrySpecificQuestionSBelow_1,
  notApplicableSeeCountrySpecificQuestionSBelow_2,
  notes,
  notFullyFunctioningEmergencyAlarmSystem,
  noTrainingCommunicationOnDueDiligenceRequirementsSupplier,
  noTrainingCommunicationOnRawMaterialsDueDiligence,
  noTrainingOnErgonomicFactorsGoodPracticesPrevent,
  noTrainingOnFoodSafetyProperHygieneRules,
  noTrainingWorkersOnPreventingSpreadContagiousDiseases,
  notSubstantiatedRejected,
  notWorkersContractorsWhoEnterConfinedSpacesKnow,
  noUnannouncedEmergencyDrills,
  noVerificationFacThatContractorPersonnelHaveAppropriate,
  noVisualSafetyManagementFeaturesSuchAsIndicators,
  noWallsFencesOtherBarriersAlongHighWorking,
  noWarningLightsAudibleSignalsReverseTravelOn,
  noWarningsEitherThroughVerbalWrittenCommunicationAre,
  noWarningSignElevatorsEG,
  noWrittenDocumentationEmergencyDrills,
  noWrittenPoliciesProceduresPlaceButInformalProcedures,
  noWrittenProceduresPlaceReportingRespondingChemicalSpills,
  numberAgencyContractWorkers,
  numberCommutingInjuriesInclFatalitiesLast_12Months,
  numberContractWorkersWorkersEmployedThirdPartyWho,
  numberForeignMigrantSupervisors,
  numberForeignMigrantWorkers,
  numberMaleAgencyContractWorkers,
  numberMaleForeignMigrantSupervisors,
  numberMaleForeignMigrantWorkers,
  numberMaleWorkersWhoAreTraineesApprenticesInterns,
  numberOfCasualWorkers,
  numberOfContractWorkers,
  numberOfContractWorkersNotPartOfTheProductionProcess,
  numberOfDiverseCasualWorkers,
  numberOfDiverseContractWorkers,
  numberOfDiverseDomesticMigrantWorkers,
  numberOfDiverseForeignMigrantSupervisors,
  numberOfDiverseForeignMigrantWorkers,
  numberOfDiverseFullTimeWorkers,
  numberOfDiverseNightShiftWorkers,
  numberOfDiversePartTimeWorkers,
  numberOfDiversePermanentWorkers,
  numberOfDiverseSeasonalWorkers,
  numberOfDiverseSupervisors,
  numberOfDiverseTemporaryWorkers,
  numberOfDiverseTraineesApprenticesInternWorkers,
  numberOfDiverseUnionisedWorkers,
  numberOfDiverseWorkers,
  numberOfDiverseWorkersHiredDirectly,
  numberOfDiverseWorkersHiredIndirectly,
  numberOfDiverseWorkersOnParentalLeave,
  numberOfDiverseWorkersPaidByUnit,
  numberOfDiverseWorkersUnder_18,
  numberOfDiverseWorkersUnderCba,
  numberOfDiverseWorkersUnderProbation,
  numberOfDiverseWorkersWithDisability,
  numberOfDiverseWorkersWithRefugeeStatus,
  numberOfDiverseWorkersWorkingRemotelyOrBringWorkHome,
  numberOfDomesticMigrantWorkers,
  numberOfEmployees,
  numberOfFemaleCasualWorkers,
  numberOfFemaleContractWorkers,
  numberOfFemaleDomesticMigrantWorkers,
  numberOfFemaleEmployees,
  numberOfFemaleForeignMigrantSupervisors,
  numberOfFemaleForeignMigrantWorkers,
  numberOfFemaleFullTimeWorkers,
  numberOfFemaleNightShiftWorkers,
  numberOfFemalePartTimeWorkers,
  numberOfFemalePermanentWorkers,
  numberOfFemaleSeasonalWorkers,
  numberOfFemaleSupervisors,
  numberOfFemaleTemporaryWorkers,
  numberOfFemaleTraineesApprenticesInternWorkers,
  numberOfFemaleUnionisedWorkers,
  numberOfFemaleWorkers,
  numberOfFemaleWorkersHiredDirectly,
  numberOfFemaleWorkersHiredIndirectly,
  numberOfFemaleWorkersOnParentalLeave,
  numberOfFemaleWorkersPaidByUnit,
  numberOfFemaleWorkersUnder_18,
  numberOfFemaleWorkersUnderCba,
  numberOfFemaleWorkersUnderProbation,
  numberOfFemaleWorkersWithDisability,
  numberOfFemaleWorkersWithRefugeeStatus,
  numberOfFemaleWorkersWorkingRemotelyOrBringWorkHome,
  numberOfForeignMigrantSupervisors,
  numberOfForeignMigrantWorkers,
  numberOffSiteHousingSitesOccupiedWorkersManaged_1,
  numberOffSiteHousingSitesOccupiedWorkersManaged_2,
  numberOfFullTimeWorkers,
  numberOfMaleCasualWorkers,
  numberOfMaleContractWorkers,
  numberOfMaleDomesticMigrantWorkers,
  numberOfMaleEmployees,
  numberOfMaleForeignMigrantSupervisors,
  numberOfMaleForeignMigrantWorkers,
  numberOfMaleFullTimeWorkers,
  numberOfMaleNightShiftWorkers,
  numberOfMalePartTimeWorkers,
  numberOfMalePermanentWorkers,
  numberOfMaleSeasonalWorkers,
  numberOfMaleSupervisors,
  numberOfMaleTemporaryWorkers,
  numberOfMaleTraineesApprenticesInternWorkers,
  numberOfMaleUnionisedWorkers,
  numberOfMaleWorkers,
  numberOfMaleWorkersHiredDirectly,
  numberOfMaleWorkersHiredIndirectly,
  numberOfMaleWorkersOnParentalLeave,
  numberOfMaleWorkersPaidByUnit,
  numberOfMaleWorkersUnder_18,
  numberOfMaleWorkersUnderCba,
  numberOfMaleWorkersUnderProbation,
  numberOfMaleWorkersWithDisability,
  numberOfMaleWorkersWithRefugeeStatus,
  numberOfMaleWorkersWorkingRemotelyOrBringWorkHome,
  numberOfPartTimeWorkers,
  numberOfPermanentEmployees,
  numberOfPermanentWorkers,
  numberOfPregnantOrBreastfeedingWorkers,
  numberOfProductionSites,
  numberOfSupervisors,
  numberOfTemporaryWorkers,
  numberOfTraineesApprenticesInternWorkers,
  numberOfWorkers,
  numberOfWorkersOnMaternityLeave,
  numberOfWorkersPaidByUnit,
  numberOfWorkersReturnedFromMaternityLeave,
  numberOfWorkersUnder_18,
  numberOfWorkersUnderProbation,
  numberOfWorkersWithDisability,
  numberOfWorkersWithRefugeeStatus,
  numberOfWorkersWorkingRemotelyOrBringWorkHome,
  numberOnSiteDormitories,
  numberWeeklyRestDaysLeast_24ConsecutiveHours,
  numberWorkersWhoAreTraineesApprenticesInterns,
  numberWorkRelatedDangerousOccurrencesLast_12Months,
  numberWorkRelatedDiseasesLast_12Months,
  numberWorkRelatedFatalitiesLast_12Months,
  numberWorkRelatedInjuriesThatResultedLeastThree,
  numberWorkRelatedInjuriesThatResultedLessThan,
  numOfAllFloors,
  numOfCommutingInjuriesInclFatalitiesInTheLast_12Months,
  numOfContractWorkersEmployedByThirdPartyNotPartOfTheProductionProcess,
  numOfDiverseManagers,
  numOfEstablishedTradeUnionsInTheFac,
  numOfFemaleManagers,
  numOfFemaleUnionMembersInTheUnionWThe_2ndLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_3rdLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_4thLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_5thLargestMemb,
  numOfFemaleUnionMembersInTheUnionWTheLargestMembersh,
  numOfFemaleUnionOfficialsInTheUnionWThe_2ndLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_3rdLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_4thLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_5thLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWTheLargestMember,
  numOfFemaleWrkrsInFifthWageLevelDefinedByFac,
  numOfFemaleWrkrsInFourthWageLevelDefinedByFac,
  numOfFemaleWrkrsInLowestWageLevelDefinedByFac,
  numOfFemaleWrkrsInSecondWageLevelDefinedByFac,
  numOfFemaleWrkrsInSeventhWageLevelDefinedByFac,
  numOfFemaleWrkrsInSixthWageLevelDefinedByFac,
  numOfFemaleWrkrsInThirdWageLevelDefinedByFac,
  numOfFemaleWrkrsInWageLevelGrade,
  numOfFemaleWrkrsInWageLevelGrade_1,
  numOfFemaleWrkrsInWageLevelGrade_1LowestWageGradeLev,
  numOfFemaleWrkrsInWageLevelGrade_2,
  numOfFemaleWrkrsInWageLevelGrade_3,
  numOfFemaleWrkrsInWageLevelGrade_4,
  numOfFemaleWrkrsInWageLevelGrade_5,
  numOfFemaleWrkrsInWageLevelSemiskilled,
  numOfFemaleWrkrsInWageLevelSkilled,
  numOfFemaleWrkrsInWageLevelUnskilled,
  numOfFemaleWrkrsWhoWerePromotedWAnIncreaseInTheirBa,
  numOfMaleManagers,
  numOfMaleWrkrsWhoWerePromotedWAnIncreaseInTheirBasi,
  numOfManagers,
  numOfOffsiteHousingSitesOccupiedByWrkrsManagedAndCont,
  numOfOffsiteHousingSitesOccupiedByWrkrsManagedOrContr,
  numOfOnsiteDormitories,
  numOfProductionBuildingsOnsite,
  numOfRegularDailyHoursWorkedAtTheFac,
  numOfRegularWeeklyHoursWorkedAtTheFac,
  numOfShiftsAndHoursOfOperationForEachNormalOperations,
  numOfShiftsAndHoursOfOperationForEachPeakOperations,
  numOfWarehousesOnsite,
  numOfWeeklyRestDaysAtLeast_24ConsecutiveHoursLongProv,
  numOfWorkrelatedDangerousOccurrencesInTheLast_12Months,
  numOfWorkrelatedDiseasesInTheLast_12Months,
  numOfWorkrelatedFatalitiesAndInjuriesThatResultedInAt,
  numOfWorkrelatedInjuriesThatResultedInLessThanThreeDa,
  oekoTex,
  officialName,
  officialNameLocalized,
  operatingLicenseregistration,
  operatingLicenseregistrationIsAvailableAndUpToDate,
  organicContentStandardOcs,
  osHubId,
  other_1,
  other_10,
  other_11,
  other_12,
  other_13,
  other_14,
  other_15,
  other_16,
  other_2,
  other_3,
  other_4,
  other_5,
  other_6,
  other_7,
  other_8,
  other_9,
  otherActionImpactingWorkers,
  otherDescribeTypeRequiredLeaveThatNotPaid,
  otherDescribeTypeRequiredLeaveThatNotProvided,
  otherGroundSIdentifiedFactoredIntoHiringDecisions,
  otherHazardousSubstancesWetProcesses,
  otherMonetaryBonusesAllowances,
  otherMonetaryBonusesAndorAllowances,
  otherNotCollectedForwarded,
  otherTypesRequiredLeave_1,
  otherTypesRequiredLeave_2,
  overtimeVoluntaryLineLegalRequirements,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_1,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_2,
  packaging_1,
  packaging_2,
  packaging_3,
  packaging_4,
  packagingProducts,
  packing,
  pakistanDoesEmployerMaintainFairPriceShop,
  pakistanDoesFacilityPayWorkersLegallyRequiredYearly,
  pakistanDoWorkers_1,
  pakistanDoWorkers_2,
  pakistanDoWorkersReceiveCorrectPaymentWorkRelated,
  pakistanDoWorkersSurvivorsReceiveRequiredMedicalCare,
  pakistanHasEmployerAdoptedCodeConductProtectAgainst,
  pakistanHasEmployerSetUpFunctioningInquiryCommittee,
  pakistanPayWorkersCorrectlyDuringIddatLeave,
  pakistanProvideRequiredTimeOffIddat,
  paperProcessing,
  partiesToTheCbaThatCoversThe_2ndGreatestNumOfWrkrsIn,
  partiesToTheCbaThatCoversThe_3rdGreatestNumOfWrkrsIn,
  partiesToTheCbaThatCoversTheGreatestNumOfWrkrsInThe,
  paternityLeave_1,
  paternityLeave_2,
  payAndBenefits,
  payrollDiverseWorkersSampled,
  payrollFemaleWorkersSampled,
  payrollHowManyWorkersWereSampled,
  payrollMaleWorkersSampled,
  payrollRecordsAreNotConsistentAttendanceRecordsOther,
  payrollRecordsDoNotShowTypesSocialInsurance,
  payrollRecordsEachWorkerAreNotMaintainedLeast,
  payrollRecsDoNotShowAllTheTypesOfSocialInsuranceThe,
  payrollWhatPercentageSampledWorkforceWasImpacted,
  payrollWorkersSampledHowManyWorkersReceivedLess,
  pctOfWorkforceCoveredByTheCbaThatCoversThe_2ndGreates,
  pctOfWorkforceCoveredByTheCbaThatCoversThe_3rdGreates,
  pctOfWorkforceCoveredByTheCbaThatCoversTheGreatestNu,
  pctOfWrkrsThatAreTradeUnionMembers,
  peakOperationMonths,
  penaltiesMonetaryOtherwiseAreUsedEnsureThatWorkers,
  pensionProvidentFundNotCollectedForwarded,
  percentageNumberOfNormalWorkforce,
  personalCareBeautyProducts,
  personalLeave_1,
  personalLeave_2,
  phone,
  plasticRubberProcessing,
  pleaseDescribe_1,
  pleaseDescribe_2,
  pleaseDescribe_3,
  pleaseDescribe_4,
  pleaseDescribe_5,
  pleaseDescribe_6,
  pleaseDescribe_7,
  pleaseDescribeWhat_1,
  pleaseDescribeWhat_2,
  pleaseDescribeWhat_3,
  pleaseSelectTheFacility,
  politicalOpinion_1,
  politicalOpinion_2,
  politicalOpinion_3,
  politicalOpinionFactoredIntoHiringDecisionsNotLine,
  politicalOpinionReferencedNotLineLegalRequirements,
  positionNotMaintained,
  potassiumPermanganatePp,
  poweredMotorVehiclesPmvProcedures,
  powerNotTurnedOff,
  ppeEquipmentClothingProvidedNotGoodConditionNot,
  ppeNotCorrectSizeWorkers,
  ppeRelatedNNDimethylformamideDmfGoodCondition,
  ppeRelatedPotassiumPermanganatePpGoodConditionRegularly,
  ppeRelatedTetrachloroethyleneRegularlyReplaced,
  pregnancyMaternityStatus_1,
  pregnancyMaternityStatus_2,
  pregnancyMaternityStatus_3,
  pregnancyMaternityStatusFactoredIntoHiringDecisionsNot,
  pregnancyMaternityStatusReferencedNotLineLegalReq,
  preparationSpinningTextileFibers,
  pressureVesselsSafety,
  primaryLanguageSpokenAtTheFac,
  primaryLanguageSpokenByFacMgmt,
  priming,
  printing_1,
  printing_2,
  printing_3,
  productCapabilities,
  productLevels,
  productTypes,
  prohibitionOfForcedLabor,
  provApproximateOfSupvsWhoCanCommunicateInThePrimaryLa,
  provApproximateOfSupvsWhoCanCommunicateInThisLanguage,
  provApproximateOfSupvsWhoCanCommunicateInThisLanguage_1,
  provApproximateOfWrkrsWhoCanCommunicateInThePrimaryLa,
  provApproximateOfWrkrsWhoCanCommunicateInThisLanguage,
  provApproximateOfWrkrsWhoCanCommunicateInThisLanguage_1,
  provideApproximateSupervisorsLanguage_1,
  provideApproximateSupervisorsLanguage_2,
  provideApproximateSupervisorsPrimaryLanguage,
  provideApproximateWorkersWhoCanCommunicatePrimaryLanguage,
  provideApproximateWorkersWhoCanCommunicateThisLanguage_1,
  provideApproximateWorkersWhoCanCommunicateThisLanguage_2,
  provideDetailsHousingArrangementsIncludingMinimumHowMany,
  provideListHealthSafetyTrainingsOfferedExistingProduction,
  provideListHealthSafetyTrainingsOfferedNewProduction,
  provideListTrainOfferedIndividualsRespImplHealth,
  raceEthnicGroupSkinColor_1,
  raceEthnicGroupSkinColor_2,
  raceEthnicGroupSkinColor_3,
  raceEthnicGroupSkinColorFactoredIntoHiring,
  raceEthnicGroupSkinColorReferencedNotLine,
  rawMaterialsSourcing,
  rawMaterialStorageWarehousing,
  rbaResponsibleBusinessAlliance,
  rbaVap,
  receiptWagePaymentConfirmedWritingWorkers,
  recruitmentAndHiring,
  recycledClaimStandardRcs,
  referenceInternationalLawIloConventions,
  referenceOtherNationalIntlReqDeclarationsGoalsGuiding,
  referenceToNationalLaw,
  regularHoursWorkedAtNight,
  regularHoursWorkedOnPublicHolidays,
  regularHoursWorkedOnWeeklyRestDays,
  relationshipType,
  religion_1,
  religion_2,
  religion_3,
  religionFactoredIntoHiringDecisionsNotLineLegal,
  religionReferencedNotLineLegalRequirements,
  residencesAreLocatedWinAnyFacBuildings,
  residentialBuildingHasBeenConvertedIntoAFac,
  respectedCommunityMemberS,
  responsiblePerson,
  retracedId,
  retracedRiskScore,
  rjcResponsibleJewelryCouncil,
  rospaGold,
  rospaSilver,
  rotaryPrinting,
  sa8000SocialAccountabilityInternational,
  safetyCommitteeDoesNotCommunicateComplaintsProblemsShared,
  safetyCommitteeDoesNotConductSafetyInspectionsDoes,
  safetyCommitteeMeetingActionItemsAreNotTracked,
  safetyCommitteeMeetingMinutesAreNotSharedWorkforce,
  safetyCommitteeMeetingsAreNotHeldLeastOnce,
  safetyCommitteeMeetingsAreNotHeldLeastQuarterly,
  screenPrinting,
  seamTaping,
  secondMostCommonlySpokenLanguageAtTheFac,
  secondWageLevelDefinedByFacCompleteDefinitionOfThisLe,
  securityGuards_1,
  securityGuards_10,
  securityGuards_2,
  securityGuards_3,
  securityGuards_4,
  securityGuards_5,
  securityGuards_6,
  securityGuards_7,
  securityGuards_8,
  securityGuards_9,
  selectTheFacsApplicableThreeLetterCurrencyCode,
  seniorManagement_1,
  seniorManagement_10,
  seniorManagement_11,
  seniorManagement_12,
  seniorManagement_13,
  seniorManagement_14,
  seniorManagement_15,
  seniorManagement_16,
  seniorManagement_17,
  seniorManagement_18,
  seniorManagement_19,
  seniorManagement_2,
  seniorManagement_20,
  seniorManagement_21,
  seniorManagement_22,
  seniorManagement_23,
  seniorManagement_24,
  seniorManagement_3,
  seniorManagement_4,
  seniorManagement_5,
  seniorManagement_6,
  seniorManagement_7,
  seniorManagement_8,
  seniorManagement_9,
  seventhWageLevelDefinedByFacCompleteDefinitionOfThisL,
  sewing,
  sexGender_1,
  sexGender_2,
  sexGender_3,
  sexGenderFactoredIntoHiringDecisionsNotLine,
  sexGenderReferencedNotLineLegalRequirements,
  sexualOrientation_1,
  sexualOrientation_2,
  sexualOrientation_3,
  sexualOrientationFactoredIntoHiringDecisionsNotLine,
  sexualOrientationReferencedNotLineLegalRequirements,
  shipping_1,
  shipping_2,
  sickLeave_1,
  sickLeave_2,
  signedCopiesContractsBetweenFacilityEachWorkerAre,
  signedCopiesTermsConditionsDocumentsBetweenFacilityEach,
  sinceEquipmentContainsPcbDoesFacilityHaveFollowing,
  sixthWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  skillsAndQualificationTests,
  slcpFacilityId,
  smetaSedexMembersEthicalTradeAudit,
  socialOrigin_1,
  socialOrigin_2,
  socialOrigin_3,
  socialOriginFactoredIntoHiringDecisionsNotLine,
  socialOriginReferencedNotLineLegalRequirements,
  sportsOutdoorHardGoods,
  sportsOutdoorSoftGoods,
  srMgntIndividualsResponsibleImplementationDoNotReceive_2,
  srMngtIndividualsResponsibleImplementationDoNotReceive_1,
  srMngtIndividualsResponsibleImplementationExistingProd,
  srMngtIndividualsResponsibleImplNewProdWorkers_1,
  srMngtIndividualsResponsibleImplNewProdWorkers_10,
  srMngtIndividualsResponsibleImplNewProdWorkers_11,
  srMngtIndividualsResponsibleImplNewProdWorkers_12,
  srMngtIndividualsResponsibleImplNewProdWorkers_13,
  srMngtIndividualsResponsibleImplNewProdWorkers_14,
  srMngtIndividualsResponsibleImplNewProdWorkers_2,
  srMngtIndividualsResponsibleImplNewProdWorkers_3,
  srMngtIndividualsResponsibleImplNewProdWorkers_4,
  srMngtIndividualsResponsibleImplNewProdWorkers_5,
  srMngtIndividualsResponsibleImplNewProdWorkers_6,
  srMngtIndividualsResponsibleImplNewProdWorkers_7,
  srMngtIndividualsResponsibleImplNewProdWorkers_8,
  srMngtIndividualsResponsibleImplNewProdWorkers_9,
  standardizationChemicalFinishing,
  standardLeadTime,
  startFinishTimesAreNotRecordedPeriodsWork,
  startFinishTimesPayrollSystemDoNotMatch,
  stationaryCompressedGasCylindersAreNotConnectedFixed,
  stockFitting,
  storageRacksShelvingNotSecuredPermanentStructures,
  sublimation,
  substantiatedStillWorkingOnRemedialAction,
  substantiatedWithoutRemedy,
  substantiatedWithRemedy,
  sundriesApplication,
  suppliersSubcontractors_1,
  suppliersSubcontractors_10,
  suppliersSubcontractors_11,
  suppliersSubcontractors_12,
  suppliersSubcontractors_13,
  suppliersSubcontractors_14,
  suppliersSubcontractors_15,
  suppliersSubcontractors_16,
  suppliersSubcontractors_17,
  suppliersSubcontractors_18,
  suppliersSubcontractors_19,
  suppliersSubcontractors_2,
  suppliersSubcontractors_20,
  suppliersSubcontractors_3,
  suppliersSubcontractors_4,
  suppliersSubcontractors_5,
  suppliersSubcontractors_6,
  suppliersSubcontractors_7,
  suppliersSubcontractors_8,
  suppliersSubcontractors_9,
  supplierSubcontractorReceivesTrainCommOnDueDiligence,
  supplierSubcontractorReceivesTrainCommOnRawMaterials,
  supplyChainTier,
  tanningDressingLeatherDressingDyeingFur,
  terminationAndRetrenchment,
  termsConditionsDocumentsAreNotUpDate,
  termsConditionsDocumentsUnclearlyInaccuratelyState,
  tetrachloroethylenePerc,
  textileExchangeId,
  theBasisOfTheHarassmentSelectAllThatApply,
  theFacDoesNotCreateImprovementPlans,
  theFacDoesNotSetTargetsKeyPerformanceIndicators,
  theFacPaidAnAnnualBonus,
  theFacPaidAnAttendanceBonus,
  theFacPaidAProductivityBonus,
  theFacPaidHousingTransportationAndorMealAllowances,
  theFacPaidSeniorityAndorGratuityBonus,
  thereAreNoOptionsSeniorManagementReviewDirect,
  thereLightningProtectorArrestorSystemLineLegalReq,
  thereWrittenDocsSurroundingTermsCondGrantingRepayment,
  thirdMostCommonlySpokenLanguageAtTheFac,
  thirdWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  totalFacAreaM2OnlyBuiltPremises,
  totalNumberOfWorkers,
  totalNumOfBuildingsOnsite,
  totalNumOfUnionMembersInTheUnionWThe_2ndLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_3rdLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_4thLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_5thLargestMembe,
  totalNumOfUnionMembersInTheUnionWTheLargestMembershi,
  totalNumOfUnionOfficialsInTheUnionWThe_2ndLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_3rdLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_4thLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_5thLargestMem,
  totalNumOfUnionOfficialsInTheUnionWTheLargestMembers,
  totalNumOfWrkrsInFifthWageLevelDefinedByFac,
  totalNumOfWrkrsInFourthWageLevelDefinedByFac,
  totalNumOfWrkrsInLowestWageLevelDefinedByFac,
  totalNumOfWrkrsInSecondWageLevelDefinedByFac,
  totalNumOfWrkrsInSeventhWageLevelDefinedByFac,
  totalNumOfWrkrsInSixthWageLevelDefinedByFac,
  totalNumOfWrkrsInThirdWageLevelDefinedByFac,
  totalNumOfWrkrsInWageLevelGrade,
  totalNumOfWrkrsInWageLevelGrade_1,
  totalNumOfWrkrsInWageLevelGrade_1LowestWageGradeLeve,
  totalNumOfWrkrsInWageLevelGrade_2,
  totalNumOfWrkrsInWageLevelGrade_3,
  totalNumOfWrkrsInWageLevelGrade_4,
  totalNumOfWrkrsInWageLevelGrade_5,
  totalNumOfWrkrsInWageLevelSemiskilled,
  totalNumOfWrkrsInWageLevelSkilled,
  totalNumOfWrkrsInWageLevelUnskilled,
  totalWorkerInterviews,
  toys,
  trafficLanesWalkPathsAreNotClearlyMarked,
  trainingAndOrientation,
  trainingRecordsOnChemicalUseHandlingDisposalSpill,
  transliteratedDisplayName,
  transliteratedOfficialName,
  transportation,
  travelAndLodging,
  trims,
  typeOfProcessesCarriedOutAtHome,
  under_12Over_18EnterAgeYoungestWorker,
  unemploymentNotCollectedForwarded,
  uniforms,
  unionRepresentatives,
  unsafeTransportationCompressedGasCylinders,
  upperManagementDoesNotRecognizeAcceptSafetyCommittee,
  upperProductionIncludingStitching,
  uscc,
  vatId,
  vehiclesMaintenanceLogsNotKept,
  vehiclesNotGoodWorkingCondition,
  vendors,
  verificationAssessmentWindow,
  verifierBodyNameCountryProgramme,
  verifierBodyType,
  verifierNamesAssessorIds,
  verifierSApscaIdS,
  videoFile,
  vietnamDoesFacAllowancesAdditional,
  vietnamDoesFacComplyLegalReqConcerningBreaks,
  vietnamDoesFacComplyLegalReqConcerningDispatched,
  vietnamDoesFacInspectMeasureEnvironmentalCondWorkplace,
  vietnamDoesFacRegularlyInspectMaintainMachinesEquip,
  vietnamDoesTheFacCollectAndForwardWrkrsContributionsAs,
  vietnamFacContributionForSocialHealthAndUnemploymentIns,
  vietnamHasTheCollectiveAgreementInForceBeenApprovedBy,
  vietnamPay_30MinutesTimeOffPerDay,
  vietnamProvide_30MinutesTimeOffPerDay,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl_1,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa_1,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv_1,
  wagesAndBenefits,
  wagesNotMaintained,
  warehousingDistribution,
  washing,
  wasteSources,
  wasteTreatmentManagement,
  wasteWaterTreatmentProficiency,
  wasTheGrievanceMechanismDevelopedThroughSocialDialogueB,
  waterManagementSystem,
  waterSources,
  weavingOfTextiles,
  webshopCompanyDescription,
  webshopCompanyDisplayName,
  webshopCompanyImageList,
  webshopCompanyVideoFile,
  website,
  welding,
  wereAllOtherWagePaymentsInLineWLegalReqs,
  wereAnyWrkrsUndTheLegalMinimumWorkingAgeWhenHired,
  wereAtLeastTwothirdsOfTheMeetingsAttendedBy_100OfMemb,
  wereExceptionRequestsGrantedVerificationOversightOrgThis,
  wereInterpretersPresentDuringVerificationAssessment,
  wereOtherWagePaymentsLineLegalRequirements,
  wereRecsOfAllWorkrelatedInjuriesFatalitiesAccidentsAnd,
  wereTerminationsOfTradeUnionOfficialsIfAnyInLineWApp,
  wereWholdingsFromWagesOtherThanSocialSecurityCalculated,
  wereWithholdingsFromWagesOtherThanSocialSecurity,
  wereWorkers,
  wetPrinting,
  whatAgeYoungestWorkerFacility,
  whatAnnualWorkerTurnoverPercent,
  whatApproximatePctOfWrkrsArePaidByTheseOtherMeans,
  whatAreIndividualWorkersBasicWagesBasedUponSelectAllT,
  whatAverageTimeDaysItTakesReachOutcome,
  whatHealthAndSafetyMeasuresDoesTheFacHaveToPreventTh,
  whatIsTheAgeOfTheYoungestWorkerInTheFac,
  whatIsTheConstructionDateOfTheOldestBuildingTheFacOc,
  whatIsTheFacsDefinitionOfLeadTime,
  whatIsTheFacsFormOfProductionOperationsPlanning,
  whatIsTheFacsMaximumLeadTimeWeeksAsUnitOfMeasurement,
  whatIsTheMaximumLengthOfTimeInDaysThatTheFacConside,
  whatIsTheReasonForTheNewConstruction,
  whatPercentageNormalWorkforceDoesTotalNumberWorkers,
  whatPercentageWorkersArePaidCardStoredValue,
  whatPercentageWorkersArePaidCash,
  whatPercentageWorkersArePaidCheck,
  whatPercentageWorkersArePaidDirectDepositInto,
  whatPercentageWorkersArePaidMobileMoney,
  whatTotalNumberInterviewsConductedContractWorkersWorkers,
  whenADisciplinaryActionIsInitiatedAgainstAWorkerIsTha,
  whenMakingChangesContractsDoesFacilitySeekWritten,
  whenPreparingFoodNoMeasuresPreventDecreasePotential,
  whenProductionvolumeIsLowerThanExpectedHowAreWrkrsImpa,
  whenWasTheLastRiskAssessmentConducted,
  whichFloorsDoesFacOccupyInAMultifloorSharedBuilding,
  whichHazardousSubstancesAreWrkrsExposed,
  whichLegalOvertimeLimitsAreNotBeingCompliedWSelectAll,
  whichOfTheFollowingApprenticeshipTraineeInternshipProgra,
  whichOfTheFollowingElementsAreReferencedInWrittenJobD,
  whichOfTheFollowingFacSocialInsuranceContributionsBoth,
  whichOfTheFollowingHasTheFacFailedToImplementSelectA,
  whichOfTheFollowingIsAFactorInDecisionsOnCompensation,
  whichOfTheFollowingIsAFactorInDecisionsOnConditionsO,
  whichOfTheFollowingIsAFactorInDecisionsOnHiringSelec,
  whichOfTheFollowingIsAFactorInDecisionsOnPromotionOr,
  whichOfTheFollowingIsAFactorInDecisionsOnTermination,
  whichOfTheFollowingLegallyRequiredCompensationBenefitsI,
  whichOfTheFollowingRecruitmentFeesOrRelatedCostsDoesT,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_1,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_10,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_11,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_12,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_13,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_14,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_2,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_3,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_4,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_5,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_6,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_7,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_8,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_9,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_1,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_2,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_3,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_4,
  whichOfTheFollowingTopicsArePartOfTheOngoingCommAnd,
  whichOfTheFollowingTopicsHaveBeenAssignedToAResponsib,
  whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPay,
  whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPro,
  whichOfTheFollowingTypesOfOvertimeHoursIsTheFacFaili,
  whichOfTheFollowingTypesOfRegularHoursWorkedAtAPremi,
  whichOfTheFollowingWorkIsPerformedByWrkrsUndAge_18Se,
  whichOfTheItemsBelowApplySelectAllThatApply,
  whichTypesOfInkindBenefitsDoesTheFacProvSelectAllTha,
  whoIsResponsibleForPayingRecruitmentFeesAndRelatedCost,
  whoPerformsTheClockinclockoutFunctionForWrkrsSelectAll,
  whoReceivesCommAndTrainingSelectAllThatApply,
  whoResponsiblePayingRecruitmentFeesRelatedCostsWorker,
  withdrawalOfComplaint,
  women,
  woodProcessing,
  worker_1,
  worker_2,
  workerFeedback,
  workerRepresentatives,
  workersAreNotRotatedBetweenTasksReduceExposure,
  workersAreNotUsingFallProtectionWhenNeeded,
  workersArePaidDirectDepositIntoBankAccount,
  workersArePaidThrough_3rdPartyAgentsHave,
  workersCannotRespondAppealSettlement,
  workersCannotTakeShortErgonomicBreaksDuringWork,
  workersDoNotGiveWrittenConsentMoniesBe,
  workersDoNotHaveAccessAccountStatusWage,
  workersDoNotHaveUnrestrictedAccessVerifyAccuracy,
  workersDoNotKnowTheirPrimaryEvacuationRoute,
  workersDoNotWearFallProtectionTimesWhen,
  workersMustStayHomeAreNotPaid,
  workersMustStayHomeArePaidLegalMinimum,
  workersMustStayHomeArePaidLessThan,
  workersMustStayHomeAreRequiredUseVacation,
  workersNotTrainedOnProperUseFallProtection,
  workersThatWorkLaserRadiationProducingEquipmentDo,
  workersTrainingLogsOnProperUseFallProtection,
  workersWhoUseLaddersAreNotTrainedPlace,
  workingHourRecordsAreNotConsistentPayrollOther,
  workingHourRecordsEachWorker,
  workingHourRecordsEachWorkerAreNotMaintained,
  workingHours,
  workingHoursRecordsEachWeekWhen_60Hours,
  workingHoursRecordsHowManyWeeksWereSampled,
  workingHoursRecordsWeeksSampledHowManyWeeks,
  workload,
  workosOrganizationId,
  workRelatedInjuryIllnessDeathNotCollectedForwarded,
  wrapWorldwideResponsibleAccreditedProduction,
  writtenJobDescriptionJobApplicationFormsReferenceOther,
  writtenPoliciesProcedures,
  yesAreTermsConditionsSame,
  yesDescribeCircumstances,
  yesDescribeHowBurningWasteControlled,
  yesDescribeHowWorkers,
  yesDescribeTermsLoansAdvancesIEInterest,
  yesDescribeTypeDeductionsWagesMadeBesidesLegally,
  yesDescribeWhatTypeConcernsWereMadeRegarding,
  yesDescribeWhatTypeHotWorkPerformedFacility,
  yesDescribeWhatTypeLaserRadiationEquipmentUsed,
  yesDoesFacilityRecruitingAgencyEverRequestThat,
  yesDoWorkersConfirmAccuracyPayoutsRePayments,
  yesHowManyCasesWasVictimFemaleWorker_1,
  yesHowManyCasesWasVictimFemaleWorker_2,
  yesHowManyCasesWasVictimFemaleWorker_3,
  yesHowManyCasesWasVictimMaleWorker_1,
  yesHowManyCasesWasVictimMaleWorker_2,
  yesHowManyCasesWasVictimMaleWorker_3,
  yesHowManyComplaintsGrievancesWereReceivedFemale,
  yesHowManyComplaintsGrievancesWereReceivedMale,
  yesHowManySubcontractors,
  yesHowManySuggestionsFeedbackReceivedFacilityAddressed_1,
  yesHowManySuggestionsFeedbackReceivedFacilityAddressed_2,
  yesHowManyWorkersAreCoveredThisOther,
  yesWhatIndoorTemperatureCelsiusFacContinuouslyMaintains,
  zdhcId,
  zipCode,
}

export default {
  aboveGroundStorageTanksUndergroundStorageTanks,
  abvtex,
  accessories,
  additionnalPhotosNonRelatedToQuestions,
  addressLine_1,
  addressLine_2,
  administrativeCosts,
  age_1,
  age_2,
  age_3,
  ageFactoredIntoHiringDecisionsNotLineLegal,
  agencyContractWorker,
  agents,
  ageReferencedNotLineLegalRequirements,
  allowSharingAddress,
  allowSharingProof,
  allPublicHolidays_1,
  allPublicHolidays_2,
  amforiClientId,
  amforiClientSecret,
  amforiCredentialsRevokedAt,
  amforiCredentialsVerifiedAt,
  amforiLastSyncedAt,
  amforiMemberId,
  amforiSiteIds,
  annualLeave_1,
  annualLeave_2,
  annualProductionCapacity,
  annualPurchaseVolume,
  annualRevenue,
  antiDiscrimination,
  antiHarassmentAndAbuse,
  apparel,
  approximateNumberOfSupervisors_1,
  approximateNumberOfSupervisors_2,
  approximateNumberOfSupervisors_3,
  approximateNumberOfSupervisors_4,
  approximateNumberOfWorkers_1,
  approximateNumberOfWorkers_2,
  approximateNumberOfWorkers_3,
  approximateNumberOfWorkers_4,
  areAffordableMenstrualProductsAvailableInTheWorkplace,
  areAllEmergencyExitsAccessibleUnobstructedAndUnlockedDu,
  areAllEmergencyExitsClearlyMarked,
  areAllInkindBenefitsVoluntary,
  areAllLoansAndorAdvancesInLineWLegalReqs,
  areAllNewWrkrsProvdWACopyOfTheFacsWorkplaceRulesAv,
  areAllOvertimeWorkingHoursInLineWLegalLimits,
  areAllWrkrsOfferedAnyOfTheFollowingProgramsByTheFac,
  areAllWrkrsOfferedAnyOfTheFollowingTypesOfDevelopment,
  areAllWrkrsOfferedAnyOfTheFollowingTypesOfMarketAcce,
  areAnyMaterialsThatAreNotRelevantToTheMaintenanceOfT,
  areAnyMonetaryDepositsRequiredOfWrkrs,
  areArrangementsInCaseOfMedicalEmergencyIncludingOnsite,
  areBipartiteCommitteeMembersReleasedFromWorkDutiesToPr,
  areBipartiteCommitteesEstablishedAndFunctioningInLineW,
  areBipartiteCommitteeSEstablishedFunctioningLineLegal,
  areBipartiteCommitteeSPlaceAlthoughThereAre,
  areBuildingconstructionStructuralSafetyAndFirePermitsAnd,
  areBuildingconstructionStructuralSafetyAndFirePermitsAnd_1,
  areChemicalsAndHazardousSubstancesLabeledInLineWLegal,
  areChemicalsAndHazardousSubstancesStoredInLineWLegalR,
  areChildrenBelowTheLegalMinimumAgeForEmploymentAllowed,
  areContractsForAllPersonsWhoPerformWorkForTheFacBoth,
  areDisciplinaryMeasuresForWrkrsInLineWLegalReqs,
  areElectricalOutletsUsedForPluggingInCordedEquipmentIn,
  areElectricalWiresCablesSwitchesPlugsPanelsDistribution,
  areElevatorsLiftsInLineWLegalReqs,
  areElevatorsLiftsLineLegalRequirements,
  areEmergencyEvacuationProceduresInLineWLegalReqs,
  areEmergencyExitsInLineWOtherLegalReqs,
  areErgonomicMeasuresInLineWLegalReqs,
  areErgonomicMeasuresLineLegalRequirements,
  areExemptionTermsAccurateCurrentValidAndFollowedByThe,
  areFacDoorsExitsAndStairsInLineWLegalReqs,
  areFacilityDoorsExitsStairsLineLegalRequirements,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_1,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_10,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_11,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_12,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_2,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_3,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_4,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_5,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_6,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_7,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_8,
  areFacPracticesFailingToComplyWAnyLegalReqsNotCovere_9,
  areFacTemperatureAndVentilationInLineWApplicableLegal,
  areFlammablecombustibleMaterialsSafelyStored,
  areFuelStorageTanksDesignedAndHandledInLineWLegalReq,
  areFuelStorageTanksDesignedHandledLineLegal,
  areGrievanceHandlingAndDisputeResolutionProceduresAccess,
  areGrievancesAndDisputesResolvedInLineWLegalReqs,
  areGrievancesDisputesResolvedLineLegalRequirements,
  areKindBenefitsVoluntary,
  areLaborRecruitersEmploymentAgenciesEverResponsibleForT,
  areLegallyRequiredGuardsProperlyInstalledAndMaintainedO,
  areLegallyRequiredGuardsProperlyInstalledMaintainedOn,
  areLegallyRequiredMechanismsForDialogueBetweenTheEmploy,
  areLegallyRequiredSafetyWarningsPostedInTheWorkplace,
  areLegallyRequiredWrkrsRepresentativesIfAnyElectedAndF,
  areLoansAdvancesLineLegalRequirements,
  areMachineryAndLightingConnectedToTheAppropriateTypeOf,
  areManagersAndSupvsHeldAccountableForEnsuringThatThere,
  areMechanismsToCooperationBetweenWrkrsAndMgmtOnOccupat,
  areMonetaryDepositsOutLineLegalRequirements,
  areMonetaryDepositsOutOfLineWLegalReqs,
  areMonetaryDepositsRequiredWorkers,
  areOffSiteCanteensEatingAreasManagedFacility,
  areOnsiteCanteensEatingAreasLineLegalRequirements,
  areOnsiteChildcareFacilitiesInLineWLegalReqs,
  areOnSiteChildcareFacilitiesLineLegalRequirements,
  areOvertimeHoursPaidAtAPremiumRateOfAtLeast_125Times,
  arePaySlipsInALanguageAllWrkrsCanUndstand,
  arePaySlipsLanguageWorkersCanUnderstand,
  arePersonnelFilesMaintainedInLineWLegalReqs,
  arePersonnelFilesMaintainedLineLegalRequirements,
  arePoliciesProceduresEndorsedSeniorManagement,
  arePossibleSourcesOfIgnitionSufficientlySafeguarded,
  arePregnantAndNursingWrkrsProtectedAgainstSafetyAndHea,
  areProbationaryTimePeriodsInLineWLegalReqs,
  areProbationaryTimePeriodsLineLegalRequirements,
  areProtRestrForWrkrsUndTheAgeOf_18InLineWLegalReqs,
  areProvisionsWinTheCollectiveBargainingAgreementsCbaAt,
  areRecruitmentFeesAndRelatedCostsPaidByWrkrsInLineW,
  areRecruitmentFeesRelatedCostsPaidWorkersLine,
  areRestroomsRegularlyStockedWNecessarySupplies,
  areSafetyDataSheetsSdsFormerlyMsdsAvailableForAllChem,
  areSeparateToiletsProvdForMalesAndFemales,
  areSpecializedHealthChecksConductedForWrkrsPerformingHi,
  areTemperatureAndVentilationSystemsMaintainedInLineWLe,
  areTheBeltAreasOfCompressorsAndGeneratorsFullyEnclosed,
  areTheFacility_1,
  areTheFacility_2,
  areTheFacility_3,
  areTheFacsEmploymentContractsForForeignMigrantsInLine,
  areTheFacsPracticesAroundMakingAccommodationsForPhysica,
  areTheFacsSanitationPracticesInLineWLegalReqs,
  areTheFacsWasteDisposalPracticesInLineWLegalReqs,
  areThereAnyBipartiteCommitteesInPlaceAtTheFac,
  areThereAnyRestrToWrkrsApplyingForOrTakingLeave,
  areTheReasonsForOvertimeInLineWLegalReqs,
  areThereCasesWhereTrashDebrisOrEmptyContainersHaveAcc,
  areThereOnsiteChildcareFacilities,
  areThereRestrictionsWorkersApplyingTakingLeave,
  areThereSufficientEmergencyExitsFromAllWorkStationsAnd,
  areThereWrittenRecsOfTheseCases,
  areThereWrittenRecsOfTheseCases_1,
  areThereWrittenRecsOfTheseCases_10,
  areThereWrittenRecsOfTheseCases_11,
  areThereWrittenRecsOfTheseCases_12,
  areThereWrittenRecsOfTheseCases_13,
  areThereWrittenRecsOfTheseCases_14,
  areThereWrittenRecsOfTheseCases_15,
  areThereWrittenRecsOfTheseCases_2,
  areThereWrittenRecsOfTheseCases_3,
  areThereWrittenRecsOfTheseCases_4,
  areThereWrittenRecsOfTheseCases_5,
  areThereWrittenRecsOfTheseCases_6,
  areThereWrittenRecsOfTheseCases_7,
  areThereWrittenRecsOfTheseCases_8,
  areThereWrittenRecsOfTheseCases_9,
  areTheseStepsToHelpWrkrsWHivAidsInLineWLegalReqs,
  areTheseStepsToHelpWrkrsWInfectionsOrIllnessesOtherT,
  areTheWeeklyRestDaysProvdByTheFacInLineWLegalReqs,
  areToiletsCleanAndSanitizedOnARegularBasis,
  areToiletsInLineWLegalReqs,
  areToiletsLineLegalRequirements,
  areTradeUnionOfficersFromTheFederationexternalTradeUnio,
  areWagePaymentsMadeRegularlyAndOnTimeAndInLineWLega,
  areWagePaymentsMadeRegularlyOnTimeLine,
  areWarehousesWinOrSeparateFromProductionBuildings,
  areWasteDisposaldischargePermitsAvailableAndUpToDate,
  areWeeklyRestDaysProvidedFacilityLineLegal,
  areWkrsInformedTermsCondSurroundingGrantingRepayment,
  areWkrsWhoHandleTetrachloroethylenePercProvidedRequired,
  areWorkerExposuresNoiseLineLegalRequirements,
  areWorkerExposuresToAirborneParticulatesEgDustFibersFu,
  areWorkerExposuresToNoiseInLineWLegalReqs,
  areWorkers,
  areWorkersAllowedAccessDrinkingWaterTime,
  areWorkersAllowedAccessToiletsRestroomsTime,
  areWorkersBasicWagesEverReviewedAndAdjustedForTheEnti,
  areWorkersInformedAboutTheirIndividualWagesDeductions,
  areWorkersInformedExistenceKindBenefits,
  areWorkersPaidDirectlyFacilityThrough_3rdParty,
  areWorkersPaidDuringBreastfeedingBreaksLineLegal,
  areWorkersPaidTheirFullWagesLegallyRequired,
  areWorkersReimbursedRecruitmentFeesRelatedCostsPaid,
  areWorkersWhoHandleNNDimethylformamideDmf,
  areWorkersWhoHandlePotassiumPermanganatePpProvided,
  areWorkplaceRulesMadeVisibleInFacCommonAreasEgCanteen,
  areWorkTargetsForProductionEgQuotaOrPieceWorkInLine,
  areWorkTargetsProductionEGQuotaPiece,
  areWrittenJobDescOrJobApplicationFormsThatReferenceOt,
  areWrittenRecsOfComplaintsAndGrievancesAndTheMgmtsRes,
  areWrittenRecsOfDisciplinaryActionsMaintainedInWrkrsPe,
  areWrittenRecsOfSuggestionsAndFeedbackMaintainedForAt,
  areWrkrsAbleToRefuseOvertimeForAnyReason,
  areWrkrsAllowedAccessToDrinkingWaterAtAnyTime,
  areWrkrsAllowedAccessToToiletsrestroomsAtAnyTime,
  areWrkrsAndWrkrsRepresentativesFreeToMeetWoutThePrese,
  areWrkrsAwareOfTheCommitteesRoleAndAdvantages,
  areWrkrsAwareOfTheProcessesInPlaceForGrievanceHandlin,
  areWrkrsEverResponsibleForTheCostOfAnyOfTheFollowing,
  areWrkrsExposedToHazardousSubstancesInTheProductionPro,
  areWrkrsForcedToWorkOvertimeUndThreatOfPenalty,
  areWrkrsFreeToComeAndGoFromTheDormitoriesAndTheIndu,
  areWrkrsFreeToFormATradeUnionOfTheirChoosing,
  areWrkrsFreeToJoinATradeUnionOfTheirChoosing,
  areWrkrsFreeToTakeLeaveOnceGivenApproval,
  areWrkrsFreeToTerminateTheirEmploymentAfterTheirNotice,
  areWrkrsInformedAboutTheirIndividualWagesAndDeductions,
  areWrkrsInformedOfTheExistenceOfInkindBenefits,
  areWrkrsPaidDirectlyByTheFacOrThrough_3rdPartyAgents,
  areWrkrsPaidDuringBreastfeedingBreaksInLineWLegalReqs,
  areWrkrsPaidForAllWorkrelatedActivitiesOutsideOfRegula,
  areWrkrsPaidTheirFullWagesInTheLegallyRequiredManner,
  areWrkrsProvdWAPrivateMeetingSpaceAtTheWorkplaceInL,
  areWrkrsReimbursedForRecruitmentFeesAndRelatedCostsPai,
  areWrkrsRestrictedFromLeavingTheWorkplaceInOrderToFor,
  areWrkrsSubjectToNegativeConsequencesIfTheyRemoveThems,
  areWrkrsTrainedAndRequiredToUsePersonalProtEquipmentI,
  areWrkrsTrainedOnChemicalHazardsAndSafeWorkPracticesP,
  assembly,
  assemblyEGCorrugatedBoard,
  audit_24412dqa111,
  audit_4pppwlgmbnl,
  audit_6atu4r8e1aq,
  auditAmforiBepi,
  auditAwsAllianceForWaterStewardship,
  auditBetterWork,
  auditBluesign,
  auditBsci,
  auditC28ljiab8qc,
  auditControlUnionFairChoiceAudit,
  auditEti,
  auditEwsEuropeanWaterStewardship,
  auditFactoryVisit,
  auditFairWearFoundation,
  auditFla,
  auditGots,
  auditGreenButtonAudit,
  auditGub825fyuyf,
  auditHiggFemHiggFacilityEnvironmentalModule,
  auditHiggFslmHiggFacilitySocialLaborModule,
  auditIcs,
  auditIctiEthicalToyProgram,
  auditImpactProgram,
  auditIso_26000,
  auditKeh8dtw175b,
  auditOcsAudit,
  auditOekoTex,
  auditOhsas_18001,
  auditQz1m274j4ym,
  auditSa8000,
  auditSedexSmeta,
  auditSfpSustainableFibreProgramme,
  auditSlcpConvergedAssessmentFramework,
  auditSustainableTextileSolutions,
  auditWfkr7fwt9tw,
  auditWrap,
  bangladeshAreTheWorkers,
  bangladeshDoAllWrkrsOtherThanApprenticesSubstitutebadli,
  bangladeshDoesFacComplyLegalReqEnsureAgainst,
  bangladeshDoesFacilityHaveLegallyRequiredLicenseStorage,
  bangladeshDoesFacilityHaveLegallyRequiredQualifiedWelfare,
  bangladeshDoesTheFacHaveLegallyRequiredQualifiedWelfare,
  bangladeshDoesTheFacHaveTheLegallyRequiredLicenseForS,
  bangladeshHasFacilityEstablishedWorkers,
  batteryChargingAreasElectricForkliftTrucksAreClose,
  benefitsNotMaintained,
  betterCottonInitiativeBci,
  bipartiteCommCommunicatesWkrsUpper,
  bipartiteCommitteeMeetingActionItemsAreTracked,
  bipartiteCommitteeMeetingMinutesAreSharedWorkforce,
  bipartiteCommitteeMeetingsAreHeldLeastQuarterly,
  bipartiteCommitteeMeetingsAreHeldOnMonthlyBasis,
  blendingFormulating,
  briberyAndAntiCorruption,
  bsciBusinessSocialComplianceInitiative,
  buildingIsSharedWOtherFacilitiesenterprises,
  cambodiaAttendanceBonusCasualWorkers,
  cambodiaAttendanceBonusDuringLeave,
  cambodiaAttendanceBonusNewWorkers,
  cambodiaDoesFacIncludeEntirePeriodContinuousEmployment,
  cambodiaIsThePieceRateSetAtALevelThatPermitsWrkrsOf,
  cambodiaSeniorityIndemnityUdcWkrs,
  cambodiaTransportHomePlaceSleepWorkersWhoFinish,
  cambodiaWageSupplementsHousingAllowances,
  cambodiaWhichOfTheFollowingOtherWagePaymentsWereNotIn,
  canApprenticesTraineesInternsAPositionInTheFacThatIs,
  canChangeCoreInformation,
  canReadProductStory,
  canteenEatingAreasAreNotProtectedFromElements,
  canteenEatingAreasAreNotSeparateFromProduction,
  canteens,
  canTheTradeUnionsFreelyFormAndJoinFederationsAndConfe,
  canWrkrsWhoOweDebtsToTheFacAndorAThirdPartyFreelyL,
  capacityChildcareFacilityNotSufficientCoverNeedWorkers,
  carbonIntensityScope,
  cardStoredValue,
  cash,
  casting_1,
  casting_2,
  chainCustodyStandardCcs,
  check,
  chemical,
  chemicalsDisposedWasteBinContainersWhichAreGenerally,
  chemicalsHazardousSubstances,
  chemicalStorageAreasDoNotHaveChemicalSpill,
  chemicalSynthesis,
  childcare,
  childCare,
  childcareFacilitiesAreNotKeptCleanSafeHygienic,
  childcareFacilitiesAreNotOnGroundFloor,
  childcareFacNotProvidedAdequateSuppliesInfrastructure,
  childcareStaffDoNotGoThroughAppropriatePre,
  childLaborYoungWorkers,
  city,
  coating,
  collaborationEndDate,
  collaborationStartDate,
  collaborationStatus,
  commercialRegistrationNumber,
  commuteServiceProvidedOrganizedFacility,
  companyLeverage,
  companySize,
  complaintsGrievancesAreNotSettledDirectlyBetweenWorker,
  complaintsGrievancesNotAdditionalStakeholders,
  compressedGasCylindersAreNotStoredAwayFrom,
  compressedGasCylindersAreNotStoredEnclosedCage,
  connectionType,
  contactPersonEmail,
  contractsDoNotClearlyAccuratelyStateTermsConditions,
  contractWorkersWorkersEmployedThirdPartyWhoAre,
  convertingRawMaterialIncomingPaperboardPlasticResin,
  copiesContractsAreNotProvidedWorkersLineApplicable,
  copiesTermsConditionsDocumentsAreNotProvidedWorkers,
  country,
  countryName,
  county,
  cutting_1,
  cutting_2,
  deductionsAreNotVoluntarilyAcceptedWorkers,
  deductionsWagesAreNotExplainedWorkers,
  describeAccommodationsArrangementsMade,
  describeAnyOtherTypesOfBuildings,
  describeConcernsDifficultiesQuestionsListedThisSection_1,
  describeConcernsDifficultiesQuestionsListedThisSection_2,
  describeConcernsDifficultiesQuestionsListedThisSection_3,
  describeConcernsDifficultiesQuestionsListedThisSection_4,
  describeConcernsDifficultiesQuestionsListedThisSection_5,
  describeConcernsDifficultiesQuestionsListedThisSection_6,
  describeConcernsDifficultiesQuestionsListedThisSection_7,
  describeConcernsDifficultiesQuestionsListedThisSection_8,
  describeHoursWorkedViolationLegalLimitsTypeWork,
  describeHowMonthlyCapacityCalculatedEGDo,
  describeOffSiteDormitoriesVisited,
  describeOnsiteDormitoriesVisited,
  describeOtherGroundSIdentifiedFactoredIntoHiring,
  describeOtherReferencesApplicationsForms,
  describeTheMostRepresentativeDepartmentWinTheFac,
  describeTheseInformalProcedures,
  describeTypesFirefightingEquipmentUsedWhichAreasFacility,
  describeTypeWorkHoursWorkedNightBothFemale,
  describeWhichLanguagesAreNotAvailableGrievanceHandling,
  description,
  didAnyOfTheFollowingOccurDuringOrAfterIndustrialActio,
  didAnyWrkrsWorkMoreThan_60HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_72HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_80HoursInTotalRegularOvertime,
  didAnyWrkrsWorkMoreThan_90HoursInTotalRegularOvertime,
  didAssessmentTakePlaceConsecutivelly,
  didFacilityExperienceExceptionalCircumstancesIELarge,
  didFacilityHaveOtherWageDeductionsBesidesLegally,
  didTheFacActivelySeekToProvOrAttainAnyOfTheFollowin,
  didTheFacCommIncludeAnyOfTheFollowingSelectAllThatA,
  didTheFacComplyWLegalReqsToInformAndorGetPermission,
  didTheFacConsultWWorkerRepresentativesAndorTradeUnion,
  didTheFacExperienceExceptionalCircumstancesIeLargeLate,
  didTheFacHaveAnyOtherWageDeductionsBesidesLegallyRequ,
  didTheFacMaintainWasteDisposalRecsIncludingDocumentatio,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_1,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_2,
  didTheFacParticipateInAnyOfTheFollowingActivitiesRela_3,
  didTheFacParticipateInAnyTypeOfEconomicEmpowermentPro,
  didWorkersWorkMoreThan_60HoursTotal,
  didWorkersWorkMoreThan_72HoursTotal,
  didWorkersWorkMoreThan_80HoursTotal,
  didWorkersWorkMoreThan_90HoursTotal,
  dieCutting,
  dieCuttingEGCartons,
  directDepositIntoBankAccount,
  disability_1,
  disability_2,
  disability_3,
  disabilityReferencedNotLineLegalRequirements,
  discipline,
  discrimination_1,
  discrimination_2,
  displayName,
  doAllPersonsWhoPerformWorkForTheFacBothOnThePremise,
  doAnyOccupationalSafetyAndHealthMeasuresIncludingCollec,
  doApprovedBuildingPlansReflectTheCurrentBuildingsStruct,
  doesAnyWorkerOweDebtsToTheFacAndorAThirdParty,
  doesFacComplyLegalRestrictionsRegardingPaymentInstead,
  doesFacContinuouslyMonitorMaintainSpecificRegulatedIndoor,
  doesFacilityChargeKindBenefitsBelowCost,
  doesFacilityComplyOccupationalSafetyHealthRelatedLegal,
  doesFacilityConsultWorkersNotifyThemAdvanceAbout,
  doesFacilityConsultWorkersProvideMinimumNoticePeriod,
  doesFacilityHaveConfinedSpacesThatLegallyRequire,
  doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_1,
  doesFacilityHaveEmergencyAlarmSystemTypesEmergencies_2,
  doesFacilityHaveFireDetectionAlarmSystemLine,
  doesFacilityHaveFireDetectionAlarmSystemPlace,
  doesFacilityHaveLegallyRequiredFirefightingEquipment,
  doesFacilityHaveLegallyRequiredUpDatePermits,
  doesFacilityHaveMechanismPlaceProtectWorkers,
  doesFacilityHaveOccupationalSafetyHealthOshCommittee,
  doesFacilityHaveWorkAreasRiskHeatCold,
  doesFacilityHaveWrittenPlanHandlingOutbreaksContagious,
  doesFacilityHireDisabledPersonsLineLegalRequirements,
  doesFacilityIncludePeriodsMaternityLeaveWorkers,
  doesFacilityIncludeSandblastingItsProcesses,
  doesFacilityLimitUseFixedTermContracts,
  doesFacilityLoanAdvanceMoneyWorkers,
  doesFacilityMonitorIndoorAirQualityLineLegal,
  doesFacilityOnlyRequireWorkersTakePaidUnpaid,
  doesFacilityPayWorkersCorrectlyDuringWorkStoppages,
  doesFacilityPerformType,
  doesFacilityProvideBreaksDuringWorkdayLineLegal,
  doesFacilityProvideKindBenefitsLineLegalRequirements,
  doesFacilityProvideTimeOffBreastfeedingLineLegal,
  doesFacilityProvideWorkersCompensatoryTimeOffLine,
  doesFacilityProvideWorkersFreePotableDrinkingWater,
  doesFacilityProvideWorkersPotableDrinkingWaterLine,
  doesFacilityRecruitingAgencyProvideForeignMigrantsSigned,
  doesFacilityRegularlyTestServiceFireExtinguishersOther,
  doesFacilityRequireHivAidsTestsDuringEmployment,
  doesFacilityRequireHivAidsTestsDuringHiring,
  doesFacilityRequireOtherInfectionIllnessTestsE_1,
  doesFacilityRequireOtherInfectionIllnessTestsE_2,
  doesFacilityTakeDeductionsFromWagesThatAre,
  doesFacilityTestNoiseExposureLevelsLineLegal,
  doesFacilityUseFixedTermContracts,
  doesFacMgmtRegularlyMeetWTradeUnionsToProactivelyAddr,
  doesFacRegisterTheirWkrsSocialSecurityInstitutions,
  doesTheEmployerAllowWrkrsToCarryOutTradeUnionActiviti,
  doesTheEmployerUseAnyOtherCoerciveTacticsToForceWrkrs,
  doesTheFacArrangeHealthChecksForAllWrkrsUndTheAge,
  doesTheFacCalculateRegularHoursAsAnAverage,
  doesTheFacChargeForInkindBenefitsAtOrBelowCost,
  doesTheFacCommunicateImprovementPlansToInterestedStakeh,
  doesTheFacCommunicatePubliclyOnSocialAndLaborPerforman,
  doesTheFacComplyWApplicableLegalReqsConcerningHomewrkr,
  doesTheFacComplyWLegalReqsRegardingHealthChecksForWr,
  doesTheFacComplyWLegalReqsRegardingMedicalChecksForW,
  doesTheFacComplyWLegalReqsRegardingQualifiedOshStaff,
  doesTheFacComplyWLegalRestrRegardingPaymentInsteadOf,
  doesTheFacComplyWOccupationalSafetyAndHealthrelatedLeg,
  doesTheFacConductMaintenanceOnElectricalEquipmentWElec,
  doesTheFacConductRegularEmergencyDrillsForAllWrkrsAnd,
  doesTheFacConductRegularReviewsAndorAssessmentsOfSocia,
  doesTheFacConductWorkerPerformanceEvaluationsBasedOnA,
  doesTheFacConsultWWrkrsAndorProvAMinimumNoticePeriod,
  doesTheFacCreateImprovementPlansBasedOnSocialAndLabor,
  doesTheFacDeductTradeUnionDuesFromWagesInLineWLegal,
  doesTheFacEmployOrContractServicesForSecurityPersonnel,
  doesTheFacEngageProactivelyWRelevantStakeholdersBefore,
  doesTheFacEvaluateExposureToConcentrationsOfAirbornePa,
  doesTheFacEvaluateWorkerExposureToChemicalsAndHazardou,
  doesTheFacFailToCollectAndForwardWrkrsContributionsTo,
  doesTheFacFollowAllLegalReqsOnProvisionAndMaintenance,
  doesTheFacFollowAnyOfTheFollowingPracticesConcerningP,
  doesTheFacFollowAnyOfTheFollowingPracticesRegardingWo,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToC,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToM,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToO,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW,
  doesTheFacFollowAnyOfTheFollowingPracticesRelatedToW_1,
  doesTheFacGenerateAirborneParticulatesDustFibersMistsF,
  doesTheFacHaveAClimateAdaptationActionPlan,
  doesTheFacHaveACurrentContractWAnAuthorizedAgencyTo,
  doesTheFacHaveAFireDetectionAndAlarmSystemInPlace,
  doesTheFacHaveAFormalizedProcessOfReviewingDocumentati,
  doesTheFacHaveALegallyRequiredFireBrigadeemergencyResp,
  doesTheFacHaveAnEstablishedAccidentInvestigationProcedu,
  doesTheFacHaveAnOccupationalSafetyAndHealthOshCommitt,
  doesTheFacHaveAnyAdditionalSafetyMeasuresInPlaceRelat,
  doesTheFacHaveAnyOfTheFollowingAdditionalSafetyMeasur,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRegard,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_1,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceRelate_2,
  doesTheFacHaveAnyOfTheFollowingMeasuresInPlaceToThe,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_1,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_10,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_11,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_12,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_13,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_14,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_15,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_16,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_17,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_18,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_2,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_3,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_4,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_5,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_6,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_7,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_8,
  doesTheFacHaveAnyOfTheFollowingSafetyMeasuresInPlace_9,
  doesTheFacHaveAnyOfTheseAdditionalMeasuresInPlaceRel,
  doesTheFacHaveAnyWorkAreasWRiskOfHeatOrColdStress,
  doesTheFacHaveASufficientNumOfToiletsForTheNumOfWr,
  doesTheFacHaveASystemForReviewingPoliciesAndProcedure,
  doesTheFacHaveAWhistleblowerSystemInPlace,
  doesTheFacHaveAWrittenChartShowingTheIndividualsRespo,
  doesTheFacHaveAWrittenEmergencyResponsePlan,
  doesTheFacHaveAWrittenStrategyGoalsDocumentsForSocial,
  doesTheFacHaveConfinedSpaces,
  doesTheFacHaveElevatorsLifts,
  doesTheFacHaveErgonomicMeasuresInPlaceThatConsiderThe,
  doesTheFacHaveEstablishedGrievanceHandlingAndDisputeRe,
  doesTheFacHaveForkliftsOrOtherTypesOfLiftingEquipment,
  doesTheFacHaveIAnEstablishedUnionOnsiteAndorIiWrkrs,
  doesTheFacHaveLegallyRequiredAndUpToDatePermitsCerti,
  doesTheFacHaveLegallyRequiredFirefightingEquipment,
  doesTheFacHaveLegallyRequiredPostedEvacuationPlansMark,
  doesTheFacHaveSafetyMeasuresInPlaceRegardingAsbestosS,
  doesTheFacHaveSafetyMeasuresInPlaceRegardingOnsiteVeh,
  doesTheFacHaveWrittenPoliciesAndorFormalProceduresFor,
  doesTheFacHaveWrittenProceduresForClassificationCollect,
  doesTheFacHireDisabledPersonsInLineWLegalReqs,
  doesTheFacIncludeAllPeriodsOfMaternityLeaveInTheWrkr,
  doesTheFacInformAllWrkrsAboutCbasAndProvCopiesInLin,
  doesTheFacKeepAllWorkerHealthInfoConfidential,
  doesTheFacLimitTheUseOfFixedtermContracts,
  doesTheFacLoanAndorAdvanceMoneyToWrkrs,
  doesTheFacMaintainAListregisterOfWrkrsUndAge_18InLin,
  doesTheFacMaintainAnInventoryOfAllChemicalsAndHazardo,
  doesTheFacMaintainAValidLaborInspectionVisitBookRecor,
  doesTheFacMaintainJobDescsForAllPositionsWinTheFac,
  doesTheFacMaintainOnlyOneAccuratePayrollRecord,
  doesTheFacMaintainOnlyOneAccurateSetOfWorkingHourRec,
  doesTheFacMaintainParentalPermissionOfWrkrsUndTheAge,
  doesTheFacMaintainRecordedParentalPermissionForWrkrsUn,
  doesTheFacMaintainRecsOfElectricalEquipmentMaintenance,
  doesTheFacMonitorIndoorAirQualityInLineWLegalReqs,
  doesTheFacMonitorTheWorkingHoursOfAllWrkrsUndTheAge,
  doesTheFacNeedToReleaseWrkrsToBeAvailableForGovernme,
  doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo,
  doesTheFacObserveAnyOfTheFollowingPracticesRelatedTo_1,
  doesTheFacOfferFemaleWrkrsInTheSupplyChainIeFemaleW,
  doesTheFacOfferParticipateInAnyApprenticeshipTraineeIn,
  doesTheFacOrRecruitingAgencyProvForeignMigrantsWASig,
  doesTheFacPayWrkrsCorrectlyDuringWorkStoppagesInLine,
  doesTheFacPerformAnyTypeOfHotWorkIeWeldingSoldering,
  doesTheFacProvAllLegallyRequiredFacilities,
  doesTheFacProvBreaksDuringTheWorkdayInLineWLegalReq,
  doesTheFacProvCommAndTrainingOnSocialAndLaborPractic,
  doesTheFacProvHandWashingFacilitiesEquippedWCleanWate,
  doesTheFacProvInkindBenefitsEvenIfNotLegallyRequired,
  doesTheFacProvInkindBenefitsInLineWLegalReqs,
  doesTheFacProvLegallyRequiredCompensationBenefitsRelate,
  doesTheFacProvOtherInsuranceToWrkrsWhoAreNotCovered,
  doesTheFacProvSpecialHealthAndSafetyTrainingsSeparate,
  doesTheFacProvTheListregisterOfWrkrsUndAge_18ToGover,
  doesTheFacProvTimeOffForBreastfeedingInLineWLegalRe,
  doesTheFacProvWrkrsWCompensatoryTimeOffInLineWLegal,
  doesTheFacProvWrkrsWFreePotableDrinkingWater,
  doesTheFacProvWrkrsWPersonalProtEquipmentPpeInLineW,
  doesTheFacProvWrkrsWPotableDrinkingWaterInLineWLega,
  doesTheFacPublishAReportAtLeastEvery_2YearsRegarding,
  doesTheFacRecordWorkrelatedAccidentsAndDiseasesAndRepo,
  doesTheFacRefuseToBargainCollectivelyOrRefuseToBargai,
  doesTheFacRegisterTheirWrkrsWSocialSecurityInstitution,
  doesTheFacRegularlyTestAndServiceFireExtinguishersAnd,
  doesTheFacRentOrOwnThePremisesTheyOccupy,
  doesTheFacRequireHivAidsTestingAtAnyTimeDuringEmploy,
  doesTheFacRequireHivAidsTestingDuringTheHiringProcess,
  doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati,
  doesTheFacRequireOtherInfectionOrIllnessTestsEgHepati_1,
  doesTheFacRequireWrkrsToJoinATradeUnion,
  doesTheFacReviewupdatePoliciesAndProceduresWrittenOrIn,
  doesTheFacTakeAnyDeductionsFromWagesThatAreNotInLin,
  doesTheFacTestNoiseExposureLevelsInLineWLegalReqs,
  doesTheFacTreatAllTradeUnionsEquallyOrAsStipulatedBy,
  doesTheFacUseChemicalsAndorHazardousSubstances,
  doesTheFacUseContractorPersonnelToPerformMaintenanceWo,
  doesTheFacUseFixedtermContracts,
  doesTheFacUseLaserOrRadiationProducingEquipment,
  doesTheFacUsePortableLadders,
  doesTheFacUsePrisonLabor,
  doFoodServiceWrkrsHaveValidHealthsanitationCertificatesp,
  domesticMigrantWorkers,
  doOperatorsTechniciansForMachineryEquipmentElectricalIns,
  doOperatorsTechniciansInstallBoiler,
  doOtherTypesOfWrittenDocumentsExplainingTheTermsAndCo,
  doPaySlipsContainAccurateInfoOnWorkerWagesInADetaile,
  doPaySlipsContainAccurateInformationOnWorker,
  doRegularWorkingHoursExceedLegalReqs,
  dormitories,
  doSecurityPersonnelCarryWeapons,
  doSecurityPersonnelCarryWeaponsOnTheProductionFloor,
  doThesePoliciesAndorProceduresHaveAReferenceToNational,
  doTradeUnionRepresentativesHaveAccessToWrkrsInTheWork,
  doTradeUnionRepresentativesHaveTimeOffToAttendRelevant,
  doTradeUnionRepresentativesHaveTimeOffToCarryOutTheir,
  doWorkersHaveAccessExternalContactsOutsideTheir,
  doWorkersUnderstandInformationIncludedWithinTheirWritten,
  doWorkersUnderstandTermsConditionsWithinTheirWritten,
  doWorkplaceRulesComplyWLegalReqs,
  doWrkrsHaveAccessToExternalContactsOutsideOfMgmtThat,
  doWrkrsHaveTheAbilityToDisputeAndCorrectWagePayments,
  doWrkrsHaveTheRightToConsultWAndBeRepresentedEither,
  doWrkrsHaveTheRightToRespondToAndorAppealAnyDiscipli,
  doWrkrsKeepAllOfTheirOriginalPersonalDocumentsSuchAs,
  doWrkrsSignAllWrittenRecsOfDisciplinaryActionsTakenAg,
  doWrkrsUndstandTheInfoIncludedWinTheirWrittenTermsAnd,
  doWrkrsUndstandTheTermsAndConditionsWinTheirWrittenEm,
  dunsNumber,
  durationOfTheCbaThatCoversThe_2ndGreatestNumOfWrkrsI,
  durationOfTheCbaThatCoversThe_3rdGreatestNumOfWrkrsI,
  durationOfTheCbaThatCoversTheGreatestNumOfWrkrsInTh,
  duringRecruitmentProcessDoMaterialsSuchAsJob,
  duringTheRecruitmentProcessDoMaterialsSuchAsJobDescOr,
  dyeing_1,
  dyeing_2,
  electronics,
  elevatorsNotWiredBeInoperableWhenElevatorDoors,
  embossing,
  embroidery,
  emergencyAlarmNotDistinctFromOtherAlarmsSignals,
  emergencyAlarmSystemButtonsSwitchesPullStationsAre,
  emergencyAlarmSystemCannotBeHeardSeenAcross,
  emergencyAlarmSystemNotFittedBackUpPower,
  emergencyExitDoorsDoNotOpenOutwardsAre,
  employmentStatusNotMaintained,
  enabledCustomInfo,
  energyIEFuelCoalElectricityGasEtc,
  energyManagementSystem,
  energySourcesPefcr,
  equipmentCosts,
  ethiopiaPayWorkersCorrectlyDuringPrenatalVisits,
  ethiopiaPayWorkersCorrectlyWhenTheyTakeTime,
  ethiopiaProvideLegallyRequiredTimeOffPrenatalVisits,
  ethiopiaProvideTimeOffWorkersAppearLaborDispute,
  etiEthicalTradingInitiative,
  europeanFlaxCertifiedCompany,
  existingProductionWorkers_1,
  existingProductionWorkers_10,
  existingProductionWorkers_11,
  existingProductionWorkers_12,
  existingProductionWorkers_13,
  existingProductionWorkers_14,
  existingProductionWorkers_15,
  existingProductionWorkers_16,
  existingProductionWorkers_17,
  existingProductionWorkers_18,
  existingProductionWorkers_19,
  existingProductionWorkers_2,
  existingProductionWorkers_20,
  existingProductionWorkers_21,
  existingProductionWorkers_22,
  existingProductionWorkers_23,
  existingProductionWorkers_24,
  existingProductionWorkers_3,
  existingProductionWorkers_4,
  existingProductionWorkers_5,
  existingProductionWorkers_6,
  existingProductionWorkers_7,
  existingProductionWorkers_8,
  existingProductionWorkers_9,
  eyewashStationsShowersAreNotClearClutterDebris,
  eyewashStationsShowersAreNotClearlyIdentifiable,
  eyewashStationsShowersAreNotEasyAccess,
  eyewashStationsShowersAreNotRegularlyInspected,
  eyewashStationsShowersDoNotUsePotableWater,
  eyewashStationsShowersInspectionLogsAreNotKept,
  facDoesNotReviewupdatePoliciesAndProceduresWrittenOrIn,
  facDoesNotUseAnyMethodsAndIsNotAwareOfChangesupdates,
  facEmail,
  facFailingComplyLegalReqContractsHiringPractices,
  facFailingComplyLegalReqNotCoveredElsewhere_1,
  facFailingComplyLegalReqNotCoveredElsewhere_2,
  facFailingComplyLegalReqNotCoveredElsewhere_3,
  facFailingComplyLegalReqNotCoveredElsewhere_4,
  facFailingComplyLegalReqNotCoveredElsewhere_5,
  facFailingComplyLegalReqNotCoveredElsewhere_6,
  facFailingComplyLegalReqNotCoveredElsewhere_7,
  facFailingComplyLegalReqNotCoveredElsewhere_8,
  facFailingComplyLegalReqWagesBenefitsPertaining,
  facFailingComplyLegalReqWorkingHoursPertaining,
  facilityAcceptsWorkersFromGovernmentPrograms,
  facilityAccessibleFireResponseEmergencyVehiclesAlthough,
  facilityAccessibleFireResponseEmergencyVehiclesLine,
  facilityAddressLocalLanguageAsPerBusinessLicense,
  facilityAdministeringHivAidsTestsDuringHiringProcess,
  facilityAdministeringOtherInfectionIllnessTestsEG,
  facilityFailingCorrectlyPayWorkersTheseTypesLeave,
  facilityFailingCorrectlyProvideWorkersTimeOffThese,
  facilityHasNotPerformedAsbestosExposureAssessment,
  facilityHasNotTakenProperStepsEnsureThat,
  facilityHasOverdueSocialInsuranceSocialSecurityDebts,
  facilityLightingLineLegalRequirements,
  facilityLineLegalRequirementsWhenAdministeringHivAids,
  facilityNameLocalLanguageAsPerBusinessLicense,
  facilityPaidHousingAllowance,
  facilityPaidMealAllowance,
  facilityPaidSeniorityGratuityBonus,
  facilityPaidTransportationAllowance,
  facilityProcesses,
  facilityRequiresPregnancyTestsThatAreNotRequired_1,
  facilityRequiresPregnancyTestsThatAreNotRequired_2,
  facilityRequiresUseContraceptivesOtherFormsBirthControl_1,
  facilityRequiresUseContraceptivesOtherFormsBirthControl_2,
  facilityRequiresVirginityTestBeforeHiring,
  facilityStairwayStepsAreNotEven,
  facilityStepSurfacesAreNotMadeFromSlip,
  facilityWorkplaceRules,
  facIsInAMultifloorBuilding,
  facLineLegalReqWhenAdministeringOtherInfection,
  facRequiresPregnancyTestsThatAreNotRequiredByApplicabl,
  facRequiresWkrProvideCommitmentsVerballyWritingThat,
  facsAverageMonthlyVolumeNumericalAmount,
  facsMonthlyCapacityNumericalAmount,
  facsMonthlyCapacityUnitOfMeasurement,
  facsMonthlyVolumeUnitOfMeasurement,
  fallProtectionEquipmentMaintenanceLogsAreNotKept,
  fallProtectionEquipmentNotGoodCondition,
  familyResponsibilities_1,
  familyResponsibilities_2,
  familyResponsibilities_3,
  familyResponsibilitiesFactoredIntoHiringDecisionsNotLine,
  familyResponsibilitiesReferencedNotLineLegalRequirements,
  fifthWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  finalProductWarehousingStorage,
  finishing_1,
  finishing_2,
  finishingOfTextiles,
  firefightingEquipmentNotAccessible,
  firefightingEquipmentNotClearlyMarkedEquippedInstructions,
  firstWageLevelDefinedByFacThisIsTheLowestWageLevelC,
  flaFairLaborAssociation,
  floorsHaveBeenAddedSinceOriginalConstruction,
  food,
  foodAndBeverage,
  foodPreparationStorageEatingAreasAreNotKept,
  footwear,
  footwearClothing,
  forEachAdditionalActiveTradeUnionThatIsSmallerThanThe,
  forEachAdditionalCollectiveBargainingAgreementCbaNotCov,
  foreignMigrantWorkers,
  forHowManyMonthsAreRecsOfDisciplinaryActionsMaintained,
  forkliftRoutesAreNotClearlyMarked,
  forWrkrsSeekingToEndTheirEmploymentHowManyDaysOfNoti,
  fourthWageLevelDefinedByFacCompleteDefinitionOfThisLe,
  freedomAssociationCollectiveBargaining,
  ftusaFairTradeUsa,
  fullAddressLocalize,
  furniture,
  geojson,
  ghgEmissionsOffsetScope,
  glassProcessing,
  globalLocationNumber,
  gluing_1,
  gluing_2,
  gluing_3,
  gotsGlobalOrganicTextileStandard,
  governmentProgramsFacilityParticipatesIn,
  grievanceHandlingDisputeResolutionProcAccessLanguages,
  grievanceHandlingDisputeResolutionProceduresAccessibleSome,
  grievanceMechanismChannels,
  grievanceMechanismLocallyAvailableForPotentialExternalStakeholders,
  grievanceSystems,
  grsGlobalRecyclingStandard,
  handbags,
  harassment_1,
  harassment_2,
  hasAllLegallyRequiredActionBeenTakenToAssessMonitorAn,
  hasAnyNewPast_3YearsConstructionBeenAddedToTheBuildin,
  hasFacConductedAssessmentIdentifyEquipContainsPcb,
  hasFacilityActedAgainstLegalRequirementsHiringTemporary,
  hasFacilityConductedHealthSafetyRiskAssessmentLine,
  hasFacilityHadRushOrdersWithinAssessmentPeriod,
  hasFacilityTakenLegallyRequiredMeasuresProtectWorkers,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_1,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_2,
  hasFacilityTakenLegallyRequiredStepsEnableWorkers_3,
  hasFacilityTrainedWorkersUseFireFightingEquipment,
  hasFacMadeDisabledPersons,
  hasFacThreatenedIntimidatedHarassedPunishedTerminatedNot,
  hasLegallyRequiredActionBeenTakenAssessMonitor_1,
  hasLegallyRequiredActionBeenTakenAssessMonitor_2,
  hasTerminationForcedResignationRetrenchmentOrRetirementE,
  hasTheFacActedAgainstLegalReqsByHiringTemporaryprobati,
  hasTheFacBeenSubjectToAnyFinesOrSanctionsRelatedToS,
  hasTheFacConductedAHealthAndSafetyRiskAssessment,
  hasTheFacConductedAHealthAndSafetyRiskAssessmentInLi,
  hasTheFacConductedAnAssessmentToIdentifyIfEquipmentCo,
  hasTheFacConductedARiskAssessmentOrTestingToDetermine,
  hasTheFacDefinedThePersonsResponsibleForTheImplementat,
  hasTheFacEncouragedSourcingPracticesThatResultedInThe,
  hasTheFacEngagedInAnyOfTheseActionsDueToAWorkersTr,
  hasTheFacEverTriedToPreventAnyWrkrsFromParticipating,
  hasTheFacEverWheldOrThreatenedToWholdOrDelayedWageP,
  hasTheFacFailedToImplementAnyApplicableCourtOrdersArb,
  hasTheFacFailedToImplementAnyOfTheProvisionsInTheCb,
  hasTheFacFailedToMaintainAnyOfTheFollowingForWrkrsD,
  hasTheFacImplementedAnyOtherCommunityImpactProjectsTha,
  hasTheFacImplementedAnyOtherProjectsThatHaveSoughtTo,
  hasTheFacMadeAccommodationsarrangementsForPhysicallyDisa,
  hasTheFacMgmtTriedToControlManipulateOrInterfereWAny,
  hasTheFacReceivedRecognitionAwardFromAPubliclyKnownIn,
  hasTheFacSetSpecificGoalstargetsForImprovementOnSocial,
  hasTheFacSetTargetsForSocialAndLaborPerformanceAddres,
  hasTheFacTakenLegallyRequiredMeasuresToProtectWrkrsFr,
  hasTheFacTakenStepsToEnableWrkrsWHivaidsToRetainThe,
  hasTheFacTakenStepsToEnableWrkrsWhoBecomeDisabledFor,
  hasTheFacTakenStepsToEnableWrkrsWInfectionsOrIllness,
  hasTheFacThreatenedIntimidatedHarassedPunishedTerminated,
  hasTheFacTrainedWrkrsToUseFirefightingEquipmentInLine,
  haveAnyCasesOfThreatsSuchAsReportingToAuthoritiesDepo,
  haveAnyCasesOfViolenceOrThreatsOfViolenceToIntimidate,
  haveDecisionsOfTerminationForcedResignationRetrenchmentO,
  haveRaceEthnicGroupSkinColorSexGender_1,
  haveRaceEthnicGroupSkinColorSexGender_2,
  haveRaceEthnicGroupSkinColorSexGender_3,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_1,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_2,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_3,
  haveRaceEthnicGroupSkinColorSexGenderReligionPolitical_4,
  haveThereBeenAndorAreThereCurrentlyCasesOfConcernAbou,
  haveThereBeenAnyCasesOfPhysicalVerbalPsychologicalHara,
  haveThereBeenAnyIncidencesOfForcedLaborIncludingSaleA,
  haveThereBeenCasesOfSexualHarassment,
  haveWorkersBeenDeniedAccessTheirOriginalPersonal,
  haveWrkrsBeenDeniedAccessToAnyOfTheirOriginalPersonal,
  healthAndSafety,
  healthClinics,
  healthSafety,
  heatPressHeatingCooling_1,
  heatPressHeatingCooling_2,
  higgId,
  hivAidsStatusRealPerceived_1,
  hivAidsStatusRealPerceived_2,
  hivAidsStatusRealPerceived_3,
  hivAidsStatusRealPerceivedFactoredIntoHiring,
  hivAidsStatusRealPerceivedReferencedNotLine,
  homeAccessories,
  homeTextiles,
  homeworkers,
  hotWorkPerformedLineLegalRequirements,
  householdProducts,
  housing,
  howAreComplaintsAndGrievancesSettledSelectAllThatApply,
  howAreHoursOfWorkRecordedForWrkrsSelectAllThatApply,
  howAreWrkrsPaidSelectAllThatApply,
  howDoesTheFacDefineWageGradesLevels,
  howDoesTheFacEngageWWrkrsToProactivelySeekSuggestions,
  howDoesTheFacProvCommAndTrainingToIndividualsResponsi,
  howDoesTheFacProvCommAndTrainingToNewProductionWrkrs,
  howDoesTheFacProvCommAndTrainingToSecurityGuardsSele,
  howDoesTheFacProvCommAndTrainingToSeniorMgmtSelectA,
  howDoesTheFacProvCommAndTrainingToSupplierssubcontract,
  howDoesTheFacProvOngoingCommAndTrainingToExistingPro,
  howManyCasesOfHarassmentBasedUponAgeOccurred,
  howManyCasesOfHarassmentBasedUponDisabilityOccurred,
  howManyCasesOfHarassmentBasedUponGenderIdentityOccurre,
  howManyCasesOfHarassmentBasedUponHivaidsStatusOccurred,
  howManyCasesOfHarassmentBasedUponMaritalStatusOccurred,
  howManyCasesOfHarassmentBasedUponNationalExtractionOcc,
  howManyCasesOfHarassmentBasedUponNationalityforeignMigr,
  howManyCasesOfHarassmentBasedUponOtherOccurred,
  howManyCasesOfHarassmentBasedUponPoliticalOpinionOccur,
  howManyCasesOfHarassmentBasedUponPregnancymaternityStat,
  howManyCasesOfHarassmentBasedUponRaceEthnicGroupSkin,
  howManyCasesOfHarassmentBasedUponReligionOccurred,
  howManyCasesOfHarassmentBasedUponSexualOrientationOccu,
  howManyCasesOfHarassmentBasedUponSocialOriginOccurred,
  howManyCasesOfSexualHarassmentOccurred,
  howManyCasesOfWorkerHarassmentBySecurityPersonnelHave,
  howManyCollectiveBargainingAgreementsCbasHaveThere,
  howManyCollectiveBargainingAgreementsCbasHaveThereBeen,
  howManyEmployerMembersAreInTheBipartiteCommittee,
  howManyEmployerMembersAreInTheOshCommittee,
  howManyFemaleMembersAreInTheBipartiteCommittee,
  howManyFemaleMembersAreInTheOshCommittee,
  howManyFemalesAreUndTheApplicableLegalMinimumWorkingA,
  howManyForeignMigrantWorkerMembersAreInTheOshCommitte,
  howManyForeignMigrantWrkrsAreInTheBipartiteCommittee,
  howManyIndustrialActionsstrikesHaveOccurred,
  howManyLangsMustBeSpokenBySupvsAndMgmtInOrderToEff,
  howManyLanguagesMustBeSpokenSupervisorsManagement,
  howManyMalesAreUndTheApplicableLegalMinimumWorkingAge,
  howManyMembersAreInTheBipartiteCommittee,
  howManyMembersAreInTheOshCommittee,
  howManyNationalitiesAreRepresentedAmongWorkersSupervisors,
  howManyNationalitiesAreRepresentedAmongWrkrsAndSupvsAt,
  howManyOffSiteDormitoriesWereVisitedProvide,
  howManyOnsiteDormitoriesWereVisitedProvideTotal,
  howManySocialLaborAuditsHaveTakenPlace,
  howManyStillValidIndependentCertificationStandardAudits,
  howManyTotalDaysWereWrkrsOnStrikeForAllStrikesDuring,
  howManyTotalPersonDaysWereWrkrsOnStrikeForAllStrikes,
  howManyUnionRepresentativesAreInTheBipartiteCommittee,
  howManyUnionRepresentativesAreInTheOshCommittee,
  howManyWageGradesLevelsDoesTheFacHave,
  howManyWorkerMembersAreInTheBipartiteCommittee,
  howManyWorkerMembersAreInTheOshCommittee,
  howManyWorkersBecameDisabledWhateverReason,
  howManyWorkersUnderAge_18HaveWorked,
  howManyWrkrsBecameDisabledForAWorkrelatedReason,
  howManyWrkrsBecameDisabledForWhateverReason,
  howOftenHasTheGrievanceMechanismBeenUsedInTheAssessme,
  icsInitiativeComplianceSustainability,
  identificationDetailsFirstLastNameOrgPartiesPresent,
  idsBadgesSwipeCards,
  ietpIctiEthicalToyProgram,
  ifEquipmentContainsPcbDoesTheFacHaveAllOfTheFollowin,
  ifMoreThan_10DaysPleaseDescribe,
  ifNoDescWhenAssessorOnSiteAndWhyVerifNotTakePlace,
  ifOtherPleaseDescribe_1,
  ifOtherPleaseDescribe_10,
  ifOtherPleaseDescribe_11,
  ifOtherPleaseDescribe_12,
  ifOtherPleaseDescribe_13,
  ifOtherPleaseDescribe_14,
  ifOtherPleaseDescribe_15,
  ifOtherPleaseDescribe_16,
  ifOtherPleaseDescribe_17,
  ifOtherPleaseDescribe_18,
  ifOtherPleaseDescribe_19,
  ifOtherPleaseDescribe_2,
  ifOtherPleaseDescribe_20,
  ifOtherPleaseDescribe_3,
  ifOtherPleaseDescribe_4,
  ifOtherPleaseDescribe_5,
  ifOtherPleaseDescribe_6,
  ifOtherPleaseDescribe_7,
  ifOtherPleaseDescribe_8,
  ifOtherPleaseDescribe_9,
  ifTheFacEngagedEitherDirectlyOrViaIndustrialTradeAsso,
  ifTheFacHasNoTradeUnionAreWrkrsFreeToTheirNonunion,
  ifTheFacHasOverdueSocialInsuranceSocialSecurityDebtsD,
  ifWrkrsArePaidByDirectDepositIntoABankAccountDoThey,
  ifWrkrsArePaidThrough_3rdPartyAgentsHaveWrkrsAuthorize,
  ifYesAreHealthChecksArrangedPriorToEmployment,
  ifYesAreTheseHivAidsTestsAdministeredInLineWLegalRe_1,
  ifYesAreTheseInfectionOrIllnessTestsAdministeredInLin_1,
  ifYesAreWorkerPerformanceEvaluationsSharedAndorDiscusse,
  ifYesDoesTheFacFollowAnyOfTheFollowingPracticesRegar,
  ifYesDoRegularHoursExceed_48HoursPerWeek,
  ifYesDoWrkrsConfirmTheAccuracyOfPayoutsAndRepayments,
  ifYesPleaseDescribe_1,
  ifYesPleaseDescribe_2,
  ifYesPleaseProvide,
  iloBetterWorkInternationalLabourOrganization,
  imageList,
  inappropriateContainersAreUsedDispensingChemicals,
  incoterms,
  individualsResponsibleForImplementation_1,
  individualsResponsibleForImplementation_10,
  individualsResponsibleForImplementation_11,
  individualsResponsibleForImplementation_12,
  individualsResponsibleForImplementation_13,
  individualsResponsibleForImplementation_14,
  individualsResponsibleForImplementation_15,
  individualsResponsibleForImplementation_16,
  individualsResponsibleForImplementation_17,
  individualsResponsibleForImplementation_18,
  individualsResponsibleForImplementation_19,
  individualsResponsibleForImplementation_2,
  individualsResponsibleForImplementation_20,
  individualsResponsibleForImplementation_21,
  individualsResponsibleForImplementation_22,
  individualsResponsibleForImplementation_23,
  individualsResponsibleForImplementation_24,
  individualsResponsibleForImplementation_3,
  individualsResponsibleForImplementation_4,
  individualsResponsibleForImplementation_5,
  individualsResponsibleForImplementation_6,
  individualsResponsibleForImplementation_7,
  individualsResponsibleForImplementation_8,
  individualsResponsibleForImplementation_9,
  indonesiaDoesFacComplyLegalReqConcerningOutsourced,
  indonesiaDoesFacComplyLegalReqConcerningPremium,
  initialRefresherTrainOnResponsibilitiesMembersFireBrigade,
  inLineWLegalReqsAreAnyOfTheConfinedSpacesPermitRequ,
  insuranceCosts,
  internalCompanyCode,
  ioshBusinessAssuranceCertification,
  isAccessToHighVoltageAreasAndGeneratorAreasRestricted,
  isAJobApplicantsCurrentOrPreviousTradeUnionMembership,
  isALightningProtectorarrestorSystemInstalledOnTheBuildi,
  isAnAnnualReviewOfTheEmergencyResponsePlanConductedTo,
  isBurningOfWasteDoneOnsite,
  isDocumentationOfHealthChecksMaintainedAndUpToDate,
  isElectricalEquipmentInspectionAndMaintenanceCarriedOut,
  isFacLightingInLineWLegalReqs,
  isHotWorkPerformedInLineWLegalReqs,
  isLaserAndRadiationProducingEquipmentInLineWLegalReqs,
  iso_14001,
  iso_26000,
  iso_31000,
  iso_45001,
  iso_50001UneEnIso_5000s,
  iso_9000,
  isOvertimeVoluntaryInLineWLegalReqs,
  isRequiredHealthAndSafetyTrainingForWrkrsOfferedFreeO,
  isTheBackupEmergencyPowerSystemWorkingAndInGoodCondit,
  isTheCommuteServiceProvdByOrganizedByTheFac,
  isTheEmergencyAlarmSystemForAllTypesOfEmergenciesOthe,
  isTheFacAccessibleToFireResponseAndEmergencyResponseV,
  isTheFacConsultingWTradeUnionsInLineWLegalReqs,
  isTheFacFailingToComplyWAnyLegalReqsForContractsAnd,
  isTheFacFailingToComplyWAnyLegalReqsForDisciplineHa,
  isTheFacFailingToComplyWAnyLegalReqsForHealthSafety,
  isTheFacFailingToComplyWAnyLegalReqsForTerminationP,
  isTheFacFailingToComplyWAnyLegalReqsForWorkingHours,
  isTheFacFailingToComplyWLegalReqsForAnyOfTheFollow,
  isTheFacFailingToComplyWLegalReqsRegardingWorkerResi,
  isTheFacFailingToContributeTheLegallyRequiredAmountFo,
  isTheFacFailingToCorrectlyPayWrkrsForAnyOfTheseType,
  isTheFacFailingToCorrectlyProvWrkrsTimeOffForAnyOf,
  isTheFacFailingToImplementMeasuresRegardingHousingdormi,
  isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe,
  isTheFacFailingToPayAnyWorkerAtLeastTheBasicWageRe_1,
  isTheFacFailingToPayAnyWorkerAtLeastTheLegalMinimum,
  isTheFacFailingToPayWrkrsCorrectlyForAnyOfTheseType,
  isTheFacFailingToPayWrkrsOvertimeInLineWLegalReqsI,
  isTheFacFailingToPayWrkrsPremiumPayAsLegallyRequired,
  isTheFacility_1,
  isTheFacility_2,
  isTheFacility_3,
  isTheFacsApprenticeshipTrainingInternshipProgramInLine,
  isTheFacsPracticeAroundFinancialOrOtherSupportOfTheU,
  isTheFacsPracticeAroundLimitsOnTheUseOfFixedtermCont,
  isTheFacsPracticeOfConsultingWWrkrsAndorNotifyingThem,
  isTheFacsPracticeOfProvidingSpecialHealthAndSafetyTra,
  isTheFacsPracticeOfRequiringWrkrsToTakePaidOrUnpaid,
  isTheFacsRecruitmentProcessForForeignMigrantWrkrsInLi,
  isTheFireDetectionAndAlarmSystemInLineWLegalReqs,
  isTheLightningProtectorarrestorSystemInLineWLegalReqs,
  isTheOshCommitteeFormedAndFunctioningInLineWLegalReq,
  isTheOtherGroundsIdentifiedFactoredIntoHiringDecisions,
  isThereAManualOrAutomaticEmergencyAlarmSystemForAllT,
  isThereAnElectricalPowerSubstationOnsiteAtTheFac,
  isThereAnOffsiteCanteenManagedByTheFac,
  isThereAnOnsiteCanteeneatingArea,
  isThereAWrittenOccupationalHealthAndSafetyPolicyInLin,
  isTheReceiptOfWagePaymentConfirmedInWritingByWrkrs,
  isThereOnsiteVehicleTrafficAtTheFac,
  isThereWrittenDocumentationSurroundingTheTermsAndCondit,
  isTheRiskAssessmentUpdatedIfNewMachineryProcessesChemi,
  isTheSubstationInLineWLegalReqsOrFireratedConstructio,
  isTheWorkplaceCleanAndTidy,
  isThisFacOwnedAndorManagedByAWoman,
  labeling,
  labsLifeBuildingSafety,
  laminating,
  laminationCoating,
  laserRadiationProducingEquipmentLineLegalRequirements,
  lasting_1,
  lasting_2,
  leatherTanningFinishing,
  leatherTanningWetOperations,
  leatherWorkingGroupBronze,
  leatherWorkingGroupGold,
  leatherWorkingGroupSilver,
  legalServices,
  lighting,
  listAdditionalNationalitiesApproximateWkrsSupervisorsHere,
  listAnyAdditionalNationalitiesAndTheApproximateOfWrkrs,
  listTheBusinessNmsOfTheOtherOccupantsOfTheBuilding,
  livingWageCalculation,
  livingWageLocalCurrency,
  localBrandRepresentatives,
  localLawEnforcementGovernmentAgency,
  lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon,
  lowestWageGradeLevelAverageMonthlyAllowanceIncentiveBon_1,
  lowestWageGradeLevelAverageMonthlyBasicWageFemale,
  lowestWageGradeLevelAverageMonthlyBasicWageMale,
  lowestWageGradeLevelAverageMonthlyOvertimeEarningsFemal,
  lowestWageGradeLevelAverageMonthlyOvertimeEarningsMale,
  lowestWageGradeLevelAverageMonthlyTakehomePayFemale,
  lowestWageGradeLevelAverageMonthlyTakehomePayMale,
  lowestWagePaidRegularWork,
  luggageBags,
  manufactureKnittedCrochetedFabrics,
  manufactureOfWearingApparel,
  manufacturerIdentificationCode,
  maritalStatus_1,
  maritalStatus_2,
  maritalStatus_3,
  maritalStatusFactoredIntoHiringDecisionsNotLine,
  maritalStatusReferencedNotLineLegalRequirements,
  materialCutoff,
  maternityLeave_1,
  maternityLeave_2,
  maternityNotCollectedForwarded,
  medicalCosts,
  medicalFacilitiesClinicsAreNotKeptCleanSanitary,
  medicalFacilitiesClinicsAreNotOperationDuringWorking,
  medicalNotCollectedForwarded,
  medicalServices,
  medicinesStoredMedicalFacilitiesClinicsAreNotKept,
  metalProcessing,
  metalWork,
  minimumAmountPaidHolidays,
  minimumOrderQuantity,
  minimumOrderQuantityPerStyle,
  minimumWageAgreedOnCbaLocalCurrency,
  mininumWageLocalCurrency,
  mobileMoney,
  molding_1,
  molding_2,
  molding_3,
  moldingPlastic,
  namesOfOrganizationsProvidingContractWorkers,
  namesOfOrganizationsProvidingContractWorkersNotPartOfTheProductionProcess,
  nanomaterials,
  nationalExtraction_1,
  nationalExtraction_2,
  nationalExtraction_3,
  nationalExtractionFactoredIntoHiringDecisionsNotLine,
  nationalExtractionReferencedNotLineLegalRequirements,
  nationalities,
  nationality_2,
  nationality_3,
  nationality_4,
  nationalityForeignMigrantWorkerStatus_1,
  nationalityForeignMigrantWorkerStatus_2,
  nationalityForeignMigrantWorkerStatus_3,
  nationalityForeignMigrantWorkerStatusFactoredIntoHiring,
  nationalityForeignMigrantWorkerStatusReferencedNotLine,
  newProductionWorkers_1,
  newProductionWorkers_10,
  newProductionWorkers_11,
  newProductionWorkers_12,
  newProductionWorkers_13,
  newProductionWorkers_14,
  newProductionWorkers_15,
  newProductionWorkers_16,
  newProductionWorkers_17,
  newProductionWorkers_18,
  newProductionWorkers_19,
  newProductionWorkers_2,
  newProductionWorkers_20,
  newProductionWorkers_21,
  newProductionWorkers_22,
  newProductionWorkers_23,
  newProductionWorkers_24,
  newProductionWorkers_3,
  newProductionWorkers_4,
  newProductionWorkers_5,
  newProductionWorkers_6,
  newProductionWorkers_7,
  newProductionWorkers_8,
  newProductionWorkers_9,
  newProductionWorkersExistingProductionWorkersDoNot,
  newProductionWorkersExistingSecurityGuards_1,
  newProductionWorkersExistingSecurityGuards_2,
  nmOfTheFederationOrConfederationOrBothWWhichThe_2ndL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_3rdL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_4thL,
  nmOfTheFederationOrConfederationOrBothWWhichThe_5thL,
  nmOfTheFederationOrConfederationOrBothWWhichTheLarge,
  nmOfUnionWThe_2ndLargestMembership,
  nmOfUnionWThe_3rdLargestMembership,
  nmOfUnionWThe_4thLargestMembership,
  nmOfUnionWThe_5thLargestMembership,
  nmOfUnionWTheLargestMembership,
  nNDimethylformamideDmf,
  noAdequateGuardrailsFencingExposedOverheadWorkingSurfaces,
  noAdequateStrengthStorageRacksSupportExistingLoads,
  noAdjustableEquipmentAccommodateIndWorkerNeedsProvided,
  noAdjustableWorkstationsAccommodateIndWorkerNeedsProvided,
  noAnnualMedicalExaminationsDoneOnFoodService,
  noAppointedDoctorNurseMedicalFacilitiesClinicS,
  noAppropriateDesignStorageAreas,
  noAppropriateDistanceOtherControlsEGFire,
  noAppropriateEquipmentFightFiresIncludingCorrectPpe,
  noAppropriateProtectionLaserRadiationEquipment,
  noAppropriateProtectionsEnsureNoAccidentalEntryEach,
  noAppropriateSafeStoragePpeEquipmentClothingOn,
  noAppropriateSignsLaserRadiationEquipment,
  noAppropriateVentilationAreasWhereHotWorkConducted,
  noApprovedDesignatedAreaHotWork,
  noAssessmentAfterDrillLearnHowImproveEvacuation,
  noAssuranceThatChemicalContainersAreProperlyCapped,
  noAssuranceThatChemicalsAreBroughtIntoFacility,
  noAssuranceThatChildrenAreOnlyReleasedParents,
  noAssuranceThatCompressedGasCylindersAreOnly,
  noAssuranceThatCompressedGasCylindersHaveClosed,
  noAssuranceThatDoorsWindowsAreClosed,
  noAssuranceThatEveryWorkerEvacuates,
  noAssuranceThatOnlyAuthorizedPeopleVehiclesAre,
  noAssuranceThatOnlyAuthorizedTrainedQualifiedPeople,
  noAssuranceThatVehiclesAreDrivenAppropriateSpeed,
  noAssuranceThatVehiclesAreOnlyUsedPurposes,
  noAssuranceThatWorkersContractorsWhoEnterConfined_1,
  noAssuranceThatWorkersContractorsWhoEnterConfined_2,
  noAssuranceThatWorkersDisabilitiesSpecialNeedsAre,
  noAssuranceThatWorkersMeetAssemblyMeetingPoints,
  noAssuranceThatWorkersWorkingRadiationSourcesAre,
  noAuthorizedEntryOnlyAccessForEachConfinedSpace,
  noAutomaticCentralizedEmergencyAlarmSystem,
  noAutomaticFireExtinguishingSystemChemicalStorageAreas,
  noBackUpBatteryProvidingContinuousLightingWithin,
  noBreakdownPossibleAcrossTypesSocialInsuranceTotal_1,
  noBreakdownPossibleAcrossTypesSocialInsuranceTotal_2,
  noCertifiedFireResistantDoorsNoFireResistant,
  noClearDisplayLoadCapacityIENumber,
  noCompleteSpillKitAppropriateTypesUseChemicals,
  noConsistentUsePpeEquipmentClothingProvidedWorkers,
  noDesignatedEmergencyAssemblyAreasMeetingPointsWhich,
  noDisplayPostingMachineryEquipSafetyInstructionsWkrs,
  noEasyEntryIesExitSChemicalStorage,
  noEquipMaterialsMaternalHealthcareMedicalFacClinic,
  noFireExtinguisherProvidedFacilityWhenHotWorks,
  noFunctioningLockoutTagoutProgramMachineryEquipApplicable,
  noHandrailHandrailingsAreNotGoodCondition,
  noHandwashingSanitizingStations,
  noHazardousSubstancesWetProcessesBeingUsed,
  noHowDoesFacilityEnsureTemperatureMaintainedProvide,
  noIlluminationNoVisibilityEmergencyExitsWhenIt,
  noImpactWorkersWorkersReceiveTheirRegularPay,
  noImplBasicMedicalSurveillanceTechniquesMonitorWkrs,
  noInspectionHotWorkEquipmentPriorUse,
  noLabelingMaterialsContainingAsbestosExposureAreas,
  noLabelingSegregationCompressedGasCylinders,
  noLockingDevicesOnLaddersLaddersNotSecure,
  noMaintenanceRegularInspectionLaserRadiationEquipment,
  noMaintenanceWorkerMachineryEquipmentTrainingRecordsLeast,
  noMarkingOf,
  noMeasuresArePlacePreventFloorOpeningsHoles,
  noMeasuresArePlacePreventStandingWaterDue,
  noMeasuresPlacePreventUnauthorizedEntryChemicalStorage,
  noMeasuresPreventAccidentalTippingFallingCompressedGas,
  noMeasuresPreventWorkersFromSlippingOnFloors,
  noMonitoringContractedPersonnelFacilityEnsureTheyPerform,
  noneAboveFacCollectsForwardsLegallyRequiredContributions,
  noneAboveFacilityContributionsTotalBrokenDownAre,
  noneAboveFacilityFollowsPracticesListedAboveRegarding,
  noneAboveFacilityMeetingMeasuresListedAbovePrevent,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_1,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_10,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_11,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_12,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_13,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_14,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_15,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_16,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_17,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_18,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_19,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_2,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_20,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_21,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_22,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_23,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_24,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_25,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_26,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_27,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_28,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_29,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_3,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_4,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_5,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_6,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_7,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_8,
  noneAboveFacilityMeetingMeasuresListedAboveRegarding_9,
  noneAboveListedGroupsReceiveCommunicationTrainingOn,
  noneAboveListedReceiveCommunicationTrainingOnAnti_1,
  noneAboveListedReceiveCommunicationTrainingOnAnti_2,
  noneAboveListedReceiveCommunicationTrainingOnBribery,
  noneAboveListedReceiveCommunicationTrainingOnProhibition,
  noneAboveListedReceiveVerbalCommunicationFromFacility,
  noneAboveListedReceiveWrittenCommunicationFromFacility,
  noneOfTheAbove_1,
  noneOfTheAbove_10,
  noneOfTheAbove_11,
  noneOfTheAbove_2,
  noneOfTheAbove_3,
  noneOfTheAbove_4,
  noneOfTheAbove_5,
  noneOfTheAbove_6,
  noneOfTheAbove_7,
  noneOfTheAbove_8,
  noneOfTheAbove_9,
  nonGovernmentOrganizationsNgosWomenSGroups,
  nonWoven,
  noParkingForkliftsDesignatedLocationSWhenNot,
  noPermitHotWorkOutsideApprovedDesignatedArea,
  noPreventionOverloadingMaterialsOnForkliftTrucks,
  noPreventionPlacingLaddersFrontDoorsThatAre,
  noPreventionTyingAchieveAdditional,
  noPreventionUsingForkliftsLiftWorkersSoThat,
  noPreventionUsingLaddersHorizontalPositionAsPlatform,
  noProtectedExplosionProofLightingStorageAreas,
  noProtectionFromFallingObjectsUnderneathGradedSurfaces,
  noProvisionAdditionalPpeEGMasksGloves,
  noProvisionMedicalFacilitiesClinicSSuppliesEquipment,
  noProvisionPpeEquipmentSuchAsHearingProtection,
  noReferencesAbove,
  noRegularInspectionDamageMaintenancePortableLadders,
  noRegularInspectionElevatorsLifts,
  noRegularInspectionMaintenanceForkLifts,
  noRegularMaintenanceInspectionTestingEmergencyAlarmSystem,
  noRescueEquipmentReadyUseWhenConfinedSpace,
  noRestBreaksRotationsWorkersWhoAreExposed,
  noRiskAssessmentWhereSignificantHeatColdExposure,
  normalHoursOfOperationPerDay,
  noSafePerformanceExcavationTrenchingWorkIE,
  noSafetyDevicesOnElevatorDoorsPreventThem,
  noSafetyOrientationProvidedContractorPersonnelFacility,
  noSafeUseScaffoldingIESecuredPermanent,
  noSecuringLaddersWhenNotUse,
  noSew,
  noShieldsProtectWorkersFromRadiantHeatSources,
  noSignsEachConfinedSpaceIndicatingTheyAre,
  noStaffMonitorsLeadsArePresentListenWatch,
  noStorageFallProtectionEquipmentDesignatedLocation,
  noSufficientNumbersChildcareStaffEnsureSafetyWell,
  noSystemAccountWorkersDuringEmergencyEvacuation,
  noSystemIdentifyingFromPhysically,
  notApplicable_1,
  notApplicable_2,
  notApplicableFacilityDoesNotHaveStairsRaised,
  notApplicableNoFallProtectionNeeded,
  notApplicableSeeCountrySpecificQuestionSBelow_1,
  notApplicableSeeCountrySpecificQuestionSBelow_2,
  notes,
  notFullyFunctioningEmergencyAlarmSystem,
  noTrainingCommunicationOnDueDiligenceRequirementsSupplier,
  noTrainingCommunicationOnRawMaterialsDueDiligence,
  noTrainingOnErgonomicFactorsGoodPracticesPrevent,
  noTrainingOnFoodSafetyProperHygieneRules,
  noTrainingWorkersOnPreventingSpreadContagiousDiseases,
  notSubstantiatedRejected,
  notWorkersContractorsWhoEnterConfinedSpacesKnow,
  noUnannouncedEmergencyDrills,
  noVerificationFacThatContractorPersonnelHaveAppropriate,
  noVisualSafetyManagementFeaturesSuchAsIndicators,
  noWallsFencesOtherBarriersAlongHighWorking,
  noWarningLightsAudibleSignalsReverseTravelOn,
  noWarningsEitherThroughVerbalWrittenCommunicationAre,
  noWarningSignElevatorsEG,
  noWrittenDocumentationEmergencyDrills,
  noWrittenPoliciesProceduresPlaceButInformalProcedures,
  noWrittenProceduresPlaceReportingRespondingChemicalSpills,
  numberAgencyContractWorkers,
  numberCommutingInjuriesInclFatalitiesLast_12Months,
  numberContractWorkersWorkersEmployedThirdPartyWho,
  numberForeignMigrantSupervisors,
  numberForeignMigrantWorkers,
  numberMaleAgencyContractWorkers,
  numberMaleForeignMigrantSupervisors,
  numberMaleForeignMigrantWorkers,
  numberMaleWorkersWhoAreTraineesApprenticesInterns,
  numberOfCasualWorkers,
  numberOfContractWorkers,
  numberOfContractWorkersNotPartOfTheProductionProcess,
  numberOfDiverseCasualWorkers,
  numberOfDiverseContractWorkers,
  numberOfDiverseDomesticMigrantWorkers,
  numberOfDiverseForeignMigrantSupervisors,
  numberOfDiverseForeignMigrantWorkers,
  numberOfDiverseFullTimeWorkers,
  numberOfDiverseNightShiftWorkers,
  numberOfDiversePartTimeWorkers,
  numberOfDiversePermanentWorkers,
  numberOfDiverseSeasonalWorkers,
  numberOfDiverseSupervisors,
  numberOfDiverseTemporaryWorkers,
  numberOfDiverseTraineesApprenticesInternWorkers,
  numberOfDiverseUnionisedWorkers,
  numberOfDiverseWorkers,
  numberOfDiverseWorkersHiredDirectly,
  numberOfDiverseWorkersHiredIndirectly,
  numberOfDiverseWorkersOnParentalLeave,
  numberOfDiverseWorkersPaidByUnit,
  numberOfDiverseWorkersUnder_18,
  numberOfDiverseWorkersUnderCba,
  numberOfDiverseWorkersUnderProbation,
  numberOfDiverseWorkersWithDisability,
  numberOfDiverseWorkersWithRefugeeStatus,
  numberOfDiverseWorkersWorkingRemotelyOrBringWorkHome,
  numberOfDomesticMigrantWorkers,
  numberOfEmployees,
  numberOfFemaleCasualWorkers,
  numberOfFemaleContractWorkers,
  numberOfFemaleDomesticMigrantWorkers,
  numberOfFemaleEmployees,
  numberOfFemaleForeignMigrantSupervisors,
  numberOfFemaleForeignMigrantWorkers,
  numberOfFemaleFullTimeWorkers,
  numberOfFemaleNightShiftWorkers,
  numberOfFemalePartTimeWorkers,
  numberOfFemalePermanentWorkers,
  numberOfFemaleSeasonalWorkers,
  numberOfFemaleSupervisors,
  numberOfFemaleTemporaryWorkers,
  numberOfFemaleTraineesApprenticesInternWorkers,
  numberOfFemaleUnionisedWorkers,
  numberOfFemaleWorkers,
  numberOfFemaleWorkersHiredDirectly,
  numberOfFemaleWorkersHiredIndirectly,
  numberOfFemaleWorkersOnParentalLeave,
  numberOfFemaleWorkersPaidByUnit,
  numberOfFemaleWorkersUnder_18,
  numberOfFemaleWorkersUnderCba,
  numberOfFemaleWorkersUnderProbation,
  numberOfFemaleWorkersWithDisability,
  numberOfFemaleWorkersWithRefugeeStatus,
  numberOfFemaleWorkersWorkingRemotelyOrBringWorkHome,
  numberOfForeignMigrantSupervisors,
  numberOfForeignMigrantWorkers,
  numberOffSiteHousingSitesOccupiedWorkersManaged_1,
  numberOffSiteHousingSitesOccupiedWorkersManaged_2,
  numberOfFullTimeWorkers,
  numberOfMaleCasualWorkers,
  numberOfMaleContractWorkers,
  numberOfMaleDomesticMigrantWorkers,
  numberOfMaleEmployees,
  numberOfMaleForeignMigrantSupervisors,
  numberOfMaleForeignMigrantWorkers,
  numberOfMaleFullTimeWorkers,
  numberOfMaleNightShiftWorkers,
  numberOfMalePartTimeWorkers,
  numberOfMalePermanentWorkers,
  numberOfMaleSeasonalWorkers,
  numberOfMaleSupervisors,
  numberOfMaleTemporaryWorkers,
  numberOfMaleTraineesApprenticesInternWorkers,
  numberOfMaleUnionisedWorkers,
  numberOfMaleWorkers,
  numberOfMaleWorkersHiredDirectly,
  numberOfMaleWorkersHiredIndirectly,
  numberOfMaleWorkersOnParentalLeave,
  numberOfMaleWorkersPaidByUnit,
  numberOfMaleWorkersUnder_18,
  numberOfMaleWorkersUnderCba,
  numberOfMaleWorkersUnderProbation,
  numberOfMaleWorkersWithDisability,
  numberOfMaleWorkersWithRefugeeStatus,
  numberOfMaleWorkersWorkingRemotelyOrBringWorkHome,
  numberOfPartTimeWorkers,
  numberOfPermanentEmployees,
  numberOfPermanentWorkers,
  numberOfPregnantOrBreastfeedingWorkers,
  numberOfProductionSites,
  numberOfSupervisors,
  numberOfTemporaryWorkers,
  numberOfTraineesApprenticesInternWorkers,
  numberOfWorkers,
  numberOfWorkersOnMaternityLeave,
  numberOfWorkersPaidByUnit,
  numberOfWorkersReturnedFromMaternityLeave,
  numberOfWorkersUnder_18,
  numberOfWorkersUnderProbation,
  numberOfWorkersWithDisability,
  numberOfWorkersWithRefugeeStatus,
  numberOfWorkersWorkingRemotelyOrBringWorkHome,
  numberOnSiteDormitories,
  numberWeeklyRestDaysLeast_24ConsecutiveHours,
  numberWorkersWhoAreTraineesApprenticesInterns,
  numberWorkRelatedDangerousOccurrencesLast_12Months,
  numberWorkRelatedDiseasesLast_12Months,
  numberWorkRelatedFatalitiesLast_12Months,
  numberWorkRelatedInjuriesThatResultedLeastThree,
  numberWorkRelatedInjuriesThatResultedLessThan,
  numOfAllFloors,
  numOfCommutingInjuriesInclFatalitiesInTheLast_12Months,
  numOfContractWorkersEmployedByThirdPartyNotPartOfTheProductionProcess,
  numOfDiverseManagers,
  numOfEstablishedTradeUnionsInTheFac,
  numOfFemaleManagers,
  numOfFemaleUnionMembersInTheUnionWThe_2ndLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_3rdLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_4thLargestMemb,
  numOfFemaleUnionMembersInTheUnionWThe_5thLargestMemb,
  numOfFemaleUnionMembersInTheUnionWTheLargestMembersh,
  numOfFemaleUnionOfficialsInTheUnionWThe_2ndLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_3rdLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_4thLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWThe_5thLargestMe,
  numOfFemaleUnionOfficialsInTheUnionWTheLargestMember,
  numOfFemaleWrkrsInFifthWageLevelDefinedByFac,
  numOfFemaleWrkrsInFourthWageLevelDefinedByFac,
  numOfFemaleWrkrsInLowestWageLevelDefinedByFac,
  numOfFemaleWrkrsInSecondWageLevelDefinedByFac,
  numOfFemaleWrkrsInSeventhWageLevelDefinedByFac,
  numOfFemaleWrkrsInSixthWageLevelDefinedByFac,
  numOfFemaleWrkrsInThirdWageLevelDefinedByFac,
  numOfFemaleWrkrsInWageLevelGrade,
  numOfFemaleWrkrsInWageLevelGrade_1,
  numOfFemaleWrkrsInWageLevelGrade_1LowestWageGradeLev,
  numOfFemaleWrkrsInWageLevelGrade_2,
  numOfFemaleWrkrsInWageLevelGrade_3,
  numOfFemaleWrkrsInWageLevelGrade_4,
  numOfFemaleWrkrsInWageLevelGrade_5,
  numOfFemaleWrkrsInWageLevelSemiskilled,
  numOfFemaleWrkrsInWageLevelSkilled,
  numOfFemaleWrkrsInWageLevelUnskilled,
  numOfFemaleWrkrsWhoWerePromotedWAnIncreaseInTheirBa,
  numOfMaleManagers,
  numOfMaleWrkrsWhoWerePromotedWAnIncreaseInTheirBasi,
  numOfManagers,
  numOfOffsiteHousingSitesOccupiedByWrkrsManagedAndCont,
  numOfOffsiteHousingSitesOccupiedByWrkrsManagedOrContr,
  numOfOnsiteDormitories,
  numOfProductionBuildingsOnsite,
  numOfRegularDailyHoursWorkedAtTheFac,
  numOfRegularWeeklyHoursWorkedAtTheFac,
  numOfShiftsAndHoursOfOperationForEachNormalOperations,
  numOfShiftsAndHoursOfOperationForEachPeakOperations,
  numOfWarehousesOnsite,
  numOfWeeklyRestDaysAtLeast_24ConsecutiveHoursLongProv,
  numOfWorkrelatedDangerousOccurrencesInTheLast_12Months,
  numOfWorkrelatedDiseasesInTheLast_12Months,
  numOfWorkrelatedFatalitiesAndInjuriesThatResultedInAt,
  numOfWorkrelatedInjuriesThatResultedInLessThanThreeDa,
  oekoTex,
  officialName,
  officialNameLocalized,
  operatingLicenseregistration,
  operatingLicenseregistrationIsAvailableAndUpToDate,
  organicContentStandardOcs,
  osHubId,
  other_1,
  other_10,
  other_11,
  other_12,
  other_13,
  other_14,
  other_15,
  other_16,
  other_2,
  other_3,
  other_4,
  other_5,
  other_6,
  other_7,
  other_8,
  other_9,
  otherActionImpactingWorkers,
  otherDescribeTypeRequiredLeaveThatNotPaid,
  otherDescribeTypeRequiredLeaveThatNotProvided,
  otherGroundSIdentifiedFactoredIntoHiringDecisions,
  otherHazardousSubstancesWetProcesses,
  otherMonetaryBonusesAllowances,
  otherMonetaryBonusesAndorAllowances,
  otherNotCollectedForwarded,
  otherTypesRequiredLeave_1,
  otherTypesRequiredLeave_2,
  overtimeVoluntaryLineLegalRequirements,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_1,
  overviewOfTheIssuesCoveredInTheCbaThatCoversTheGreat_2,
  packaging_1,
  packaging_2,
  packaging_3,
  packaging_4,
  packagingProducts,
  packing,
  pakistanDoesEmployerMaintainFairPriceShop,
  pakistanDoesFacilityPayWorkersLegallyRequiredYearly,
  pakistanDoWorkers_1,
  pakistanDoWorkers_2,
  pakistanDoWorkersReceiveCorrectPaymentWorkRelated,
  pakistanDoWorkersSurvivorsReceiveRequiredMedicalCare,
  pakistanHasEmployerAdoptedCodeConductProtectAgainst,
  pakistanHasEmployerSetUpFunctioningInquiryCommittee,
  pakistanPayWorkersCorrectlyDuringIddatLeave,
  pakistanProvideRequiredTimeOffIddat,
  paperProcessing,
  partiesToTheCbaThatCoversThe_2ndGreatestNumOfWrkrsIn,
  partiesToTheCbaThatCoversThe_3rdGreatestNumOfWrkrsIn,
  partiesToTheCbaThatCoversTheGreatestNumOfWrkrsInThe,
  paternityLeave_1,
  paternityLeave_2,
  payAndBenefits,
  payrollDiverseWorkersSampled,
  payrollFemaleWorkersSampled,
  payrollHowManyWorkersWereSampled,
  payrollMaleWorkersSampled,
  payrollRecordsAreNotConsistentAttendanceRecordsOther,
  payrollRecordsDoNotShowTypesSocialInsurance,
  payrollRecordsEachWorkerAreNotMaintainedLeast,
  payrollRecsDoNotShowAllTheTypesOfSocialInsuranceThe,
  payrollWhatPercentageSampledWorkforceWasImpacted,
  payrollWorkersSampledHowManyWorkersReceivedLess,
  pctOfWorkforceCoveredByTheCbaThatCoversThe_2ndGreates,
  pctOfWorkforceCoveredByTheCbaThatCoversThe_3rdGreates,
  pctOfWorkforceCoveredByTheCbaThatCoversTheGreatestNu,
  pctOfWrkrsThatAreTradeUnionMembers,
  peakOperationMonths,
  penaltiesMonetaryOtherwiseAreUsedEnsureThatWorkers,
  pensionProvidentFundNotCollectedForwarded,
  percentageNumberOfNormalWorkforce,
  personalCareBeautyProducts,
  personalLeave_1,
  personalLeave_2,
  phone,
  plasticRubberProcessing,
  pleaseDescribe_1,
  pleaseDescribe_2,
  pleaseDescribe_3,
  pleaseDescribe_4,
  pleaseDescribe_5,
  pleaseDescribe_6,
  pleaseDescribe_7,
  pleaseDescribeWhat_1,
  pleaseDescribeWhat_2,
  pleaseDescribeWhat_3,
  pleaseSelectTheFacility,
  politicalOpinion_1,
  politicalOpinion_2,
  politicalOpinion_3,
  politicalOpinionFactoredIntoHiringDecisionsNotLine,
  politicalOpinionReferencedNotLineLegalRequirements,
  positionNotMaintained,
  potassiumPermanganatePp,
  poweredMotorVehiclesPmvProcedures,
  powerNotTurnedOff,
  ppeEquipmentClothingProvidedNotGoodConditionNot,
  ppeNotCorrectSizeWorkers,
  ppeRelatedNNDimethylformamideDmfGoodCondition,
  ppeRelatedPotassiumPermanganatePpGoodConditionRegularly,
  ppeRelatedTetrachloroethyleneRegularlyReplaced,
  pregnancyMaternityStatus_1,
  pregnancyMaternityStatus_2,
  pregnancyMaternityStatus_3,
  pregnancyMaternityStatusFactoredIntoHiringDecisionsNot,
  pregnancyMaternityStatusReferencedNotLineLegalReq,
  preparationSpinningTextileFibers,
  pressureVesselsSafety,
  primaryLanguageSpokenAtTheFac,
  primaryLanguageSpokenByFacMgmt,
  priming,
  printing_1,
  printing_2,
  printing_3,
  productCapabilities,
  productLevels,
  productTypes,
  prohibitionOfForcedLabor,
  provApproximateOfSupvsWhoCanCommunicateInThePrimaryLa,
  provApproximateOfSupvsWhoCanCommunicateInThisLanguage,
  provApproximateOfSupvsWhoCanCommunicateInThisLanguage_1,
  provApproximateOfWrkrsWhoCanCommunicateInThePrimaryLa,
  provApproximateOfWrkrsWhoCanCommunicateInThisLanguage,
  provApproximateOfWrkrsWhoCanCommunicateInThisLanguage_1,
  provideApproximateSupervisorsLanguage_1,
  provideApproximateSupervisorsLanguage_2,
  provideApproximateSupervisorsPrimaryLanguage,
  provideApproximateWorkersWhoCanCommunicatePrimaryLanguage,
  provideApproximateWorkersWhoCanCommunicateThisLanguage_1,
  provideApproximateWorkersWhoCanCommunicateThisLanguage_2,
  provideDetailsHousingArrangementsIncludingMinimumHowMany,
  provideListHealthSafetyTrainingsOfferedExistingProduction,
  provideListHealthSafetyTrainingsOfferedNewProduction,
  provideListTrainOfferedIndividualsRespImplHealth,
  raceEthnicGroupSkinColor_1,
  raceEthnicGroupSkinColor_2,
  raceEthnicGroupSkinColor_3,
  raceEthnicGroupSkinColorFactoredIntoHiring,
  raceEthnicGroupSkinColorReferencedNotLine,
  rawMaterialsSourcing,
  rawMaterialStorageWarehousing,
  rbaResponsibleBusinessAlliance,
  rbaVap,
  receiptWagePaymentConfirmedWritingWorkers,
  recruitmentAndHiring,
  recycledClaimStandardRcs,
  referenceInternationalLawIloConventions,
  referenceOtherNationalIntlReqDeclarationsGoalsGuiding,
  referenceToNationalLaw,
  regularHoursWorkedAtNight,
  regularHoursWorkedOnPublicHolidays,
  regularHoursWorkedOnWeeklyRestDays,
  relationshipType,
  religion_1,
  religion_2,
  religion_3,
  religionFactoredIntoHiringDecisionsNotLineLegal,
  religionReferencedNotLineLegalRequirements,
  residencesAreLocatedWinAnyFacBuildings,
  residentialBuildingHasBeenConvertedIntoAFac,
  respectedCommunityMemberS,
  responsiblePerson,
  retracedId,
  retracedRiskScore,
  rjcResponsibleJewelryCouncil,
  rospaGold,
  rospaSilver,
  rotaryPrinting,
  sa8000SocialAccountabilityInternational,
  safetyCommitteeDoesNotCommunicateComplaintsProblemsShared,
  safetyCommitteeDoesNotConductSafetyInspectionsDoes,
  safetyCommitteeMeetingActionItemsAreNotTracked,
  safetyCommitteeMeetingMinutesAreNotSharedWorkforce,
  safetyCommitteeMeetingsAreNotHeldLeastOnce,
  safetyCommitteeMeetingsAreNotHeldLeastQuarterly,
  screenPrinting,
  seamTaping,
  secondMostCommonlySpokenLanguageAtTheFac,
  secondWageLevelDefinedByFacCompleteDefinitionOfThisLe,
  securityGuards_1,
  securityGuards_10,
  securityGuards_2,
  securityGuards_3,
  securityGuards_4,
  securityGuards_5,
  securityGuards_6,
  securityGuards_7,
  securityGuards_8,
  securityGuards_9,
  selectTheFacsApplicableThreeLetterCurrencyCode,
  seniorManagement_1,
  seniorManagement_10,
  seniorManagement_11,
  seniorManagement_12,
  seniorManagement_13,
  seniorManagement_14,
  seniorManagement_15,
  seniorManagement_16,
  seniorManagement_17,
  seniorManagement_18,
  seniorManagement_19,
  seniorManagement_2,
  seniorManagement_20,
  seniorManagement_21,
  seniorManagement_22,
  seniorManagement_23,
  seniorManagement_24,
  seniorManagement_3,
  seniorManagement_4,
  seniorManagement_5,
  seniorManagement_6,
  seniorManagement_7,
  seniorManagement_8,
  seniorManagement_9,
  seventhWageLevelDefinedByFacCompleteDefinitionOfThisL,
  sewing,
  sexGender_1,
  sexGender_2,
  sexGender_3,
  sexGenderFactoredIntoHiringDecisionsNotLine,
  sexGenderReferencedNotLineLegalRequirements,
  sexualOrientation_1,
  sexualOrientation_2,
  sexualOrientation_3,
  sexualOrientationFactoredIntoHiringDecisionsNotLine,
  sexualOrientationReferencedNotLineLegalRequirements,
  shipping_1,
  shipping_2,
  sickLeave_1,
  sickLeave_2,
  signedCopiesContractsBetweenFacilityEachWorkerAre,
  signedCopiesTermsConditionsDocumentsBetweenFacilityEach,
  sinceEquipmentContainsPcbDoesFacilityHaveFollowing,
  sixthWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  skillsAndQualificationTests,
  slcpFacilityId,
  smetaSedexMembersEthicalTradeAudit,
  socialOrigin_1,
  socialOrigin_2,
  socialOrigin_3,
  socialOriginFactoredIntoHiringDecisionsNotLine,
  socialOriginReferencedNotLineLegalRequirements,
  sportsOutdoorHardGoods,
  sportsOutdoorSoftGoods,
  srMgntIndividualsResponsibleImplementationDoNotReceive_2,
  srMngtIndividualsResponsibleImplementationDoNotReceive_1,
  srMngtIndividualsResponsibleImplementationExistingProd,
  srMngtIndividualsResponsibleImplNewProdWorkers_1,
  srMngtIndividualsResponsibleImplNewProdWorkers_10,
  srMngtIndividualsResponsibleImplNewProdWorkers_11,
  srMngtIndividualsResponsibleImplNewProdWorkers_12,
  srMngtIndividualsResponsibleImplNewProdWorkers_13,
  srMngtIndividualsResponsibleImplNewProdWorkers_14,
  srMngtIndividualsResponsibleImplNewProdWorkers_2,
  srMngtIndividualsResponsibleImplNewProdWorkers_3,
  srMngtIndividualsResponsibleImplNewProdWorkers_4,
  srMngtIndividualsResponsibleImplNewProdWorkers_5,
  srMngtIndividualsResponsibleImplNewProdWorkers_6,
  srMngtIndividualsResponsibleImplNewProdWorkers_7,
  srMngtIndividualsResponsibleImplNewProdWorkers_8,
  srMngtIndividualsResponsibleImplNewProdWorkers_9,
  standardizationChemicalFinishing,
  standardLeadTime,
  startFinishTimesAreNotRecordedPeriodsWork,
  startFinishTimesPayrollSystemDoNotMatch,
  stationaryCompressedGasCylindersAreNotConnectedFixed,
  stockFitting,
  storageRacksShelvingNotSecuredPermanentStructures,
  sublimation,
  substantiatedStillWorkingOnRemedialAction,
  substantiatedWithoutRemedy,
  substantiatedWithRemedy,
  sundriesApplication,
  suppliersSubcontractors_1,
  suppliersSubcontractors_10,
  suppliersSubcontractors_11,
  suppliersSubcontractors_12,
  suppliersSubcontractors_13,
  suppliersSubcontractors_14,
  suppliersSubcontractors_15,
  suppliersSubcontractors_16,
  suppliersSubcontractors_17,
  suppliersSubcontractors_18,
  suppliersSubcontractors_19,
  suppliersSubcontractors_2,
  suppliersSubcontractors_20,
  suppliersSubcontractors_3,
  suppliersSubcontractors_4,
  suppliersSubcontractors_5,
  suppliersSubcontractors_6,
  suppliersSubcontractors_7,
  suppliersSubcontractors_8,
  suppliersSubcontractors_9,
  supplierSubcontractorReceivesTrainCommOnDueDiligence,
  supplierSubcontractorReceivesTrainCommOnRawMaterials,
  supplyChainTier,
  tanningDressingLeatherDressingDyeingFur,
  terminationAndRetrenchment,
  termsConditionsDocumentsAreNotUpDate,
  termsConditionsDocumentsUnclearlyInaccuratelyState,
  tetrachloroethylenePerc,
  textileExchangeId,
  theBasisOfTheHarassmentSelectAllThatApply,
  theFacDoesNotCreateImprovementPlans,
  theFacDoesNotSetTargetsKeyPerformanceIndicators,
  theFacPaidAnAnnualBonus,
  theFacPaidAnAttendanceBonus,
  theFacPaidAProductivityBonus,
  theFacPaidHousingTransportationAndorMealAllowances,
  theFacPaidSeniorityAndorGratuityBonus,
  thereAreNoOptionsSeniorManagementReviewDirect,
  thereLightningProtectorArrestorSystemLineLegalReq,
  thereWrittenDocsSurroundingTermsCondGrantingRepayment,
  thirdMostCommonlySpokenLanguageAtTheFac,
  thirdWageLevelDefinedByFacCompleteDefinitionOfThisLev,
  totalFacAreaM2OnlyBuiltPremises,
  totalNumberOfWorkers,
  totalNumOfBuildingsOnsite,
  totalNumOfUnionMembersInTheUnionWThe_2ndLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_3rdLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_4thLargestMembe,
  totalNumOfUnionMembersInTheUnionWThe_5thLargestMembe,
  totalNumOfUnionMembersInTheUnionWTheLargestMembershi,
  totalNumOfUnionOfficialsInTheUnionWThe_2ndLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_3rdLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_4thLargestMem,
  totalNumOfUnionOfficialsInTheUnionWThe_5thLargestMem,
  totalNumOfUnionOfficialsInTheUnionWTheLargestMembers,
  totalNumOfWrkrsInFifthWageLevelDefinedByFac,
  totalNumOfWrkrsInFourthWageLevelDefinedByFac,
  totalNumOfWrkrsInLowestWageLevelDefinedByFac,
  totalNumOfWrkrsInSecondWageLevelDefinedByFac,
  totalNumOfWrkrsInSeventhWageLevelDefinedByFac,
  totalNumOfWrkrsInSixthWageLevelDefinedByFac,
  totalNumOfWrkrsInThirdWageLevelDefinedByFac,
  totalNumOfWrkrsInWageLevelGrade,
  totalNumOfWrkrsInWageLevelGrade_1,
  totalNumOfWrkrsInWageLevelGrade_1LowestWageGradeLeve,
  totalNumOfWrkrsInWageLevelGrade_2,
  totalNumOfWrkrsInWageLevelGrade_3,
  totalNumOfWrkrsInWageLevelGrade_4,
  totalNumOfWrkrsInWageLevelGrade_5,
  totalNumOfWrkrsInWageLevelSemiskilled,
  totalNumOfWrkrsInWageLevelSkilled,
  totalNumOfWrkrsInWageLevelUnskilled,
  totalWorkerInterviews,
  toys,
  trafficLanesWalkPathsAreNotClearlyMarked,
  trainingAndOrientation,
  trainingRecordsOnChemicalUseHandlingDisposalSpill,
  transliteratedDisplayName,
  transliteratedOfficialName,
  transportation,
  travelAndLodging,
  trims,
  typeOfProcessesCarriedOutAtHome,
  under_12Over_18EnterAgeYoungestWorker,
  unemploymentNotCollectedForwarded,
  uniforms,
  unionRepresentatives,
  unsafeTransportationCompressedGasCylinders,
  upperManagementDoesNotRecognizeAcceptSafetyCommittee,
  upperProductionIncludingStitching,
  uscc,
  vatId,
  vehiclesMaintenanceLogsNotKept,
  vehiclesNotGoodWorkingCondition,
  vendors,
  verificationAssessmentWindow,
  verifierBodyNameCountryProgramme,
  verifierBodyType,
  verifierNamesAssessorIds,
  verifierSApscaIdS,
  videoFile,
  vietnamDoesFacAllowancesAdditional,
  vietnamDoesFacComplyLegalReqConcerningBreaks,
  vietnamDoesFacComplyLegalReqConcerningDispatched,
  vietnamDoesFacInspectMeasureEnvironmentalCondWorkplace,
  vietnamDoesFacRegularlyInspectMaintainMachinesEquip,
  vietnamDoesTheFacCollectAndForwardWrkrsContributionsAs,
  vietnamFacContributionForSocialHealthAndUnemploymentIns,
  vietnamHasTheCollectiveAgreementInForceBeenApprovedBy,
  vietnamPay_30MinutesTimeOffPerDay,
  vietnamProvide_30MinutesTimeOffPerDay,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyAl_1,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyBa_1,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv,
  wageGradeLevelMostRepresentedInTheFacAverageMonthlyOv_1,
  wagesAndBenefits,
  wagesNotMaintained,
  warehousingDistribution,
  washing,
  wasteSources,
  wasteTreatmentManagement,
  wasteWaterTreatmentProficiency,
  wasTheGrievanceMechanismDevelopedThroughSocialDialogueB,
  waterManagementSystem,
  waterSources,
  weavingOfTextiles,
  webshopCompanyDescription,
  webshopCompanyDisplayName,
  webshopCompanyImageList,
  webshopCompanyVideoFile,
  website,
  welding,
  wereAllOtherWagePaymentsInLineWLegalReqs,
  wereAnyWrkrsUndTheLegalMinimumWorkingAgeWhenHired,
  wereAtLeastTwothirdsOfTheMeetingsAttendedBy_100OfMemb,
  wereExceptionRequestsGrantedVerificationOversightOrgThis,
  wereInterpretersPresentDuringVerificationAssessment,
  wereOtherWagePaymentsLineLegalRequirements,
  wereRecsOfAllWorkrelatedInjuriesFatalitiesAccidentsAnd,
  wereTerminationsOfTradeUnionOfficialsIfAnyInLineWApp,
  wereWholdingsFromWagesOtherThanSocialSecurityCalculated,
  wereWithholdingsFromWagesOtherThanSocialSecurity,
  wereWorkers,
  wetPrinting,
  whatAgeYoungestWorkerFacility,
  whatAnnualWorkerTurnoverPercent,
  whatApproximatePctOfWrkrsArePaidByTheseOtherMeans,
  whatAreIndividualWorkersBasicWagesBasedUponSelectAllT,
  whatAverageTimeDaysItTakesReachOutcome,
  whatHealthAndSafetyMeasuresDoesTheFacHaveToPreventTh,
  whatIsTheAgeOfTheYoungestWorkerInTheFac,
  whatIsTheConstructionDateOfTheOldestBuildingTheFacOc,
  whatIsTheFacsDefinitionOfLeadTime,
  whatIsTheFacsFormOfProductionOperationsPlanning,
  whatIsTheFacsMaximumLeadTimeWeeksAsUnitOfMeasurement,
  whatIsTheMaximumLengthOfTimeInDaysThatTheFacConside,
  whatIsTheReasonForTheNewConstruction,
  whatPercentageNormalWorkforceDoesTotalNumberWorkers,
  whatPercentageWorkersArePaidCardStoredValue,
  whatPercentageWorkersArePaidCash,
  whatPercentageWorkersArePaidCheck,
  whatPercentageWorkersArePaidDirectDepositInto,
  whatPercentageWorkersArePaidMobileMoney,
  whatTotalNumberInterviewsConductedContractWorkersWorkers,
  whenADisciplinaryActionIsInitiatedAgainstAWorkerIsTha,
  whenMakingChangesContractsDoesFacilitySeekWritten,
  whenPreparingFoodNoMeasuresPreventDecreasePotential,
  whenProductionvolumeIsLowerThanExpectedHowAreWrkrsImpa,
  whenWasTheLastRiskAssessmentConducted,
  whichFloorsDoesFacOccupyInAMultifloorSharedBuilding,
  whichHazardousSubstancesAreWrkrsExposed,
  whichLegalOvertimeLimitsAreNotBeingCompliedWSelectAll,
  whichOfTheFollowingApprenticeshipTraineeInternshipProgra,
  whichOfTheFollowingElementsAreReferencedInWrittenJobD,
  whichOfTheFollowingFacSocialInsuranceContributionsBoth,
  whichOfTheFollowingHasTheFacFailedToImplementSelectA,
  whichOfTheFollowingIsAFactorInDecisionsOnCompensation,
  whichOfTheFollowingIsAFactorInDecisionsOnConditionsO,
  whichOfTheFollowingIsAFactorInDecisionsOnHiringSelec,
  whichOfTheFollowingIsAFactorInDecisionsOnPromotionOr,
  whichOfTheFollowingIsAFactorInDecisionsOnTermination,
  whichOfTheFollowingLegallyRequiredCompensationBenefitsI,
  whichOfTheFollowingRecruitmentFeesOrRelatedCostsDoesT,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_1,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_10,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_11,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_12,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_13,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_14,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_2,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_3,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_4,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_5,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_6,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_7,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_8,
  whichOfTheFollowingTopicsAreIncludedWinTheFacsWritten_9,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_1,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_2,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_3,
  whichOfTheFollowingTopicsArePartOfTheCommAndTraining_4,
  whichOfTheFollowingTopicsArePartOfTheOngoingCommAnd,
  whichOfTheFollowingTopicsHaveBeenAssignedToAResponsib,
  whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPay,
  whichOfTheFollowingTypesOfLeaveIsTheFacFailingToPro,
  whichOfTheFollowingTypesOfOvertimeHoursIsTheFacFaili,
  whichOfTheFollowingTypesOfRegularHoursWorkedAtAPremi,
  whichOfTheFollowingWorkIsPerformedByWrkrsUndAge_18Se,
  whichOfTheItemsBelowApplySelectAllThatApply,
  whichTypesOfInkindBenefitsDoesTheFacProvSelectAllTha,
  whoIsResponsibleForPayingRecruitmentFeesAndRelatedCost,
  whoPerformsTheClockinclockoutFunctionForWrkrsSelectAll,
  whoReceivesCommAndTrainingSelectAllThatApply,
  whoResponsiblePayingRecruitmentFeesRelatedCostsWorker,
  withdrawalOfComplaint,
  women,
  woodProcessing,
  worker_1,
  worker_2,
  workerFeedback,
  workerRepresentatives,
  workersAreNotRotatedBetweenTasksReduceExposure,
  workersAreNotUsingFallProtectionWhenNeeded,
  workersArePaidDirectDepositIntoBankAccount,
  workersArePaidThrough_3rdPartyAgentsHave,
  workersCannotRespondAppealSettlement,
  workersCannotTakeShortErgonomicBreaksDuringWork,
  workersDoNotGiveWrittenConsentMoniesBe,
  workersDoNotHaveAccessAccountStatusWage,
  workersDoNotHaveUnrestrictedAccessVerifyAccuracy,
  workersDoNotKnowTheirPrimaryEvacuationRoute,
  workersDoNotWearFallProtectionTimesWhen,
  workersMustStayHomeAreNotPaid,
  workersMustStayHomeArePaidLegalMinimum,
  workersMustStayHomeArePaidLessThan,
  workersMustStayHomeAreRequiredUseVacation,
  workersNotTrainedOnProperUseFallProtection,
  workersThatWorkLaserRadiationProducingEquipmentDo,
  workersTrainingLogsOnProperUseFallProtection,
  workersWhoUseLaddersAreNotTrainedPlace,
  workingHourRecordsAreNotConsistentPayrollOther,
  workingHourRecordsEachWorker,
  workingHourRecordsEachWorkerAreNotMaintained,
  workingHours,
  workingHoursRecordsEachWeekWhen_60Hours,
  workingHoursRecordsHowManyWeeksWereSampled,
  workingHoursRecordsWeeksSampledHowManyWeeks,
  workload,
  workosOrganizationId,
  workRelatedInjuryIllnessDeathNotCollectedForwarded,
  wrapWorldwideResponsibleAccreditedProduction,
  writtenJobDescriptionJobApplicationFormsReferenceOther,
  writtenPoliciesProcedures,
  yesAreTermsConditionsSame,
  yesDescribeCircumstances,
  yesDescribeHowBurningWasteControlled,
  yesDescribeHowWorkers,
  yesDescribeTermsLoansAdvancesIEInterest,
  yesDescribeTypeDeductionsWagesMadeBesidesLegally,
  yesDescribeWhatTypeConcernsWereMadeRegarding,
  yesDescribeWhatTypeHotWorkPerformedFacility,
  yesDescribeWhatTypeLaserRadiationEquipmentUsed,
  yesDoesFacilityRecruitingAgencyEverRequestThat,
  yesDoWorkersConfirmAccuracyPayoutsRePayments,
  yesHowManyCasesWasVictimFemaleWorker_1,
  yesHowManyCasesWasVictimFemaleWorker_2,
  yesHowManyCasesWasVictimFemaleWorker_3,
  yesHowManyCasesWasVictimMaleWorker_1,
  yesHowManyCasesWasVictimMaleWorker_2,
  yesHowManyCasesWasVictimMaleWorker_3,
  yesHowManyComplaintsGrievancesWereReceivedFemale,
  yesHowManyComplaintsGrievancesWereReceivedMale,
  yesHowManySubcontractors,
  yesHowManySuggestionsFeedbackReceivedFacilityAddressed_1,
  yesHowManySuggestionsFeedbackReceivedFacilityAddressed_2,
  yesHowManyWorkersAreCoveredThisOther,
  yesWhatIndoorTemperatureCelsiusFacContinuouslyMaintains,
  zdhcId,
  zipCode,
}